
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
// src/app.js
/*! @azure/msal-browser v4.13.1 2025-06-10 */ /*! @azure/msal-browser v4.13.1 2025-06-10 */ /*! @azure/msal-browser v4.13.1 2025-06-10 */ /*! @azure/msal-browser v4.13.1 2025-06-10 */ /*! @azure/msal-common v15.7.0 2025-05-30 */ /*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $7c375ae106b964be$export$a002182e51710d39 = {
    LIBRARY_NAME: "MSAL.JS",
    SKU: "msal.js.common",
    // Prefix for all library cache entries
    CACHE_PREFIX: "msal",
    // default authority
    DEFAULT_AUTHORITY: "https://login.microsoftonline.com/common/",
    DEFAULT_AUTHORITY_HOST: "login.microsoftonline.com",
    DEFAULT_COMMON_TENANT: "common",
    // ADFS String
    ADFS: "adfs",
    DSTS: "dstsv2",
    // Default AAD Instance Discovery Endpoint
    AAD_INSTANCE_DISCOVERY_ENDPT: "https://login.microsoftonline.com/common/discovery/instance?api-version=1.1&authorization_endpoint=",
    // CIAM URL
    CIAM_AUTH_URL: ".ciamlogin.com",
    AAD_TENANT_DOMAIN_SUFFIX: ".onmicrosoft.com",
    // Resource delimiter - used for certain cache entries
    RESOURCE_DELIM: "|",
    // Placeholder for non-existent account ids/objects
    NO_ACCOUNT: "NO_ACCOUNT",
    // Claims
    CLAIMS: "claims",
    // Consumer UTID
    CONSUMER_UTID: "9188040d-6c67-4c5b-b112-36a304b66dad",
    // Default scopes
    OPENID_SCOPE: "openid",
    PROFILE_SCOPE: "profile",
    OFFLINE_ACCESS_SCOPE: "offline_access",
    EMAIL_SCOPE: "email",
    CODE_GRANT_TYPE: "authorization_code",
    RT_GRANT_TYPE: "refresh_token",
    S256_CODE_CHALLENGE_METHOD: "S256",
    URL_FORM_CONTENT_TYPE: "application/x-www-form-urlencoded;charset=utf-8",
    AUTHORIZATION_PENDING: "authorization_pending",
    NOT_DEFINED: "not_defined",
    EMPTY_STRING: "",
    NOT_APPLICABLE: "N/A",
    NOT_AVAILABLE: "Not Available",
    FORWARD_SLASH: "/",
    IMDS_ENDPOINT: "http://169.254.169.254/metadata/instance/compute/location",
    IMDS_VERSION: "2020-06-01",
    IMDS_TIMEOUT: 2000,
    AZURE_REGION_AUTO_DISCOVER_FLAG: "TryAutoDetect",
    REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX: "login.microsoft.com",
    KNOWN_PUBLIC_CLOUDS: [
        "login.microsoftonline.com",
        "login.windows.net",
        "login.microsoft.com",
        "sts.windows.net"
    ],
    SHR_NONCE_VALIDITY: 240,
    INVALID_INSTANCE: "invalid_instance"
};
const $7c375ae106b964be$export$2b71909294c66558 = {
    SUCCESS: 200,
    SUCCESS_RANGE_START: 200,
    SUCCESS_RANGE_END: 299,
    REDIRECT: 302,
    CLIENT_ERROR: 400,
    CLIENT_ERROR_RANGE_START: 400,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    REQUEST_TIMEOUT: 408,
    GONE: 410,
    TOO_MANY_REQUESTS: 429,
    CLIENT_ERROR_RANGE_END: 499,
    SERVER_ERROR: 500,
    SERVER_ERROR_RANGE_START: 500,
    SERVICE_UNAVAILABLE: 503,
    GATEWAY_TIMEOUT: 504,
    SERVER_ERROR_RANGE_END: 599,
    MULTI_SIDED_ERROR: 600
};
const $7c375ae106b964be$export$893b1b5b686d84ef = [
    $7c375ae106b964be$export$a002182e51710d39.OPENID_SCOPE,
    $7c375ae106b964be$export$a002182e51710d39.PROFILE_SCOPE,
    $7c375ae106b964be$export$a002182e51710d39.OFFLINE_ACCESS_SCOPE
];
const $7c375ae106b964be$export$268e88275f5afab2 = [
    ...$7c375ae106b964be$export$893b1b5b686d84ef,
    $7c375ae106b964be$export$a002182e51710d39.EMAIL_SCOPE
];
/**
 * Request header names
 */ const $7c375ae106b964be$export$28d77f87efed1d88 = {
    CONTENT_TYPE: "Content-Type",
    CONTENT_LENGTH: "Content-Length",
    RETRY_AFTER: "Retry-After",
    CCS_HEADER: "X-AnchorMailbox",
    WWWAuthenticate: "WWW-Authenticate",
    AuthenticationInfo: "Authentication-Info",
    X_MS_REQUEST_ID: "x-ms-request-id",
    X_MS_HTTP_VERSION: "x-ms-httpver"
};
/**
 * Persistent cache keys MSAL which stay while user is logged in.
 */ const $7c375ae106b964be$export$81ab9ba9bd28255c = {
    ACTIVE_ACCOUNT_FILTERS: "active-account-filters"
};
/**
 * String constants related to AAD Authority
 */ const $7c375ae106b964be$export$e18ac120172ed505 = {
    COMMON: "common",
    ORGANIZATIONS: "organizations",
    CONSUMERS: "consumers"
};
/**
 * Claims request keys
 */ const $7c375ae106b964be$export$c125cda26c71ef54 = {
    ACCESS_TOKEN: "access_token",
    XMS_CC: "xms_cc"
};
/**
 * we considered making this "enum" in the request instead of string, however it looks like the allowed list of
 * prompt values kept changing over past couple of years. There are some undocumented prompt values for some
 * internal partners too, hence the choice of generic "string" type instead of the "enum"
 */ const $7c375ae106b964be$export$49a06cbda5acaa5 = {
    LOGIN: "login",
    SELECT_ACCOUNT: "select_account",
    CONSENT: "consent",
    NONE: "none",
    CREATE: "create",
    NO_SESSION: "no_session"
};
/**
 * allowed values for codeVerifier
 */ const $7c375ae106b964be$export$a1fe36237c1cc863 = {
    PLAIN: "plain",
    S256: "S256"
};
/**
 * Allowed values for response_type
 */ const $7c375ae106b964be$export$5ef2b2ebd3da3e04 = {
    CODE: "code",
    IDTOKEN_TOKEN: "id_token token",
    IDTOKEN_TOKEN_REFRESHTOKEN: "id_token token refresh_token"
};
/**
 * allowed values for server response type
 * @deprecated Use ResponseMode instead
 */ const $7c375ae106b964be$export$b34cb6fbea2adc44 = {
    QUERY: "query",
    FRAGMENT: "fragment"
};
/**
 * allowed values for response_mode
 */ const $7c375ae106b964be$export$f990a5bae1260b8c = {
    QUERY: "query",
    FRAGMENT: "fragment",
    FORM_POST: "form_post"
};
/**
 * allowed grant_type
 */ const $7c375ae106b964be$export$ce68f19b50b39c0b = {
    IMPLICIT_GRANT: "implicit",
    AUTHORIZATION_CODE_GRANT: "authorization_code",
    CLIENT_CREDENTIALS_GRANT: "client_credentials",
    RESOURCE_OWNER_PASSWORD_GRANT: "password",
    REFRESH_TOKEN_GRANT: "refresh_token",
    DEVICE_CODE_GRANT: "device_code",
    JWT_BEARER: "urn:ietf:params:oauth:grant-type:jwt-bearer"
};
/**
 * Account types in Cache
 */ const $7c375ae106b964be$export$23244fafa2e7f55c = {
    MSSTS_ACCOUNT_TYPE: "MSSTS",
    ADFS_ACCOUNT_TYPE: "ADFS",
    MSAV1_ACCOUNT_TYPE: "MSA",
    GENERIC_ACCOUNT_TYPE: "Generic"
};
/**
 * Separators used in cache
 */ const $7c375ae106b964be$export$520854da2ba5d734 = {
    CACHE_KEY_SEPARATOR: "-",
    CLIENT_INFO_SEPARATOR: "."
};
/**
 * Credential Type stored in the cache
 */ const $7c375ae106b964be$export$eca2dc7e6e608a68 = {
    ID_TOKEN: "IdToken",
    ACCESS_TOKEN: "AccessToken",
    ACCESS_TOKEN_WITH_AUTH_SCHEME: "AccessToken_With_AuthScheme",
    REFRESH_TOKEN: "RefreshToken"
};
/**
 * Combine all cache types
 */ const $7c375ae106b964be$export$ba193b555633db78 = {
    ADFS: 1001,
    MSA: 1002,
    MSSTS: 1003,
    GENERIC: 1004,
    ACCESS_TOKEN: 2001,
    REFRESH_TOKEN: 2002,
    ID_TOKEN: 2003,
    APP_METADATA: 3001,
    UNDEFINED: 9999
};
/**
 * More Cache related constants
 */ const $7c375ae106b964be$export$7e1bea6dc1b6b32e = "appmetadata";
const $7c375ae106b964be$export$476989d62bcb4c85 = "client_info";
const $7c375ae106b964be$export$978fe7ab5e74b539 = "1";
const $7c375ae106b964be$export$d483f966e66f4db5 = {
    CACHE_KEY: "authority-metadata",
    REFRESH_TIME_SECONDS: 86400
};
const $7c375ae106b964be$export$5d365d77acfcb55d = {
    CONFIG: "config",
    CACHE: "cache",
    NETWORK: "network",
    HARDCODED_VALUES: "hardcoded_values"
};
const $7c375ae106b964be$export$30fa4ad28fb9feeb = {
    SCHEMA_VERSION: 5,
    MAX_CUR_HEADER_BYTES: 80,
    MAX_LAST_HEADER_BYTES: 330,
    MAX_CACHED_ERRORS: 50,
    CACHE_KEY: "server-telemetry",
    CATEGORY_SEPARATOR: "|",
    VALUE_SEPARATOR: ",",
    OVERFLOW_TRUE: "1",
    OVERFLOW_FALSE: "0",
    UNKNOWN_ERROR: "unknown_error"
};
/**
 * Type of the authentication request
 */ const $7c375ae106b964be$export$901491a717da2ba5 = {
    BEARER: "Bearer",
    POP: "pop",
    SSH: "ssh-cert"
};
/**
 * Constants related to throttling
 */ const $7c375ae106b964be$export$a2330d6808e6d893 = {
    // Default time to throttle RequestThumbprint in seconds
    DEFAULT_THROTTLE_TIME_SECONDS: 60,
    // Default maximum time to throttle in seconds, overrides what the server sends back
    DEFAULT_MAX_THROTTLE_TIME_SECONDS: 3600,
    // Prefix for storing throttling entries
    THROTTLING_PREFIX: "throttling",
    // Value assigned to the x-ms-lib-capability header to indicate to the server the library supports throttling
    X_MS_LIB_CAPABILITY_VALUE: "retry-after, h429"
};
const $7c375ae106b964be$export$b8e9cd941e8016ac = {
    INVALID_GRANT_ERROR: "invalid_grant",
    CLIENT_MISMATCH_ERROR: "client_mismatch"
};
/**
 * Password grant parameters
 */ const $7c375ae106b964be$export$fa8b29062cab1da = {
    username: "username",
    password: "password"
};
/**
 * Region Discovery Sources
 */ const $7c375ae106b964be$export$3d4a3e11df589b40 = {
    FAILED_AUTO_DETECTION: "1",
    INTERNAL_CACHE: "2",
    ENVIRONMENT_VARIABLE: "3",
    IMDS: "4"
};
/**
 * Region Discovery Outcomes
 */ const $7c375ae106b964be$export$92a685f9218422bd = {
    CONFIGURED_MATCHES_DETECTED: "1",
    CONFIGURED_NO_AUTO_DETECTION: "2",
    CONFIGURED_NOT_DETECTED: "3",
    AUTO_DETECTION_REQUESTED_SUCCESSFUL: "4",
    AUTO_DETECTION_REQUESTED_FAILED: "5"
};
/**
 * Specifies the reason for fetching the access token from the identity provider
 */ const $7c375ae106b964be$export$aa4af185ea049f6b = {
    // When a token is found in the cache or the cache is not supposed to be hit when making the request
    NOT_APPLICABLE: "0",
    // When the token request goes to the identity provider because force_refresh was set to true. Also occurs if claims were requested
    FORCE_REFRESH_OR_CLAIMS: "1",
    // When the token request goes to the identity provider because no cached access token exists
    NO_CACHED_ACCESS_TOKEN: "2",
    // When the token request goes to the identity provider because cached access token expired
    CACHED_ACCESS_TOKEN_EXPIRED: "3",
    // When the token request goes to the identity provider because refresh_in was used and the existing token needs to be refreshed
    PROACTIVELY_REFRESHED: "4"
};
const $7c375ae106b964be$export$fe5c42ed17efe603 = {
    Jwt: "JWT",
    Jwk: "JWK",
    Pop: "pop"
};
const $7c375ae106b964be$export$14c29d43b22a755f = 86400000;
// Token renewal offset default in seconds
const $7c375ae106b964be$export$8d50f42618161d1a = 300;
const $7c375ae106b964be$export$6592cb873eed5846 = {
    BASE64: "base64",
    HEX: "hex",
    UTF8: "utf-8"
};


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Log message level.
 */ var $0bf1d54ef751a29c$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["Error"] = 0] = "Error";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Trace"] = 4] = "Trace";
})($0bf1d54ef751a29c$export$243e62d78d3b544d || ($0bf1d54ef751a29c$export$243e62d78d3b544d = {}));
/**
 * Class which facilitates logging of messages to a specific place.
 */ class $0bf1d54ef751a29c$export$efa9a398d6368992 {
    constructor(loggerOptions, packageName, packageVersion){
        // Current log level, defaults to info.
        this.level = $0bf1d54ef751a29c$export$243e62d78d3b544d.Info;
        const defaultLoggerCallback = ()=>{
            return;
        };
        const setLoggerOptions = loggerOptions || $0bf1d54ef751a29c$export$efa9a398d6368992.createDefaultLoggerOptions();
        this.localCallback = setLoggerOptions.loggerCallback || defaultLoggerCallback;
        this.piiLoggingEnabled = setLoggerOptions.piiLoggingEnabled || false;
        this.level = typeof setLoggerOptions.logLevel === "number" ? setLoggerOptions.logLevel : $0bf1d54ef751a29c$export$243e62d78d3b544d.Info;
        this.correlationId = setLoggerOptions.correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.packageName = packageName || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.packageVersion = packageVersion || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
    }
    static createDefaultLoggerOptions() {
        return {
            loggerCallback: ()=>{
            // allow users to not set loggerCallback
            },
            piiLoggingEnabled: false,
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Info
        };
    }
    /**
     * Create new Logger with existing configurations.
     */ clone(packageName, packageVersion, correlationId) {
        return new $0bf1d54ef751a29c$export$efa9a398d6368992({
            loggerCallback: this.localCallback,
            piiLoggingEnabled: this.piiLoggingEnabled,
            logLevel: this.level,
            correlationId: correlationId || this.correlationId
        }, packageName, packageVersion);
    }
    /**
     * Log message with required options.
     */ logMessage(logMessage, options) {
        if (options.logLevel > this.level || !this.piiLoggingEnabled && options.containsPii) return;
        const timestamp = new Date().toUTCString();
        // Add correlationId to logs if set, correlationId provided on log messages take precedence
        const logHeader = `[${timestamp}] : [${options.correlationId || this.correlationId || ""}]`;
        const log = `${logHeader} : ${this.packageName}@${this.packageVersion} : ${$0bf1d54ef751a29c$export$243e62d78d3b544d[options.logLevel]} - ${logMessage}`;
        // debug(`msal:${LogLevel[options.logLevel]}${options.containsPii ? "-Pii": Constants.EMPTY_STRING}${options.context ? `:${options.context}` : Constants.EMPTY_STRING}`)(logMessage);
        this.executeCallback(options.logLevel, log, options.containsPii || false);
    }
    /**
     * Execute callback with message.
     */ executeCallback(level, message, containsPii) {
        if (this.localCallback) this.localCallback(level, message, containsPii);
    }
    /**
     * Logs error messages.
     */ error(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Error,
            containsPii: false,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs error messages with PII.
     */ errorPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Error,
            containsPii: true,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs warning messages.
     */ warning(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Warning,
            containsPii: false,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs warning messages with PII.
     */ warningPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Warning,
            containsPii: true,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs info messages.
     */ info(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Info,
            containsPii: false,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs info messages with PII.
     */ infoPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Info,
            containsPii: true,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs verbose messages.
     */ verbose(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Verbose,
            containsPii: false,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs verbose messages with PII.
     */ verbosePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Verbose,
            containsPii: true,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs trace messages.
     */ trace(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Trace,
            containsPii: false,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs trace messages with PII.
     */ tracePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Trace,
            containsPii: true,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Returns whether PII Logging is enabled or not.
     */ isPiiLoggingEnabled() {
        return this.piiLoggingEnabled || false;
    }
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ /*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Protocol modes supported by MSAL.
 */ const $de576c4d1becc778$export$73a3e3dedd37150d = {
    /**
     * Auth Code + PKCE with Entra ID (formerly AAD) specific optimizations and features
     */ AAD: "AAD",
    /**
     * Auth Code + PKCE without Entra ID specific optimizations and features. For use only with non-Microsoft owned authorities.
     * Support is limited for this mode.
     */ OIDC: "OIDC",
    /**
     * Encrypted Authorize Response (EAR) with Entra ID specific optimizations and features
     */ EAR: "EAR"
};

/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $399fa9610e7cb0fb$export$4cda21933050d9ec = {
    // AzureCloudInstance is not specified.
    None: "none",
    // Microsoft Azure public cloud
    AzurePublic: "https://login.microsoftonline.com",
    // Microsoft PPE
    AzurePpe: "https://login.windows-ppe.net",
    // Microsoft Chinese national/regional cloud
    AzureChina: "https://login.chinacloudapi.cn",
    // Microsoft German national/regional cloud ("Black Forest")
    AzureGermany: "https://login.microsoftonline.de",
    // US Government cloud
    AzureUsGovernment: "https://login.microsoftonline.us"
};

/*! @azure/msal-common v15.7.0 2025-05-30 */ /*! @azure/msal-common v15.7.0 2025-05-30 */ /*! @azure/msal-common v15.7.0 2025-05-30 */ /*! @azure/msal-common v15.7.0 2025-05-30 */ 
var $1a08d0bb87f43eeb$exports = {};

$parcel$export($1a08d0bb87f43eeb$exports, "unexpectedError", () => $1a08d0bb87f43eeb$export$efbc88c27b0be04);
$parcel$export($1a08d0bb87f43eeb$exports, "postRequestFailed", () => $1a08d0bb87f43eeb$export$7a1e28a7b60ca602);
/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 */ const $1a08d0bb87f43eeb$export$efbc88c27b0be04 = "unexpected_error";
const $1a08d0bb87f43eeb$export$7a1e28a7b60ca602 = "post_request_failed";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $0ff8310393c4d2db$export$cd5f04206718d3a5 = {
    [(0, $1a08d0bb87f43eeb$export$efbc88c27b0be04)]: "Unexpected error in authentication.",
    [(0, $1a08d0bb87f43eeb$export$7a1e28a7b60ca602)]: "Post request failed from the network, could be a 4xx/5xx or a network unavailability. Please check the exact error code for details."
};
/**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use AuthErrorCodes instead
 */ const $0ff8310393c4d2db$export$930cbd4733f218f0 = {
    unexpectedError: {
        code: (0, $1a08d0bb87f43eeb$export$efbc88c27b0be04),
        desc: $0ff8310393c4d2db$export$cd5f04206718d3a5[0, $1a08d0bb87f43eeb$export$efbc88c27b0be04]
    },
    postRequestFailed: {
        code: (0, $1a08d0bb87f43eeb$export$7a1e28a7b60ca602),
        desc: $0ff8310393c4d2db$export$cd5f04206718d3a5[0, $1a08d0bb87f43eeb$export$7a1e28a7b60ca602]
    }
};
/**
 * General error class thrown by the MSAL.js library.
 */ class $0ff8310393c4d2db$export$145273558d58e0ac extends Error {
    constructor(errorCode, errorMessage, suberror){
        const errorString = errorMessage ? `${errorCode}: ${errorMessage}` : errorCode;
        super(errorString);
        Object.setPrototypeOf(this, $0ff8310393c4d2db$export$145273558d58e0ac.prototype);
        this.errorCode = errorCode || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.errorMessage = errorMessage || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.subError = suberror || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.name = "AuthError";
    }
    setCorrelationId(correlationId) {
        this.correlationId = correlationId;
    }
}
function $0ff8310393c4d2db$export$eb157f7636c79bd2(code, additionalMessage) {
    return new $0ff8310393c4d2db$export$145273558d58e0ac(code, additionalMessage ? `${$0ff8310393c4d2db$export$cd5f04206718d3a5[code]} ${additionalMessage}` : $0ff8310393c4d2db$export$cd5f04206718d3a5[code]);
}


var $6be88bbe69356b76$exports = {};

$parcel$export($6be88bbe69356b76$exports, "clientInfoDecodingError", () => $6be88bbe69356b76$export$ccdf48c387c47b82);
$parcel$export($6be88bbe69356b76$exports, "clientInfoEmptyError", () => $6be88bbe69356b76$export$12315251e24e0181);
$parcel$export($6be88bbe69356b76$exports, "tokenParsingError", () => $6be88bbe69356b76$export$ad362b2e3a260143);
$parcel$export($6be88bbe69356b76$exports, "nullOrEmptyToken", () => $6be88bbe69356b76$export$78d01e29cb494be2);
$parcel$export($6be88bbe69356b76$exports, "endpointResolutionError", () => $6be88bbe69356b76$export$c9fcc93738cc2bc3);
$parcel$export($6be88bbe69356b76$exports, "networkError", () => $6be88bbe69356b76$export$4358cbadf08aa73);
$parcel$export($6be88bbe69356b76$exports, "openIdConfigError", () => $6be88bbe69356b76$export$73566da29bc073eb);
$parcel$export($6be88bbe69356b76$exports, "hashNotDeserialized", () => $6be88bbe69356b76$export$14c4d54a8414667f);
$parcel$export($6be88bbe69356b76$exports, "invalidState", () => $6be88bbe69356b76$export$72a77317632c052b);
$parcel$export($6be88bbe69356b76$exports, "stateMismatch", () => $6be88bbe69356b76$export$6a56d8f882843cd8);
$parcel$export($6be88bbe69356b76$exports, "stateNotFound", () => $6be88bbe69356b76$export$ef9214cfa5960fc);
$parcel$export($6be88bbe69356b76$exports, "nonceMismatch", () => $6be88bbe69356b76$export$edd0491c2c280be7);
$parcel$export($6be88bbe69356b76$exports, "authTimeNotFound", () => $6be88bbe69356b76$export$43356944266c945e);
$parcel$export($6be88bbe69356b76$exports, "maxAgeTranspired", () => $6be88bbe69356b76$export$f95fb86904f89749);
$parcel$export($6be88bbe69356b76$exports, "multipleMatchingTokens", () => $6be88bbe69356b76$export$47c50a2451614107);
$parcel$export($6be88bbe69356b76$exports, "multipleMatchingAccounts", () => $6be88bbe69356b76$export$2804a8b1b4c3be8b);
$parcel$export($6be88bbe69356b76$exports, "multipleMatchingAppMetadata", () => $6be88bbe69356b76$export$575bb2924bcd0084);
$parcel$export($6be88bbe69356b76$exports, "requestCannotBeMade", () => $6be88bbe69356b76$export$4ac9fb1f531eded7);
$parcel$export($6be88bbe69356b76$exports, "cannotRemoveEmptyScope", () => $6be88bbe69356b76$export$f7a276c01beb068a);
$parcel$export($6be88bbe69356b76$exports, "cannotAppendScopeSet", () => $6be88bbe69356b76$export$93883786cf4a4a27);
$parcel$export($6be88bbe69356b76$exports, "emptyInputScopeSet", () => $6be88bbe69356b76$export$41e2ce5958c42c83);
$parcel$export($6be88bbe69356b76$exports, "deviceCodePollingCancelled", () => $6be88bbe69356b76$export$e3af42f9856ab2a);
$parcel$export($6be88bbe69356b76$exports, "deviceCodeExpired", () => $6be88bbe69356b76$export$c0ef55deeb5e30d5);
$parcel$export($6be88bbe69356b76$exports, "deviceCodeUnknownError", () => $6be88bbe69356b76$export$4a9e9cce395ba70c);
$parcel$export($6be88bbe69356b76$exports, "noAccountInSilentRequest", () => $6be88bbe69356b76$export$5a3c7d1c90ac9220);
$parcel$export($6be88bbe69356b76$exports, "invalidCacheRecord", () => $6be88bbe69356b76$export$d396103576f879cc);
$parcel$export($6be88bbe69356b76$exports, "invalidCacheEnvironment", () => $6be88bbe69356b76$export$dedc648643245fa1);
$parcel$export($6be88bbe69356b76$exports, "noAccountFound", () => $6be88bbe69356b76$export$b98ebfe073f0162f);
$parcel$export($6be88bbe69356b76$exports, "noCryptoObject", () => $6be88bbe69356b76$export$c39e501a22cba395);
$parcel$export($6be88bbe69356b76$exports, "unexpectedCredentialType", () => $6be88bbe69356b76$export$21fdd1f95350cd6d);
$parcel$export($6be88bbe69356b76$exports, "invalidAssertion", () => $6be88bbe69356b76$export$e168896c692fb06b);
$parcel$export($6be88bbe69356b76$exports, "invalidClientCredential", () => $6be88bbe69356b76$export$c483ba88a47982b1);
$parcel$export($6be88bbe69356b76$exports, "tokenRefreshRequired", () => $6be88bbe69356b76$export$e23b692cce0c7779);
$parcel$export($6be88bbe69356b76$exports, "userTimeoutReached", () => $6be88bbe69356b76$export$afbb99ff17e87b86);
$parcel$export($6be88bbe69356b76$exports, "tokenClaimsCnfRequiredForSignedJwt", () => $6be88bbe69356b76$export$6f89b8a7d491b526);
$parcel$export($6be88bbe69356b76$exports, "authorizationCodeMissingFromServerResponse", () => $6be88bbe69356b76$export$93625fc864d26bba);
$parcel$export($6be88bbe69356b76$exports, "bindingKeyNotRemoved", () => $6be88bbe69356b76$export$5765db5d84418d29);
$parcel$export($6be88bbe69356b76$exports, "endSessionEndpointNotSupported", () => $6be88bbe69356b76$export$c3bd741c16a889f3);
$parcel$export($6be88bbe69356b76$exports, "keyIdMissing", () => $6be88bbe69356b76$export$3c9338a50e294d1);
$parcel$export($6be88bbe69356b76$exports, "noNetworkConnectivity", () => $6be88bbe69356b76$export$31ae862f18c3b2b7);
$parcel$export($6be88bbe69356b76$exports, "userCanceled", () => $6be88bbe69356b76$export$8ee329e65a880ec7);
$parcel$export($6be88bbe69356b76$exports, "missingTenantIdError", () => $6be88bbe69356b76$export$8c321d057617a458);
$parcel$export($6be88bbe69356b76$exports, "methodNotImplemented", () => $6be88bbe69356b76$export$24176fc1f15eea22);
$parcel$export($6be88bbe69356b76$exports, "nestedAppAuthBridgeDisabled", () => $6be88bbe69356b76$export$3078b0202fe7eea3);
/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $6be88bbe69356b76$export$ccdf48c387c47b82 = "client_info_decoding_error";
const $6be88bbe69356b76$export$12315251e24e0181 = "client_info_empty_error";
const $6be88bbe69356b76$export$ad362b2e3a260143 = "token_parsing_error";
const $6be88bbe69356b76$export$78d01e29cb494be2 = "null_or_empty_token";
const $6be88bbe69356b76$export$c9fcc93738cc2bc3 = "endpoints_resolution_error";
const $6be88bbe69356b76$export$4358cbadf08aa73 = "network_error";
const $6be88bbe69356b76$export$73566da29bc073eb = "openid_config_error";
const $6be88bbe69356b76$export$14c4d54a8414667f = "hash_not_deserialized";
const $6be88bbe69356b76$export$72a77317632c052b = "invalid_state";
const $6be88bbe69356b76$export$6a56d8f882843cd8 = "state_mismatch";
const $6be88bbe69356b76$export$ef9214cfa5960fc = "state_not_found";
const $6be88bbe69356b76$export$edd0491c2c280be7 = "nonce_mismatch";
const $6be88bbe69356b76$export$43356944266c945e = "auth_time_not_found";
const $6be88bbe69356b76$export$f95fb86904f89749 = "max_age_transpired";
const $6be88bbe69356b76$export$47c50a2451614107 = "multiple_matching_tokens";
const $6be88bbe69356b76$export$2804a8b1b4c3be8b = "multiple_matching_accounts";
const $6be88bbe69356b76$export$575bb2924bcd0084 = "multiple_matching_appMetadata";
const $6be88bbe69356b76$export$4ac9fb1f531eded7 = "request_cannot_be_made";
const $6be88bbe69356b76$export$f7a276c01beb068a = "cannot_remove_empty_scope";
const $6be88bbe69356b76$export$93883786cf4a4a27 = "cannot_append_scopeset";
const $6be88bbe69356b76$export$41e2ce5958c42c83 = "empty_input_scopeset";
const $6be88bbe69356b76$export$e3af42f9856ab2a = "device_code_polling_cancelled";
const $6be88bbe69356b76$export$c0ef55deeb5e30d5 = "device_code_expired";
const $6be88bbe69356b76$export$4a9e9cce395ba70c = "device_code_unknown_error";
const $6be88bbe69356b76$export$5a3c7d1c90ac9220 = "no_account_in_silent_request";
const $6be88bbe69356b76$export$d396103576f879cc = "invalid_cache_record";
const $6be88bbe69356b76$export$dedc648643245fa1 = "invalid_cache_environment";
const $6be88bbe69356b76$export$b98ebfe073f0162f = "no_account_found";
const $6be88bbe69356b76$export$c39e501a22cba395 = "no_crypto_object";
const $6be88bbe69356b76$export$21fdd1f95350cd6d = "unexpected_credential_type";
const $6be88bbe69356b76$export$e168896c692fb06b = "invalid_assertion";
const $6be88bbe69356b76$export$c483ba88a47982b1 = "invalid_client_credential";
const $6be88bbe69356b76$export$e23b692cce0c7779 = "token_refresh_required";
const $6be88bbe69356b76$export$afbb99ff17e87b86 = "user_timeout_reached";
const $6be88bbe69356b76$export$6f89b8a7d491b526 = "token_claims_cnf_required_for_signedjwt";
const $6be88bbe69356b76$export$93625fc864d26bba = "authorization_code_missing_from_server_response";
const $6be88bbe69356b76$export$5765db5d84418d29 = "binding_key_not_removed";
const $6be88bbe69356b76$export$c3bd741c16a889f3 = "end_session_endpoint_not_supported";
const $6be88bbe69356b76$export$3c9338a50e294d1 = "key_id_missing";
const $6be88bbe69356b76$export$31ae862f18c3b2b7 = "no_network_connectivity";
const $6be88bbe69356b76$export$8ee329e65a880ec7 = "user_canceled";
const $6be88bbe69356b76$export$8c321d057617a458 = "missing_tenant_id_error";
const $6be88bbe69356b76$export$24176fc1f15eea22 = "method_not_implemented";
const $6be88bbe69356b76$export$3078b0202fe7eea3 = "nested_app_auth_bridge_disabled";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ClientAuthErrorMessage class containing string constants used by error codes and messages.
 */ const $eaea74bac26129fa$export$8190ec70cbf7ec08 = {
    [(0, $6be88bbe69356b76$export$ccdf48c387c47b82)]: "The client info could not be parsed/decoded correctly",
    [(0, $6be88bbe69356b76$export$12315251e24e0181)]: "The client info was empty",
    [(0, $6be88bbe69356b76$export$ad362b2e3a260143)]: "Token cannot be parsed",
    [(0, $6be88bbe69356b76$export$78d01e29cb494be2)]: "The token is null or empty",
    [(0, $6be88bbe69356b76$export$c9fcc93738cc2bc3)]: "Endpoints cannot be resolved",
    [(0, $6be88bbe69356b76$export$4358cbadf08aa73)]: "Network request failed",
    [(0, $6be88bbe69356b76$export$73566da29bc073eb)]: "Could not retrieve endpoints. Check your authority and verify the .well-known/openid-configuration endpoint returns the required endpoints.",
    [(0, $6be88bbe69356b76$export$14c4d54a8414667f)]: "The hash parameters could not be deserialized",
    [(0, $6be88bbe69356b76$export$72a77317632c052b)]: "State was not the expected format",
    [(0, $6be88bbe69356b76$export$6a56d8f882843cd8)]: "State mismatch error",
    [(0, $6be88bbe69356b76$export$ef9214cfa5960fc)]: "State not found",
    [(0, $6be88bbe69356b76$export$edd0491c2c280be7)]: "Nonce mismatch error",
    [(0, $6be88bbe69356b76$export$43356944266c945e)]: "Max Age was requested and the ID token is missing the auth_time variable. auth_time is an optional claim and is not enabled by default - it must be enabled. See https://aka.ms/msaljs/optional-claims for more information.",
    [(0, $6be88bbe69356b76$export$f95fb86904f89749)]: "Max Age is set to 0, or too much time has elapsed since the last end-user authentication.",
    [(0, $6be88bbe69356b76$export$47c50a2451614107)]: "The cache contains multiple tokens satisfying the requirements. Call AcquireToken again providing more requirements such as authority or account.",
    [(0, $6be88bbe69356b76$export$2804a8b1b4c3be8b)]: "The cache contains multiple accounts satisfying the given parameters. Please pass more info to obtain the correct account",
    [(0, $6be88bbe69356b76$export$575bb2924bcd0084)]: "The cache contains multiple appMetadata satisfying the given parameters. Please pass more info to obtain the correct appMetadata",
    [(0, $6be88bbe69356b76$export$4ac9fb1f531eded7)]: "Token request cannot be made without authorization code or refresh token.",
    [(0, $6be88bbe69356b76$export$f7a276c01beb068a)]: "Cannot remove null or empty scope from ScopeSet",
    [(0, $6be88bbe69356b76$export$93883786cf4a4a27)]: "Cannot append ScopeSet",
    [(0, $6be88bbe69356b76$export$41e2ce5958c42c83)]: "Empty input ScopeSet cannot be processed",
    [(0, $6be88bbe69356b76$export$e3af42f9856ab2a)]: "Caller has cancelled token endpoint polling during device code flow by setting DeviceCodeRequest.cancel = true.",
    [(0, $6be88bbe69356b76$export$c0ef55deeb5e30d5)]: "Device code is expired.",
    [(0, $6be88bbe69356b76$export$4a9e9cce395ba70c)]: "Device code stopped polling for unknown reasons.",
    [(0, $6be88bbe69356b76$export$5a3c7d1c90ac9220)]: "Please pass an account object, silent flow is not supported without account information",
    [(0, $6be88bbe69356b76$export$d396103576f879cc)]: "Cache record object was null or undefined.",
    [(0, $6be88bbe69356b76$export$dedc648643245fa1)]: "Invalid environment when attempting to create cache entry",
    [(0, $6be88bbe69356b76$export$b98ebfe073f0162f)]: "No account found in cache for given key.",
    [(0, $6be88bbe69356b76$export$c39e501a22cba395)]: "No crypto object detected.",
    [(0, $6be88bbe69356b76$export$21fdd1f95350cd6d)]: "Unexpected credential type.",
    [(0, $6be88bbe69356b76$export$e168896c692fb06b)]: "Client assertion must meet requirements described in https://tools.ietf.org/html/rfc7515",
    [(0, $6be88bbe69356b76$export$c483ba88a47982b1)]: "Client credential (secret, certificate, or assertion) must not be empty when creating a confidential client. An application should at most have one credential",
    [(0, $6be88bbe69356b76$export$e23b692cce0c7779)]: "Cannot return token from cache because it must be refreshed. This may be due to one of the following reasons: forceRefresh parameter is set to true, claims have been requested, there is no cached access token or it is expired.",
    [(0, $6be88bbe69356b76$export$afbb99ff17e87b86)]: "User defined timeout for device code polling reached",
    [(0, $6be88bbe69356b76$export$6f89b8a7d491b526)]: "Cannot generate a POP jwt if the token_claims are not populated",
    [(0, $6be88bbe69356b76$export$93625fc864d26bba)]: "Server response does not contain an authorization code to proceed",
    [(0, $6be88bbe69356b76$export$5765db5d84418d29)]: "Could not remove the credential's binding key from storage.",
    [(0, $6be88bbe69356b76$export$c3bd741c16a889f3)]: "The provided authority does not support logout",
    [(0, $6be88bbe69356b76$export$3c9338a50e294d1)]: "A keyId value is missing from the requested bound token's cache record and is required to match the token to it's stored binding key.",
    [(0, $6be88bbe69356b76$export$31ae862f18c3b2b7)]: "No network connectivity. Check your internet connection.",
    [(0, $6be88bbe69356b76$export$8ee329e65a880ec7)]: "User cancelled the flow.",
    [(0, $6be88bbe69356b76$export$8c321d057617a458)]: "A tenant id - not common, organizations, or consumers - must be specified when using the client_credentials flow.",
    [(0, $6be88bbe69356b76$export$24176fc1f15eea22)]: "This method has not been implemented",
    [(0, $6be88bbe69356b76$export$3078b0202fe7eea3)]: "The nested app auth bridge is disabled"
};
/**
 * String constants used by error codes and messages.
 * @deprecated Use ClientAuthErrorCodes instead
 */ const $eaea74bac26129fa$export$51eee17394e135b = {
    clientInfoDecodingError: {
        code: (0, $6be88bbe69356b76$export$ccdf48c387c47b82),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$ccdf48c387c47b82]
    },
    clientInfoEmptyError: {
        code: (0, $6be88bbe69356b76$export$12315251e24e0181),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$12315251e24e0181]
    },
    tokenParsingError: {
        code: (0, $6be88bbe69356b76$export$ad362b2e3a260143),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$ad362b2e3a260143]
    },
    nullOrEmptyToken: {
        code: (0, $6be88bbe69356b76$export$78d01e29cb494be2),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$78d01e29cb494be2]
    },
    endpointResolutionError: {
        code: (0, $6be88bbe69356b76$export$c9fcc93738cc2bc3),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$c9fcc93738cc2bc3]
    },
    networkError: {
        code: (0, $6be88bbe69356b76$export$4358cbadf08aa73),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$4358cbadf08aa73]
    },
    unableToGetOpenidConfigError: {
        code: (0, $6be88bbe69356b76$export$73566da29bc073eb),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$73566da29bc073eb]
    },
    hashNotDeserialized: {
        code: (0, $6be88bbe69356b76$export$14c4d54a8414667f),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$14c4d54a8414667f]
    },
    invalidStateError: {
        code: (0, $6be88bbe69356b76$export$72a77317632c052b),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$72a77317632c052b]
    },
    stateMismatchError: {
        code: (0, $6be88bbe69356b76$export$6a56d8f882843cd8),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$6a56d8f882843cd8]
    },
    stateNotFoundError: {
        code: (0, $6be88bbe69356b76$export$ef9214cfa5960fc),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$ef9214cfa5960fc]
    },
    nonceMismatchError: {
        code: (0, $6be88bbe69356b76$export$edd0491c2c280be7),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$edd0491c2c280be7]
    },
    authTimeNotFoundError: {
        code: (0, $6be88bbe69356b76$export$43356944266c945e),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$43356944266c945e]
    },
    maxAgeTranspired: {
        code: (0, $6be88bbe69356b76$export$f95fb86904f89749),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$f95fb86904f89749]
    },
    multipleMatchingTokens: {
        code: (0, $6be88bbe69356b76$export$47c50a2451614107),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$47c50a2451614107]
    },
    multipleMatchingAccounts: {
        code: (0, $6be88bbe69356b76$export$2804a8b1b4c3be8b),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$2804a8b1b4c3be8b]
    },
    multipleMatchingAppMetadata: {
        code: (0, $6be88bbe69356b76$export$575bb2924bcd0084),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$575bb2924bcd0084]
    },
    tokenRequestCannotBeMade: {
        code: (0, $6be88bbe69356b76$export$4ac9fb1f531eded7),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$4ac9fb1f531eded7]
    },
    removeEmptyScopeError: {
        code: (0, $6be88bbe69356b76$export$f7a276c01beb068a),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$f7a276c01beb068a]
    },
    appendScopeSetError: {
        code: (0, $6be88bbe69356b76$export$93883786cf4a4a27),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$93883786cf4a4a27]
    },
    emptyInputScopeSetError: {
        code: (0, $6be88bbe69356b76$export$41e2ce5958c42c83),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$41e2ce5958c42c83]
    },
    DeviceCodePollingCancelled: {
        code: (0, $6be88bbe69356b76$export$e3af42f9856ab2a),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$e3af42f9856ab2a]
    },
    DeviceCodeExpired: {
        code: (0, $6be88bbe69356b76$export$c0ef55deeb5e30d5),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$c0ef55deeb5e30d5]
    },
    DeviceCodeUnknownError: {
        code: (0, $6be88bbe69356b76$export$4a9e9cce395ba70c),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$4a9e9cce395ba70c]
    },
    NoAccountInSilentRequest: {
        code: (0, $6be88bbe69356b76$export$5a3c7d1c90ac9220),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$5a3c7d1c90ac9220]
    },
    invalidCacheRecord: {
        code: (0, $6be88bbe69356b76$export$d396103576f879cc),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$d396103576f879cc]
    },
    invalidCacheEnvironment: {
        code: (0, $6be88bbe69356b76$export$dedc648643245fa1),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$dedc648643245fa1]
    },
    noAccountFound: {
        code: (0, $6be88bbe69356b76$export$b98ebfe073f0162f),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$b98ebfe073f0162f]
    },
    noCryptoObj: {
        code: (0, $6be88bbe69356b76$export$c39e501a22cba395),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$c39e501a22cba395]
    },
    unexpectedCredentialType: {
        code: (0, $6be88bbe69356b76$export$21fdd1f95350cd6d),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$21fdd1f95350cd6d]
    },
    invalidAssertion: {
        code: (0, $6be88bbe69356b76$export$e168896c692fb06b),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$e168896c692fb06b]
    },
    invalidClientCredential: {
        code: (0, $6be88bbe69356b76$export$c483ba88a47982b1),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$c483ba88a47982b1]
    },
    tokenRefreshRequired: {
        code: (0, $6be88bbe69356b76$export$e23b692cce0c7779),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$e23b692cce0c7779]
    },
    userTimeoutReached: {
        code: (0, $6be88bbe69356b76$export$afbb99ff17e87b86),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$afbb99ff17e87b86]
    },
    tokenClaimsRequired: {
        code: (0, $6be88bbe69356b76$export$6f89b8a7d491b526),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$6f89b8a7d491b526]
    },
    noAuthorizationCodeFromServer: {
        code: (0, $6be88bbe69356b76$export$93625fc864d26bba),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$93625fc864d26bba]
    },
    bindingKeyNotRemovedError: {
        code: (0, $6be88bbe69356b76$export$5765db5d84418d29),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$5765db5d84418d29]
    },
    logoutNotSupported: {
        code: (0, $6be88bbe69356b76$export$c3bd741c16a889f3),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$c3bd741c16a889f3]
    },
    keyIdMissing: {
        code: (0, $6be88bbe69356b76$export$3c9338a50e294d1),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$3c9338a50e294d1]
    },
    noNetworkConnectivity: {
        code: (0, $6be88bbe69356b76$export$31ae862f18c3b2b7),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$31ae862f18c3b2b7]
    },
    userCanceledError: {
        code: (0, $6be88bbe69356b76$export$8ee329e65a880ec7),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$8ee329e65a880ec7]
    },
    missingTenantIdError: {
        code: (0, $6be88bbe69356b76$export$8c321d057617a458),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$8c321d057617a458]
    },
    nestedAppAuthBridgeDisabled: {
        code: (0, $6be88bbe69356b76$export$3078b0202fe7eea3),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$3078b0202fe7eea3]
    }
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */ class $eaea74bac26129fa$export$a839ff85a7957561 extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, additionalMessage){
        super(errorCode, additionalMessage ? `${$eaea74bac26129fa$export$8190ec70cbf7ec08[errorCode]}: ${additionalMessage}` : $eaea74bac26129fa$export$8190ec70cbf7ec08[errorCode]);
        this.name = "ClientAuthError";
        Object.setPrototypeOf(this, $eaea74bac26129fa$export$a839ff85a7957561.prototype);
    }
}
function $eaea74bac26129fa$export$ea892ce48f5bb4f3(errorCode, additionalMessage) {
    return new $eaea74bac26129fa$export$a839ff85a7957561(errorCode, additionalMessage);
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $dd88ab1a0b4d3851$export$865f57d401606752 = {
    createNewGuid: ()=>{
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    base64Decode: ()=>{
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    base64Encode: ()=>{
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    base64UrlEncode: ()=>{
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    encodeKid: ()=>{
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    async getPublicKeyThumbprint () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    async removeTokenBindingKey () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    async clearKeystore () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    async signJwt () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    async hashString () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
};




/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/* eslint-disable header/header */ const $4c1e49235f95193e$export$a8ff84c12d48cfa6 = "@azure/msal-common";
const $4c1e49235f95193e$export$83d89fbfd8236492 = "15.7.0";



/*! @azure/msal-common v15.7.0 2025-05-30 */ 
var $9ab3d26df56b176d$exports = {};

$parcel$export($9ab3d26df56b176d$exports, "generateCredentialKey", () => $9ab3d26df56b176d$export$1aaa1362083ec7a3);
$parcel$export($9ab3d26df56b176d$exports, "createIdTokenEntity", () => $9ab3d26df56b176d$export$d8a173a23f325769);
$parcel$export($9ab3d26df56b176d$exports, "createAccessTokenEntity", () => $9ab3d26df56b176d$export$fa005e75d915b6db);
$parcel$export($9ab3d26df56b176d$exports, "createRefreshTokenEntity", () => $9ab3d26df56b176d$export$9095b5885dfa55cc);
$parcel$export($9ab3d26df56b176d$exports, "isCredentialEntity", () => $9ab3d26df56b176d$export$b8fc93e8af17dc04);
$parcel$export($9ab3d26df56b176d$exports, "isAccessTokenEntity", () => $9ab3d26df56b176d$export$d7e6bcc84cf680df);
$parcel$export($9ab3d26df56b176d$exports, "isIdTokenEntity", () => $9ab3d26df56b176d$export$71eec93d11c94dfc);
$parcel$export($9ab3d26df56b176d$exports, "isRefreshTokenEntity", () => $9ab3d26df56b176d$export$f1bb3af43d5b8bc7);
$parcel$export($9ab3d26df56b176d$exports, "isServerTelemetryEntity", () => $9ab3d26df56b176d$export$7ad16989078344e5);
$parcel$export($9ab3d26df56b176d$exports, "isThrottlingEntity", () => $9ab3d26df56b176d$export$7e43cc7efaf4bec2);
$parcel$export($9ab3d26df56b176d$exports, "generateAppMetadataKey", () => $9ab3d26df56b176d$export$ddbc6773ab812685);
$parcel$export($9ab3d26df56b176d$exports, "isAppMetadataEntity", () => $9ab3d26df56b176d$export$bb2a01b66d0b3486);
$parcel$export($9ab3d26df56b176d$exports, "isAuthorityMetadataEntity", () => $9ab3d26df56b176d$export$6231cab310116b3c);
$parcel$export($9ab3d26df56b176d$exports, "generateAuthorityMetadataExpiresAt", () => $9ab3d26df56b176d$export$90f464c4238c27e5);
$parcel$export($9ab3d26df56b176d$exports, "updateAuthorityEndpointMetadata", () => $9ab3d26df56b176d$export$ef87e8fbd8af5f96);
$parcel$export($9ab3d26df56b176d$exports, "updateCloudDiscoveryMetadata", () => $9ab3d26df56b176d$export$6d4972e1d88c8518);
$parcel$export($9ab3d26df56b176d$exports, "isAuthorityMetadataExpired", () => $9ab3d26df56b176d$export$b96839cf63a15b0f);
/*! @azure/msal-common v15.7.0 2025-05-30 */ var $b29e27fb146a7ddd$exports = {};

$parcel$export($b29e27fb146a7ddd$exports, "extractTokenClaims", () => $b29e27fb146a7ddd$export$8a59e6f35fb00518);
$parcel$export($b29e27fb146a7ddd$exports, "getJWSPayload", () => $b29e27fb146a7ddd$export$b9f318d6daf53c97);
$parcel$export($b29e27fb146a7ddd$exports, "checkMaxAge", () => $b29e27fb146a7ddd$export$ee7a34ea7880144c);
/*! @azure/msal-common v15.7.0 2025-05-30 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extract token by decoding the rawToken
 *
 * @param encodedToken
 */ function $b29e27fb146a7ddd$export$8a59e6f35fb00518(encodedToken, base64Decode) {
    const jswPayload = $b29e27fb146a7ddd$export$b9f318d6daf53c97(encodedToken);
    // token will be decoded to get the username
    try {
        // base64Decode() should throw an error if there is an issue
        const base64Decoded = base64Decode(jswPayload);
        return JSON.parse(base64Decoded);
    } catch (err) {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$ad362b2e3a260143));
    }
}
/**
 * decode a JWT
 *
 * @param authToken
 */ function $b29e27fb146a7ddd$export$b9f318d6daf53c97(authToken) {
    if (!authToken) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$78d01e29cb494be2));
    const tokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
    const matches = tokenPartsRegex.exec(authToken);
    if (!matches || matches.length < 4) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$ad362b2e3a260143));
    /**
     * const crackedToken = {
     *  header: matches[1],
     *  JWSPayload: matches[2],
     *  JWSSig: matches[3],
     * };
     */ return matches[2];
}
/**
 * Determine if the token's max_age has transpired
 */ function $b29e27fb146a7ddd$export$ee7a34ea7880144c(authTime, maxAge) {
    /*
     * per https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest
     * To force an immediate re-authentication: If an app requires that a user re-authenticate prior to access,
     * provide a value of 0 for the max_age parameter and the AS will force a fresh login.
     */ const fiveMinuteSkew = 300000; // five minutes in milliseconds
    if (maxAge === 0 || Date.now() - fiveMinuteSkew > authTime + maxAge) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$f95fb86904f89749));
}




var $0a4a8f22735f9ff5$exports = {};

$parcel$export($0a4a8f22735f9ff5$exports, "nowSeconds", () => $0a4a8f22735f9ff5$export$ae62599a119ac50a);
$parcel$export($0a4a8f22735f9ff5$exports, "toSecondsFromDate", () => $0a4a8f22735f9ff5$export$13bf6a15fb02e52d);
$parcel$export($0a4a8f22735f9ff5$exports, "toDateFromSeconds", () => $0a4a8f22735f9ff5$export$dcee164673849555);
$parcel$export($0a4a8f22735f9ff5$exports, "isTokenExpired", () => $0a4a8f22735f9ff5$export$b007d77a962aa175);
$parcel$export($0a4a8f22735f9ff5$exports, "wasClockTurnedBack", () => $0a4a8f22735f9ff5$export$8961be72dcbc368e);
$parcel$export($0a4a8f22735f9ff5$exports, "delay", () => $0a4a8f22735f9ff5$export$1391212d75b2ee65);
/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility functions for managing date and time operations.
 */ /**
 * return the current time in Unix time (seconds).
 */ function $0a4a8f22735f9ff5$export$ae62599a119ac50a() {
    // Date.getTime() returns in milliseconds.
    return Math.round(new Date().getTime() / 1000.0);
}
/**
 * Converts JS Date object to seconds
 * @param date Date
 */ function $0a4a8f22735f9ff5$export$13bf6a15fb02e52d(date) {
    // Convert date to seconds
    return date.getTime() / 1000;
}
/**
 * Convert seconds to JS Date object. Seconds can be in a number or string format or undefined (will still return a date).
 * @param seconds
 */ function $0a4a8f22735f9ff5$export$dcee164673849555(seconds) {
    if (seconds) return new Date(Number(seconds) * 1000);
    return new Date();
}
/**
 * check if a token is expired based on given UTC time in seconds.
 * @param expiresOn
 */ function $0a4a8f22735f9ff5$export$b007d77a962aa175(expiresOn, offset) {
    // check for access token expiry
    const expirationSec = Number(expiresOn) || 0;
    const offsetCurrentTimeSec = $0a4a8f22735f9ff5$export$ae62599a119ac50a() + offset;
    // If current time + offset is greater than token expiration time, then token is expired.
    return offsetCurrentTimeSec > expirationSec;
}
/**
 * If the current time is earlier than the time that a token was cached at, we must discard the token
 * i.e. The system clock was turned back after acquiring the cached token
 * @param cachedAt
 * @param offset
 */ function $0a4a8f22735f9ff5$export$8961be72dcbc368e(cachedAt) {
    const cachedAtSec = Number(cachedAt);
    return cachedAtSec > $0a4a8f22735f9ff5$export$ae62599a119ac50a();
}
/**
 * Waits for t number of milliseconds
 * @param t number
 * @param value T
 */ function $0a4a8f22735f9ff5$export$1391212d75b2ee65(t, value) {
    return new Promise((resolve)=>setTimeout(()=>resolve(value), t));
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Cache Key: <home_account_id>-<environment>-<credential_type>-<client_id or familyId>-<realm>-<scopes>-<claims hash>-<scheme>
 * IdToken Example: uid.utid-login.microsoftonline.com-idtoken-app_client_id-contoso.com
 * AccessToken Example: uid.utid-login.microsoftonline.com-accesstoken-app_client_id-contoso.com-scope1 scope2--pop
 * RefreshToken Example: uid.utid-login.microsoftonline.com-refreshtoken-1-contoso.com
 * @param credentialEntity
 * @returns
 */ function $9ab3d26df56b176d$export$1aaa1362083ec7a3(credentialEntity) {
    const credentialKey = [
        $9ab3d26df56b176d$var$generateAccountId(credentialEntity),
        $9ab3d26df56b176d$var$generateCredentialId(credentialEntity),
        $9ab3d26df56b176d$var$generateTarget(credentialEntity),
        $9ab3d26df56b176d$var$generateClaimsHash(credentialEntity),
        $9ab3d26df56b176d$var$generateScheme(credentialEntity)
    ];
    return credentialKey.join((0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
}
/**
 * Create IdTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function $9ab3d26df56b176d$export$d8a173a23f325769(homeAccountId, environment, idToken, clientId, tenantId) {
    const idTokenEntity = {
        credentialType: (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: idToken,
        realm: tenantId
    };
    return idTokenEntity;
}
/**
 * Create AccessTokenEntity
 * @param homeAccountId
 * @param environment
 * @param accessToken
 * @param clientId
 * @param tenantId
 * @param scopes
 * @param expiresOn
 * @param extExpiresOn
 */ function $9ab3d26df56b176d$export$fa005e75d915b6db(homeAccountId, environment, accessToken, clientId, tenantId, scopes, expiresOn, extExpiresOn, base64Decode, refreshOn, tokenType, userAssertionHash, keyId, requestedClaims, requestedClaimsHash) {
    const atEntity = {
        homeAccountId: homeAccountId,
        credentialType: (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN,
        secret: accessToken,
        cachedAt: (0, $0a4a8f22735f9ff5$export$ae62599a119ac50a)().toString(),
        expiresOn: expiresOn.toString(),
        extendedExpiresOn: extExpiresOn.toString(),
        environment: environment,
        clientId: clientId,
        realm: tenantId,
        target: scopes,
        tokenType: tokenType || (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER
    };
    if (userAssertionHash) atEntity.userAssertionHash = userAssertionHash;
    if (refreshOn) atEntity.refreshOn = refreshOn.toString();
    if (requestedClaims) {
        atEntity.requestedClaims = requestedClaims;
        atEntity.requestedClaimsHash = requestedClaimsHash;
    }
    /*
     * Create Access Token With Auth Scheme instead of regular access token
     * Cast to lower to handle "bearer" from ADFS
     */ if (atEntity.tokenType?.toLowerCase() !== (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER.toLowerCase()) {
        atEntity.credentialType = (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME;
        switch(atEntity.tokenType){
            case (0, $7c375ae106b964be$export$901491a717da2ba5).POP:
                // Make sure keyId is present and add it to credential
                const tokenClaims = (0, $b29e27fb146a7ddd$export$8a59e6f35fb00518)(accessToken, base64Decode);
                if (!tokenClaims?.cnf?.kid) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$6f89b8a7d491b526));
                atEntity.keyId = tokenClaims.cnf.kid;
                break;
            case (0, $7c375ae106b964be$export$901491a717da2ba5).SSH:
                atEntity.keyId = keyId;
        }
    }
    return atEntity;
}
/**
 * Create RefreshTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function $9ab3d26df56b176d$export$9095b5885dfa55cc(homeAccountId, environment, refreshToken, clientId, familyId, userAssertionHash, expiresOn) {
    const rtEntity = {
        credentialType: (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: refreshToken
    };
    if (userAssertionHash) rtEntity.userAssertionHash = userAssertionHash;
    if (familyId) rtEntity.familyId = familyId;
    if (expiresOn) rtEntity.expiresOn = expiresOn.toString();
    return rtEntity;
}
function $9ab3d26df56b176d$export$b8fc93e8af17dc04(entity) {
    return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("credentialType") && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("secret");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ab3d26df56b176d$export$d7e6bcc84cf680df(entity) {
    if (!entity) return false;
    return $9ab3d26df56b176d$export$b8fc93e8af17dc04(entity) && entity.hasOwnProperty("realm") && entity.hasOwnProperty("target") && (entity["credentialType"] === (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN || entity["credentialType"] === (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME);
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ab3d26df56b176d$export$71eec93d11c94dfc(entity) {
    if (!entity) return false;
    return $9ab3d26df56b176d$export$b8fc93e8af17dc04(entity) && entity.hasOwnProperty("realm") && entity["credentialType"] === (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN;
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ab3d26df56b176d$export$f1bb3af43d5b8bc7(entity) {
    if (!entity) return false;
    return $9ab3d26df56b176d$export$b8fc93e8af17dc04(entity) && entity["credentialType"] === (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN;
}
/**
 * Generate Account Id key component as per the schema: <home_account_id>-<environment>
 */ function $9ab3d26df56b176d$var$generateAccountId(credentialEntity) {
    const accountId = [
        credentialEntity.homeAccountId,
        credentialEntity.environment
    ];
    return accountId.join((0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
}
/**
 * Generate Credential Id key component as per the schema: <credential_type>-<client_id>-<realm>
 */ function $9ab3d26df56b176d$var$generateCredentialId(credentialEntity) {
    const clientOrFamilyId = credentialEntity.credentialType === (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN ? credentialEntity.familyId || credentialEntity.clientId : credentialEntity.clientId;
    const credentialId = [
        credentialEntity.credentialType,
        clientOrFamilyId,
        credentialEntity.realm || ""
    ];
    return credentialId.join((0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
}
/**
 * Generate target key component as per schema: <target>
 */ function $9ab3d26df56b176d$var$generateTarget(credentialEntity) {
    return (credentialEntity.target || "").toLowerCase();
}
/**
 * Generate requested claims key component as per schema: <requestedClaims>
 */ function $9ab3d26df56b176d$var$generateClaimsHash(credentialEntity) {
    return (credentialEntity.requestedClaimsHash || "").toLowerCase();
}
/**
 * Generate scheme key componenet as per schema: <scheme>
 */ function $9ab3d26df56b176d$var$generateScheme(credentialEntity) {
    /*
     * PoP Tokens and SSH certs include scheme in cache key
     * Cast to lowercase to handle "bearer" from ADFS
     */ return credentialEntity.tokenType && credentialEntity.tokenType.toLowerCase() !== (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER.toLowerCase() ? credentialEntity.tokenType.toLowerCase() : "";
}
/**
 * validates if a given cache entry is "Telemetry", parses <key,value>
 * @param key
 * @param entity
 */ function $9ab3d26df56b176d$export$7ad16989078344e5(key, entity) {
    const validateKey = key.indexOf((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).CACHE_KEY) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("failedRequests") && entity.hasOwnProperty("errors") && entity.hasOwnProperty("cacheHits");
    return validateKey && validateEntity;
}
/**
 * validates if a given cache entry is "Throttling", parses <key,value>
 * @param key
 * @param entity
 */ function $9ab3d26df56b176d$export$7e43cc7efaf4bec2(key, entity) {
    let validateKey = false;
    if (key) validateKey = key.indexOf((0, $7c375ae106b964be$export$a2330d6808e6d893).THROTTLING_PREFIX) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("throttleTime");
    return validateKey && validateEntity;
}
/**
 * Generate AppMetadata Cache Key as per the schema: appmetadata-<environment>-<client_id>
 */ function $9ab3d26df56b176d$export$ddbc6773ab812685({ environment: environment, clientId: clientId }) {
    const appMetaDataKeyArray = [
        (0, $7c375ae106b964be$export$7e1bea6dc1b6b32e),
        environment,
        clientId
    ];
    return appMetaDataKeyArray.join((0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
}
/*
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ab3d26df56b176d$export$bb2a01b66d0b3486(key, entity) {
    if (!entity) return false;
    return key.indexOf((0, $7c375ae106b964be$export$7e1bea6dc1b6b32e)) === 0 && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("environment");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ab3d26df56b176d$export$6231cab310116b3c(key, entity) {
    if (!entity) return false;
    return key.indexOf((0, $7c375ae106b964be$export$d483f966e66f4db5).CACHE_KEY) === 0 && entity.hasOwnProperty("aliases") && entity.hasOwnProperty("preferred_cache") && entity.hasOwnProperty("preferred_network") && entity.hasOwnProperty("canonical_authority") && entity.hasOwnProperty("authorization_endpoint") && entity.hasOwnProperty("token_endpoint") && entity.hasOwnProperty("issuer") && entity.hasOwnProperty("aliasesFromNetwork") && entity.hasOwnProperty("endpointsFromNetwork") && entity.hasOwnProperty("expiresAt") && entity.hasOwnProperty("jwks_uri");
}
/**
 * Reset the exiresAt value
 */ function $9ab3d26df56b176d$export$90f464c4238c27e5() {
    return (0, $0a4a8f22735f9ff5$export$ae62599a119ac50a)() + (0, $7c375ae106b964be$export$d483f966e66f4db5).REFRESH_TIME_SECONDS;
}
function $9ab3d26df56b176d$export$ef87e8fbd8af5f96(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.authorization_endpoint = updatedValues.authorization_endpoint;
    authorityMetadata.token_endpoint = updatedValues.token_endpoint;
    authorityMetadata.end_session_endpoint = updatedValues.end_session_endpoint;
    authorityMetadata.issuer = updatedValues.issuer;
    authorityMetadata.endpointsFromNetwork = fromNetwork;
    authorityMetadata.jwks_uri = updatedValues.jwks_uri;
}
function $9ab3d26df56b176d$export$6d4972e1d88c8518(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.aliases = updatedValues.aliases;
    authorityMetadata.preferred_cache = updatedValues.preferred_cache;
    authorityMetadata.preferred_network = updatedValues.preferred_network;
    authorityMetadata.aliasesFromNetwork = fromNetwork;
}
/**
 * Returns whether or not the data needs to be refreshed
 */ function $9ab3d26df56b176d$export$b96839cf63a15b0f(metadata) {
    return metadata.expiresAt <= (0, $0a4a8f22735f9ff5$export$ae62599a119ac50a)();
}


/*! @azure/msal-common v15.7.0 2025-05-30 */ /*! @azure/msal-common v15.7.0 2025-05-30 */ 
var $3a016e333d7347e3$exports = {};

$parcel$export($3a016e333d7347e3$exports, "redirectUriEmpty", () => $3a016e333d7347e3$export$7a02f9bdce79dd4e);
$parcel$export($3a016e333d7347e3$exports, "claimsRequestParsingError", () => $3a016e333d7347e3$export$561c97672a478709);
$parcel$export($3a016e333d7347e3$exports, "authorityUriInsecure", () => $3a016e333d7347e3$export$f77c6af656c8444b);
$parcel$export($3a016e333d7347e3$exports, "urlParseError", () => $3a016e333d7347e3$export$ee2a1a3389f75508);
$parcel$export($3a016e333d7347e3$exports, "urlEmptyError", () => $3a016e333d7347e3$export$859df485a5e0f239);
$parcel$export($3a016e333d7347e3$exports, "emptyInputScopesError", () => $3a016e333d7347e3$export$6ac27379c42383f);
$parcel$export($3a016e333d7347e3$exports, "invalidPromptValue", () => $3a016e333d7347e3$export$ccbe5d2d7c960c35);
$parcel$export($3a016e333d7347e3$exports, "invalidClaims", () => $3a016e333d7347e3$export$96e755c70e0d0e34);
$parcel$export($3a016e333d7347e3$exports, "tokenRequestEmpty", () => $3a016e333d7347e3$export$eca67ff7a91fed9d);
$parcel$export($3a016e333d7347e3$exports, "logoutRequestEmpty", () => $3a016e333d7347e3$export$9eb2eeb401492d88);
$parcel$export($3a016e333d7347e3$exports, "invalidCodeChallengeMethod", () => $3a016e333d7347e3$export$b8d8b332f17376dc);
$parcel$export($3a016e333d7347e3$exports, "pkceParamsMissing", () => $3a016e333d7347e3$export$2da3866b327f1753);
$parcel$export($3a016e333d7347e3$exports, "invalidCloudDiscoveryMetadata", () => $3a016e333d7347e3$export$92a2985751150ca5);
$parcel$export($3a016e333d7347e3$exports, "invalidAuthorityMetadata", () => $3a016e333d7347e3$export$edb4d5942bc8ccff);
$parcel$export($3a016e333d7347e3$exports, "untrustedAuthority", () => $3a016e333d7347e3$export$50c3162fda5f57);
$parcel$export($3a016e333d7347e3$exports, "missingSshJwk", () => $3a016e333d7347e3$export$8fbed44b22d9136f);
$parcel$export($3a016e333d7347e3$exports, "missingSshKid", () => $3a016e333d7347e3$export$b728bd8a588956c);
$parcel$export($3a016e333d7347e3$exports, "missingNonceAuthenticationHeader", () => $3a016e333d7347e3$export$4f88b4462bcef15f);
$parcel$export($3a016e333d7347e3$exports, "invalidAuthenticationHeader", () => $3a016e333d7347e3$export$bea58e1a2e503b59);
$parcel$export($3a016e333d7347e3$exports, "cannotSetOIDCOptions", () => $3a016e333d7347e3$export$a5c9fbb90473dca2);
$parcel$export($3a016e333d7347e3$exports, "cannotAllowPlatformBroker", () => $3a016e333d7347e3$export$9a3a7609ff879ac7);
$parcel$export($3a016e333d7347e3$exports, "authorityMismatch", () => $3a016e333d7347e3$export$91415fb6baea5d09);
/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $3a016e333d7347e3$export$7a02f9bdce79dd4e = "redirect_uri_empty";
const $3a016e333d7347e3$export$561c97672a478709 = "claims_request_parsing_error";
const $3a016e333d7347e3$export$f77c6af656c8444b = "authority_uri_insecure";
const $3a016e333d7347e3$export$ee2a1a3389f75508 = "url_parse_error";
const $3a016e333d7347e3$export$859df485a5e0f239 = "empty_url_error";
const $3a016e333d7347e3$export$6ac27379c42383f = "empty_input_scopes_error";
const $3a016e333d7347e3$export$ccbe5d2d7c960c35 = "invalid_prompt_value";
const $3a016e333d7347e3$export$96e755c70e0d0e34 = "invalid_claims";
const $3a016e333d7347e3$export$eca67ff7a91fed9d = "token_request_empty";
const $3a016e333d7347e3$export$9eb2eeb401492d88 = "logout_request_empty";
const $3a016e333d7347e3$export$b8d8b332f17376dc = "invalid_code_challenge_method";
const $3a016e333d7347e3$export$2da3866b327f1753 = "pkce_params_missing";
const $3a016e333d7347e3$export$92a2985751150ca5 = "invalid_cloud_discovery_metadata";
const $3a016e333d7347e3$export$edb4d5942bc8ccff = "invalid_authority_metadata";
const $3a016e333d7347e3$export$50c3162fda5f57 = "untrusted_authority";
const $3a016e333d7347e3$export$8fbed44b22d9136f = "missing_ssh_jwk";
const $3a016e333d7347e3$export$b728bd8a588956c = "missing_ssh_kid";
const $3a016e333d7347e3$export$4f88b4462bcef15f = "missing_nonce_authentication_header";
const $3a016e333d7347e3$export$bea58e1a2e503b59 = "invalid_authentication_header";
const $3a016e333d7347e3$export$a5c9fbb90473dca2 = "cannot_set_OIDCOptions";
const $3a016e333d7347e3$export$9a3a7609ff879ac7 = "cannot_allow_platform_broker";
const $3a016e333d7347e3$export$91415fb6baea5d09 = "authority_mismatch";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $350dc36ccc5c7715$export$45752b5111a13710 = {
    [(0, $3a016e333d7347e3$export$7a02f9bdce79dd4e)]: "A redirect URI is required for all calls, and none has been set.",
    [(0, $3a016e333d7347e3$export$561c97672a478709)]: "Could not parse the given claims request object.",
    [(0, $3a016e333d7347e3$export$f77c6af656c8444b)]: "Authority URIs must use https.  Please see here for valid authority configuration options: https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-initializing-client-applications#configuration-options",
    [(0, $3a016e333d7347e3$export$ee2a1a3389f75508)]: "URL could not be parsed into appropriate segments.",
    [(0, $3a016e333d7347e3$export$859df485a5e0f239)]: "URL was empty or null.",
    [(0, $3a016e333d7347e3$export$6ac27379c42383f)]: "Scopes cannot be passed as null, undefined or empty array because they are required to obtain an access token.",
    [(0, $3a016e333d7347e3$export$ccbe5d2d7c960c35)]: "Please see here for valid configuration options: https://azuread.github.io/microsoft-authentication-library-for-js/ref/modules/_azure_msal_common.html#commonauthorizationurlrequest",
    [(0, $3a016e333d7347e3$export$96e755c70e0d0e34)]: "Given claims parameter must be a stringified JSON object.",
    [(0, $3a016e333d7347e3$export$eca67ff7a91fed9d)]: "Token request was empty and not found in cache.",
    [(0, $3a016e333d7347e3$export$9eb2eeb401492d88)]: "The logout request was null or undefined.",
    [(0, $3a016e333d7347e3$export$b8d8b332f17376dc)]: 'code_challenge_method passed is invalid. Valid values are "plain" and "S256".',
    [(0, $3a016e333d7347e3$export$2da3866b327f1753)]: "Both params: code_challenge and code_challenge_method are to be passed if to be sent in the request",
    [(0, $3a016e333d7347e3$export$92a2985751150ca5)]: "Invalid cloudDiscoveryMetadata provided. Must be a stringified JSON object containing tenant_discovery_endpoint and metadata fields",
    [(0, $3a016e333d7347e3$export$edb4d5942bc8ccff)]: "Invalid authorityMetadata provided. Must by a stringified JSON object containing authorization_endpoint, token_endpoint, issuer fields.",
    [(0, $3a016e333d7347e3$export$50c3162fda5f57)]: "The provided authority is not a trusted authority. Please include this authority in the knownAuthorities config parameter.",
    [(0, $3a016e333d7347e3$export$8fbed44b22d9136f)]: "Missing sshJwk in SSH certificate request. A stringified JSON Web Key is required when using the SSH authentication scheme.",
    [(0, $3a016e333d7347e3$export$b728bd8a588956c)]: "Missing sshKid in SSH certificate request. A string that uniquely identifies the public SSH key is required when using the SSH authentication scheme.",
    [(0, $3a016e333d7347e3$export$4f88b4462bcef15f)]: "Unable to find an authentication header containing server nonce. Either the Authentication-Info or WWW-Authenticate headers must be present in order to obtain a server nonce.",
    [(0, $3a016e333d7347e3$export$bea58e1a2e503b59)]: "Invalid authentication header provided",
    [(0, $3a016e333d7347e3$export$a5c9fbb90473dca2)]: "Cannot set OIDCOptions parameter. Please change the protocol mode to OIDC or use a non-Microsoft authority.",
    [(0, $3a016e333d7347e3$export$9a3a7609ff879ac7)]: "Cannot set allowPlatformBroker parameter to true when not in AAD protocol mode.",
    [(0, $3a016e333d7347e3$export$91415fb6baea5d09)]: "Authority mismatch error. Authority provided in login request or PublicClientApplication config does not match the environment of the provided account. Please use a matching account or make an interactive request to login to this authority."
};
/**
 * ClientConfigurationErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use ClientConfigurationErrorCodes instead
 */ const $350dc36ccc5c7715$export$8a1024301e8298df = {
    redirectUriNotSet: {
        code: (0, $3a016e333d7347e3$export$7a02f9bdce79dd4e),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$7a02f9bdce79dd4e]
    },
    claimsRequestParsingError: {
        code: (0, $3a016e333d7347e3$export$561c97672a478709),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$561c97672a478709]
    },
    authorityUriInsecure: {
        code: (0, $3a016e333d7347e3$export$f77c6af656c8444b),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$f77c6af656c8444b]
    },
    urlParseError: {
        code: (0, $3a016e333d7347e3$export$ee2a1a3389f75508),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$ee2a1a3389f75508]
    },
    urlEmptyError: {
        code: (0, $3a016e333d7347e3$export$859df485a5e0f239),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$859df485a5e0f239]
    },
    emptyScopesError: {
        code: (0, $3a016e333d7347e3$export$6ac27379c42383f),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$6ac27379c42383f]
    },
    invalidPrompt: {
        code: (0, $3a016e333d7347e3$export$ccbe5d2d7c960c35),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$ccbe5d2d7c960c35]
    },
    invalidClaimsRequest: {
        code: (0, $3a016e333d7347e3$export$96e755c70e0d0e34),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$96e755c70e0d0e34]
    },
    tokenRequestEmptyError: {
        code: (0, $3a016e333d7347e3$export$eca67ff7a91fed9d),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$eca67ff7a91fed9d]
    },
    logoutRequestEmptyError: {
        code: (0, $3a016e333d7347e3$export$9eb2eeb401492d88),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$9eb2eeb401492d88]
    },
    invalidCodeChallengeMethod: {
        code: (0, $3a016e333d7347e3$export$b8d8b332f17376dc),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$b8d8b332f17376dc]
    },
    invalidCodeChallengeParams: {
        code: (0, $3a016e333d7347e3$export$2da3866b327f1753),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$2da3866b327f1753]
    },
    invalidCloudDiscoveryMetadata: {
        code: (0, $3a016e333d7347e3$export$92a2985751150ca5),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$92a2985751150ca5]
    },
    invalidAuthorityMetadata: {
        code: (0, $3a016e333d7347e3$export$edb4d5942bc8ccff),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$edb4d5942bc8ccff]
    },
    untrustedAuthority: {
        code: (0, $3a016e333d7347e3$export$50c3162fda5f57),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$50c3162fda5f57]
    },
    missingSshJwk: {
        code: (0, $3a016e333d7347e3$export$8fbed44b22d9136f),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$8fbed44b22d9136f]
    },
    missingSshKid: {
        code: (0, $3a016e333d7347e3$export$b728bd8a588956c),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$b728bd8a588956c]
    },
    missingNonceAuthenticationHeader: {
        code: (0, $3a016e333d7347e3$export$4f88b4462bcef15f),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$4f88b4462bcef15f]
    },
    invalidAuthenticationHeader: {
        code: (0, $3a016e333d7347e3$export$bea58e1a2e503b59),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$bea58e1a2e503b59]
    },
    cannotSetOIDCOptions: {
        code: (0, $3a016e333d7347e3$export$a5c9fbb90473dca2),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$a5c9fbb90473dca2]
    },
    cannotAllowPlatformBroker: {
        code: (0, $3a016e333d7347e3$export$9a3a7609ff879ac7),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$9a3a7609ff879ac7]
    },
    authorityMismatch: {
        code: (0, $3a016e333d7347e3$export$91415fb6baea5d09),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$91415fb6baea5d09]
    }
};
/**
 * Error thrown when there is an error in configuration of the MSAL.js library.
 */ class $350dc36ccc5c7715$export$ac9d9d20c2327339 extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode){
        super(errorCode, $350dc36ccc5c7715$export$45752b5111a13710[errorCode]);
        this.name = "ClientConfigurationError";
        Object.setPrototypeOf(this, $350dc36ccc5c7715$export$ac9d9d20c2327339.prototype);
    }
}
function $350dc36ccc5c7715$export$5d63d098f4f130a1(errorCode) {
    return new $350dc36ccc5c7715$export$ac9d9d20c2327339(errorCode);
}


/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * @hidden
 */ class $442eacaa0418a38d$export$ecc754f99843e759 {
    /**
     * Check if stringified object is empty
     * @param strObj
     */ static isEmptyObj(strObj) {
        if (strObj) try {
            const obj = JSON.parse(strObj);
            return Object.keys(obj).length === 0;
        } catch (e) {}
        return true;
    }
    static startsWith(str, search) {
        return str.indexOf(search) === 0;
    }
    static endsWith(str, search) {
        return str.length >= search.length && str.lastIndexOf(search) === str.length - search.length;
    }
    /**
     * Parses string into an object.
     *
     * @param query
     */ static queryStringToObject(query) {
        const obj = {};
        const params = query.split("&");
        const decode = (s)=>decodeURIComponent(s.replace(/\+/g, " "));
        params.forEach((pair)=>{
            if (pair.trim()) {
                const [key, value] = pair.split(/=(.+)/g, 2); // Split on the first occurence of the '=' character
                if (key && value) obj[decode(key)] = decode(value);
            }
        });
        return obj;
    }
    /**
     * Trims entries in an array.
     *
     * @param arr
     */ static trimArrayEntries(arr) {
        return arr.map((entry)=>entry.trim());
    }
    /**
     * Removes empty strings from array
     * @param arr
     */ static removeEmptyStringsFromArray(arr) {
        return arr.filter((entry)=>{
            return !!entry;
        });
    }
    /**
     * Attempts to parse a string into JSON
     * @param str
     */ static jsonParseHelper(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return null;
        }
    }
    /**
     * Tests if a given string matches a given pattern, with support for wildcards and queries.
     * @param pattern Wildcard pattern to string match. Supports "*" for wildcards and "?" for queries
     * @param input String to match against
     */ static matchPattern(pattern, input) {
        /**
         * Wildcard support: https://stackoverflow.com/a/3117248/4888559
         * Queries: replaces "?" in string with escaped "\?" for regex test
         */ // eslint-disable-next-line security/detect-non-literal-regexp
        const regex = new RegExp(pattern.replace(/\\/g, "\\\\").replace(/\*/g, "[^ ]*").replace(/\?/g, "\\?"));
        return regex.test(input);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The ScopeSet class creates a set of scopes. Scopes are case-insensitive, unique values, so the Set object in JS makes
 * the most sense to implement for this class. All scopes are trimmed and converted to lower case strings in intersection and union functions
 * to ensure uniqueness of strings.
 */ class $74ffed612cd8faee$export$b9b82b0f94ae1f99 {
    constructor(inputScopes){
        // Filter empty string and null/undefined array items
        const scopeArr = inputScopes ? (0, $442eacaa0418a38d$export$ecc754f99843e759).trimArrayEntries([
            ...inputScopes
        ]) : [];
        const filteredInput = scopeArr ? (0, $442eacaa0418a38d$export$ecc754f99843e759).removeEmptyStringsFromArray(scopeArr) : [];
        // Check if scopes array has at least one member
        if (!filteredInput || !filteredInput.length) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$6ac27379c42383f));
        this.scopes = new Set(); // Iterator in constructor not supported by IE11
        filteredInput.forEach((scope)=>this.scopes.add(scope));
    }
    /**
     * Factory method to create ScopeSet from space-delimited string
     * @param inputScopeString
     * @param appClientId
     * @param scopesRequired
     */ static fromString(inputScopeString) {
        const scopeString = inputScopeString || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        const inputScopes = scopeString.split(" ");
        return new $74ffed612cd8faee$export$b9b82b0f94ae1f99(inputScopes);
    }
    /**
     * Creates the set of scopes to search for in cache lookups
     * @param inputScopeString
     * @returns
     */ static createSearchScopes(inputScopeString) {
        const scopeSet = new $74ffed612cd8faee$export$b9b82b0f94ae1f99(inputScopeString);
        if (!scopeSet.containsOnlyOIDCScopes()) scopeSet.removeOIDCScopes();
        else scopeSet.removeScope((0, $7c375ae106b964be$export$a002182e51710d39).OFFLINE_ACCESS_SCOPE);
        return scopeSet;
    }
    /**
     * Check if a given scope is present in this set of scopes.
     * @param scope
     */ containsScope(scope) {
        const lowerCaseScopes = this.printScopesLowerCase().split(" ");
        const lowerCaseScopesSet = new $74ffed612cd8faee$export$b9b82b0f94ae1f99(lowerCaseScopes);
        // compare lowercase scopes
        return scope ? lowerCaseScopesSet.scopes.has(scope.toLowerCase()) : false;
    }
    /**
     * Check if a set of scopes is present in this set of scopes.
     * @param scopeSet
     */ containsScopeSet(scopeSet) {
        if (!scopeSet || scopeSet.scopes.size <= 0) return false;
        return this.scopes.size >= scopeSet.scopes.size && scopeSet.asArray().every((scope)=>this.containsScope(scope));
    }
    /**
     * Check if set of scopes contains only the defaults
     */ containsOnlyOIDCScopes() {
        let defaultScopeCount = 0;
        (0, $7c375ae106b964be$export$268e88275f5afab2).forEach((defaultScope)=>{
            if (this.containsScope(defaultScope)) defaultScopeCount += 1;
        });
        return this.scopes.size === defaultScopeCount;
    }
    /**
     * Appends single scope if passed
     * @param newScope
     */ appendScope(newScope) {
        if (newScope) this.scopes.add(newScope.trim());
    }
    /**
     * Appends multiple scopes if passed
     * @param newScopes
     */ appendScopes(newScopes) {
        try {
            newScopes.forEach((newScope)=>this.appendScope(newScope));
        } catch (e) {
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$93883786cf4a4a27));
        }
    }
    /**
     * Removes element from set of scopes.
     * @param scope
     */ removeScope(scope) {
        if (!scope) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$f7a276c01beb068a));
        this.scopes.delete(scope.trim());
    }
    /**
     * Removes default scopes from set of scopes
     * Primarily used to prevent cache misses if the default scopes are not returned from the server
     */ removeOIDCScopes() {
        (0, $7c375ae106b964be$export$268e88275f5afab2).forEach((defaultScope)=>{
            this.scopes.delete(defaultScope);
        });
    }
    /**
     * Combines an array of scopes with the current set of scopes.
     * @param otherScopes
     */ unionScopeSets(otherScopes) {
        if (!otherScopes) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$41e2ce5958c42c83));
        const unionScopes = new Set(); // Iterator in constructor not supported in IE11
        otherScopes.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        this.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        return unionScopes;
    }
    /**
     * Check if scopes intersect between this set and another.
     * @param otherScopes
     */ intersectingScopeSets(otherScopes) {
        if (!otherScopes) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$41e2ce5958c42c83));
        // Do not allow OIDC scopes to be the only intersecting scopes
        if (!otherScopes.containsOnlyOIDCScopes()) otherScopes.removeOIDCScopes();
        const unionScopes = this.unionScopeSets(otherScopes);
        const sizeOtherScopes = otherScopes.getScopeCount();
        const sizeThisScopes = this.getScopeCount();
        const sizeUnionScopes = unionScopes.size;
        return sizeUnionScopes < sizeThisScopes + sizeOtherScopes;
    }
    /**
     * Returns size of set of scopes.
     */ getScopeCount() {
        return this.scopes.size;
    }
    /**
     * Returns the scopes as an array of string values
     */ asArray() {
        const array = [];
        this.scopes.forEach((val)=>array.push(val));
        return array;
    }
    /**
     * Prints scopes into a space-delimited string
     */ printScopes() {
        if (this.scopes) {
            const scopeArr = this.asArray();
            return scopeArr.join(" ");
        }
        return (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
    }
    /**
     * Prints scopes into a space-delimited lower-case string (used for caching)
     */ printScopesLowerCase() {
        return this.printScopes().toLowerCase();
    }
}


/*! @azure/msal-common v15.7.0 2025-05-30 */ 
/*! @azure/msal-common v15.7.0 2025-05-30 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Function to build a client info object from server clientInfo string
 * @param rawClientInfo
 * @param crypto
 */ function $7aacd5d6e6d7482c$export$575e1419cfbab7f8(rawClientInfo, base64Decode) {
    if (!rawClientInfo) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$12315251e24e0181));
    try {
        const decodedClientInfo = base64Decode(rawClientInfo);
        return JSON.parse(decodedClientInfo);
    } catch (e) {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$ccdf48c387c47b82));
    }
}
/**
 * Function to build a client info object from cached homeAccountId string
 * @param homeAccountId
 */ function $7aacd5d6e6d7482c$export$63508a6d6b7dbe07(homeAccountId) {
    if (!homeAccountId) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$ccdf48c387c47b82));
    const clientInfoParts = homeAccountId.split((0, $7c375ae106b964be$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR, 2);
    return {
        uid: clientInfoParts[0],
        utid: clientInfoParts.length < 2 ? (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING : clientInfoParts[1]
    };
}


/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns true if tenantId matches the utid portion of homeAccountId
 * @param tenantId
 * @param homeAccountId
 * @returns
 */ function $54830df9a5d9a12c$export$bc62fd222eddc2d7(tenantId, homeAccountId) {
    return !!tenantId && !!homeAccountId && tenantId === homeAccountId.split(".")[1];
}
/**
 * Build tenant profile
 * @param homeAccountId - Home account identifier for this account object
 * @param localAccountId - Local account identifer for this account object
 * @param tenantId - Full tenant or organizational id that this account belongs to
 * @param idTokenClaims - Claims from the ID token
 * @returns
 */ function $54830df9a5d9a12c$export$924857724cb21ba4(homeAccountId, localAccountId, tenantId, idTokenClaims) {
    if (idTokenClaims) {
        const { oid: oid, sub: sub, tid: tid, name: name, tfp: tfp, acr: acr } = idTokenClaims;
        /**
         * Since there is no way to determine if the authority is AAD or B2C, we exhaust all the possible claims that can serve as tenant ID with the following precedence:
         * tid - TenantID claim that identifies the tenant that issued the token in AAD. Expected in all AAD ID tokens, not present in B2C ID Tokens.
         * tfp - Trust Framework Policy claim that identifies the policy that was used to authenticate the user. Functions as tenant for B2C scenarios.
         * acr - Authentication Context Class Reference claim used only with older B2C policies. Fallback in case tfp is not present, but likely won't be present anyway.
         */ const tenantId = tid || tfp || acr || "";
        return {
            tenantId: tenantId,
            localAccountId: oid || sub || "",
            name: name,
            isHomeTenant: $54830df9a5d9a12c$export$bc62fd222eddc2d7(tenantId, homeAccountId)
        };
    } else return {
        tenantId: tenantId,
        localAccountId: localAccountId,
        isHomeTenant: $54830df9a5d9a12c$export$bc62fd222eddc2d7(tenantId, homeAccountId)
    };
}
/**
 * Replaces account info that varies by tenant profile sourced from the ID token claims passed in with the tenant-specific account info
 * @param baseAccountInfo
 * @param idTokenClaims
 * @returns
 */ function $54830df9a5d9a12c$export$452a054c78b83dad(baseAccountInfo, tenantProfile, idTokenClaims, idTokenSecret) {
    let updatedAccountInfo = baseAccountInfo;
    // Tenant Profile overrides passed in account info
    if (tenantProfile) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant: isHomeTenant, ...tenantProfileOverride } = tenantProfile;
        updatedAccountInfo = {
            ...baseAccountInfo,
            ...tenantProfileOverride
        };
    }
    // ID token claims override passed in account info and tenant profile
    if (idTokenClaims) {
        // Ignore isHomeTenant, loginHint, and sid which are part of tenant profile but not base account info
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant: isHomeTenant, ...claimsSourcedTenantProfile } = $54830df9a5d9a12c$export$924857724cb21ba4(baseAccountInfo.homeAccountId, baseAccountInfo.localAccountId, baseAccountInfo.tenantId, idTokenClaims);
        updatedAccountInfo = {
            ...updatedAccountInfo,
            ...claimsSourcedTenantProfile,
            idTokenClaims: idTokenClaims,
            idToken: idTokenSecret
        };
        return updatedAccountInfo;
    }
    return updatedAccountInfo;
}



/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Authority types supported by MSAL.
 */ const $70363054a03152f4$export$cd82032b224a3839 = {
    Default: 0,
    Adfs: 1,
    Dsts: 2,
    Ciam: 3
};


/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Gets tenantId from available ID token claims to set as credential realm with the following precedence:
 * 1. tid - if the token is acquired from an Azure AD tenant tid will be present
 * 2. tfp - if the token is acquired from a modern B2C tenant tfp should be present
 * 3. acr - if the token is acquired from a legacy B2C tenant acr should be present
 * Downcased to match the realm case-insensitive comparison requirements
 * @param idTokenClaims
 * @returns
 */ function $da8f9f8eb56c5a02$export$8e1decb9a5e2932(idTokenClaims) {
    if (idTokenClaims) {
        const tenantId = idTokenClaims.tid || idTokenClaims.tfp || idTokenClaims.acr;
        return tenantId || null;
    }
    return null;
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Type that defines required and optional parameters for an Account field (based on universal cache schema implemented by all MSALs).
 *
 * Key : Value Schema
 *
 * Key: <home_account_id>-<environment>-<realm*>
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      localAccountId: Original tenant-specific accountID, usually used for legacy cases
 *      username: primary username that represents the user, usually corresponds to preferred_username in the v2 endpt
 *      authorityType: Accounts authority type as a string
 *      name: Full name for the account, including given name and family name,
 *      lastModificationTime: last time this entity was modified in the cache
 *      lastModificationApp:
 *      nativeAccountId: Account identifier on the native device
 *      tenantProfiles: Array of tenant profile objects for each tenant that the account has authenticated with in the browser
 * }
 * @internal
 */ class $d6acc4a6126921e0$export$680160523e6bfa6a {
    /**
     * Generate Account Id key component as per the schema: <home_account_id>-<environment>
     */ generateAccountId() {
        const accountId = [
            this.homeAccountId,
            this.environment
        ];
        return accountId.join((0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    }
    /**
     * Generate Account Cache Key as per the schema: <home_account_id>-<environment>-<realm*>
     */ generateAccountKey() {
        return $d6acc4a6126921e0$export$680160523e6bfa6a.generateAccountCacheKey({
            homeAccountId: this.homeAccountId,
            environment: this.environment,
            tenantId: this.realm,
            username: this.username,
            localAccountId: this.localAccountId
        });
    }
    /**
     * Returns the AccountInfo interface for this account.
     */ getAccountInfo() {
        return {
            homeAccountId: this.homeAccountId,
            environment: this.environment,
            tenantId: this.realm,
            username: this.username,
            localAccountId: this.localAccountId,
            name: this.name,
            nativeAccountId: this.nativeAccountId,
            authorityType: this.authorityType,
            // Deserialize tenant profiles array into a Map
            tenantProfiles: new Map((this.tenantProfiles || []).map((tenantProfile)=>{
                return [
                    tenantProfile.tenantId,
                    tenantProfile
                ];
            }))
        };
    }
    /**
     * Returns true if the account entity is in single tenant format (outdated), false otherwise
     */ isSingleTenant() {
        return !this.tenantProfiles;
    }
    /**
     * Generates account key from interface
     * @param accountInterface
     */ static generateAccountCacheKey(accountInterface) {
        const homeTenantId = accountInterface.homeAccountId.split(".")[1];
        const accountKey = [
            accountInterface.homeAccountId,
            accountInterface.environment || "",
            homeTenantId || accountInterface.tenantId || ""
        ];
        return accountKey.join((0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    }
    /**
     * Build Account cache from IdToken, clientInfo and authority/policy. Associated with AAD.
     * @param accountDetails
     */ static createAccount(accountDetails, authority, base64Decode) {
        const account = new $d6acc4a6126921e0$export$680160523e6bfa6a();
        if (authority.authorityType === (0, $70363054a03152f4$export$cd82032b224a3839).Adfs) account.authorityType = (0, $7c375ae106b964be$export$23244fafa2e7f55c).ADFS_ACCOUNT_TYPE;
        else if (authority.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC) account.authorityType = (0, $7c375ae106b964be$export$23244fafa2e7f55c).GENERIC_ACCOUNT_TYPE;
        else account.authorityType = (0, $7c375ae106b964be$export$23244fafa2e7f55c).MSSTS_ACCOUNT_TYPE;
        let clientInfo;
        if (accountDetails.clientInfo && base64Decode) clientInfo = (0, $7aacd5d6e6d7482c$export$575e1419cfbab7f8)(accountDetails.clientInfo, base64Decode);
        account.clientInfo = accountDetails.clientInfo;
        account.homeAccountId = accountDetails.homeAccountId;
        account.nativeAccountId = accountDetails.nativeAccountId;
        const env = accountDetails.environment || authority && authority.getPreferredCache();
        if (!env) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$dedc648643245fa1));
        account.environment = env;
        // non AAD scenarios can have empty realm
        account.realm = clientInfo?.utid || (0, $da8f9f8eb56c5a02$export$8e1decb9a5e2932)(accountDetails.idTokenClaims) || "";
        // How do you account for MSA CID here?
        account.localAccountId = clientInfo?.uid || accountDetails.idTokenClaims?.oid || accountDetails.idTokenClaims?.sub || "";
        /*
         * In B2C scenarios the emails claim is used instead of preferred_username and it is an array.
         * In most cases it will contain a single email. This field should not be relied upon if a custom
         * policy is configured to return more than 1 email.
         */ const preferredUsername = accountDetails.idTokenClaims?.preferred_username || accountDetails.idTokenClaims?.upn;
        const email = accountDetails.idTokenClaims?.emails ? accountDetails.idTokenClaims.emails[0] : null;
        account.username = preferredUsername || email || "";
        account.name = accountDetails.idTokenClaims?.name || "";
        account.cloudGraphHostName = accountDetails.cloudGraphHostName;
        account.msGraphHost = accountDetails.msGraphHost;
        if (accountDetails.tenantProfiles) account.tenantProfiles = accountDetails.tenantProfiles;
        else {
            const tenantProfile = (0, $54830df9a5d9a12c$export$924857724cb21ba4)(accountDetails.homeAccountId, account.localAccountId, account.realm, accountDetails.idTokenClaims);
            account.tenantProfiles = [
                tenantProfile
            ];
        }
        return account;
    }
    /**
     * Creates an AccountEntity object from AccountInfo
     * @param accountInfo
     * @param cloudGraphHostName
     * @param msGraphHost
     * @returns
     */ static createFromAccountInfo(accountInfo, cloudGraphHostName, msGraphHost) {
        const account = new $d6acc4a6126921e0$export$680160523e6bfa6a();
        account.authorityType = accountInfo.authorityType || (0, $7c375ae106b964be$export$23244fafa2e7f55c).GENERIC_ACCOUNT_TYPE;
        account.homeAccountId = accountInfo.homeAccountId;
        account.localAccountId = accountInfo.localAccountId;
        account.nativeAccountId = accountInfo.nativeAccountId;
        account.realm = accountInfo.tenantId;
        account.environment = accountInfo.environment;
        account.username = accountInfo.username;
        account.name = accountInfo.name;
        account.cloudGraphHostName = cloudGraphHostName;
        account.msGraphHost = msGraphHost;
        // Serialize tenant profiles map into an array
        account.tenantProfiles = Array.from(accountInfo.tenantProfiles?.values() || []);
        return account;
    }
    /**
     * Generate HomeAccountId from server response
     * @param serverClientInfo
     * @param authType
     */ static generateHomeAccountId(serverClientInfo, authType, logger, cryptoObj, idTokenClaims) {
        // since ADFS/DSTS do not have tid and does not set client_info
        if (!(authType === (0, $70363054a03152f4$export$cd82032b224a3839).Adfs || authType === (0, $70363054a03152f4$export$cd82032b224a3839).Dsts)) {
            // for cases where there is clientInfo
            if (serverClientInfo) try {
                const clientInfo = (0, $7aacd5d6e6d7482c$export$575e1419cfbab7f8)(serverClientInfo, cryptoObj.base64Decode);
                if (clientInfo.uid && clientInfo.utid) return `${clientInfo.uid}.${clientInfo.utid}`;
            } catch (e) {}
            logger.warning("No client info in response");
        }
        // default to "sub" claim
        return idTokenClaims?.sub || "";
    }
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */ static isAccountEntity(entity) {
        if (!entity) return false;
        return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("realm") && entity.hasOwnProperty("localAccountId") && entity.hasOwnProperty("username") && entity.hasOwnProperty("authorityType");
    }
    /**
     * Helper function to determine whether 2 accountInfo objects represent the same account
     * @param accountA
     * @param accountB
     * @param compareClaims - If set to true idTokenClaims will also be compared to determine account equality
     */ static accountInfoIsEqual(accountA, accountB, compareClaims) {
        if (!accountA || !accountB) return false;
        let claimsMatch = true; // default to true so as to not fail comparison below if compareClaims: false
        if (compareClaims) {
            const accountAClaims = accountA.idTokenClaims || {};
            const accountBClaims = accountB.idTokenClaims || {};
            // issued at timestamp and nonce are expected to change each time a new id token is acquired
            claimsMatch = accountAClaims.iat === accountBClaims.iat && accountAClaims.nonce === accountBClaims.nonce;
        }
        return accountA.homeAccountId === accountB.homeAccountId && accountA.localAccountId === accountB.localAccountId && accountA.username === accountB.username && accountA.tenantId === accountB.tenantId && accountA.environment === accountB.environment && accountA.nativeAccountId === accountB.nativeAccountId && claimsMatch;
    }
}






/*! @azure/msal-common v15.7.0 2025-05-30 */ /*! @azure/msal-common v15.7.0 2025-05-30 */ 


var $0763983a1d35c4b8$exports = {};

$parcel$export($0763983a1d35c4b8$exports, "stripLeadingHashOrQuery", () => $0763983a1d35c4b8$export$fe89dd256736a6b3);
$parcel$export($0763983a1d35c4b8$exports, "getDeserializedResponse", () => $0763983a1d35c4b8$export$f98e0976781b1204);
$parcel$export($0763983a1d35c4b8$exports, "mapToQueryString", () => $0763983a1d35c4b8$export$44d4663acf79cde2);
/*! @azure/msal-common v15.7.0 2025-05-30 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Parses hash string from given string. Returns empty string if no hash symbol is found.
 * @param hashString
 */ function $0763983a1d35c4b8$export$fe89dd256736a6b3(responseString) {
    if (responseString.startsWith("#/")) return responseString.substring(2);
    else if (responseString.startsWith("#") || responseString.startsWith("?")) return responseString.substring(1);
    return responseString;
}
/**
 * Returns URL hash as server auth code response object.
 */ function $0763983a1d35c4b8$export$f98e0976781b1204(responseString) {
    // Check if given hash is empty
    if (!responseString || responseString.indexOf("=") < 0) return null;
    try {
        // Strip the # or ? symbol if present
        const normalizedResponse = $0763983a1d35c4b8$export$fe89dd256736a6b3(responseString);
        // If # symbol was not present, above will return empty string, so give original hash value
        const deserializedHash = Object.fromEntries(new URLSearchParams(normalizedResponse));
        // Check for known response properties
        if (deserializedHash.code || deserializedHash.ear_jwe || deserializedHash.error || deserializedHash.error_description || deserializedHash.state) return deserializedHash;
    } catch (e) {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$14c4d54a8414667f));
    }
    return null;
}
/**
 * Utility to create a URL from the params map
 */ function $0763983a1d35c4b8$export$44d4663acf79cde2(parameters, encodeExtraParams = true, extraQueryParameters) {
    const queryParameterArray = new Array();
    parameters.forEach((value, key)=>{
        if (!encodeExtraParams && extraQueryParameters && key in extraQueryParameters) queryParameterArray.push(`${key}=${value}`);
        else queryParameterArray.push(`${key}=${encodeURIComponent(value)}`);
    });
    return queryParameterArray.join("&");
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Url object class which can perform various transformations on url strings.
 */ class $f7f911f196324278$export$3abcdca7229e54f2 {
    get urlString() {
        return this._urlString;
    }
    constructor(url){
        this._urlString = url;
        if (!this._urlString) // Throws error if url is empty
        throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$859df485a5e0f239));
        if (!url.includes("#")) this._urlString = $f7f911f196324278$export$3abcdca7229e54f2.canonicalizeUri(url);
    }
    /**
     * Ensure urls are lower case and end with a / character.
     * @param url
     */ static canonicalizeUri(url) {
        if (url) {
            let lowerCaseUrl = url.toLowerCase();
            if ((0, $442eacaa0418a38d$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?")) lowerCaseUrl = lowerCaseUrl.slice(0, -1);
            else if ((0, $442eacaa0418a38d$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?/")) lowerCaseUrl = lowerCaseUrl.slice(0, -2);
            if (!(0, $442eacaa0418a38d$export$ecc754f99843e759).endsWith(lowerCaseUrl, "/")) lowerCaseUrl += "/";
            return lowerCaseUrl;
        }
        return url;
    }
    /**
     * Throws if urlString passed is not a valid authority URI string.
     */ validateAsUri() {
        // Attempts to parse url for uri components
        let components;
        try {
            components = this.getUrlComponents();
        } catch (e) {
            throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$ee2a1a3389f75508));
        }
        // Throw error if URI or path segments are not parseable.
        if (!components.HostNameAndPort || !components.PathSegments) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$ee2a1a3389f75508));
        // Throw error if uri is insecure.
        if (!components.Protocol || components.Protocol.toLowerCase() !== "https:") throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$f77c6af656c8444b));
    }
    /**
     * Given a url and a query string return the url with provided query string appended
     * @param url
     * @param queryString
     */ static appendQueryString(url, queryString) {
        if (!queryString) return url;
        return url.indexOf("?") < 0 ? `${url}?${queryString}` : `${url}&${queryString}`;
    }
    /**
     * Returns a url with the hash removed
     * @param url
     */ static removeHashFromUrl(url) {
        return $f7f911f196324278$export$3abcdca7229e54f2.canonicalizeUri(url.split("#")[0]);
    }
    /**
     * Given a url like https://a:b/common/d?e=f#g, and a tenantId, returns https://a:b/tenantId/d
     * @param href The url
     * @param tenantId The tenant id to replace
     */ replaceTenantPath(tenantId) {
        const urlObject = this.getUrlComponents();
        const pathArray = urlObject.PathSegments;
        if (tenantId && pathArray.length !== 0 && (pathArray[0] === (0, $7c375ae106b964be$export$e18ac120172ed505).COMMON || pathArray[0] === (0, $7c375ae106b964be$export$e18ac120172ed505).ORGANIZATIONS)) pathArray[0] = tenantId;
        return $f7f911f196324278$export$3abcdca7229e54f2.constructAuthorityUriFromObject(urlObject);
    }
    /**
     * Parses out the components from a url string.
     * @returns An object with the various components. Please cache this value insted of calling this multiple times on the same url.
     */ getUrlComponents() {
        // https://gist.github.com/curtisz/11139b2cfcaef4a261e0
        const regEx = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
        // If url string does not match regEx, we throw an error
        const match = this.urlString.match(regEx);
        if (!match) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$ee2a1a3389f75508));
        // Url component object
        const urlComponents = {
            Protocol: match[1],
            HostNameAndPort: match[4],
            AbsolutePath: match[5],
            QueryString: match[7]
        };
        let pathSegments = urlComponents.AbsolutePath.split("/");
        pathSegments = pathSegments.filter((val)=>val && val.length > 0); // remove empty elements
        urlComponents.PathSegments = pathSegments;
        if (urlComponents.QueryString && urlComponents.QueryString.endsWith("/")) urlComponents.QueryString = urlComponents.QueryString.substring(0, urlComponents.QueryString.length - 1);
        return urlComponents;
    }
    static getDomainFromUrl(url) {
        const regEx = RegExp("^([^:/?#]+://)?([^/?#]*)");
        const match = url.match(regEx);
        if (!match) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$ee2a1a3389f75508));
        return match[2];
    }
    static getAbsoluteUrl(relativeUrl, baseUrl) {
        if (relativeUrl[0] === (0, $7c375ae106b964be$export$a002182e51710d39).FORWARD_SLASH) {
            const url = new $f7f911f196324278$export$3abcdca7229e54f2(baseUrl);
            const baseComponents = url.getUrlComponents();
            return baseComponents.Protocol + "//" + baseComponents.HostNameAndPort + relativeUrl;
        }
        return relativeUrl;
    }
    static constructAuthorityUriFromObject(urlObject) {
        return new $f7f911f196324278$export$3abcdca7229e54f2(urlObject.Protocol + "//" + urlObject.HostNameAndPort + "/" + urlObject.PathSegments.join("/"));
    }
    /**
     * Check if the hash of the URL string contains known properties
     * @deprecated This API will be removed in a future version
     */ static hashContainsKnownProperties(response) {
        return !!(0, $0763983a1d35c4b8$export$f98e0976781b1204)(response);
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $ff4bd32e3511744b$export$223f43dfec89cb87 = {
    endpointMetadata: {
        "login.microsoftonline.com": {
            token_endpoint: "https://login.microsoftonline.com/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.microsoftonline.com/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.microsoftonline.com/{tenantid}/v2.0",
            authorization_endpoint: "https://login.microsoftonline.com/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.microsoftonline.com/{tenantid}/oauth2/v2.0/logout"
        },
        "login.chinacloudapi.cn": {
            token_endpoint: "https://login.chinacloudapi.cn/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.chinacloudapi.cn/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.partner.microsoftonline.cn/{tenantid}/v2.0",
            authorization_endpoint: "https://login.chinacloudapi.cn/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.chinacloudapi.cn/{tenantid}/oauth2/v2.0/logout"
        },
        "login.microsoftonline.us": {
            token_endpoint: "https://login.microsoftonline.us/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.microsoftonline.us/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.microsoftonline.us/{tenantid}/v2.0",
            authorization_endpoint: "https://login.microsoftonline.us/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.microsoftonline.us/{tenantid}/oauth2/v2.0/logout"
        }
    },
    instanceDiscoveryMetadata: {
        tenant_discovery_endpoint: "https://{canonicalAuthority}/v2.0/.well-known/openid-configuration",
        metadata: [
            {
                preferred_network: "login.microsoftonline.com",
                preferred_cache: "login.windows.net",
                aliases: [
                    "login.microsoftonline.com",
                    "login.windows.net",
                    "login.microsoft.com",
                    "sts.windows.net"
                ]
            },
            {
                preferred_network: "login.partner.microsoftonline.cn",
                preferred_cache: "login.partner.microsoftonline.cn",
                aliases: [
                    "login.partner.microsoftonline.cn",
                    "login.chinacloudapi.cn"
                ]
            },
            {
                preferred_network: "login.microsoftonline.de",
                preferred_cache: "login.microsoftonline.de",
                aliases: [
                    "login.microsoftonline.de"
                ]
            },
            {
                preferred_network: "login.microsoftonline.us",
                preferred_cache: "login.microsoftonline.us",
                aliases: [
                    "login.microsoftonline.us",
                    "login.usgovcloudapi.net"
                ]
            },
            {
                preferred_network: "login-us.microsoftonline.com",
                preferred_cache: "login-us.microsoftonline.com",
                aliases: [
                    "login-us.microsoftonline.com"
                ]
            }
        ]
    }
};
const $ff4bd32e3511744b$export$f612854287391207 = $ff4bd32e3511744b$export$223f43dfec89cb87.endpointMetadata;
const $ff4bd32e3511744b$export$a21acafc3b6f5582 = $ff4bd32e3511744b$export$223f43dfec89cb87.instanceDiscoveryMetadata;
const $ff4bd32e3511744b$export$7d026f079148cd31 = new Set();
$ff4bd32e3511744b$export$a21acafc3b6f5582.metadata.forEach((metadataEntry)=>{
    metadataEntry.aliases.forEach((alias)=>{
        $ff4bd32e3511744b$export$7d026f079148cd31.add(alias);
    });
});
/**
 * Attempts to get an aliases array from the static authority metadata sources based on the canonical authority host
 * @param staticAuthorityOptions
 * @param logger
 * @returns
 */ function $ff4bd32e3511744b$export$2c21adf4b4d4efc0(staticAuthorityOptions, logger) {
    let staticAliases;
    const canonicalAuthority = staticAuthorityOptions.canonicalAuthority;
    if (canonicalAuthority) {
        const authorityHost = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(canonicalAuthority).getUrlComponents().HostNameAndPort;
        staticAliases = $ff4bd32e3511744b$export$d195904946de56a1(authorityHost, staticAuthorityOptions.cloudDiscoveryMetadata?.metadata, (0, $7c375ae106b964be$export$5d365d77acfcb55d).CONFIG, logger) || $ff4bd32e3511744b$export$d195904946de56a1(authorityHost, $ff4bd32e3511744b$export$a21acafc3b6f5582.metadata, (0, $7c375ae106b964be$export$5d365d77acfcb55d).HARDCODED_VALUES, logger) || staticAuthorityOptions.knownAuthorities;
    }
    return staticAliases || [];
}
/**
 * Returns aliases for from the raw cloud discovery metadata passed in
 * @param authorityHost
 * @param rawCloudDiscoveryMetadata
 * @returns
 */ function $ff4bd32e3511744b$export$d195904946de56a1(authorityHost, cloudDiscoveryMetadata, source, logger) {
    logger?.trace(`getAliasesFromMetadata called with source: ${source}`);
    if (authorityHost && cloudDiscoveryMetadata) {
        const metadata = $ff4bd32e3511744b$export$6e21098ea6e60dc(cloudDiscoveryMetadata, authorityHost);
        if (metadata) {
            logger?.trace(`getAliasesFromMetadata: found cloud discovery metadata in ${source}, returning aliases`);
            return metadata.aliases;
        } else logger?.trace(`getAliasesFromMetadata: did not find cloud discovery metadata in ${source}`);
    }
    return null;
}
/**
 * Get cloud discovery metadata for common authorities
 */ function $ff4bd32e3511744b$export$1b1433f93c9873f(authorityHost) {
    const metadata = $ff4bd32e3511744b$export$6e21098ea6e60dc($ff4bd32e3511744b$export$a21acafc3b6f5582.metadata, authorityHost);
    return metadata;
}
/**
 * Searches instance discovery network response for the entry that contains the host in the aliases list
 * @param response
 * @param authority
 */ function $ff4bd32e3511744b$export$6e21098ea6e60dc(response, authorityHost) {
    for(let i = 0; i < response.length; i++){
        const metadata = response[i];
        if (metadata.aliases.includes(authorityHost)) return metadata;
    }
    return null;
}


/*! @azure/msal-common v15.7.0 2025-05-30 */ /*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $d0300807e9c5c64e$export$4b5a0d15123a80af = "cache_quota_exceeded";
const $d0300807e9c5c64e$export$ede5ac6f832527a1 = "cache_error_unknown";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $531f2a6dee41cfa4$export$7ab11f0b2c87dadd = {
    [(0, $d0300807e9c5c64e$export$4b5a0d15123a80af)]: "Exceeded cache storage capacity.",
    [(0, $d0300807e9c5c64e$export$ede5ac6f832527a1)]: "Unexpected error occurred when using cache storage."
};
/**
 * Error thrown when there is an error with the cache
 */ class $531f2a6dee41cfa4$export$78ff06e91c3de382 extends Error {
    constructor(errorCode, errorMessage){
        const message = errorMessage || ($531f2a6dee41cfa4$export$7ab11f0b2c87dadd[errorCode] ? $531f2a6dee41cfa4$export$7ab11f0b2c87dadd[errorCode] : $531f2a6dee41cfa4$export$7ab11f0b2c87dadd[0, $d0300807e9c5c64e$export$ede5ac6f832527a1]);
        super(`${errorCode}: ${message}`);
        Object.setPrototypeOf(this, $531f2a6dee41cfa4$export$78ff06e91c3de382.prototype);
        this.name = "CacheError";
        this.errorCode = errorCode;
        this.errorMessage = message;
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Interface class which implement cache storage functions used by MSAL to perform validity checks, and store tokens.
 * @internal
 */ class $0c353f04031c78df$export$996e3ea69314b5c6 {
    constructor(clientId, cryptoImpl, logger, staticAuthorityOptions){
        this.clientId = clientId;
        this.cryptoImpl = cryptoImpl;
        this.commonLogger = logger.clone((0, $4c1e49235f95193e$export$a8ff84c12d48cfa6), (0, $4c1e49235f95193e$export$83d89fbfd8236492));
        this.staticAuthorityOptions = staticAuthorityOptions;
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return this.buildTenantProfiles(this.getAccountsFilteredBy(accountFilter || {}), accountFilter);
    }
    /**
     * Gets first tenanted AccountInfo object found based on provided filters
     */ getAccountInfoFilteredBy(accountFilter) {
        const allAccounts = this.getAllAccounts(accountFilter);
        if (allAccounts.length > 1) {
            // If one or more accounts are found, prioritize accounts that have an ID token
            const sortedAccounts = allAccounts.sort((account)=>{
                return account.idTokenClaims ? -1 : 1;
            });
            return sortedAccounts[0];
        } else if (allAccounts.length === 1) // If only one account is found, return it regardless of whether a matching ID token was found
        return allAccounts[0];
        else return null;
    }
    /**
     * Returns a single matching
     * @param accountFilter
     * @returns
     */ getBaseAccountInfo(accountFilter) {
        const accountEntities = this.getAccountsFilteredBy(accountFilter);
        if (accountEntities.length > 0) return accountEntities[0].getAccountInfo();
        else return null;
    }
    /**
     * Matches filtered account entities with cached ID tokens that match the tenant profile-specific account filters
     * and builds the account info objects from the matching ID token's claims
     * @param cachedAccounts
     * @param accountFilter
     * @returns Array of AccountInfo objects that match account and tenant profile filters
     */ buildTenantProfiles(cachedAccounts, accountFilter) {
        return cachedAccounts.flatMap((accountEntity)=>{
            return this.getTenantProfilesFromAccountEntity(accountEntity, accountFilter?.tenantId, accountFilter);
        });
    }
    getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, tenantProfileFilter) {
        let tenantedAccountInfo = null;
        let idTokenClaims;
        if (tenantProfileFilter) {
            if (!this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter)) return null;
        }
        const idToken = this.getIdToken(accountInfo, tokenKeys, tenantProfile.tenantId);
        if (idToken) {
            idTokenClaims = (0, $b29e27fb146a7ddd$export$8a59e6f35fb00518)(idToken.secret, this.cryptoImpl.base64Decode);
            if (!this.idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter)) // ID token sourced claims don't match so this tenant profile is not a match
            return null;
        }
        // Expand tenant profile into account info based on matching tenant profile and if available matching ID token claims
        tenantedAccountInfo = (0, $54830df9a5d9a12c$export$452a054c78b83dad)(accountInfo, tenantProfile, idTokenClaims, idToken?.secret);
        return tenantedAccountInfo;
    }
    getTenantProfilesFromAccountEntity(accountEntity, targetTenantId, tenantProfileFilter) {
        const accountInfo = accountEntity.getAccountInfo();
        let searchTenantProfiles = accountInfo.tenantProfiles || new Map();
        const tokenKeys = this.getTokenKeys();
        // If a tenant ID was provided, only return the tenant profile for that tenant ID if it exists
        if (targetTenantId) {
            const tenantProfile = searchTenantProfiles.get(targetTenantId);
            if (tenantProfile) // Reduce search field to just this tenant profile
            searchTenantProfiles = new Map([
                [
                    targetTenantId,
                    tenantProfile
                ]
            ]);
            else // No tenant profile for search tenant ID, return empty array
            return [];
        }
        const matchingTenantProfiles = [];
        searchTenantProfiles.forEach((tenantProfile)=>{
            const tenantedAccountInfo = this.getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, tenantProfileFilter);
            if (tenantedAccountInfo) matchingTenantProfiles.push(tenantedAccountInfo);
        });
        return matchingTenantProfiles;
    }
    tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter) {
        if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTenantProfile(tenantProfile, tenantProfileFilter.localAccountId)) return false;
        if (!!tenantProfileFilter.name && !(tenantProfile.name === tenantProfileFilter.name)) return false;
        if (tenantProfileFilter.isHomeTenant !== undefined && !(tenantProfile.isHomeTenant === tenantProfileFilter.isHomeTenant)) return false;
        return true;
    }
    idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter) {
        // Tenant Profile filtering
        if (tenantProfileFilter) {
            if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTokenClaims(idTokenClaims, tenantProfileFilter.localAccountId)) return false;
            if (!!tenantProfileFilter.loginHint && !this.matchLoginHintFromTokenClaims(idTokenClaims, tenantProfileFilter.loginHint)) return false;
            if (!!tenantProfileFilter.username && !this.matchUsername(idTokenClaims.preferred_username, tenantProfileFilter.username)) return false;
            if (!!tenantProfileFilter.name && !this.matchName(idTokenClaims, tenantProfileFilter.name)) return false;
            if (!!tenantProfileFilter.sid && !this.matchSid(idTokenClaims, tenantProfileFilter.sid)) return false;
        }
        return true;
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param storeInCache {?StoreInCache}
     * @param correlationId {?string} correlation id
     */ async saveCacheRecord(cacheRecord, correlationId, storeInCache) {
        if (!cacheRecord) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$d396103576f879cc));
        try {
            if (!!cacheRecord.account) await this.setAccount(cacheRecord.account, correlationId);
            if (!!cacheRecord.idToken && storeInCache?.idToken !== false) await this.setIdTokenCredential(cacheRecord.idToken, correlationId);
            if (!!cacheRecord.accessToken && storeInCache?.accessToken !== false) await this.saveAccessToken(cacheRecord.accessToken, correlationId);
            if (!!cacheRecord.refreshToken && storeInCache?.refreshToken !== false) await this.setRefreshTokenCredential(cacheRecord.refreshToken, correlationId);
            if (!!cacheRecord.appMetadata) this.setAppMetadata(cacheRecord.appMetadata);
        } catch (e) {
            this.commonLogger?.error(`CacheManager.saveCacheRecord: failed`);
            if (e instanceof Error) {
                this.commonLogger?.errorPii(`CacheManager.saveCacheRecord: ${e.message}`, correlationId);
                if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED" || e.message.includes("exceeded the quota")) {
                    this.commonLogger?.error(`CacheManager.saveCacheRecord: exceeded storage quota`, correlationId);
                    throw new (0, $531f2a6dee41cfa4$export$78ff06e91c3de382)((0, $d0300807e9c5c64e$export$4b5a0d15123a80af));
                } else throw new (0, $531f2a6dee41cfa4$export$78ff06e91c3de382)(e.name, e.message);
            } else {
                this.commonLogger?.errorPii(`CacheManager.saveCacheRecord: ${e}`, correlationId);
                throw new (0, $531f2a6dee41cfa4$export$78ff06e91c3de382)((0, $d0300807e9c5c64e$export$ede5ac6f832527a1));
            }
        }
    }
    /**
     * saves access token credential
     * @param credential
     */ async saveAccessToken(credential, correlationId) {
        const accessTokenFilter = {
            clientId: credential.clientId,
            credentialType: credential.credentialType,
            environment: credential.environment,
            homeAccountId: credential.homeAccountId,
            realm: credential.realm,
            tokenType: credential.tokenType,
            requestedClaimsHash: credential.requestedClaimsHash
        };
        const tokenKeys = this.getTokenKeys();
        const currentScopes = (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(credential.target);
        const removedAccessTokens = [];
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, accessTokenFilter, false)) return;
            const tokenEntity = this.getAccessTokenCredential(key);
            if (tokenEntity && this.credentialMatchesFilter(tokenEntity, accessTokenFilter)) {
                const tokenScopeSet = (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(tokenEntity.target);
                if (tokenScopeSet.intersectingScopeSets(currentScopes)) removedAccessTokens.push(this.removeAccessToken(key));
            }
        });
        await Promise.all(removedAccessTokens);
        await this.setAccessTokenCredential(credential, correlationId);
    }
    /**
     * Retrieve account entities matching all provided tenant-agnostic filters; if no filter is set, get all account entities in the cache
     * Not checking for casing as keys are all generated in lower case, remember to convert to lower case if object properties are compared
     * @param accountFilter - An object containing Account properties to filter by
     */ getAccountsFilteredBy(accountFilter) {
        const allAccountKeys = this.getAccountKeys();
        const matchingAccounts = [];
        allAccountKeys.forEach((cacheKey)=>{
            if (!this.isAccountKey(cacheKey, accountFilter.homeAccountId)) // Don't parse value if the key doesn't match the account filters
            return;
            const entity = this.getAccount(cacheKey, this.commonLogger);
            // Match base account fields
            if (!entity) return;
            if (!!accountFilter.homeAccountId && !this.matchHomeAccountId(entity, accountFilter.homeAccountId)) return;
            if (!!accountFilter.username && !this.matchUsername(entity.username, accountFilter.username)) return;
            if (!!accountFilter.environment && !this.matchEnvironment(entity, accountFilter.environment)) return;
            if (!!accountFilter.realm && !this.matchRealm(entity, accountFilter.realm)) return;
            if (!!accountFilter.nativeAccountId && !this.matchNativeAccountId(entity, accountFilter.nativeAccountId)) return;
            if (!!accountFilter.authorityType && !this.matchAuthorityType(entity, accountFilter.authorityType)) return;
            // If at least one tenant profile matches the tenant profile filter, add the account to the list of matching accounts
            const tenantProfileFilter = {
                localAccountId: accountFilter?.localAccountId,
                name: accountFilter?.name
            };
            const matchingTenantProfiles = entity.tenantProfiles?.filter((tenantProfile)=>{
                return this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter);
            });
            if (matchingTenantProfiles && matchingTenantProfiles.length === 0) // No tenant profile for this account matches filter, don't add to list of matching accounts
            return;
            matchingAccounts.push(entity);
        });
        return matchingAccounts;
    }
    /**
     * Returns true if the given key matches our account key schema. Also matches homeAccountId and/or tenantId if provided
     * @param key
     * @param homeAccountId
     * @param tenantId
     * @returns
     */ isAccountKey(key, homeAccountId, tenantId) {
        if (key.split((0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).length < 3) // Account cache keys contain 3 items separated by '-' (each item may also contain '-')
        return false;
        if (homeAccountId && !key.toLowerCase().includes(homeAccountId.toLowerCase())) return false;
        if (tenantId && !key.toLowerCase().includes(tenantId.toLowerCase())) return false;
        // Do not check environment as aliasing can cause false negatives
        return true;
    }
    /**
     * Returns true if the given key matches our credential key schema.
     * @param key
     */ isCredentialKey(key) {
        if (key.split((0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).length < 6) // Credential cache keys contain 6 items separated by '-' (each item may also contain '-')
        return false;
        const lowerCaseKey = key.toLowerCase();
        // Credential keys must indicate what credential type they represent
        if (lowerCaseKey.indexOf((0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN.toLowerCase()) === -1 && lowerCaseKey.indexOf((0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN.toLowerCase()) === -1 && lowerCaseKey.indexOf((0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase()) === -1 && lowerCaseKey.indexOf((0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN.toLowerCase()) === -1) return false;
        if (lowerCaseKey.indexOf((0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN.toLowerCase()) > -1) {
            // Refresh tokens must contain the client id or family id
            const clientIdValidation = `${(0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN}${(0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR}${this.clientId}${(0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR}`;
            const familyIdValidation = `${(0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN}${(0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR}${(0, $7c375ae106b964be$export$978fe7ab5e74b539)}${(0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR}`;
            if (lowerCaseKey.indexOf(clientIdValidation.toLowerCase()) === -1 && lowerCaseKey.indexOf(familyIdValidation.toLowerCase()) === -1) return false;
        } else if (lowerCaseKey.indexOf(this.clientId.toLowerCase()) === -1) // Tokens must contain the clientId
        return false;
        return true;
    }
    /**
     * Returns whether or not the given credential entity matches the filter
     * @param entity
     * @param filter
     * @returns
     */ credentialMatchesFilter(entity, filter) {
        if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return false;
        if (!!filter.userAssertionHash && !this.matchUserAssertionHash(entity, filter.userAssertionHash)) return false;
        /*
         * homeAccountId can be undefined, and we want to filter out cached items that have a homeAccountId of ""
         * because we don't want a client_credential request to return a cached token that has a homeAccountId
         */ if (typeof filter.homeAccountId === "string" && !this.matchHomeAccountId(entity, filter.homeAccountId)) return false;
        if (!!filter.environment && !this.matchEnvironment(entity, filter.environment)) return false;
        if (!!filter.realm && !this.matchRealm(entity, filter.realm)) return false;
        if (!!filter.credentialType && !this.matchCredentialType(entity, filter.credentialType)) return false;
        if (!!filter.familyId && !this.matchFamilyId(entity, filter.familyId)) return false;
        /*
         * idTokens do not have "target", target specific refreshTokens do exist for some types of authentication
         * Resource specific refresh tokens case will be added when the support is deemed necessary
         */ if (!!filter.target && !this.matchTarget(entity, filter.target)) return false;
        // If request OR cached entity has requested Claims Hash, check if they match
        if (filter.requestedClaimsHash || entity.requestedClaimsHash) {
            // Don't match if either is undefined or they are different
            if (entity.requestedClaimsHash !== filter.requestedClaimsHash) return false;
        }
        // Access Token with Auth Scheme specific matching
        if (entity.credentialType === (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME) {
            if (!!filter.tokenType && !this.matchTokenType(entity, filter.tokenType)) return false;
            // KeyId (sshKid) in request must match cached SSH certificate keyId because SSH cert is bound to a specific key
            if (filter.tokenType === (0, $7c375ae106b964be$export$901491a717da2ba5).SSH) {
                if (filter.keyId && !this.matchKeyId(entity, filter.keyId)) return false;
            }
        }
        return true;
    }
    /**
     * retrieve appMetadata matching all provided filters; if no filter is set, get all appMetadata
     * @param filter
     */ getAppMetadataFilteredBy(filter) {
        const allCacheKeys = this.getKeys();
        const matchingAppMetadata = {};
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-appMetadata type cache entities
            if (!this.isAppMetadata(cacheKey)) return;
            // Attempt retrieval
            const entity = this.getAppMetadata(cacheKey);
            if (!entity) return;
            if (!!filter.environment && !this.matchEnvironment(entity, filter.environment)) return;
            if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return;
            matchingAppMetadata[cacheKey] = entity;
        });
        return matchingAppMetadata;
    }
    /**
     * retrieve authorityMetadata that contains a matching alias
     * @param filter
     */ getAuthorityMetadataByAlias(host) {
        const allCacheKeys = this.getAuthorityMetadataKeys();
        let matchedEntity = null;
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-authorityMetadata type cache entities
            if (!this.isAuthorityMetadata(cacheKey) || cacheKey.indexOf(this.clientId) === -1) return;
            // Attempt retrieval
            const entity = this.getAuthorityMetadata(cacheKey);
            if (!entity) return;
            if (entity.aliases.indexOf(host) === -1) return;
            matchedEntity = entity;
        });
        return matchedEntity;
    }
    /**
     * Removes all accounts and related tokens from cache.
     */ async removeAllAccounts() {
        const allAccountKeys = this.getAccountKeys();
        const removedAccounts = [];
        allAccountKeys.forEach((cacheKey)=>{
            removedAccounts.push(this.removeAccount(cacheKey));
        });
        await Promise.all(removedAccounts);
    }
    /**
     * Removes the account and related tokens for a given account key
     * @param account
     */ async removeAccount(accountKey) {
        const account = this.getAccount(accountKey, this.commonLogger);
        if (!account) return;
        await this.removeAccountContext(account);
        this.removeItem(accountKey);
    }
    /**
     * Removes credentials associated with the provided account
     * @param account
     */ async removeAccountContext(account) {
        const allTokenKeys = this.getTokenKeys();
        const accountId = account.generateAccountId();
        const removedCredentials = [];
        allTokenKeys.idToken.forEach((key)=>{
            if (key.indexOf(accountId) === 0) this.removeIdToken(key);
        });
        allTokenKeys.accessToken.forEach((key)=>{
            if (key.indexOf(accountId) === 0) removedCredentials.push(this.removeAccessToken(key));
        });
        allTokenKeys.refreshToken.forEach((key)=>{
            if (key.indexOf(accountId) === 0) this.removeRefreshToken(key);
        });
        await Promise.all(removedCredentials);
    }
    /**
     * returns a boolean if the given credential is removed
     * @param credential
     */ async removeAccessToken(key) {
        const credential = this.getAccessTokenCredential(key);
        if (!credential) return;
        // Remove Token Binding Key from key store for PoP Tokens Credentials
        if (credential.credentialType.toLowerCase() === (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase()) {
            if (credential.tokenType === (0, $7c375ae106b964be$export$901491a717da2ba5).POP) {
                const accessTokenWithAuthSchemeEntity = credential;
                const kid = accessTokenWithAuthSchemeEntity.keyId;
                if (kid) try {
                    await this.cryptoImpl.removeTokenBindingKey(kid);
                } catch (error) {
                    throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$5765db5d84418d29));
                }
            }
        }
        return this.removeItem(key);
    }
    /**
     * Removes all app metadata objects from cache.
     */ removeAppMetadata() {
        const allCacheKeys = this.getKeys();
        allCacheKeys.forEach((cacheKey)=>{
            if (this.isAppMetadata(cacheKey)) this.removeItem(cacheKey);
        });
        return true;
    }
    /**
     * Retrieve AccountEntity from cache
     * @param account
     */ readAccountFromCache(account) {
        const accountKey = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).generateAccountCacheKey(account);
        return this.getAccount(accountKey, this.commonLogger);
    }
    /**
     * Retrieve IdTokenEntity from cache
     * @param account {AccountInfo}
     * @param tokenKeys {?TokenKeys}
     * @param targetRealm {?string}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getIdToken(account, tokenKeys, targetRealm, performanceClient, correlationId) {
        this.commonLogger.trace("CacheManager - getIdToken called");
        const idTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN,
            clientId: this.clientId,
            realm: targetRealm
        };
        const idTokenMap = this.getIdTokensByFilter(idTokenFilter, tokenKeys);
        const numIdTokens = idTokenMap.size;
        if (numIdTokens < 1) {
            this.commonLogger.info("CacheManager:getIdToken - No token found");
            return null;
        } else if (numIdTokens > 1) {
            let tokensToBeRemoved = idTokenMap;
            // Multiple tenant profiles and no tenant specified, pick home account
            if (!targetRealm) {
                const homeIdTokenMap = new Map();
                idTokenMap.forEach((idToken, key)=>{
                    if (idToken.realm === account.tenantId) homeIdTokenMap.set(key, idToken);
                });
                const numHomeIdTokens = homeIdTokenMap.size;
                if (numHomeIdTokens < 1) {
                    this.commonLogger.info("CacheManager:getIdToken - Multiple ID tokens found for account but none match account entity tenant id, returning first result");
                    return idTokenMap.values().next().value;
                } else if (numHomeIdTokens === 1) {
                    this.commonLogger.info("CacheManager:getIdToken - Multiple ID tokens found for account, defaulting to home tenant profile");
                    return homeIdTokenMap.values().next().value;
                } else // Multiple ID tokens for home tenant profile, remove all and return null
                tokensToBeRemoved = homeIdTokenMap;
            }
            // Multiple tokens for a single tenant profile, remove all and return null
            this.commonLogger.info("CacheManager:getIdToken - Multiple matching ID tokens found, clearing them");
            tokensToBeRemoved.forEach((idToken, key)=>{
                this.removeIdToken(key);
            });
            if (performanceClient && correlationId) performanceClient.addFields({
                multiMatchedID: idTokenMap.size
            }, correlationId);
            return null;
        }
        this.commonLogger.info("CacheManager:getIdToken - Returning ID token");
        return idTokenMap.values().next().value;
    }
    /**
     * Gets all idTokens matching the given filter
     * @param filter
     * @returns
     */ getIdTokensByFilter(filter, tokenKeys) {
        const idTokenKeys = tokenKeys && tokenKeys.idToken || this.getTokenKeys().idToken;
        const idTokens = new Map();
        idTokenKeys.forEach((key)=>{
            if (!this.idTokenKeyMatchesFilter(key, {
                clientId: this.clientId,
                ...filter
            })) return;
            const idToken = this.getIdTokenCredential(key);
            if (idToken && this.credentialMatchesFilter(idToken, filter)) idTokens.set(key, idToken);
        });
        return idTokens;
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @returns
     */ idTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Removes idToken from the cache
     * @param key
     */ removeIdToken(key) {
        this.removeItem(key);
    }
    /**
     * Removes refresh token from the cache
     * @param key
     */ removeRefreshToken(key) {
        this.removeItem(key);
    }
    /**
     * Retrieve AccessTokenEntity from cache
     * @param account {AccountInfo}
     * @param request {BaseAuthRequest}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getAccessToken(account, request, tokenKeys, targetRealm, performanceClient, correlationId) {
        this.commonLogger.trace("CacheManager - getAccessToken called");
        const scopes = (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).createSearchScopes(request.scopes);
        const authScheme = request.authenticationScheme || (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER;
        /*
         * Distinguish between Bearer and PoP/SSH token cache types
         * Cast to lowercase to handle "bearer" from ADFS
         */ const credentialType = authScheme && authScheme.toLowerCase() !== (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER.toLowerCase() ? (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME : (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN;
        const accessTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: credentialType,
            clientId: this.clientId,
            realm: targetRealm || account.tenantId,
            target: scopes,
            tokenType: authScheme,
            keyId: request.sshKid,
            requestedClaimsHash: request.requestedClaimsHash
        };
        const accessTokenKeys = tokenKeys && tokenKeys.accessToken || this.getTokenKeys().accessToken;
        const accessTokens = [];
        accessTokenKeys.forEach((key)=>{
            // Validate key
            if (this.accessTokenKeyMatchesFilter(key, accessTokenFilter, true)) {
                const accessToken = this.getAccessTokenCredential(key);
                // Validate value
                if (accessToken && this.credentialMatchesFilter(accessToken, accessTokenFilter)) accessTokens.push(accessToken);
            }
        });
        const numAccessTokens = accessTokens.length;
        if (numAccessTokens < 1) {
            this.commonLogger.info("CacheManager:getAccessToken - No token found");
            return null;
        } else if (numAccessTokens > 1) {
            this.commonLogger.info("CacheManager:getAccessToken - Multiple access tokens found, clearing them");
            accessTokens.forEach((accessToken)=>{
                this.removeAccessToken((0, $9ab3d26df56b176d$export$1aaa1362083ec7a3)(accessToken));
            });
            if (performanceClient && correlationId) performanceClient.addFields({
                multiMatchedAT: accessTokens.length
            }, correlationId);
            return null;
        }
        this.commonLogger.info("CacheManager:getAccessToken - Returning access token");
        return accessTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @param keyMustContainAllScopes
     * @returns
     */ accessTokenKeyMatchesFilter(inputKey, filter, keyMustContainAllScopes) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        if (filter.realm && key.indexOf(filter.realm.toLowerCase()) === -1) return false;
        if (filter.requestedClaimsHash && key.indexOf(filter.requestedClaimsHash.toLowerCase()) === -1) return false;
        if (filter.target) {
            const scopes = filter.target.asArray();
            for(let i = 0; i < scopes.length; i++){
                if (keyMustContainAllScopes && !key.includes(scopes[i].toLowerCase())) // When performing a cache lookup a missing scope would be a cache miss
                return false;
                else if (!keyMustContainAllScopes && key.includes(scopes[i].toLowerCase())) // When performing a cache write, any token with a subset of requested scopes should be replaced
                return true;
            }
        }
        return true;
    }
    /**
     * Gets all access tokens matching the filter
     * @param filter
     * @returns
     */ getAccessTokensByFilter(filter) {
        const tokenKeys = this.getTokenKeys();
        const accessTokens = [];
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, filter, true)) return;
            const accessToken = this.getAccessTokenCredential(key);
            if (accessToken && this.credentialMatchesFilter(accessToken, filter)) accessTokens.push(accessToken);
        });
        return accessTokens;
    }
    /**
     * Helper to retrieve the appropriate refresh token from cache
     * @param account {AccountInfo}
     * @param familyRT {boolean}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getRefreshToken(account, familyRT, tokenKeys, performanceClient, correlationId) {
        this.commonLogger.trace("CacheManager - getRefreshToken called");
        const id = familyRT ? (0, $7c375ae106b964be$export$978fe7ab5e74b539) : undefined;
        const refreshTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN,
            clientId: this.clientId,
            familyId: id
        };
        const refreshTokenKeys = tokenKeys && tokenKeys.refreshToken || this.getTokenKeys().refreshToken;
        const refreshTokens = [];
        refreshTokenKeys.forEach((key)=>{
            // Validate key
            if (this.refreshTokenKeyMatchesFilter(key, refreshTokenFilter)) {
                const refreshToken = this.getRefreshTokenCredential(key);
                // Validate value
                if (refreshToken && this.credentialMatchesFilter(refreshToken, refreshTokenFilter)) refreshTokens.push(refreshToken);
            }
        });
        const numRefreshTokens = refreshTokens.length;
        if (numRefreshTokens < 1) {
            this.commonLogger.info("CacheManager:getRefreshToken - No refresh token found.");
            return null;
        }
        // address the else case after remove functions address environment aliases
        if (numRefreshTokens > 1 && performanceClient && correlationId) performanceClient.addFields({
            multiMatchedRT: numRefreshTokens
        }, correlationId);
        this.commonLogger.info("CacheManager:getRefreshToken - returning refresh token");
        return refreshTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     */ refreshTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.familyId && key.indexOf(filter.familyId.toLowerCase()) === -1) return false;
        // If familyId is used, clientId is not in the key
        if (!filter.familyId && filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Retrieve AppMetadataEntity from cache
     */ readAppMetadataFromCache(environment) {
        const appMetadataFilter = {
            environment: environment,
            clientId: this.clientId
        };
        const appMetadata = this.getAppMetadataFilteredBy(appMetadataFilter);
        const appMetadataEntries = Object.keys(appMetadata).map((key)=>appMetadata[key]);
        const numAppMetadata = appMetadataEntries.length;
        if (numAppMetadata < 1) return null;
        else if (numAppMetadata > 1) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$575bb2924bcd0084));
        return appMetadataEntries[0];
    }
    /**
     * Return the family_id value associated  with FOCI
     * @param environment
     * @param clientId
     */ isAppMetadataFOCI(environment) {
        const appMetadata = this.readAppMetadataFromCache(environment);
        return !!(appMetadata && appMetadata.familyId === (0, $7c375ae106b964be$export$978fe7ab5e74b539));
    }
    /**
     * helper to match account ids
     * @param value
     * @param homeAccountId
     */ matchHomeAccountId(entity, homeAccountId) {
        return !!(typeof entity.homeAccountId === "string" && homeAccountId === entity.homeAccountId);
    }
    /**
     * helper to match account ids
     * @param entity
     * @param localAccountId
     * @returns
     */ matchLocalAccountIdFromTokenClaims(tokenClaims, localAccountId) {
        const idTokenLocalAccountId = tokenClaims.oid || tokenClaims.sub;
        return localAccountId === idTokenLocalAccountId;
    }
    matchLocalAccountIdFromTenantProfile(tenantProfile, localAccountId) {
        return tenantProfile.localAccountId === localAccountId;
    }
    /**
     * helper to match names
     * @param entity
     * @param name
     * @returns true if the downcased name properties are present and match in the filter and the entity
     */ matchName(claims, name) {
        return !!(name.toLowerCase() === claims.name?.toLowerCase());
    }
    /**
     * helper to match usernames
     * @param entity
     * @param username
     * @returns
     */ matchUsername(cachedUsername, filterUsername) {
        return !!(cachedUsername && typeof cachedUsername === "string" && filterUsername?.toLowerCase() === cachedUsername.toLowerCase());
    }
    /**
     * helper to match assertion
     * @param value
     * @param oboAssertion
     */ matchUserAssertionHash(entity, userAssertionHash) {
        return !!(entity.userAssertionHash && userAssertionHash === entity.userAssertionHash);
    }
    /**
     * helper to match environment
     * @param value
     * @param environment
     */ matchEnvironment(entity, environment) {
        // Check static authority options first for cases where authority metadata has not been resolved and cached yet
        if (this.staticAuthorityOptions) {
            const staticAliases = (0, $ff4bd32e3511744b$export$2c21adf4b4d4efc0)(this.staticAuthorityOptions, this.commonLogger);
            if (staticAliases.includes(environment) && staticAliases.includes(entity.environment)) return true;
        }
        // Query metadata cache if no static authority configuration has aliases that match enviroment
        const cloudMetadata = this.getAuthorityMetadataByAlias(environment);
        if (cloudMetadata && cloudMetadata.aliases.indexOf(entity.environment) > -1) return true;
        return false;
    }
    /**
     * helper to match credential type
     * @param entity
     * @param credentialType
     */ matchCredentialType(entity, credentialType) {
        return entity.credentialType && credentialType.toLowerCase() === entity.credentialType.toLowerCase();
    }
    /**
     * helper to match client ids
     * @param entity
     * @param clientId
     */ matchClientId(entity, clientId) {
        return !!(entity.clientId && clientId === entity.clientId);
    }
    /**
     * helper to match family ids
     * @param entity
     * @param familyId
     */ matchFamilyId(entity, familyId) {
        return !!(entity.familyId && familyId === entity.familyId);
    }
    /**
     * helper to match realm
     * @param entity
     * @param realm
     */ matchRealm(entity, realm) {
        return !!(entity.realm?.toLowerCase() === realm.toLowerCase());
    }
    /**
     * helper to match nativeAccountId
     * @param entity
     * @param nativeAccountId
     * @returns boolean indicating the match result
     */ matchNativeAccountId(entity, nativeAccountId) {
        return !!(entity.nativeAccountId && nativeAccountId === entity.nativeAccountId);
    }
    /**
     * helper to match loginHint which can be either:
     * 1. login_hint ID token claim
     * 2. username in cached account object
     * 3. upn in ID token claims
     * @param entity
     * @param loginHint
     * @returns
     */ matchLoginHintFromTokenClaims(tokenClaims, loginHint) {
        if (tokenClaims.login_hint === loginHint) return true;
        if (tokenClaims.preferred_username === loginHint) return true;
        if (tokenClaims.upn === loginHint) return true;
        return false;
    }
    /**
     * Helper to match sid
     * @param entity
     * @param sid
     * @returns true if the sid claim is present and matches the filter
     */ matchSid(idTokenClaims, sid) {
        return idTokenClaims.sid === sid;
    }
    matchAuthorityType(entity, authorityType) {
        return !!(entity.authorityType && authorityType.toLowerCase() === entity.authorityType.toLowerCase());
    }
    /**
     * Returns true if the target scopes are a subset of the current entity's scopes, false otherwise.
     * @param entity
     * @param target
     */ matchTarget(entity, target) {
        const isNotAccessTokenCredential = entity.credentialType !== (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN && entity.credentialType !== (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME;
        if (isNotAccessTokenCredential || !entity.target) return false;
        const entityScopeSet = (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(entity.target);
        return entityScopeSet.containsScopeSet(target);
    }
    /**
     * Returns true if the credential's tokenType or Authentication Scheme matches the one in the request, false otherwise
     * @param entity
     * @param tokenType
     */ matchTokenType(entity, tokenType) {
        return !!(entity.tokenType && entity.tokenType === tokenType);
    }
    /**
     * Returns true if the credential's keyId matches the one in the request, false otherwise
     * @param entity
     * @param keyId
     */ matchKeyId(entity, keyId) {
        return !!(entity.keyId && entity.keyId === keyId);
    }
    /**
     * returns if a given cache entity is of the type appmetadata
     * @param key
     */ isAppMetadata(key) {
        return key.indexOf((0, $7c375ae106b964be$export$7e1bea6dc1b6b32e)) !== -1;
    }
    /**
     * returns if a given cache entity is of the type authoritymetadata
     * @param key
     */ isAuthorityMetadata(key) {
        return key.indexOf((0, $7c375ae106b964be$export$d483f966e66f4db5).CACHE_KEY) !== -1;
    }
    /**
     * returns cache key used for cloud instance metadata
     */ generateAuthorityMetadataCacheKey(authority) {
        return `${(0, $7c375ae106b964be$export$d483f966e66f4db5).CACHE_KEY}-${this.clientId}-${authority}`;
    }
    /**
     * Helper to convert serialized data to object
     * @param obj
     * @param json
     */ static toObject(obj, json) {
        for(const propertyName in json)obj[propertyName] = json[propertyName];
        return obj;
    }
}
/** @internal */ class $0c353f04031c78df$export$b7254d304b3004b6 extends $0c353f04031c78df$export$996e3ea69314b5c6 {
    async setAccount() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getAccount() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    async setIdTokenCredential() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getIdTokenCredential() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    async setAccessTokenCredential() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getAccessTokenCredential() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    async setRefreshTokenCredential() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getRefreshTokenCredential() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    setAppMetadata() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getAppMetadata() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    setServerTelemetry() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getServerTelemetry() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    setAuthorityMetadata() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getAuthorityMetadata() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getAuthorityMetadataKeys() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    setThrottlingCache() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getThrottlingCache() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    removeItem() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getKeys() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getAccountKeys() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getTokenKeys() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $d21eb39178ebb5ae$export$f7a7dd6bfc156d75 = {
    tokenRenewalOffsetSeconds: (0, $7c375ae106b964be$export$8d50f42618161d1a),
    preventCorsPreflight: false
};
const $d21eb39178ebb5ae$var$DEFAULT_LOGGER_IMPLEMENTATION = {
    loggerCallback: ()=>{
    // allow users to not set loggerCallback
    },
    piiLoggingEnabled: false,
    logLevel: (0, $0bf1d54ef751a29c$export$243e62d78d3b544d).Info,
    correlationId: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
};
const $d21eb39178ebb5ae$var$DEFAULT_CACHE_OPTIONS = {
    claimsBasedCachingEnabled: false
};
const $d21eb39178ebb5ae$var$DEFAULT_NETWORK_IMPLEMENTATION = {
    async sendGetRequestAsync () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    async sendPostRequestAsync () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
};
const $d21eb39178ebb5ae$var$DEFAULT_LIBRARY_INFO = {
    sku: (0, $7c375ae106b964be$export$a002182e51710d39).SKU,
    version: (0, $4c1e49235f95193e$export$83d89fbfd8236492),
    cpu: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
    os: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
};
const $d21eb39178ebb5ae$var$DEFAULT_CLIENT_CREDENTIALS = {
    clientSecret: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
    clientAssertion: undefined
};
const $d21eb39178ebb5ae$var$DEFAULT_AZURE_CLOUD_OPTIONS = {
    azureCloudInstance: (0, $399fa9610e7cb0fb$export$4cda21933050d9ec).None,
    tenant: `${(0, $7c375ae106b964be$export$a002182e51710d39).DEFAULT_COMMON_TENANT}`
};
const $d21eb39178ebb5ae$var$DEFAULT_TELEMETRY_OPTIONS = {
    application: {
        appName: "",
        appVersion: ""
    }
};
/**
 * Function that sets the default options when not explicitly configured from app developer
 *
 * @param Configuration
 *
 * @returns Configuration
 */ function $d21eb39178ebb5ae$export$57a091701dcdabb2({ authOptions: userAuthOptions, systemOptions: userSystemOptions, loggerOptions: userLoggerOption, cacheOptions: userCacheOptions, storageInterface: storageImplementation, networkInterface: networkImplementation, cryptoInterface: cryptoImplementation, clientCredentials: clientCredentials, libraryInfo: libraryInfo, telemetry: telemetry, serverTelemetryManager: serverTelemetryManager, persistencePlugin: persistencePlugin, serializableCache: serializableCache }) {
    const loggerOptions = {
        ...$d21eb39178ebb5ae$var$DEFAULT_LOGGER_IMPLEMENTATION,
        ...userLoggerOption
    };
    return {
        authOptions: $d21eb39178ebb5ae$var$buildAuthOptions(userAuthOptions),
        systemOptions: {
            ...$d21eb39178ebb5ae$export$f7a7dd6bfc156d75,
            ...userSystemOptions
        },
        loggerOptions: loggerOptions,
        cacheOptions: {
            ...$d21eb39178ebb5ae$var$DEFAULT_CACHE_OPTIONS,
            ...userCacheOptions
        },
        storageInterface: storageImplementation || new (0, $0c353f04031c78df$export$b7254d304b3004b6)(userAuthOptions.clientId, (0, $dd88ab1a0b4d3851$export$865f57d401606752), new (0, $0bf1d54ef751a29c$export$efa9a398d6368992)(loggerOptions)),
        networkInterface: networkImplementation || $d21eb39178ebb5ae$var$DEFAULT_NETWORK_IMPLEMENTATION,
        cryptoInterface: cryptoImplementation || (0, $dd88ab1a0b4d3851$export$865f57d401606752),
        clientCredentials: clientCredentials || $d21eb39178ebb5ae$var$DEFAULT_CLIENT_CREDENTIALS,
        libraryInfo: {
            ...$d21eb39178ebb5ae$var$DEFAULT_LIBRARY_INFO,
            ...libraryInfo
        },
        telemetry: {
            ...$d21eb39178ebb5ae$var$DEFAULT_TELEMETRY_OPTIONS,
            ...telemetry
        },
        serverTelemetryManager: serverTelemetryManager || null,
        persistencePlugin: persistencePlugin || null,
        serializableCache: serializableCache || null
    };
}
/**
 * Construct authoptions from the client and platform passed values
 * @param authOptions
 */ function $d21eb39178ebb5ae$var$buildAuthOptions(authOptions) {
    return {
        clientCapabilities: [],
        azureCloudOptions: $d21eb39178ebb5ae$var$DEFAULT_AZURE_CLOUD_OPTIONS,
        skipAuthorityMetadataCache: false,
        instanceAware: false,
        encodeExtraQueryParams: false,
        ...authOptions
    };
}
/**
 * Returns true if config has protocolMode set to ProtocolMode.OIDC, false otherwise
 * @param ClientConfiguration
 */ function $d21eb39178ebb5ae$export$25afa7198c2ed9b9(config) {
    return config.authOptions.authority.options.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC;
}

/*! @azure/msal-common v15.7.0 2025-05-30 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $04922ae8364b32fe$export$6d95060a8ed7155a = {
    sendGetRequestAsync: ()=>{
        return Promise.reject((0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22)));
    },
    sendPostRequestAsync: ()=>{
        return Promise.reject((0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22)));
    }
};

/*! @azure/msal-common v15.7.0 2025-05-30 */ /*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Enumeration of operations that are instrumented by have their performance measured by the PerformanceClient.
 *
 * @export
 * @enum {number}
 */ const $80a5304d92c187bf$export$2f2811a3e1b21823 = {
    /**
     * acquireTokenByCode API (msal-browser and msal-node).
     * Used to acquire tokens by trading an authorization code against the token endpoint.
     */ AcquireTokenByCode: "acquireTokenByCode",
    /**
     * acquireTokenByRefreshToken API (msal-browser and msal-node).
     * Used to renew an access token using a refresh token against the token endpoint.
     */ AcquireTokenByRefreshToken: "acquireTokenByRefreshToken",
    /**
     * acquireTokenSilent API (msal-browser and msal-node).
     * Used to silently acquire a new access token (from the cache or the network).
     */ AcquireTokenSilent: "acquireTokenSilent",
    /**
     * acquireTokenSilentAsync (msal-browser).
     * Internal API for acquireTokenSilent.
     */ AcquireTokenSilentAsync: "acquireTokenSilentAsync",
    /**
     * acquireTokenPopup (msal-browser).
     * Used to acquire a new access token interactively through pop ups
     */ AcquireTokenPopup: "acquireTokenPopup",
    /**
     * acquireTokenPreRedirect (msal-browser).
     * First part of the redirect flow.
     * Used to acquire a new access token interactively through redirects.
     */ AcquireTokenPreRedirect: "acquireTokenPreRedirect",
    /**
     * acquireTokenRedirect (msal-browser).
     * Second part of the redirect flow.
     * Used to acquire a new access token interactively through redirects.
     */ AcquireTokenRedirect: "acquireTokenRedirect",
    /**
     * getPublicKeyThumbprint API in CryptoOpts class (msal-browser).
     * Used to generate a public/private keypair and generate a public key thumbprint for pop requests.
     */ CryptoOptsGetPublicKeyThumbprint: "cryptoOptsGetPublicKeyThumbprint",
    /**
     * signJwt API in CryptoOpts class (msal-browser).
     * Used to signed a pop token.
     */ CryptoOptsSignJwt: "cryptoOptsSignJwt",
    /**
     * acquireToken API in the SilentCacheClient class (msal-browser).
     * Used to read access tokens from the cache.
     */ SilentCacheClientAcquireToken: "silentCacheClientAcquireToken",
    /**
     * acquireToken API in the SilentIframeClient class (msal-browser).
     * Used to acquire a new set of tokens from the authorize endpoint in a hidden iframe.
     */ SilentIframeClientAcquireToken: "silentIframeClientAcquireToken",
    AwaitConcurrentIframe: "awaitConcurrentIframe",
    /**
     * acquireToken API in SilentRereshClient (msal-browser).
     * Used to acquire a new set of tokens from the token endpoint using a refresh token.
     */ SilentRefreshClientAcquireToken: "silentRefreshClientAcquireToken",
    /**
     * ssoSilent API (msal-browser).
     * Used to silently acquire an authorization code and set of tokens using a hidden iframe.
     */ SsoSilent: "ssoSilent",
    /**
     * getDiscoveredAuthority API in StandardInteractionClient class (msal-browser).
     * Used to load authority metadata for a request.
     */ StandardInteractionClientGetDiscoveredAuthority: "standardInteractionClientGetDiscoveredAuthority",
    /**
     * acquireToken APIs in msal-browser.
     * Used to make an /authorize endpoint call with native brokering enabled.
     */ FetchAccountIdWithNativeBroker: "fetchAccountIdWithNativeBroker",
    /**
     * acquireToken API in NativeInteractionClient class (msal-browser).
     * Used to acquire a token from Native component when native brokering is enabled.
     */ NativeInteractionClientAcquireToken: "nativeInteractionClientAcquireToken",
    /**
     * Time spent creating default headers for requests to token endpoint
     */ BaseClientCreateTokenRequestHeaders: "baseClientCreateTokenRequestHeaders",
    /**
     * Time spent sending/waiting for the response of a request to the token endpoint
     */ NetworkClientSendPostRequestAsync: "networkClientSendPostRequestAsync",
    RefreshTokenClientExecutePostToTokenEndpoint: "refreshTokenClientExecutePostToTokenEndpoint",
    AuthorizationCodeClientExecutePostToTokenEndpoint: "authorizationCodeClientExecutePostToTokenEndpoint",
    /**
     * Used to measure the time taken for completing embedded-broker handshake (PW-Broker).
     */ BrokerHandhshake: "brokerHandshake",
    /**
     * acquireTokenByRefreshToken API in BrokerClientApplication (PW-Broker) .
     */ AcquireTokenByRefreshTokenInBroker: "acquireTokenByRefreshTokenInBroker",
    /**
     * Time taken for token acquisition by broker
     */ AcquireTokenByBroker: "acquireTokenByBroker",
    /**
     * Time spent on the network for refresh token acquisition
     */ RefreshTokenClientExecuteTokenRequest: "refreshTokenClientExecuteTokenRequest",
    /**
     * Time taken for acquiring refresh token , records RT size
     */ RefreshTokenClientAcquireToken: "refreshTokenClientAcquireToken",
    /**
     * Time taken for acquiring cached refresh token
     */ RefreshTokenClientAcquireTokenWithCachedRefreshToken: "refreshTokenClientAcquireTokenWithCachedRefreshToken",
    /**
     * acquireTokenByRefreshToken API in RefreshTokenClient (msal-common).
     */ RefreshTokenClientAcquireTokenByRefreshToken: "refreshTokenClientAcquireTokenByRefreshToken",
    /**
     * Helper function to create token request body in RefreshTokenClient (msal-common).
     */ RefreshTokenClientCreateTokenRequestBody: "refreshTokenClientCreateTokenRequestBody",
    /**
     * acquireTokenFromCache (msal-browser).
     * Internal API for acquiring token from cache
     */ AcquireTokenFromCache: "acquireTokenFromCache",
    SilentFlowClientAcquireCachedToken: "silentFlowClientAcquireCachedToken",
    SilentFlowClientGenerateResultFromCacheRecord: "silentFlowClientGenerateResultFromCacheRecord",
    /**
     * acquireTokenBySilentIframe (msal-browser).
     * Internal API for acquiring token by silent Iframe
     */ AcquireTokenBySilentIframe: "acquireTokenBySilentIframe",
    /**
     * Internal API for initializing base request in BaseInteractionClient (msal-browser)
     */ InitializeBaseRequest: "initializeBaseRequest",
    /**
     * Internal API for initializing silent request in SilentCacheClient (msal-browser)
     */ InitializeSilentRequest: "initializeSilentRequest",
    InitializeClientApplication: "initializeClientApplication",
    InitializeCache: "initializeCache",
    /**
     * Helper function in SilentIframeClient class (msal-browser).
     */ SilentIframeClientTokenHelper: "silentIframeClientTokenHelper",
    /**
     * SilentHandler
     */ SilentHandlerInitiateAuthRequest: "silentHandlerInitiateAuthRequest",
    SilentHandlerMonitorIframeForHash: "silentHandlerMonitorIframeForHash",
    SilentHandlerLoadFrame: "silentHandlerLoadFrame",
    SilentHandlerLoadFrameSync: "silentHandlerLoadFrameSync",
    /**
     * Helper functions in StandardInteractionClient class (msal-browser)
     */ StandardInteractionClientCreateAuthCodeClient: "standardInteractionClientCreateAuthCodeClient",
    StandardInteractionClientGetClientConfiguration: "standardInteractionClientGetClientConfiguration",
    StandardInteractionClientInitializeAuthorizationRequest: "standardInteractionClientInitializeAuthorizationRequest",
    /**
     * getAuthCodeUrl API (msal-browser and msal-node).
     */ GetAuthCodeUrl: "getAuthCodeUrl",
    GetStandardParams: "getStandardParams",
    /**
     * Functions from InteractionHandler (msal-browser)
     */ HandleCodeResponseFromServer: "handleCodeResponseFromServer",
    HandleCodeResponse: "handleCodeResponse",
    HandleResponseEar: "handleResponseEar",
    HandleResponsePlatformBroker: "handleResponsePlatformBroker",
    HandleResponseCode: "handleResponseCode",
    UpdateTokenEndpointAuthority: "updateTokenEndpointAuthority",
    /**
     * APIs in Authorization Code Client (msal-common)
     */ AuthClientAcquireToken: "authClientAcquireToken",
    AuthClientExecuteTokenRequest: "authClientExecuteTokenRequest",
    AuthClientCreateTokenRequestBody: "authClientCreateTokenRequestBody",
    /**
     * Generate functions in PopTokenGenerator (msal-common)
     */ PopTokenGenerateCnf: "popTokenGenerateCnf",
    PopTokenGenerateKid: "popTokenGenerateKid",
    /**
     * handleServerTokenResponse API in ResponseHandler (msal-common)
     */ HandleServerTokenResponse: "handleServerTokenResponse",
    DeserializeResponse: "deserializeResponse",
    /**
     * Authority functions
     */ AuthorityFactoryCreateDiscoveredInstance: "authorityFactoryCreateDiscoveredInstance",
    AuthorityResolveEndpointsAsync: "authorityResolveEndpointsAsync",
    AuthorityResolveEndpointsFromLocalSources: "authorityResolveEndpointsFromLocalSources",
    AuthorityGetCloudDiscoveryMetadataFromNetwork: "authorityGetCloudDiscoveryMetadataFromNetwork",
    AuthorityUpdateCloudDiscoveryMetadata: "authorityUpdateCloudDiscoveryMetadata",
    AuthorityGetEndpointMetadataFromNetwork: "authorityGetEndpointMetadataFromNetwork",
    AuthorityUpdateEndpointMetadata: "authorityUpdateEndpointMetadata",
    AuthorityUpdateMetadataWithRegionalInformation: "authorityUpdateMetadataWithRegionalInformation",
    /**
     * Region Discovery functions
     */ RegionDiscoveryDetectRegion: "regionDiscoveryDetectRegion",
    RegionDiscoveryGetRegionFromIMDS: "regionDiscoveryGetRegionFromIMDS",
    RegionDiscoveryGetCurrentVersion: "regionDiscoveryGetCurrentVersion",
    AcquireTokenByCodeAsync: "acquireTokenByCodeAsync",
    GetEndpointMetadataFromNetwork: "getEndpointMetadataFromNetwork",
    GetCloudDiscoveryMetadataFromNetworkMeasurement: "getCloudDiscoveryMetadataFromNetworkMeasurement",
    HandleRedirectPromiseMeasurement: "handleRedirectPromise",
    HandleNativeRedirectPromiseMeasurement: "handleNativeRedirectPromise",
    UpdateCloudDiscoveryMetadataMeasurement: "updateCloudDiscoveryMetadataMeasurement",
    UsernamePasswordClientAcquireToken: "usernamePasswordClientAcquireToken",
    NativeMessageHandlerHandshake: "nativeMessageHandlerHandshake",
    NativeGenerateAuthResult: "nativeGenerateAuthResult",
    RemoveHiddenIframe: "removeHiddenIframe",
    /**
     * Cache operations
     */ ClearTokensAndKeysWithClaims: "clearTokensAndKeysWithClaims",
    CacheManagerGetRefreshToken: "cacheManagerGetRefreshToken",
    ImportExistingCache: "importExistingCache",
    SetUserData: "setUserData",
    LocalStorageUpdated: "localStorageUpdated",
    /**
     * Crypto Operations
     */ GeneratePkceCodes: "generatePkceCodes",
    GenerateCodeVerifier: "generateCodeVerifier",
    GenerateCodeChallengeFromVerifier: "generateCodeChallengeFromVerifier",
    Sha256Digest: "sha256Digest",
    GetRandomValues: "getRandomValues",
    GenerateHKDF: "generateHKDF",
    GenerateBaseKey: "generateBaseKey",
    Base64Decode: "base64Decode",
    UrlEncodeArr: "urlEncodeArr",
    Encrypt: "encrypt",
    Decrypt: "decrypt",
    GenerateEarKey: "generateEarKey",
    DecryptEarResponse: "decryptEarResponse"
};
const $80a5304d92c187bf$export$8dc198b6eb7c4c72 = new Map([
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenByCode,
        "ATByCode"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenByRefreshToken,
        "ATByRT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenSilent,
        "ATS"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenSilentAsync,
        "ATSAsync"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenPopup,
        "ATPopup"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenRedirect,
        "ATRedirect"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.CryptoOptsGetPublicKeyThumbprint,
        "CryptoGetPKThumb"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.CryptoOptsSignJwt,
        "CryptoSignJwt"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentCacheClientAcquireToken,
        "SltCacheClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentIframeClientAcquireToken,
        "SltIframeClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentRefreshClientAcquireToken,
        "SltRClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SsoSilent,
        "SsoSlt"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.StandardInteractionClientGetDiscoveredAuthority,
        "StdIntClientGetDiscAuth"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.FetchAccountIdWithNativeBroker,
        "FetchAccIdWithNtvBroker"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.NativeInteractionClientAcquireToken,
        "NtvIntClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.BaseClientCreateTokenRequestHeaders,
        "BaseClientCreateTReqHead"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.NetworkClientSendPostRequestAsync,
        "NetClientSendPost"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RefreshTokenClientExecutePostToTokenEndpoint,
        "RTClientExecPost"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorizationCodeClientExecutePostToTokenEndpoint,
        "AuthCodeClientExecPost"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.BrokerHandhshake,
        "BrokerHandshake"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenByRefreshTokenInBroker,
        "ATByRTInBroker"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenByBroker,
        "ATByBroker"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RefreshTokenClientExecuteTokenRequest,
        "RTClientExecTReq"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RefreshTokenClientAcquireToken,
        "RTClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RefreshTokenClientAcquireTokenWithCachedRefreshToken,
        "RTClientATWithCachedRT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RefreshTokenClientAcquireTokenByRefreshToken,
        "RTClientATByRT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RefreshTokenClientCreateTokenRequestBody,
        "RTClientCreateTReqBody"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenFromCache,
        "ATFromCache"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentFlowClientAcquireCachedToken,
        "SltFlowClientATCached"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentFlowClientGenerateResultFromCacheRecord,
        "SltFlowClientGenResFromCache"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenBySilentIframe,
        "ATBySltIframe"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.InitializeBaseRequest,
        "InitBaseReq"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.InitializeSilentRequest,
        "InitSltReq"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.InitializeClientApplication,
        "InitClientApplication"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.InitializeCache,
        "InitCache"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.ImportExistingCache,
        "importCache"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SetUserData,
        "setUserData"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.LocalStorageUpdated,
        "localStorageUpdated"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentIframeClientTokenHelper,
        "SIClientTHelper"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentHandlerInitiateAuthRequest,
        "SHandlerInitAuthReq"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentHandlerMonitorIframeForHash,
        "SltHandlerMonitorIframeForHash"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentHandlerLoadFrame,
        "SHandlerLoadFrame"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentHandlerLoadFrameSync,
        "SHandlerLoadFrameSync"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.StandardInteractionClientCreateAuthCodeClient,
        "StdIntClientCreateAuthCodeClient"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.StandardInteractionClientGetClientConfiguration,
        "StdIntClientGetClientConf"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.StandardInteractionClientInitializeAuthorizationRequest,
        "StdIntClientInitAuthReq"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GetAuthCodeUrl,
        "GetAuthCodeUrl"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleCodeResponseFromServer,
        "HandleCodeResFromServer"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleCodeResponse,
        "HandleCodeResp"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleResponseEar,
        "HandleRespEar"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleResponseCode,
        "HandleRespCode"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleResponsePlatformBroker,
        "HandleRespPlatBroker"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.UpdateTokenEndpointAuthority,
        "UpdTEndpointAuth"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthClientAcquireToken,
        "AuthClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthClientExecuteTokenRequest,
        "AuthClientExecTReq"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthClientCreateTokenRequestBody,
        "AuthClientCreateTReqBody"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.PopTokenGenerateCnf,
        "PopTGenCnf"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.PopTokenGenerateKid,
        "PopTGenKid"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleServerTokenResponse,
        "HandleServerTRes"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.DeserializeResponse,
        "DeserializeRes"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityFactoryCreateDiscoveredInstance,
        "AuthFactCreateDiscInst"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityResolveEndpointsAsync,
        "AuthResolveEndpointsAsync"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityResolveEndpointsFromLocalSources,
        "AuthResolveEndpointsFromLocal"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityGetCloudDiscoveryMetadataFromNetwork,
        "AuthGetCDMetaFromNet"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityUpdateCloudDiscoveryMetadata,
        "AuthUpdCDMeta"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityGetEndpointMetadataFromNetwork,
        "AuthUpdCDMetaFromNet"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityUpdateEndpointMetadata,
        "AuthUpdEndpointMeta"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityUpdateMetadataWithRegionalInformation,
        "AuthUpdMetaWithRegInfo"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RegionDiscoveryDetectRegion,
        "RegDiscDetectReg"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RegionDiscoveryGetRegionFromIMDS,
        "RegDiscGetRegFromIMDS"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RegionDiscoveryGetCurrentVersion,
        "RegDiscGetCurrentVer"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenByCodeAsync,
        "ATByCodeAsync"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GetEndpointMetadataFromNetwork,
        "GetEndpointMetaFromNet"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GetCloudDiscoveryMetadataFromNetworkMeasurement,
        "GetCDMetaFromNet"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleRedirectPromiseMeasurement,
        "HandleRedirectPromise"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleNativeRedirectPromiseMeasurement,
        "HandleNtvRedirectPromise"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.UpdateCloudDiscoveryMetadataMeasurement,
        "UpdateCDMeta"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.UsernamePasswordClientAcquireToken,
        "UserPassClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.NativeMessageHandlerHandshake,
        "NtvMsgHandlerHandshake"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.NativeGenerateAuthResult,
        "NtvGenAuthRes"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RemoveHiddenIframe,
        "RemoveHiddenIframe"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.ClearTokensAndKeysWithClaims,
        "ClearTAndKeysWithClaims"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.CacheManagerGetRefreshToken,
        "CacheManagerGetRT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GeneratePkceCodes,
        "GenPkceCodes"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GenerateCodeVerifier,
        "GenCodeVerifier"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GenerateCodeChallengeFromVerifier,
        "GenCodeChallengeFromVerifier"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.Sha256Digest,
        "Sha256Digest"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GetRandomValues,
        "GetRandomValues"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GenerateHKDF,
        "genHKDF"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GenerateBaseKey,
        "genBaseKey"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.Base64Decode,
        "b64Decode"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.UrlEncodeArr,
        "urlEncArr"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.Encrypt,
        "encrypt"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.Decrypt,
        "decrypt"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GenerateEarKey,
        "genEarKey"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.DecryptEarResponse,
        "decryptEarResp"
    ]
]);
/**
 * State of the performance event.
 *
 * @export
 * @enum {number}
 */ const $80a5304d92c187bf$export$bc3547c8ae7b1db = {
    NotStarted: 0,
    InProgress: 1,
    Completed: 2
};
const $80a5304d92c187bf$export$f16d39729f4b7302 = new Set([
    "accessTokenSize",
    "durationMs",
    "idTokenSize",
    "matsSilentStatus",
    "matsHttpStatus",
    "refreshTokenSize",
    "queuedTimeMs",
    "startTimeMs",
    "status",
    "multiMatchedAT",
    "multiMatchedID",
    "multiMatchedRT",
    "unencryptedCacheCount",
    "encryptedCacheExpiredCount"
]);


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $c21b15fc7f6dcd1f$export$647004217f4122f0 {
    startMeasurement() {
        return;
    }
    endMeasurement() {
        return;
    }
    flushMeasurement() {
        return null;
    }
}
class $c21b15fc7f6dcd1f$export$c70f2989a65fda3e {
    generateId() {
        return "callback-id";
    }
    startMeasurement(measureName, correlationId) {
        return {
            end: ()=>null,
            discard: ()=>{},
            add: ()=>{},
            increment: ()=>{},
            event: {
                eventId: this.generateId(),
                status: (0, $80a5304d92c187bf$export$bc3547c8ae7b1db).InProgress,
                authority: "",
                libraryName: "",
                libraryVersion: "",
                clientId: "",
                name: measureName,
                startTimeMs: Date.now(),
                correlationId: correlationId || ""
            },
            measurement: new $c21b15fc7f6dcd1f$export$647004217f4122f0()
        };
    }
    startPerformanceMeasurement() {
        return new $c21b15fc7f6dcd1f$export$647004217f4122f0();
    }
    calculateQueuedTime() {
        return 0;
    }
    addQueueMeasurement() {
        return;
    }
    setPreQueueTime() {
        return;
    }
    endMeasurement() {
        return null;
    }
    discardMeasurements() {
        return;
    }
    removePerformanceCallback() {
        return true;
    }
    addPerformanceCallback() {
        return "";
    }
    emitEvents() {
        return;
    }
    addFields() {
        return;
    }
    incrementFields() {
        return;
    }
    cacheEventByCorrelationId() {
        return;
    }
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Constants
 */ const $5ff55562d73e0e2b$export$a0a689e4294b9880 = {
    /**
     * Interaction in progress cache value
     */ INTERACTION_IN_PROGRESS_VALUE: "interaction_in_progress",
    /**
     * Invalid grant error code
     */ INVALID_GRANT_ERROR: "invalid_grant",
    /**
     * Default popup window width
     */ POPUP_WIDTH: 483,
    /**
     * Default popup window height
     */ POPUP_HEIGHT: 600,
    /**
     * Name of the popup window starts with
     */ POPUP_NAME_PREFIX: "msal",
    /**
     * Default popup monitor poll interval in milliseconds
     */ DEFAULT_POLL_INTERVAL_MS: 30,
    /**
     * Msal-browser SKU
     */ MSAL_SKU: "msal.js.browser"
};
const $5ff55562d73e0e2b$export$3ebdf53424883b5f = {
    CHANNEL_ID: "53ee284d-920a-4b59-9d30-a60315b26836",
    PREFERRED_EXTENSION_ID: "ppnbnpeolgkicgegkbkbjmhlideopiji",
    MATS_TELEMETRY: "MATS",
    MICROSOFT_ENTRA_BROKERID: "MicrosoftEntra",
    DOM_API_NAME: "DOM API",
    PLATFORM_DOM_APIS: "get-token-and-sign-out",
    PLATFORM_DOM_PROVIDER: "PlatformAuthDOMHandler",
    PLATFORM_EXTENSION_PROVIDER: "PlatformAuthExtensionHandler"
};
const $5ff55562d73e0e2b$export$3536098be6c7dadb = {
    HandshakeRequest: "Handshake",
    HandshakeResponse: "HandshakeResponse",
    GetToken: "GetToken",
    Response: "Response"
};
const $5ff55562d73e0e2b$export$573384e47a12d835 = {
    LocalStorage: "localStorage",
    SessionStorage: "sessionStorage",
    MemoryStorage: "memoryStorage"
};
/**
 * HTTP Request types supported by MSAL.
 */ const $5ff55562d73e0e2b$export$c774c31b4c31da8 = {
    GET: "GET",
    POST: "POST"
};
const $5ff55562d73e0e2b$export$dc1d3aa5f3837765 = {
    SIGNIN: "signin",
    SIGNOUT: "signout"
};
/**
 * Temporary cache keys for MSAL, deleted after any request.
 */ const $5ff55562d73e0e2b$export$21d55bedf0d269fb = {
    ORIGIN_URI: "request.origin",
    URL_HASH: "urlHash",
    REQUEST_PARAMS: "request.params",
    VERIFIER: "code.verifier",
    INTERACTION_STATUS_KEY: "interaction.status",
    NATIVE_REQUEST: "request.native"
};
const $5ff55562d73e0e2b$export$f6ce23cce692699f = {
    ACCOUNT_KEYS: "msal.account.keys",
    TOKEN_KEYS: "msal.token.keys",
    VERSION: "msal.version"
};
/**
 * Cache keys stored in-memory
 */ const $5ff55562d73e0e2b$export$8f546f90896bcfa9 = {
    WRAPPER_SKU: "wrapper.sku",
    WRAPPER_VER: "wrapper.version"
};
/**
 * API Codes for Telemetry purposes.
 * Before adding a new code you must claim it in the MSAL Telemetry tracker as these number spaces are shared across all MSALs
 * 0-99 Silent Flow
 * 800-899 Auth Code Flow
 */ const $5ff55562d73e0e2b$export$192d74ad69b40705 = {
    acquireTokenRedirect: 861,
    acquireTokenPopup: 862,
    ssoSilent: 863,
    acquireTokenSilent_authCode: 864,
    handleRedirectPromise: 865,
    acquireTokenByCode: 866,
    acquireTokenSilent_silentFlow: 61,
    logout: 961,
    logoutPopup: 962
};
/*
 * Interaction type of the API - used for state and telemetry
 */ var $5ff55562d73e0e2b$export$4ec29255e7e7f68f;
(function(InteractionType) {
    InteractionType["Redirect"] = "redirect";
    InteractionType["Popup"] = "popup";
    InteractionType["Silent"] = "silent";
    InteractionType["None"] = "none";
})($5ff55562d73e0e2b$export$4ec29255e7e7f68f || ($5ff55562d73e0e2b$export$4ec29255e7e7f68f = {}));
/**
 * Types of interaction currently in progress.
 * Used in events in wrapper libraries to invoke functions when certain interaction is in progress or all interactions are complete.
 */ const $5ff55562d73e0e2b$export$bec20eda0179362b = {
    /**
     * Initial status before interaction occurs
     */ Startup: "startup",
    /**
     * Status set when all login calls occuring
     */ Login: "login",
    /**
     * Status set when logout call occuring
     */ Logout: "logout",
    /**
     * Status set for acquireToken calls
     */ AcquireToken: "acquireToken",
    /**
     * Status set for ssoSilent calls
     */ SsoSilent: "ssoSilent",
    /**
     * Status set when handleRedirect in progress
     */ HandleRedirect: "handleRedirect",
    /**
     * Status set when interaction is complete
     */ None: "none"
};
const $5ff55562d73e0e2b$export$7e12949cd6884193 = {
    scopes: (0, $7c375ae106b964be$export$893b1b5b686d84ef)
};
/**
 * JWK Key Format string (Type MUST be defined for window crypto APIs)
 */ const $5ff55562d73e0e2b$export$1294c3e3f84694cd = "jwk";
// Supported wrapper SKUs
const $5ff55562d73e0e2b$export$8abb9de997bb4e44 = {
    React: "@azure/msal-react",
    Angular: "@azure/msal-angular"
};
// DatabaseStorage Constants
const $5ff55562d73e0e2b$export$3c22ff8b64b8f565 = "msal.db";
const $5ff55562d73e0e2b$export$6a9022b4c5fcea02 = 1;
const $5ff55562d73e0e2b$export$9d785db034fb436f = `${$5ff55562d73e0e2b$export$3c22ff8b64b8f565}.keys`;
const $5ff55562d73e0e2b$export$4394baa7e922d42d = {
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired
     * or cannot be found the refresh token will be used to acquire a new one. Finally, if the refresh token
     * is expired acquireTokenSilent will attempt to acquire new access and refresh tokens.
     */ Default: 0,
    /*
     * acquireTokenSilent will only look for access tokens in the cache. It will not attempt to renew access or
     * refresh tokens.
     */ AccessToken: 1,
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired or
     * cannot be found, the refresh token will be used to acquire a new one. If the refresh token is expired, it
     * will not be renewed and acquireTokenSilent will fail.
     */ AccessTokenAndRefreshToken: 2,
    /*
     * acquireTokenSilent will not attempt to retrieve access tokens from the cache and will instead attempt to
     * exchange the cached refresh token for a new access token. If the refresh token is expired, it will not be
     * renewed and acquireTokenSilent will fail.
     */ RefreshToken: 3,
    /*
     * acquireTokenSilent will not look in the cache for the access token. It will go directly to network with the
     * cached refresh token. If the refresh token is expired an attempt will be made to renew it. This is equivalent to
     * setting "forceRefresh: true".
     */ RefreshTokenAndNetwork: 4,
    /*
     * acquireTokenSilent will attempt to renew both access and refresh tokens. It will not look in the cache. This will
     * always fail if 3rd party cookies are blocked by the browser.
     */ Skip: 5
};
const $5ff55562d73e0e2b$export$736180706fb122ee = [
    $5ff55562d73e0e2b$export$4394baa7e922d42d.Default,
    $5ff55562d73e0e2b$export$4394baa7e922d42d.Skip,
    $5ff55562d73e0e2b$export$4394baa7e922d42d.RefreshTokenAndNetwork
];
const $5ff55562d73e0e2b$export$b28668d53eb57e63 = "msal.browser.log.level";
const $5ff55562d73e0e2b$export$d9bc1c202a3825f1 = "msal.browser.log.pii";
const $5ff55562d73e0e2b$export$54408f0b0cf727d4 = "msal.browser.performance.enabled";
const $5ff55562d73e0e2b$export$43c3e4cbd5e04b77 = "msal.browser.platform.auth.dom";


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $cb0bb957d18a08cc$export$d0d362a73d466c9b {
    /**
     * Navigates to other pages within the same web application
     * @param url
     * @param options
     */ navigateInternal(url, options) {
        return $cb0bb957d18a08cc$export$d0d362a73d466c9b.defaultNavigateWindow(url, options);
    }
    /**
     * Navigates to other pages outside the web application i.e. the Identity Provider
     * @param url
     * @param options
     */ navigateExternal(url, options) {
        return $cb0bb957d18a08cc$export$d0d362a73d466c9b.defaultNavigateWindow(url, options);
    }
    /**
     * Default navigation implementation invoked by the internal and external functions
     * @param url
     * @param options
     */ static defaultNavigateWindow(url, options) {
        if (options.noHistory) window.location.replace(url); // CodeQL [SM03712] Application owner controls the URL. User can't change it.
        else window.location.assign(url); // CodeQL [SM03712] Application owner controls the URL. User can't change it.
        return new Promise((resolve)=>{
            setTimeout(()=>{
                resolve(true);
            }, options.timeout);
        });
    }
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ /*! @azure/msal-common v15.7.0 2025-05-30 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Represents network related errors
 */ class $01c2dbbf2115e471$export$bae979e68e4dc802 extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(error, httpStatus, responseHeaders){
        super(error.errorCode, error.errorMessage, error.subError);
        Object.setPrototypeOf(this, $01c2dbbf2115e471$export$bae979e68e4dc802.prototype);
        this.name = "NetworkError";
        this.error = error;
        this.httpStatus = httpStatus;
        this.responseHeaders = responseHeaders;
    }
}
/**
 * Creates NetworkError object for a failed network request
 * @param error - Error to be thrown back to the caller
 * @param httpStatus - Status code of the network request
 * @param responseHeaders - Response headers of the network request, when available
 * @returns NetworkError object
 */ function $01c2dbbf2115e471$export$262c4a35fb53be19(error, httpStatus, responseHeaders, additionalError) {
    error.errorMessage = `${error.errorMessage}, additionalErrorInfo: error.name:${additionalError?.name}, error.message:${additionalError?.message}`;
    return new $01c2dbbf2115e471$export$bae979e68e4dc802(error, httpStatus, responseHeaders);
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 
/*! @azure/msal-browser v4.13.1 2025-06-10 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $0780bb28b98eb888$export$ee549107fa376fc1 = "pkce_not_created";
const $0780bb28b98eb888$export$2c031f99d3e081ff = "ear_jwk_empty";
const $0780bb28b98eb888$export$b9f7c47ac4054f3d = "ear_jwe_empty";
const $0780bb28b98eb888$export$6319761d10f0cc4c = "crypto_nonexistent";
const $0780bb28b98eb888$export$be9285c64f247822 = "empty_navigate_uri";
const $0780bb28b98eb888$export$a29c42a1dd414317 = "hash_empty_error";
const $0780bb28b98eb888$export$211c8e8843a8d278 = "no_state_in_hash";
const $0780bb28b98eb888$export$5743873a5ba5d124 = "hash_does_not_contain_known_properties";
const $0780bb28b98eb888$export$237bdd0b913cb30c = "unable_to_parse_state";
const $0780bb28b98eb888$export$499b1b95c97a1c75 = "state_interaction_type_mismatch";
const $0780bb28b98eb888$export$2700dc1c133d227e = "interaction_in_progress";
const $0780bb28b98eb888$export$f1b7091ee48d0b3e = "popup_window_error";
const $0780bb28b98eb888$export$5e827e513523a576 = "empty_window_error";
const $0780bb28b98eb888$export$6bae303c5e922702 = "user_cancelled";
const $0780bb28b98eb888$export$e2e3374c08b8ef2a = "monitor_popup_timeout";
const $0780bb28b98eb888$export$c8b6efb19551013d = "monitor_window_timeout";
const $0780bb28b98eb888$export$9cc12eb574ceee30 = "redirect_in_iframe";
const $0780bb28b98eb888$export$71bafc2814e56c09 = "block_iframe_reload";
const $0780bb28b98eb888$export$c4a80c97d7b48f72 = "block_nested_popups";
const $0780bb28b98eb888$export$6a76760db525f402 = "iframe_closed_prematurely";
const $0780bb28b98eb888$export$78523a40be105a03 = "silent_logout_unsupported";
const $0780bb28b98eb888$export$87933d7d4116cb12 = "no_account_error";
const $0780bb28b98eb888$export$24dae796d0958d3 = "silent_prompt_value_error";
const $0780bb28b98eb888$export$8b51939fb2aab3d7 = "no_token_request_cache_error";
const $0780bb28b98eb888$export$f3ae24cdfaab4488 = "unable_to_parse_token_request_cache_error";
const $0780bb28b98eb888$export$c47649cf6408c7b2 = "auth_request_not_set_error";
const $0780bb28b98eb888$export$ff7164a2aeeff392 = "invalid_cache_type";
const $0780bb28b98eb888$export$932e0f52d657f7fb = "non_browser_environment";
const $0780bb28b98eb888$export$4752ced1a1a262f = "database_not_open";
const $0780bb28b98eb888$export$31ae862f18c3b2b7 = "no_network_connectivity";
const $0780bb28b98eb888$export$7a1e28a7b60ca602 = "post_request_failed";
const $0780bb28b98eb888$export$45e7eaaecd19d31e = "get_request_failed";
const $0780bb28b98eb888$export$96735047beea85a0 = "failed_to_parse_response";
const $0780bb28b98eb888$export$6acf650331eb5f5f = "unable_to_load_token";
const $0780bb28b98eb888$export$a416b0eceb5c15df = "crypto_key_not_found";
const $0780bb28b98eb888$export$e502d98cd8d2da43 = "auth_code_required";
const $0780bb28b98eb888$export$8bea68053103eaeb = "auth_code_or_nativeAccountId_required";
const $0780bb28b98eb888$export$1efb009e9d75bbe4 = "spa_code_and_nativeAccountId_present";
const $0780bb28b98eb888$export$c1110692d2978b8 = "database_unavailable";
const $0780bb28b98eb888$export$b897bbe2c683def2 = "unable_to_acquire_token_from_native_platform";
const $0780bb28b98eb888$export$4747c302ef0117fd = "native_handshake_timeout";
const $0780bb28b98eb888$export$59080ea2398ee306 = "native_extension_not_installed";
const $0780bb28b98eb888$export$7b7357e3538624aa = "native_connection_not_established";
const $0780bb28b98eb888$export$436657cdcd7fe2be = "uninitialized_public_client_application";
const $0780bb28b98eb888$export$62fdd8848aa75547 = "native_prompt_not_supported";
const $0780bb28b98eb888$export$fcc6790b5d12da63 = "invalid_base64_string";
const $0780bb28b98eb888$export$f6f43ae33ad04b91 = "invalid_pop_token_request";
const $0780bb28b98eb888$export$df9e6aae71bd84f = "failed_to_build_headers";
const $0780bb28b98eb888$export$487fe7232a90003c = "failed_to_parse_headers";
const $0780bb28b98eb888$export$6e3539c6f28cd91f = "failed_to_decrypt_ear_response";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $6e0b7bb04b1e6592$var$ErrorLink = "For more visit: aka.ms/msaljs/browser-errors";
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 */ const $6e0b7bb04b1e6592$export$16ffff3fb076c606 = {
    [(0, $0780bb28b98eb888$export$ee549107fa376fc1)]: "The PKCE code challenge and verifier could not be generated.",
    [(0, $0780bb28b98eb888$export$2c031f99d3e081ff)]: "No EAR encryption key provided. This is unexpected.",
    [(0, $0780bb28b98eb888$export$b9f7c47ac4054f3d)]: "Server response does not contain ear_jwe property. This is unexpected.",
    [(0, $0780bb28b98eb888$export$6319761d10f0cc4c)]: "The crypto object or function is not available.",
    [(0, $0780bb28b98eb888$export$be9285c64f247822)]: "Navigation URI is empty. Please check stack trace for more info.",
    [(0, $0780bb28b98eb888$export$a29c42a1dd414317)]: `Hash value cannot be processed because it is empty. Please verify that your redirectUri is not clearing the hash. ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$211c8e8843a8d278)]: "Hash does not contain state. Please verify that the request originated from msal.",
    [(0, $0780bb28b98eb888$export$5743873a5ba5d124)]: `Hash does not contain known properites. Please verify that your redirectUri is not changing the hash.  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$237bdd0b913cb30c)]: "Unable to parse state. Please verify that the request originated from msal.",
    [(0, $0780bb28b98eb888$export$499b1b95c97a1c75)]: "Hash contains state but the interaction type does not match the caller.",
    [(0, $0780bb28b98eb888$export$2700dc1c133d227e)]: `Interaction is currently in progress. Please ensure that this interaction has been completed before calling an interactive API.   ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$f1b7091ee48d0b3e)]: "Error opening popup window. This can happen if you are using IE or if popups are blocked in the browser.",
    [(0, $0780bb28b98eb888$export$5e827e513523a576)]: "window.open returned null or undefined window object.",
    [(0, $0780bb28b98eb888$export$6bae303c5e922702)]: "User cancelled the flow.",
    [(0, $0780bb28b98eb888$export$e2e3374c08b8ef2a)]: `Token acquisition in popup failed due to timeout.  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$c8b6efb19551013d)]: `Token acquisition in iframe failed due to timeout.  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$9cc12eb574ceee30)]: "Redirects are not supported for iframed or brokered applications. Please ensure you are using MSAL.js in a top frame of the window if using the redirect APIs, or use the popup APIs.",
    [(0, $0780bb28b98eb888$export$71bafc2814e56c09)]: `Request was blocked inside an iframe because MSAL detected an authentication response.  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$c4a80c97d7b48f72)]: "Request was blocked inside a popup because MSAL detected it was running in a popup.",
    [(0, $0780bb28b98eb888$export$6a76760db525f402)]: "The iframe being monitored was closed prematurely.",
    [(0, $0780bb28b98eb888$export$78523a40be105a03)]: "Silent logout not supported. Please call logoutRedirect or logoutPopup instead.",
    [(0, $0780bb28b98eb888$export$87933d7d4116cb12)]: "No account object provided to acquireTokenSilent and no active account has been set. Please call setActiveAccount or provide an account on the request.",
    [(0, $0780bb28b98eb888$export$24dae796d0958d3)]: "The value given for the prompt value is not valid for silent requests - must be set to 'none' or 'no_session'.",
    [(0, $0780bb28b98eb888$export$8b51939fb2aab3d7)]: "No token request found in cache.",
    [(0, $0780bb28b98eb888$export$f3ae24cdfaab4488)]: "The cached token request could not be parsed.",
    [(0, $0780bb28b98eb888$export$c47649cf6408c7b2)]: "Auth Request not set. Please ensure initiateAuthRequest was called from the InteractionHandler",
    [(0, $0780bb28b98eb888$export$ff7164a2aeeff392)]: "Invalid cache type",
    [(0, $0780bb28b98eb888$export$932e0f52d657f7fb)]: "Login and token requests are not supported in non-browser environments.",
    [(0, $0780bb28b98eb888$export$4752ced1a1a262f)]: "Database is not open!",
    [(0, $0780bb28b98eb888$export$31ae862f18c3b2b7)]: "No network connectivity. Check your internet connection.",
    [(0, $0780bb28b98eb888$export$7a1e28a7b60ca602)]: "Network request failed: If the browser threw a CORS error, check that the redirectUri is registered in the Azure App Portal as type 'SPA'",
    [(0, $0780bb28b98eb888$export$45e7eaaecd19d31e)]: "Network request failed. Please check the network trace to determine root cause.",
    [(0, $0780bb28b98eb888$export$96735047beea85a0)]: "Failed to parse network response. Check network trace.",
    [(0, $0780bb28b98eb888$export$6acf650331eb5f5f)]: "Error loading token to cache.",
    [(0, $0780bb28b98eb888$export$a416b0eceb5c15df)]: "Cryptographic Key or Keypair not found in browser storage.",
    [(0, $0780bb28b98eb888$export$e502d98cd8d2da43)]: "An authorization code must be provided (as the `code` property on the request) to this flow.",
    [(0, $0780bb28b98eb888$export$8bea68053103eaeb)]: "An authorization code or nativeAccountId must be provided to this flow.",
    [(0, $0780bb28b98eb888$export$1efb009e9d75bbe4)]: "Request cannot contain both spa code and native account id.",
    [(0, $0780bb28b98eb888$export$c1110692d2978b8)]: "IndexedDB, which is required for persistent cryptographic key storage, is unavailable. This may be caused by browser privacy features which block persistent storage in third-party contexts.",
    [(0, $0780bb28b98eb888$export$b897bbe2c683def2)]: `Unable to acquire token from native platform.  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$4747c302ef0117fd)]: "Timed out while attempting to establish connection to browser extension",
    [(0, $0780bb28b98eb888$export$59080ea2398ee306)]: "Native extension is not installed. If you think this is a mistake call the initialize function.",
    [(0, $0780bb28b98eb888$export$7b7357e3538624aa)]: `Connection to native platform has not been established. Please install a compatible browser extension and run initialize().  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$436657cdcd7fe2be)]: `You must call and await the initialize function before attempting to call any other MSAL API.  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$62fdd8848aa75547)]: "The provided prompt is not supported by the native platform. This request should be routed to the web based flow.",
    [(0, $0780bb28b98eb888$export$fcc6790b5d12da63)]: "Invalid base64 encoded string.",
    [(0, $0780bb28b98eb888$export$f6f43ae33ad04b91)]: "Invalid PoP token request. The request should not have both a popKid value and signPopToken set to true.",
    [(0, $0780bb28b98eb888$export$df9e6aae71bd84f)]: "Failed to build request headers object.",
    [(0, $0780bb28b98eb888$export$487fe7232a90003c)]: "Failed to parse response headers",
    [(0, $0780bb28b98eb888$export$6e3539c6f28cd91f)]: "Failed to decrypt ear response"
};
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use exported BrowserAuthErrorCodes instead.
 * In your app you can do :
 * ```
 * import { BrowserAuthErrorCodes } from "@azure/msal-browser";
 * ```
 */ const $6e0b7bb04b1e6592$export$6deffaef56f0bd5a = {
    pkceNotGenerated: {
        code: (0, $0780bb28b98eb888$export$ee549107fa376fc1),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$ee549107fa376fc1]
    },
    cryptoDoesNotExist: {
        code: (0, $0780bb28b98eb888$export$6319761d10f0cc4c),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$6319761d10f0cc4c]
    },
    emptyNavigateUriError: {
        code: (0, $0780bb28b98eb888$export$be9285c64f247822),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$be9285c64f247822]
    },
    hashEmptyError: {
        code: (0, $0780bb28b98eb888$export$a29c42a1dd414317),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$a29c42a1dd414317]
    },
    hashDoesNotContainStateError: {
        code: (0, $0780bb28b98eb888$export$211c8e8843a8d278),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$211c8e8843a8d278]
    },
    hashDoesNotContainKnownPropertiesError: {
        code: (0, $0780bb28b98eb888$export$5743873a5ba5d124),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$5743873a5ba5d124]
    },
    unableToParseStateError: {
        code: (0, $0780bb28b98eb888$export$237bdd0b913cb30c),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$237bdd0b913cb30c]
    },
    stateInteractionTypeMismatchError: {
        code: (0, $0780bb28b98eb888$export$499b1b95c97a1c75),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$499b1b95c97a1c75]
    },
    interactionInProgress: {
        code: (0, $0780bb28b98eb888$export$2700dc1c133d227e),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$2700dc1c133d227e]
    },
    popupWindowError: {
        code: (0, $0780bb28b98eb888$export$f1b7091ee48d0b3e),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$f1b7091ee48d0b3e]
    },
    emptyWindowError: {
        code: (0, $0780bb28b98eb888$export$5e827e513523a576),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$5e827e513523a576]
    },
    userCancelledError: {
        code: (0, $0780bb28b98eb888$export$6bae303c5e922702),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$6bae303c5e922702]
    },
    monitorPopupTimeoutError: {
        code: (0, $0780bb28b98eb888$export$e2e3374c08b8ef2a),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$e2e3374c08b8ef2a]
    },
    monitorIframeTimeoutError: {
        code: (0, $0780bb28b98eb888$export$c8b6efb19551013d),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$c8b6efb19551013d]
    },
    redirectInIframeError: {
        code: (0, $0780bb28b98eb888$export$9cc12eb574ceee30),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$9cc12eb574ceee30]
    },
    blockTokenRequestsInHiddenIframeError: {
        code: (0, $0780bb28b98eb888$export$71bafc2814e56c09),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$71bafc2814e56c09]
    },
    blockAcquireTokenInPopupsError: {
        code: (0, $0780bb28b98eb888$export$c4a80c97d7b48f72),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$c4a80c97d7b48f72]
    },
    iframeClosedPrematurelyError: {
        code: (0, $0780bb28b98eb888$export$6a76760db525f402),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$6a76760db525f402]
    },
    silentLogoutUnsupportedError: {
        code: (0, $0780bb28b98eb888$export$78523a40be105a03),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$78523a40be105a03]
    },
    noAccountError: {
        code: (0, $0780bb28b98eb888$export$87933d7d4116cb12),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$87933d7d4116cb12]
    },
    silentPromptValueError: {
        code: (0, $0780bb28b98eb888$export$24dae796d0958d3),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$24dae796d0958d3]
    },
    noTokenRequestCacheError: {
        code: (0, $0780bb28b98eb888$export$8b51939fb2aab3d7),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$8b51939fb2aab3d7]
    },
    unableToParseTokenRequestCacheError: {
        code: (0, $0780bb28b98eb888$export$f3ae24cdfaab4488),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$f3ae24cdfaab4488]
    },
    authRequestNotSet: {
        code: (0, $0780bb28b98eb888$export$c47649cf6408c7b2),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$c47649cf6408c7b2]
    },
    invalidCacheType: {
        code: (0, $0780bb28b98eb888$export$ff7164a2aeeff392),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$ff7164a2aeeff392]
    },
    notInBrowserEnvironment: {
        code: (0, $0780bb28b98eb888$export$932e0f52d657f7fb),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$932e0f52d657f7fb]
    },
    databaseNotOpen: {
        code: (0, $0780bb28b98eb888$export$4752ced1a1a262f),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$4752ced1a1a262f]
    },
    noNetworkConnectivity: {
        code: (0, $0780bb28b98eb888$export$31ae862f18c3b2b7),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$31ae862f18c3b2b7]
    },
    postRequestFailed: {
        code: (0, $0780bb28b98eb888$export$7a1e28a7b60ca602),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$7a1e28a7b60ca602]
    },
    getRequestFailed: {
        code: (0, $0780bb28b98eb888$export$45e7eaaecd19d31e),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$45e7eaaecd19d31e]
    },
    failedToParseNetworkResponse: {
        code: (0, $0780bb28b98eb888$export$96735047beea85a0),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$96735047beea85a0]
    },
    unableToLoadTokenError: {
        code: (0, $0780bb28b98eb888$export$6acf650331eb5f5f),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$6acf650331eb5f5f]
    },
    signingKeyNotFoundInStorage: {
        code: (0, $0780bb28b98eb888$export$a416b0eceb5c15df),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$a416b0eceb5c15df]
    },
    authCodeRequired: {
        code: (0, $0780bb28b98eb888$export$e502d98cd8d2da43),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$e502d98cd8d2da43]
    },
    authCodeOrNativeAccountRequired: {
        code: (0, $0780bb28b98eb888$export$8bea68053103eaeb),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$8bea68053103eaeb]
    },
    spaCodeAndNativeAccountPresent: {
        code: (0, $0780bb28b98eb888$export$1efb009e9d75bbe4),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$1efb009e9d75bbe4]
    },
    databaseUnavailable: {
        code: (0, $0780bb28b98eb888$export$c1110692d2978b8),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$c1110692d2978b8]
    },
    unableToAcquireTokenFromNativePlatform: {
        code: (0, $0780bb28b98eb888$export$b897bbe2c683def2),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$b897bbe2c683def2]
    },
    nativeHandshakeTimeout: {
        code: (0, $0780bb28b98eb888$export$4747c302ef0117fd),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$4747c302ef0117fd]
    },
    nativeExtensionNotInstalled: {
        code: (0, $0780bb28b98eb888$export$59080ea2398ee306),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$59080ea2398ee306]
    },
    nativeConnectionNotEstablished: {
        code: (0, $0780bb28b98eb888$export$7b7357e3538624aa),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$7b7357e3538624aa]
    },
    uninitializedPublicClientApplication: {
        code: (0, $0780bb28b98eb888$export$436657cdcd7fe2be),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$436657cdcd7fe2be]
    },
    nativePromptNotSupported: {
        code: (0, $0780bb28b98eb888$export$62fdd8848aa75547),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$62fdd8848aa75547]
    },
    invalidBase64StringError: {
        code: (0, $0780bb28b98eb888$export$fcc6790b5d12da63),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$fcc6790b5d12da63]
    },
    invalidPopTokenRequest: {
        code: (0, $0780bb28b98eb888$export$f6f43ae33ad04b91),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$f6f43ae33ad04b91]
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class $6e0b7bb04b1e6592$export$f8eb6760ca13876a extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, subError){
        super(errorCode, $6e0b7bb04b1e6592$export$16ffff3fb076c606[errorCode], subError);
        Object.setPrototypeOf(this, $6e0b7bb04b1e6592$export$f8eb6760ca13876a.prototype);
        this.name = "BrowserAuthError";
    }
}
function $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb(errorCode, subError) {
    return new $6e0b7bb04b1e6592$export$f8eb6760ca13876a(errorCode, subError);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements the Fetch API for GET and POST requests. See more here: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 */ class $f210e947e17010a2$export$4c206ef5be879972 {
    /**
     * Fetch Client for REST endpoints - Get request
     * @param url
     * @param headers
     * @param body
     */ async sendGetRequestAsync(url, options) {
        let response;
        let responseHeaders = {};
        let responseStatus = 0;
        const reqHeaders = $f210e947e17010a2$var$getFetchHeaders(options);
        try {
            response = await fetch(url, {
                method: (0, $5ff55562d73e0e2b$export$c774c31b4c31da8).GET,
                headers: reqHeaders
            });
        } catch (e) {
            throw (0, $01c2dbbf2115e471$export$262c4a35fb53be19)((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)(window.navigator.onLine ? (0, $0780bb28b98eb888$export$45e7eaaecd19d31e) : (0, $0780bb28b98eb888$export$31ae862f18c3b2b7)), undefined, undefined, e);
        }
        responseHeaders = $f210e947e17010a2$var$getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw (0, $01c2dbbf2115e471$export$262c4a35fb53be19)((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$96735047beea85a0)), responseStatus, responseHeaders, e);
        }
    }
    /**
     * Fetch Client for REST endpoints - Post request
     * @param url
     * @param headers
     * @param body
     */ async sendPostRequestAsync(url, options) {
        const reqBody = options && options.body || "";
        const reqHeaders = $f210e947e17010a2$var$getFetchHeaders(options);
        let response;
        let responseStatus = 0;
        let responseHeaders = {};
        try {
            response = await fetch(url, {
                method: (0, $5ff55562d73e0e2b$export$c774c31b4c31da8).POST,
                headers: reqHeaders,
                body: reqBody
            });
        } catch (e) {
            throw (0, $01c2dbbf2115e471$export$262c4a35fb53be19)((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)(window.navigator.onLine ? (0, $0780bb28b98eb888$export$7a1e28a7b60ca602) : (0, $0780bb28b98eb888$export$31ae862f18c3b2b7)), undefined, undefined, e);
        }
        responseHeaders = $f210e947e17010a2$var$getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw (0, $01c2dbbf2115e471$export$262c4a35fb53be19)((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$96735047beea85a0)), responseStatus, responseHeaders, e);
        }
    }
}
/**
 * Get Fetch API Headers object from string map
 * @param inputHeaders
 */ function $f210e947e17010a2$var$getFetchHeaders(options) {
    try {
        const headers = new Headers();
        if (!(options && options.headers)) return headers;
        const optionsHeaders = options.headers;
        Object.entries(optionsHeaders).forEach(([key, value])=>{
            headers.append(key, value);
        });
        return headers;
    } catch (e) {
        throw (0, $01c2dbbf2115e471$export$262c4a35fb53be19)((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$df9e6aae71bd84f)), undefined, undefined, e);
    }
}
/**
 * Returns object representing response headers
 * @param headers
 * @returns
 */ function $f210e947e17010a2$var$getHeaderDict(headers) {
    try {
        const headerDict = {};
        headers.forEach((value, key)=>{
            headerDict[key] = value;
        });
        return headerDict;
    } catch (e) {
        throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$487fe7232a90003c));
    }
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to encode plaintext to base64 encoded string. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */ /**
 * Returns URL Safe b64 encoded string from a plaintext string.
 * @param input
 */ function $6f6986007da7f422$export$9ef804feabbcbaf1(input) {
    return encodeURIComponent($6f6986007da7f422$export$e510a73ee562749(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_"));
}
/**
 * Returns URL Safe b64 encoded string from an int8Array.
 * @param inputArr
 */ function $6f6986007da7f422$export$84f5a428c7153a69(inputArr) {
    return $6f6986007da7f422$var$base64EncArr(inputArr).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * Returns b64 encoded string from plaintext string.
 * @param input
 */ function $6f6986007da7f422$export$e510a73ee562749(input) {
    return $6f6986007da7f422$var$base64EncArr(new TextEncoder().encode(input));
}
/**
 * Base64 encode byte array
 * @param aBytes
 */ function $6f6986007da7f422$var$base64EncArr(aBytes) {
    const binString = Array.from(aBytes, (x)=>String.fromCodePoint(x)).join("");
    return btoa(binString);
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to decode base64 strings to plaintext. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
 */ /**
 * Returns a URL-safe plaintext decoded string from b64 encoded input.
 * @param input
 */ function $581fd3df606755c8$export$c62426fdd000a97e(input) {
    return new TextDecoder().decode($581fd3df606755c8$export$8f0c237d3e8188bc(input));
}
/**
 * Decodes base64 into Uint8Array
 * @param base64String
 */ function $581fd3df606755c8$export$8f0c237d3e8188bc(base64String) {
    let encodedString = base64String.replace(/-/g, "+").replace(/_/g, "/");
    switch(encodedString.length % 4){
        case 0:
            break;
        case 2:
            encodedString += "==";
            break;
        case 3:
            encodedString += "=";
            break;
        default:
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$fcc6790b5d12da63));
    }
    const binString = atob(encodedString);
    return Uint8Array.from(binString, (m)=>m.codePointAt(0) || 0);
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This file defines functions used by the browser library to perform cryptography operations such as
 * hashing and encoding. It also has helper functions to validate the availability of specific APIs.
 */ /**
 * See here for more info on RsaHashedKeyGenParams: https://developer.mozilla.org/en-US/docs/Web/API/RsaHashedKeyGenParams
 */ // Algorithms
const $4e0948336b4ea4a7$var$PKCS1_V15_KEYGEN_ALG = "RSASSA-PKCS1-v1_5";
const $4e0948336b4ea4a7$var$AES_GCM = "AES-GCM";
const $4e0948336b4ea4a7$var$HKDF = "HKDF";
// SHA-256 hashing algorithm
const $4e0948336b4ea4a7$var$S256_HASH_ALG = "SHA-256";
// MOD length for PoP tokens
const $4e0948336b4ea4a7$var$MODULUS_LENGTH = 2048;
// Public Exponent
const $4e0948336b4ea4a7$var$PUBLIC_EXPONENT = new Uint8Array([
    0x01,
    0x00,
    0x01
]);
// UUID hex digits
const $4e0948336b4ea4a7$var$UUID_CHARS = "0123456789abcdef";
// Array to store UINT32 random value
const $4e0948336b4ea4a7$var$UINT32_ARR = new Uint32Array(1);
// Key Format
const $4e0948336b4ea4a7$var$RAW = "raw";
// Key Usages
const $4e0948336b4ea4a7$var$ENCRYPT = "encrypt";
const $4e0948336b4ea4a7$var$DECRYPT = "decrypt";
const $4e0948336b4ea4a7$var$DERIVE_KEY = "deriveKey";
// Suberror
const $4e0948336b4ea4a7$var$SUBTLE_SUBERROR = "crypto_subtle_undefined";
const $4e0948336b4ea4a7$var$keygenAlgorithmOptions = {
    name: $4e0948336b4ea4a7$var$PKCS1_V15_KEYGEN_ALG,
    hash: $4e0948336b4ea4a7$var$S256_HASH_ALG,
    modulusLength: $4e0948336b4ea4a7$var$MODULUS_LENGTH,
    publicExponent: $4e0948336b4ea4a7$var$PUBLIC_EXPONENT
};
/**
 * Check whether browser crypto is available.
 */ function $4e0948336b4ea4a7$export$1ddcc6bab2bf2314(skipValidateSubtleCrypto) {
    if (!window) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$932e0f52d657f7fb));
    if (!window.crypto) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6319761d10f0cc4c));
    if (!skipValidateSubtleCrypto && !window.crypto.subtle) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6319761d10f0cc4c), $4e0948336b4ea4a7$var$SUBTLE_SUBERROR);
}
/**
 * Returns a sha-256 hash of the given dataString as an ArrayBuffer.
 * @param dataString {string} data string
 * @param performanceClient {?IPerformanceClient}
 * @param correlationId {?string} correlation id
 */ async function $4e0948336b4ea4a7$export$52caff7bddbaf316(dataString, performanceClient, correlationId) {
    performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).Sha256Digest, correlationId);
    const encoder = new TextEncoder();
    const data = encoder.encode(dataString);
    return window.crypto.subtle.digest($4e0948336b4ea4a7$var$S256_HASH_ALG, data);
}
/**
 * Populates buffer with cryptographically random values.
 * @param dataBuffer
 */ function $4e0948336b4ea4a7$export$960b9ff25e7d4257(dataBuffer) {
    return window.crypto.getRandomValues(dataBuffer);
}
/**
 * Returns random Uint32 value.
 * @returns {number}
 */ function $4e0948336b4ea4a7$var$getRandomUint32() {
    window.crypto.getRandomValues($4e0948336b4ea4a7$var$UINT32_ARR);
    return $4e0948336b4ea4a7$var$UINT32_ARR[0];
}
/**
 * Creates a UUID v7 from the current timestamp.
 * Implementation relies on the system clock to guarantee increasing order of generated identifiers.
 * @returns {number}
 */ function $4e0948336b4ea4a7$export$6ef0355fa80a5278() {
    const currentTimestamp = Date.now();
    const baseRand = $4e0948336b4ea4a7$var$getRandomUint32() * 0x400 + ($4e0948336b4ea4a7$var$getRandomUint32() & 0x3ff);
    // Result byte array
    const bytes = new Uint8Array(16);
    // A 12-bit `rand_a` field value
    const randA = Math.trunc(baseRand / 2 ** 30);
    // The higher 30 bits of 62-bit `rand_b` field value
    const randBHi = baseRand & 2 ** 30 - 1;
    // The lower 32 bits of 62-bit `rand_b` field value
    const randBLo = $4e0948336b4ea4a7$var$getRandomUint32();
    bytes[0] = currentTimestamp / 2 ** 40;
    bytes[1] = currentTimestamp / 2 ** 32;
    bytes[2] = currentTimestamp / 2 ** 24;
    bytes[3] = currentTimestamp / 2 ** 16;
    bytes[4] = currentTimestamp / 256;
    bytes[5] = currentTimestamp;
    bytes[6] = 0x70 | randA >>> 8;
    bytes[7] = randA;
    bytes[8] = 0x80 | randBHi >>> 24;
    bytes[9] = randBHi >>> 16;
    bytes[10] = randBHi >>> 8;
    bytes[11] = randBHi;
    bytes[12] = randBLo >>> 24;
    bytes[13] = randBLo >>> 16;
    bytes[14] = randBLo >>> 8;
    bytes[15] = randBLo;
    let text = "";
    for(let i = 0; i < bytes.length; i++){
        text += $4e0948336b4ea4a7$var$UUID_CHARS.charAt(bytes[i] >>> 4);
        text += $4e0948336b4ea4a7$var$UUID_CHARS.charAt(bytes[i] & 0xf);
        if (i === 3 || i === 5 || i === 7 || i === 9) text += "-";
    }
    return text;
}
/**
 * Generates a keypair based on current keygen algorithm config.
 * @param extractable
 * @param usages
 */ async function $4e0948336b4ea4a7$export$a949d36eab55b41f(extractable, usages) {
    return window.crypto.subtle.generateKey($4e0948336b4ea4a7$var$keygenAlgorithmOptions, extractable, usages);
}
/**
 * Export key as Json Web Key (JWK)
 * @param key
 */ async function $4e0948336b4ea4a7$export$88781b8595a7d2ff(key) {
    return window.crypto.subtle.exportKey((0, $5ff55562d73e0e2b$export$1294c3e3f84694cd), key);
}
/**
 * Imports key as Json Web Key (JWK), can set extractable and usages.
 * @param key
 * @param extractable
 * @param usages
 */ async function $4e0948336b4ea4a7$export$8bdea4e2e3f593c9(key, extractable, usages) {
    return window.crypto.subtle.importKey((0, $5ff55562d73e0e2b$export$1294c3e3f84694cd), key, $4e0948336b4ea4a7$var$keygenAlgorithmOptions, extractable, usages);
}
/**
 * Signs given data with given key
 * @param key
 * @param data
 */ async function $4e0948336b4ea4a7$export$c5552dfdbc7cec71(key, data) {
    return window.crypto.subtle.sign($4e0948336b4ea4a7$var$keygenAlgorithmOptions, key, data);
}
/**
 * Generates Base64 encoded jwk used in the Encrypted Authorize Response (EAR) flow
 */ async function $4e0948336b4ea4a7$export$95528b8a314880d1() {
    const key = await $4e0948336b4ea4a7$export$1222fa1cada87c76();
    const keyStr = (0, $6f6986007da7f422$export$84f5a428c7153a69)(new Uint8Array(key));
    const jwk = {
        alg: "dir",
        kty: "oct",
        k: keyStr
    };
    return (0, $6f6986007da7f422$export$e510a73ee562749)(JSON.stringify(jwk));
}
/**
 * Parses earJwk for encryption key and returns CryptoKey object
 * @param earJwk
 * @returns
 */ async function $4e0948336b4ea4a7$export$cf6da4e13ceceed(earJwk) {
    const b64DecodedJwk = (0, $581fd3df606755c8$export$c62426fdd000a97e)(earJwk);
    const jwkJson = JSON.parse(b64DecodedJwk);
    const rawKey = jwkJson.k;
    const keyBuffer = (0, $581fd3df606755c8$export$8f0c237d3e8188bc)(rawKey);
    return window.crypto.subtle.importKey($4e0948336b4ea4a7$var$RAW, keyBuffer, $4e0948336b4ea4a7$var$AES_GCM, false, [
        $4e0948336b4ea4a7$var$DECRYPT
    ]);
}
/**
 * Decrypt ear_jwe response returned in the Encrypted Authorize Response (EAR) flow
 * @param earJwk
 * @param earJwe
 * @returns
 */ async function $4e0948336b4ea4a7$export$13b9c776ab498ef3(earJwk, earJwe) {
    const earJweParts = earJwe.split(".");
    if (earJweParts.length !== 5) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6e3539c6f28cd91f), "jwe_length");
    const key = await $4e0948336b4ea4a7$export$cf6da4e13ceceed(earJwk).catch(()=>{
        throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6e3539c6f28cd91f), "import_key");
    });
    try {
        const header = new TextEncoder().encode(earJweParts[0]);
        const iv = (0, $581fd3df606755c8$export$8f0c237d3e8188bc)(earJweParts[2]);
        const ciphertext = (0, $581fd3df606755c8$export$8f0c237d3e8188bc)(earJweParts[3]);
        const tag = (0, $581fd3df606755c8$export$8f0c237d3e8188bc)(earJweParts[4]);
        const tagLengthBits = tag.byteLength * 8;
        // Concat ciphertext and tag
        const encryptedData = new Uint8Array(ciphertext.length + tag.length);
        encryptedData.set(ciphertext);
        encryptedData.set(tag, ciphertext.length);
        const decryptedData = await window.crypto.subtle.decrypt({
            name: $4e0948336b4ea4a7$var$AES_GCM,
            iv: iv,
            tagLength: tagLengthBits,
            additionalData: header
        }, key, encryptedData);
        return new TextDecoder().decode(decryptedData);
    } catch (e) {
        throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6e3539c6f28cd91f), "decrypt");
    }
}
/**
 * Generates symmetric base encryption key. This may be stored as all encryption/decryption keys will be derived from this one.
 */ async function $4e0948336b4ea4a7$export$1222fa1cada87c76() {
    const key = await window.crypto.subtle.generateKey({
        name: $4e0948336b4ea4a7$var$AES_GCM,
        length: 256
    }, true, [
        $4e0948336b4ea4a7$var$ENCRYPT,
        $4e0948336b4ea4a7$var$DECRYPT
    ]);
    return window.crypto.subtle.exportKey($4e0948336b4ea4a7$var$RAW, key);
}
/**
 * Returns the raw key to be passed into the key derivation function
 * @param baseKey
 * @returns
 */ async function $4e0948336b4ea4a7$export$5a71d4e3178f19c4(baseKey) {
    return window.crypto.subtle.importKey($4e0948336b4ea4a7$var$RAW, baseKey, $4e0948336b4ea4a7$var$HKDF, false, [
        $4e0948336b4ea4a7$var$DERIVE_KEY
    ]);
}
/**
 * Given a base key and a nonce generates a derived key to be used in encryption and decryption.
 * Note: every time we encrypt a new key is derived
 * @param baseKey
 * @param nonce
 * @returns
 */ async function $4e0948336b4ea4a7$var$deriveKey(baseKey, nonce, context) {
    return window.crypto.subtle.deriveKey({
        name: $4e0948336b4ea4a7$var$HKDF,
        salt: nonce,
        hash: $4e0948336b4ea4a7$var$S256_HASH_ALG,
        info: new TextEncoder().encode(context)
    }, baseKey, {
        name: $4e0948336b4ea4a7$var$AES_GCM,
        length: 256
    }, false, [
        $4e0948336b4ea4a7$var$ENCRYPT,
        $4e0948336b4ea4a7$var$DECRYPT
    ]);
}
/**
 * Encrypt the given data given a base key. Returns encrypted data and a nonce that must be provided during decryption
 * @param key
 * @param rawData
 */ async function $4e0948336b4ea4a7$export$5b0f6292f11d1d18(baseKey, rawData, context) {
    const encodedData = new TextEncoder().encode(rawData);
    // The nonce must never be reused with a given key.
    const nonce = window.crypto.getRandomValues(new Uint8Array(16));
    const derivedKey = await $4e0948336b4ea4a7$var$deriveKey(baseKey, nonce, context);
    const encryptedData = await window.crypto.subtle.encrypt({
        name: $4e0948336b4ea4a7$var$AES_GCM,
        iv: new Uint8Array(12)
    }, derivedKey, encodedData);
    return {
        data: (0, $6f6986007da7f422$export$84f5a428c7153a69)(new Uint8Array(encryptedData)),
        nonce: (0, $6f6986007da7f422$export$84f5a428c7153a69)(nonce)
    };
}
/**
 * Decrypt data with the given key and nonce
 * @param key
 * @param nonce
 * @param encryptedData
 * @returns
 */ async function $4e0948336b4ea4a7$export$e85a0c9a1067c5d3(baseKey, nonce, context, encryptedData) {
    const encodedData = (0, $581fd3df606755c8$export$8f0c237d3e8188bc)(encryptedData);
    const derivedKey = await $4e0948336b4ea4a7$var$deriveKey(baseKey, (0, $581fd3df606755c8$export$8f0c237d3e8188bc)(nonce), context);
    const decryptedData = await window.crypto.subtle.decrypt({
        name: $4e0948336b4ea4a7$var$AES_GCM,
        iv: new Uint8Array(12)
    }, derivedKey, encodedData);
    return new TextDecoder().decode(decryptedData);
}
/**
 * Returns the SHA-256 hash of an input string
 * @param plainText
 */ async function $4e0948336b4ea4a7$export$9169be2e06c9c165(plainText) {
    const hashBuffer = await $4e0948336b4ea4a7$export$52caff7bddbaf316(plainText);
    const hashBytes = new Uint8Array(hashBuffer);
    return (0, $6f6986007da7f422$export$84f5a428c7153a69)(hashBytes);
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 
/*! @azure/msal-browser v4.13.1 2025-06-10 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $b7c9daf3e548a083$export$41d7a3d4e14d6113 = "storage_not_supported";
const $b7c9daf3e548a083$export$1377ea690fa0b6d8 = "stubbed_public_client_application_called";
const $b7c9daf3e548a083$export$37486e3b6bed61c6 = "in_mem_redirect_unavailable";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $d12a658e6d92d79e$export$a14089932466e176 = {
    [(0, $b7c9daf3e548a083$export$41d7a3d4e14d6113)]: "Given storage configuration option was not supported.",
    [(0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)]: "Stub instance of Public Client Application was called. If using msal-react, please ensure context is not used without a provider. For more visit: aka.ms/msaljs/browser-errors",
    [(0, $b7c9daf3e548a083$export$37486e3b6bed61c6)]: "Redirect cannot be supported. In-memory storage was selected and storeAuthStateInCookie=false, which would cause the library to be unable to handle the incoming hash. If you would like to use the redirect API, please use session/localStorage or set storeAuthStateInCookie=true."
};
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use BrowserAuthErrorCodes instead
 */ const $d12a658e6d92d79e$export$daccd9364f884077 = {
    storageNotSupportedError: {
        code: (0, $b7c9daf3e548a083$export$41d7a3d4e14d6113),
        desc: $d12a658e6d92d79e$export$a14089932466e176[0, $b7c9daf3e548a083$export$41d7a3d4e14d6113]
    },
    stubPcaInstanceCalled: {
        code: (0, $b7c9daf3e548a083$export$1377ea690fa0b6d8),
        desc: $d12a658e6d92d79e$export$a14089932466e176[0, $b7c9daf3e548a083$export$1377ea690fa0b6d8]
    },
    inMemRedirectUnavailable: {
        code: (0, $b7c9daf3e548a083$export$37486e3b6bed61c6),
        desc: $d12a658e6d92d79e$export$a14089932466e176[0, $b7c9daf3e548a083$export$37486e3b6bed61c6]
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class $d12a658e6d92d79e$export$2eb7a1dfdc4c5fba extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        this.name = "BrowserConfigurationAuthError";
        Object.setPrototypeOf(this, $d12a658e6d92d79e$export$2eb7a1dfdc4c5fba.prototype);
    }
}
function $d12a658e6d92d79e$export$176bd5050947ba0c(errorCode) {
    return new $d12a658e6d92d79e$export$2eb7a1dfdc4c5fba(errorCode, $d12a658e6d92d79e$export$a14089932466e176[errorCode]);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Clears hash from window url.
 */ function $3003b661a087a867$export$a20c3032ba81d6aa(contentWindow) {
    // Office.js sets history.replaceState to null
    contentWindow.location.hash = "";
    if (typeof contentWindow.history.replaceState === "function") // Full removes "#" from url
    contentWindow.history.replaceState(null, "", `${contentWindow.location.origin}${contentWindow.location.pathname}${contentWindow.location.search}`);
}
/**
 * Replaces current hash with hash from provided url
 */ function $3003b661a087a867$export$9bf2691bda54425c(url) {
    const urlParts = url.split("#");
    urlParts.shift(); // Remove part before the hash
    window.location.hash = urlParts.length > 0 ? urlParts.join("#") : "";
}
/**
 * Returns boolean of whether the current window is in an iframe or not.
 */ function $3003b661a087a867$export$9f140ed41af5108c() {
    return window.parent !== window;
}
/**
 * Returns boolean of whether or not the current window is a popup opened by msal
 */ function $3003b661a087a867$export$722fdce8786cc28b() {
    return typeof window !== "undefined" && !!window.opener && window.opener !== window && typeof window.name === "string" && window.name.indexOf(`${(0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.`) === 0;
}
// #endregion
/**
 * Returns current window URL as redirect uri
 */ function $3003b661a087a867$export$1204531fbbf6ecde() {
    return typeof window !== "undefined" && window.location ? window.location.href.split("?")[0].split("#")[0] : "";
}
/**
 * Gets the homepage url for the current window location.
 */ function $3003b661a087a867$export$60785768478b4ffc() {
    const currentUrl = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(window.location.href);
    const urlComponents = currentUrl.getUrlComponents();
    return `${urlComponents.Protocol}//${urlComponents.HostNameAndPort}/`;
}
/**
 * Throws error if we have completed an auth and are
 * attempting another auth request inside an iframe.
 */ function $3003b661a087a867$export$8fdba407d8e31f54() {
    const isResponseHash = (0, $f7f911f196324278$export$3abcdca7229e54f2).hashContainsKnownProperties(window.location.hash);
    // return an error if called from the hidden iframe created by the msal js silent calls
    if (isResponseHash && $3003b661a087a867$export$9f140ed41af5108c()) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$71bafc2814e56c09));
}
/**
 * Block redirect operations in iframes unless explicitly allowed
 * @param interactionType Interaction type for the request
 * @param allowRedirectInIframe Config value to allow redirects when app is inside an iframe
 */ function $3003b661a087a867$export$5ae6b09f947c8a9e(allowRedirectInIframe) {
    if ($3003b661a087a867$export$9f140ed41af5108c() && !allowRedirectInIframe) // If we are not in top frame, we shouldn't redirect. This is also handled by the service.
    throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$9cc12eb574ceee30));
}
/**
 * Block redirectUri loaded in popup from calling AcquireToken APIs
 */ function $3003b661a087a867$export$dc99b653c8cd2cd7() {
    // Popups opened by msal popup APIs are given a name that starts with "msal."
    if ($3003b661a087a867$export$722fdce8786cc28b()) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$c4a80c97d7b48f72));
}
/**
 * Throws error if token requests are made in non-browser environment
 * @param isBrowserEnvironment Flag indicating if environment is a browser.
 */ function $3003b661a087a867$export$c7939bfe92ae2787() {
    if (typeof window === "undefined") throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$932e0f52d657f7fb));
}
/**
 * Throws error if initialize hasn't been called
 * @param initialized
 */ function $3003b661a087a867$export$630119c5db8b5529(initialized) {
    if (!initialized) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$436657cdcd7fe2be));
}
/**
 * Helper to validate app environment before making an auth request
 * @param initialized
 */ function $3003b661a087a867$export$4dd091cbdc98b52e(initialized) {
    // Block request if not in browser environment
    $3003b661a087a867$export$c7939bfe92ae2787();
    // Block auth requests inside a hidden iframe
    $3003b661a087a867$export$8fdba407d8e31f54();
    // Block redirectUri opened in a popup from calling MSAL APIs
    $3003b661a087a867$export$dc99b653c8cd2cd7();
    // Block token acquisition before initialize has been called
    $3003b661a087a867$export$630119c5db8b5529(initialized);
}
/**
 * Helper to validate app enviornment before making redirect request
 * @param initialized
 * @param config
 */ function $3003b661a087a867$export$62c8f4fdca4df60f(initialized, config) {
    $3003b661a087a867$export$4dd091cbdc98b52e(initialized);
    $3003b661a087a867$export$5ae6b09f947c8a9e(config.system.allowRedirectInIframe);
    // Block redirects if memory storage is enabled but storeAuthStateInCookie is not
    if (config.cache.cacheLocation === (0, $5ff55562d73e0e2b$export$573384e47a12d835).MemoryStorage && !config.cache.storeAuthStateInCookie) throw (0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$37486e3b6bed61c6));
}
/**
 * Adds a preconnect link element to the header which begins DNS resolution and SSL connection in anticipation of the /token request
 * @param loginDomain Authority domain, including https protocol e.g. https://login.microsoftonline.com
 * @returns
 */ function $3003b661a087a867$export$a0816fa17a9e79be(authority) {
    const link = document.createElement("link");
    link.rel = "preconnect";
    link.href = new URL(authority).origin;
    link.crossOrigin = "anonymous";
    document.head.appendChild(link);
    // The browser will close connection if not used within a few seconds, remove element from the header after 10s
    window.setTimeout(()=>{
        try {
            document.head.removeChild(link);
        } catch  {}
    }, 10000); // 10s Timeout
}
/**
 * Wrapper function that creates a UUID v7 from the current timestamp.
 * @returns {string}
 */ function $3003b661a087a867$export$7571c350ed9fec74() {
    return (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Default timeout for popup windows and iframes in milliseconds
const $68fb5a78014bcfe7$export$a5835ee54399d410 = 60000;
const $68fb5a78014bcfe7$export$f3ffe700be354b19 = 10000;
const $68fb5a78014bcfe7$export$293647e7865520c6 = 30000;
const $68fb5a78014bcfe7$export$73d1d87a8b7ddb57 = 2000;
/**
 * MSAL function that sets the default options when not explicitly configured from app developer
 *
 * @param auth
 * @param cache
 * @param system
 *
 * @returns Configuration object
 */ function $68fb5a78014bcfe7$export$f8352245bee68086({ auth: userInputAuth, cache: userInputCache, system: userInputSystem, telemetry: userInputTelemetry }, isBrowserEnvironment) {
    // Default auth options for browser
    const DEFAULT_AUTH_OPTIONS = {
        clientId: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
        authority: `${(0, $7c375ae106b964be$export$a002182e51710d39).DEFAULT_AUTHORITY}`,
        knownAuthorities: [],
        cloudDiscoveryMetadata: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
        authorityMetadata: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
        redirectUri: typeof window !== "undefined" ? (0, $3003b661a087a867$export$1204531fbbf6ecde)() : "",
        postLogoutRedirectUri: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
        navigateToLoginRequestUrl: true,
        clientCapabilities: [],
        protocolMode: (0, $de576c4d1becc778$export$73a3e3dedd37150d).AAD,
        OIDCOptions: {
            serverResponseType: (0, $7c375ae106b964be$export$b34cb6fbea2adc44).FRAGMENT,
            defaultScopes: [
                (0, $7c375ae106b964be$export$a002182e51710d39).OPENID_SCOPE,
                (0, $7c375ae106b964be$export$a002182e51710d39).PROFILE_SCOPE,
                (0, $7c375ae106b964be$export$a002182e51710d39).OFFLINE_ACCESS_SCOPE
            ]
        },
        azureCloudOptions: {
            azureCloudInstance: (0, $399fa9610e7cb0fb$export$4cda21933050d9ec).None,
            tenant: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        },
        skipAuthorityMetadataCache: false,
        supportsNestedAppAuth: false,
        instanceAware: false,
        encodeExtraQueryParams: false
    };
    // Default cache options for browser
    const DEFAULT_CACHE_OPTIONS = {
        cacheLocation: (0, $5ff55562d73e0e2b$export$573384e47a12d835).SessionStorage,
        temporaryCacheLocation: (0, $5ff55562d73e0e2b$export$573384e47a12d835).SessionStorage,
        storeAuthStateInCookie: false,
        secureCookies: false,
        // Default cache migration to true if cache location is localStorage since entries are preserved across tabs/windows. Migration has little to no benefit in sessionStorage and memoryStorage
        cacheMigrationEnabled: userInputCache && userInputCache.cacheLocation === (0, $5ff55562d73e0e2b$export$573384e47a12d835).LocalStorage ? true : false,
        claimsBasedCachingEnabled: false
    };
    // Default logger options for browser
    const DEFAULT_LOGGER_OPTIONS = {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        loggerCallback: ()=>{
        // allow users to not set logger call back
        },
        logLevel: (0, $0bf1d54ef751a29c$export$243e62d78d3b544d).Info,
        piiLoggingEnabled: false
    };
    // Default system options for browser
    const DEFAULT_BROWSER_SYSTEM_OPTIONS = {
        ...(0, $d21eb39178ebb5ae$export$f7a7dd6bfc156d75),
        loggerOptions: DEFAULT_LOGGER_OPTIONS,
        networkClient: isBrowserEnvironment ? new (0, $f210e947e17010a2$export$4c206ef5be879972)() : (0, $04922ae8364b32fe$export$6d95060a8ed7155a),
        navigationClient: new (0, $cb0bb957d18a08cc$export$d0d362a73d466c9b)(),
        loadFrameTimeout: 0,
        // If loadFrameTimeout is provided, use that as default.
        windowHashTimeout: userInputSystem?.loadFrameTimeout || $68fb5a78014bcfe7$export$a5835ee54399d410,
        iframeHashTimeout: userInputSystem?.loadFrameTimeout || $68fb5a78014bcfe7$export$f3ffe700be354b19,
        navigateFrameWait: 0,
        redirectNavigationTimeout: $68fb5a78014bcfe7$export$293647e7865520c6,
        asyncPopups: false,
        allowRedirectInIframe: false,
        allowPlatformBroker: false,
        nativeBrokerHandshakeTimeout: userInputSystem?.nativeBrokerHandshakeTimeout || $68fb5a78014bcfe7$export$73d1d87a8b7ddb57,
        pollIntervalMilliseconds: (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).DEFAULT_POLL_INTERVAL_MS
    };
    const providedSystemOptions = {
        ...DEFAULT_BROWSER_SYSTEM_OPTIONS,
        ...userInputSystem,
        loggerOptions: userInputSystem?.loggerOptions || DEFAULT_LOGGER_OPTIONS
    };
    const DEFAULT_TELEMETRY_OPTIONS = {
        application: {
            appName: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            appVersion: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        },
        client: new (0, $c21b15fc7f6dcd1f$export$c70f2989a65fda3e)()
    };
    // Throw an error if user has set OIDCOptions without being in OIDC protocol mode
    if (userInputAuth?.protocolMode !== (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC && userInputAuth?.OIDCOptions) {
        const logger = new (0, $0bf1d54ef751a29c$export$efa9a398d6368992)(providedSystemOptions.loggerOptions);
        logger.warning(JSON.stringify((0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).cannotSetOIDCOptions)));
    }
    // Throw an error if user has set allowPlatformBroker to true with OIDC protocol mode
    if (userInputAuth?.protocolMode && userInputAuth.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC && providedSystemOptions?.allowPlatformBroker) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).cannotAllowPlatformBroker);
    const overlayedConfig = {
        auth: {
            ...DEFAULT_AUTH_OPTIONS,
            ...userInputAuth,
            OIDCOptions: {
                ...DEFAULT_AUTH_OPTIONS.OIDCOptions,
                ...userInputAuth?.OIDCOptions
            }
        },
        cache: {
            ...DEFAULT_CACHE_OPTIONS,
            ...userInputCache
        },
        system: providedSystemOptions,
        telemetry: {
            ...DEFAULT_TELEMETRY_OPTIONS,
            ...userInputTelemetry
        }
    };
    return overlayedConfig;
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 'use strict';
/* eslint-disable header/header */ const $183cce12cb16965c$export$a8ff84c12d48cfa6 = "@azure/msal-browser";
const $183cce12cb16965c$export$83d89fbfd8236492 = "4.13.1";



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base class for operating context
 * Operating contexts are contexts in which MSAL.js is being run
 * More than one operating context may be available at a time
 * It's important from a logging and telemetry point of view for us to be able to identify the operating context.
 * For example: Some operating contexts will pre-cache tokens impacting performance telemetry
 */ class $277b893ea3b41414$export$3aea257f46651b2b {
    static loggerCallback(level, message) {
        switch(level){
            case (0, $0bf1d54ef751a29c$export$243e62d78d3b544d).Error:
                // eslint-disable-next-line no-console
                console.error(message);
                return;
            case (0, $0bf1d54ef751a29c$export$243e62d78d3b544d).Info:
                // eslint-disable-next-line no-console
                console.info(message);
                return;
            case (0, $0bf1d54ef751a29c$export$243e62d78d3b544d).Verbose:
                // eslint-disable-next-line no-console
                console.debug(message);
                return;
            case (0, $0bf1d54ef751a29c$export$243e62d78d3b544d).Warning:
                // eslint-disable-next-line no-console
                console.warn(message);
                return;
            default:
                // eslint-disable-next-line no-console
                console.log(message);
                return;
        }
    }
    constructor(config){
        /*
         * If loaded in an environment where window is not available,
         * set internal flag to false so that further requests fail.
         * This is to support server-side rendering environments.
         */ this.browserEnvironment = typeof window !== "undefined";
        this.config = (0, $68fb5a78014bcfe7$export$f8352245bee68086)(config, this.browserEnvironment);
        let sessionStorage;
        try {
            sessionStorage = window[(0, $5ff55562d73e0e2b$export$573384e47a12d835).SessionStorage];
        // Mute errors if it's a non-browser environment or cookies are blocked.
        } catch (e) {}
        const logLevelKey = sessionStorage?.getItem((0, $5ff55562d73e0e2b$export$b28668d53eb57e63));
        const piiLoggingKey = sessionStorage?.getItem((0, $5ff55562d73e0e2b$export$d9bc1c202a3825f1))?.toLowerCase();
        const piiLoggingEnabled = piiLoggingKey === "true" ? true : piiLoggingKey === "false" ? false : undefined;
        const loggerOptions = {
            ...this.config.system.loggerOptions
        };
        const logLevel = logLevelKey && Object.keys((0, $0bf1d54ef751a29c$export$243e62d78d3b544d)).includes(logLevelKey) ? (0, $0bf1d54ef751a29c$export$243e62d78d3b544d)[logLevelKey] : undefined;
        if (logLevel) {
            loggerOptions.loggerCallback = $277b893ea3b41414$export$3aea257f46651b2b.loggerCallback;
            loggerOptions.logLevel = logLevel;
        }
        if (piiLoggingEnabled !== undefined) loggerOptions.piiLoggingEnabled = piiLoggingEnabled;
        this.logger = new (0, $0bf1d54ef751a29c$export$efa9a398d6368992)(loggerOptions, (0, $183cce12cb16965c$export$a8ff84c12d48cfa6), (0, $183cce12cb16965c$export$83d89fbfd8236492));
        this.available = false;
    }
    /**
     * Return the MSAL config
     * @returns BrowserConfiguration
     */ getConfig() {
        return this.config;
    }
    /**
     * Returns the MSAL Logger
     * @returns Logger
     */ getLogger() {
        return this.logger;
    }
    isAvailable() {
        return this.available;
    }
    isBrowserEnvironment() {
        return this.browserEnvironment;
    }
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ /*! @azure/msal-browser v4.13.1 2025-06-10 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $067e966d84ac4206$export$6d05f68c12a46a00 = {
    UserInteractionRequired: "USER_INTERACTION_REQUIRED",
    UserCancel: "USER_CANCEL",
    NoNetwork: "NO_NETWORK",
    TransientError: "TRANSIENT_ERROR",
    PersistentError: "PERSISTENT_ERROR",
    Disabled: "DISABLED",
    AccountUnavailable: "ACCOUNT_UNAVAILABLE",
    NestedAppAuthUnavailable: "NESTED_APP_AUTH_UNAVAILABLE"
};





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * BridgeProxy
 * Provides a proxy for accessing a bridge to a host app and/or
 * platform broker
 */ class $ca5905c77ac1cd45$export$d974b2d5dad1979e {
    /**
     * initializeNestedAppAuthBridge - Initializes the bridge to the host app
     * @returns a promise that resolves to an InitializeBridgeResponse or rejects with an Error
     * @remarks This method will be called by the create factory method
     * @remarks If the bridge is not available, this method will throw an error
     */ static async initializeNestedAppAuthBridge() {
        if (window === undefined) throw new Error("window is undefined");
        if (window.nestedAppAuthBridge === undefined) throw new Error("window.nestedAppAuthBridge is undefined");
        try {
            window.nestedAppAuthBridge.addEventListener("message", (response)=>{
                const responsePayload = typeof response === "string" ? response : response.data;
                const responseEnvelope = JSON.parse(responsePayload);
                const request = $ca5905c77ac1cd45$export$d974b2d5dad1979e.bridgeRequests.find((element)=>element.requestId === responseEnvelope.requestId);
                if (request !== undefined) {
                    $ca5905c77ac1cd45$export$d974b2d5dad1979e.bridgeRequests.splice($ca5905c77ac1cd45$export$d974b2d5dad1979e.bridgeRequests.indexOf(request), 1);
                    if (responseEnvelope.success) request.resolve(responseEnvelope);
                    else request.reject(responseEnvelope.error);
                }
            });
            const bridgeResponse = await new Promise((resolve, reject)=>{
                const message = $ca5905c77ac1cd45$export$d974b2d5dad1979e.buildRequest("GetInitContext");
                const request = {
                    requestId: message.requestId,
                    method: message.method,
                    resolve: resolve,
                    reject: reject
                };
                $ca5905c77ac1cd45$export$d974b2d5dad1979e.bridgeRequests.push(request);
                window.nestedAppAuthBridge.postMessage(JSON.stringify(message));
            });
            return $ca5905c77ac1cd45$export$d974b2d5dad1979e.validateBridgeResultOrThrow(bridgeResponse.initContext);
        } catch (error) {
            window.console.log(error);
            throw error;
        }
    }
    /**
     * getTokenInteractive - Attempts to get a token interactively from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenInteractive(request) {
        return this.getToken("GetTokenPopup", request);
    }
    /**
     * getTokenSilent Attempts to get a token silently from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenSilent(request) {
        return this.getToken("GetToken", request);
    }
    async getToken(requestType, request) {
        const result = await this.sendRequest(requestType, {
            tokenParams: request
        });
        return {
            token: $ca5905c77ac1cd45$export$d974b2d5dad1979e.validateBridgeResultOrThrow(result.token),
            account: $ca5905c77ac1cd45$export$d974b2d5dad1979e.validateBridgeResultOrThrow(result.account)
        };
    }
    getHostCapabilities() {
        return this.capabilities ?? null;
    }
    getAccountContext() {
        return this.accountContext ? this.accountContext : null;
    }
    static buildRequest(method, requestParams) {
        return {
            messageType: "NestedAppAuthRequest",
            method: method,
            requestId: (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)(),
            sendTime: Date.now(),
            clientLibrary: (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).MSAL_SKU,
            clientLibraryVersion: (0, $183cce12cb16965c$export$83d89fbfd8236492),
            ...requestParams
        };
    }
    /**
     * A method used to send a request to the bridge
     * @param request A token request
     * @returns a promise that resolves to a response of provided type or rejects with a BridgeError
     */ sendRequest(method, requestParams) {
        const message = $ca5905c77ac1cd45$export$d974b2d5dad1979e.buildRequest(method, requestParams);
        const promise = new Promise((resolve, reject)=>{
            const request = {
                requestId: message.requestId,
                method: message.method,
                resolve: resolve,
                reject: reject
            };
            $ca5905c77ac1cd45$export$d974b2d5dad1979e.bridgeRequests.push(request);
            window.nestedAppAuthBridge.postMessage(JSON.stringify(message));
        });
        return promise;
    }
    static validateBridgeResultOrThrow(input) {
        if (input === undefined) {
            const bridgeError = {
                status: (0, $067e966d84ac4206$export$6d05f68c12a46a00).NestedAppAuthUnavailable
            };
            throw bridgeError;
        }
        return input;
    }
    /**
     * Private constructor for BridgeProxy
     * @param sdkName The name of the SDK being used to make requests on behalf of the app
     * @param sdkVersion The version of the SDK being used to make requests on behalf of the app
     * @param capabilities The capabilities of the bridge / SDK / platform broker
     */ constructor(sdkName, sdkVersion, accountContext, capabilities){
        this.sdkName = sdkName;
        this.sdkVersion = sdkVersion;
        this.accountContext = accountContext;
        this.capabilities = capabilities;
    }
    /**
     * Factory method for creating an implementation of IBridgeProxy
     * @returns A promise that resolves to a BridgeProxy implementation
     */ static async create() {
        const response = await $ca5905c77ac1cd45$export$d974b2d5dad1979e.initializeNestedAppAuthBridge();
        return new $ca5905c77ac1cd45$export$d974b2d5dad1979e(response.sdkName, response.sdkVersion, response.accountContext, response.capabilities);
    }
}
$ca5905c77ac1cd45$export$d974b2d5dad1979e.bridgeRequests = [];


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $769cd552162fdff8$export$a2170d4e3f010950 extends (0, $277b893ea3b41414$export$3aea257f46651b2b) {
    constructor(){
        super(...arguments);
        this.bridgeProxy = undefined;
        this.accountContext = null;
    }
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return $769cd552162fdff8$export$a2170d4e3f010950.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return $769cd552162fdff8$export$a2170d4e3f010950.ID;
    }
    /**
     * Returns the current BridgeProxy
     * @returns IBridgeProxy | undefined
     */ getBridgeProxy() {
        return this.bridgeProxy;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ async initialize() {
        try {
            if (typeof window !== "undefined") {
                if (typeof window.__initializeNestedAppAuth === "function") await window.__initializeNestedAppAuth();
                const bridgeProxy = await (0, $ca5905c77ac1cd45$export$d974b2d5dad1979e).create();
                /*
                 * Because we want single sign on we expect the host app to provide the account context
                 * with a min set of params that can be used to identify the account
                 * this.account = nestedApp.getAccountByFilter(bridgeProxy.getAccountContext());
                 */ this.accountContext = bridgeProxy.getAccountContext();
                this.bridgeProxy = bridgeProxy;
                this.available = bridgeProxy !== undefined;
            }
        } catch (ex) {
            this.logger.infoPii(`Could not initialize Nested App Auth bridge (${ex})`);
        }
        this.logger.info(`Nested App Auth Bridge available: ${this.available}`);
        return this.available;
    }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ $769cd552162fdff8$export$a2170d4e3f010950.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ $769cd552162fdff8$export$a2170d4e3f010950.ID = "NestedAppOperatingContext";


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $36cb4f619f94d121$export$f39c23bbfed89e6e extends (0, $277b893ea3b41414$export$3aea257f46651b2b) {
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return $36cb4f619f94d121$export$f39c23bbfed89e6e.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return $36cb4f619f94d121$export$f39c23bbfed89e6e.ID;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ async initialize() {
        this.available = typeof window !== "undefined";
        return this.available;
    /*
         * NOTE: The standard context is available as long as there is a window.  If/when we split out WAM from Browser
         * We can move the current contents of the initialize method to here and verify that the WAM extension is available
         */ }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ $36cb4f619f94d121$export$f39c23bbfed89e6e.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ $36cb4f619f94d121$export$f39c23bbfed89e6e.ID = "StandardOperatingContext";


/*! @azure/msal-browser v4.13.1 2025-06-10 */ /*! @azure/msal-browser v4.13.1 2025-06-10 */ /*! @azure/msal-common v15.7.0 2025-05-30 */ /*! @azure/msal-common v15.7.0 2025-05-30 */ 
/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $449d8ba978713aa9$export$e2ac717a196f20ed = "missing_kid_error";
const $449d8ba978713aa9$export$de67390d0a514010 = "missing_alg_error";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $3953c3c36cc43bcf$export$ce96a12d056376ad = {
    [(0, $449d8ba978713aa9$export$e2ac717a196f20ed)]: "The JOSE Header for the requested JWT, JWS or JWK object requires a keyId to be configured as the 'kid' header claim. No 'kid' value was provided.",
    [(0, $449d8ba978713aa9$export$de67390d0a514010)]: "The JOSE Header for the requested JWT, JWS or JWK object requires an algorithm to be specified as the 'alg' header claim. No 'alg' value was provided."
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */ class $3953c3c36cc43bcf$export$980ad46b7a115fad extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        this.name = "JoseHeaderError";
        Object.setPrototypeOf(this, $3953c3c36cc43bcf$export$980ad46b7a115fad.prototype);
    }
}
/** Returns JoseHeaderError object */ function $3953c3c36cc43bcf$export$3ef463ea134172ed(code) {
    return new $3953c3c36cc43bcf$export$980ad46b7a115fad(code, $3953c3c36cc43bcf$export$ce96a12d056376ad[code]);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $3c3d586eea595f5f$export$91748d132e6cb9b3 {
    constructor(options){
        this.typ = options.typ;
        this.alg = options.alg;
        this.kid = options.kid;
    }
    /**
     * Builds SignedHttpRequest formatted JOSE Header from the
     * JOSE Header options provided or previously set on the object and returns
     * the stringified header object.
     * Throws if keyId or algorithm aren't provided since they are required for Access Token Binding.
     * @param shrHeaderOptions
     * @returns
     */ static getShrHeaderString(shrHeaderOptions) {
        // KeyID is required on the SHR header
        if (!shrHeaderOptions.kid) throw (0, $3953c3c36cc43bcf$export$3ef463ea134172ed)((0, $449d8ba978713aa9$export$e2ac717a196f20ed));
        // Alg is required on the SHR header
        if (!shrHeaderOptions.alg) throw (0, $3953c3c36cc43bcf$export$3ef463ea134172ed)((0, $449d8ba978713aa9$export$de67390d0a514010));
        const shrHeader = new $3c3d586eea595f5f$export$91748d132e6cb9b3({
            // Access Token PoP headers must have type pop, but the type header can be overriden for special cases
            typ: shrHeaderOptions.typ || (0, $7c375ae106b964be$export$fe5c42ed17efe603).Pop,
            kid: shrHeaderOptions.kid,
            alg: shrHeaderOptions.alg
        });
        return JSON.stringify(shrHeader);
    }
}






/*! @azure/msal-browser v4.13.1 2025-06-10 */ 
/*! @azure/msal-browser v4.13.1 2025-06-10 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Storage wrapper for IndexedDB storage in browsers: https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */ class $f0fb072e99d60057$export$286b0f3b569e5f16 {
    constructor(){
        this.dbName = (0, $5ff55562d73e0e2b$export$3c22ff8b64b8f565);
        this.version = (0, $5ff55562d73e0e2b$export$6a9022b4c5fcea02);
        this.tableName = (0, $5ff55562d73e0e2b$export$9d785db034fb436f);
        this.dbOpen = false;
    }
    /**
     * Opens IndexedDB instance.
     */ async open() {
        return new Promise((resolve, reject)=>{
            const openDB = window.indexedDB.open(this.dbName, this.version);
            openDB.addEventListener("upgradeneeded", (e)=>{
                const event = e;
                event.target.result.createObjectStore(this.tableName);
            });
            openDB.addEventListener("success", (e)=>{
                const event = e;
                this.db = event.target.result;
                this.dbOpen = true;
                resolve();
            });
            openDB.addEventListener("error", ()=>reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$c1110692d2978b8))));
        });
    }
    /**
     * Closes the connection to IndexedDB database when all pending transactions
     * complete.
     */ closeConnection() {
        const db = this.db;
        if (db && this.dbOpen) {
            db.close();
            this.dbOpen = false;
        }
    }
    /**
     * Opens database if it's not already open
     */ async validateDbIsOpen() {
        if (!this.dbOpen) return this.open();
    }
    /**
     * Retrieves item from IndexedDB instance.
     * @param key
     */ async getItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGet = objectStore.get(key);
            dbGet.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGet.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Adds item to IndexedDB under given key
     * @param key
     * @param payload
     */ async setItem(key, payload) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbPut = objectStore.put(payload, key);
            dbPut.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbPut.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Removes item from IndexedDB under given key
     * @param key
     */ async removeItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbDelete = objectStore.delete(key);
            dbDelete.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbDelete.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Get all the keys from the storage object as an iterable array of strings.
     */ async getKeys() {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGetKeys = objectStore.getAllKeys();
            dbGetKeys.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGetKeys.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     *
     * Checks whether there is an object under the search key in the object store
     */ async containsKey(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbContainsKey = objectStore.count(key);
            dbContainsKey.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result === 1);
            });
            dbContainsKey.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Deletes the MSAL database. The database is deleted rather than cleared to make it possible
     * for client applications to downgrade to a previous MSAL version without worrying about forward compatibility issues
     * with IndexedDB database versions.
     */ async deleteDatabase() {
        // Check if database being deleted exists
        if (this.db && this.dbOpen) this.closeConnection();
        return new Promise((resolve, reject)=>{
            const deleteDbRequest = window.indexedDB.deleteDatabase((0, $5ff55562d73e0e2b$export$3c22ff8b64b8f565));
            const id = setTimeout(()=>reject(false), 200); // Reject if events aren't raised within 200ms
            deleteDbRequest.addEventListener("success", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("blocked", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("error", ()=>{
                clearTimeout(id);
                return reject(false);
            });
        });
    }
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $6be83965311b144c$export$d7392285c701ecf5 {
    constructor(){
        this.cache = new Map();
    }
    async initialize() {
    // Memory storage does not require initialization
    }
    getItem(key) {
        return this.cache.get(key) || null;
    }
    getUserData(key) {
        return this.getItem(key);
    }
    setItem(key, value) {
        this.cache.set(key, value);
    }
    async setUserData(key, value) {
        this.setItem(key, value);
    }
    removeItem(key) {
        this.cache.delete(key);
    }
    getKeys() {
        const cacheKeys = [];
        this.cache.forEach((value, key)=>{
            cacheKeys.push(key);
        });
        return cacheKeys;
    }
    containsKey(key) {
        return this.cache.has(key);
    }
    clear() {
        this.cache.clear();
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class allows MSAL to store artifacts asynchronously using the DatabaseStorage IndexedDB wrapper,
 * backed up with the more volatile MemoryStorage object for cases in which IndexedDB may be unavailable.
 */ class $9f41ba1b3e22ed80$export$b38f35aab37afcde {
    constructor(logger){
        this.inMemoryCache = new (0, $6be83965311b144c$export$d7392285c701ecf5)();
        this.indexedDBCache = new (0, $f0fb072e99d60057$export$286b0f3b569e5f16)();
        this.logger = logger;
    }
    handleDatabaseAccessError(error) {
        if (error instanceof (0, $6e0b7bb04b1e6592$export$f8eb6760ca13876a) && error.errorCode === (0, $0780bb28b98eb888$export$c1110692d2978b8)) this.logger.error("Could not access persistent storage. This may be caused by browser privacy features which block persistent storage in third-party contexts.");
        else throw error;
    }
    /**
     * Get the item matching the given key. Tries in-memory cache first, then in the asynchronous
     * storage object if item isn't found in-memory.
     * @param key
     */ async getItem(key) {
        const item = this.inMemoryCache.getItem(key);
        if (!item) try {
            this.logger.verbose("Queried item not found in in-memory cache, now querying persistent storage.");
            return await this.indexedDBCache.getItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
        return item;
    }
    /**
     * Sets the item in the in-memory cache and then tries to set it in the asynchronous
     * storage object with the given key.
     * @param key
     * @param value
     */ async setItem(key, value) {
        this.inMemoryCache.setItem(key, value);
        try {
            await this.indexedDBCache.setItem(key, value);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
    }
    /**
     * Removes the item matching the key from the in-memory cache, then tries to remove it from the asynchronous storage object.
     * @param key
     */ async removeItem(key) {
        this.inMemoryCache.removeItem(key);
        try {
            await this.indexedDBCache.removeItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
    }
    /**
     * Get all the keys from the in-memory cache as an iterable array of strings. If no keys are found, query the keys in the
     * asynchronous storage object.
     */ async getKeys() {
        const cacheKeys = this.inMemoryCache.getKeys();
        if (cacheKeys.length === 0) try {
            this.logger.verbose("In-memory cache is empty, now querying persistent storage.");
            return await this.indexedDBCache.getKeys();
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
        return cacheKeys;
    }
    /**
     * Returns true or false if the given key is present in the cache.
     * @param key
     */ async containsKey(key) {
        const containsKey = this.inMemoryCache.containsKey(key);
        if (!containsKey) try {
            this.logger.verbose("Key not found in in-memory cache, now querying persistent storage.");
            return await this.indexedDBCache.containsKey(key);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
        return containsKey;
    }
    /**
     * Clears in-memory Map
     */ clearInMemory() {
        // InMemory cache is a Map instance, clear is straightforward
        this.logger.verbose(`Deleting in-memory keystore`);
        this.inMemoryCache.clear();
        this.logger.verbose(`In-memory keystore deleted`);
    }
    /**
     * Tries to delete the IndexedDB database
     * @returns
     */ async clearPersistent() {
        try {
            this.logger.verbose("Deleting persistent keystore");
            const dbDeleted = await this.indexedDBCache.deleteDatabase();
            if (dbDeleted) this.logger.verbose("Persistent keystore deleted");
            return dbDeleted;
        } catch (e) {
            this.handleDatabaseAccessError(e);
            return false;
        }
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements MSAL's crypto interface, which allows it to perform base64 encoding and decoding, generating cryptographically random GUIDs and
 * implementing Proof Key for Code Exchange specs for the OAuth Authorization Code Flow using PKCE (rfc here: https://tools.ietf.org/html/rfc7636).
 */ class $e72c2cdc5fe24d6f$export$c274a7f0ebd24b14 {
    constructor(logger, performanceClient, skipValidateSubtleCrypto){
        this.logger = logger;
        // Browser crypto needs to be validated first before any other classes can be set.
        (0, $4e0948336b4ea4a7$export$1ddcc6bab2bf2314)(skipValidateSubtleCrypto ?? false);
        this.cache = new (0, $9f41ba1b3e22ed80$export$b38f35aab37afcde)(this.logger);
        this.performanceClient = performanceClient;
    }
    /**
     * Creates a new random GUID - used to populate state and nonce.
     * @returns string (GUID)
     */ createNewGuid() {
        return (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
    }
    /**
     * Encodes input string to base64.
     * @param input
     */ base64Encode(input) {
        return (0, $6f6986007da7f422$export$e510a73ee562749)(input);
    }
    /**
     * Decodes input string from base64.
     * @param input
     */ base64Decode(input) {
        return (0, $581fd3df606755c8$export$c62426fdd000a97e)(input);
    }
    /**
     * Encodes input string to base64 URL safe string.
     * @param input
     */ base64UrlEncode(input) {
        return (0, $6f6986007da7f422$export$9ef804feabbcbaf1)(input);
    }
    /**
     * Stringifies and base64Url encodes input public key
     * @param inputKid
     * @returns Base64Url encoded public key
     */ encodeKid(inputKid) {
        return this.base64UrlEncode(JSON.stringify({
            kid: inputKid
        }));
    }
    /**
     * Generates a keypair, stores it and returns a thumbprint
     * @param request
     */ async getPublicKeyThumbprint(request) {
        const publicKeyThumbMeasurement = this.performanceClient?.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).CryptoOptsGetPublicKeyThumbprint, request.correlationId);
        // Generate Keypair
        const keyPair = await (0, $4e0948336b4ea4a7$export$a949d36eab55b41f)($e72c2cdc5fe24d6f$export$c274a7f0ebd24b14.EXTRACTABLE, $e72c2cdc5fe24d6f$export$c274a7f0ebd24b14.POP_KEY_USAGES);
        // Generate Thumbprint for Public Key
        const publicKeyJwk = await (0, $4e0948336b4ea4a7$export$88781b8595a7d2ff)(keyPair.publicKey);
        const pubKeyThumprintObj = {
            e: publicKeyJwk.e,
            kty: publicKeyJwk.kty,
            n: publicKeyJwk.n
        };
        const publicJwkString = $e72c2cdc5fe24d6f$var$getSortedObjectString(pubKeyThumprintObj);
        const publicJwkHash = await this.hashString(publicJwkString);
        // Generate Thumbprint for Private Key
        const privateKeyJwk = await (0, $4e0948336b4ea4a7$export$88781b8595a7d2ff)(keyPair.privateKey);
        // Re-import private key to make it unextractable
        const unextractablePrivateKey = await (0, $4e0948336b4ea4a7$export$8bdea4e2e3f593c9)(privateKeyJwk, false, [
            "sign"
        ]);
        // Store Keypair data in keystore
        await this.cache.setItem(publicJwkHash, {
            privateKey: unextractablePrivateKey,
            publicKey: keyPair.publicKey,
            requestMethod: request.resourceRequestMethod,
            requestUri: request.resourceRequestUri
        });
        if (publicKeyThumbMeasurement) publicKeyThumbMeasurement.end({
            success: true
        });
        return publicJwkHash;
    }
    /**
     * Removes cryptographic keypair from key store matching the keyId passed in
     * @param kid
     */ async removeTokenBindingKey(kid) {
        await this.cache.removeItem(kid);
        const keyFound = await this.cache.containsKey(kid);
        return !keyFound;
    }
    /**
     * Removes all cryptographic keys from IndexedDB storage
     */ async clearKeystore() {
        // Delete in-memory keystores
        this.cache.clearInMemory();
        /**
         * There is only one database, so calling clearPersistent on asymmetric keystore takes care of
         * every persistent keystore
         */ try {
            await this.cache.clearPersistent();
            return true;
        } catch (e) {
            if (e instanceof Error) this.logger.error(`Clearing keystore failed with error: ${e.message}`);
            else this.logger.error("Clearing keystore failed with unknown error");
            return false;
        }
    }
    /**
     * Signs the given object as a jwt payload with private key retrieved by given kid.
     * @param payload
     * @param kid
     */ async signJwt(payload, kid, shrOptions, correlationId) {
        const signJwtMeasurement = this.performanceClient?.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).CryptoOptsSignJwt, correlationId);
        const cachedKeyPair = await this.cache.getItem(kid);
        if (!cachedKeyPair) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$a416b0eceb5c15df));
        // Get public key as JWK
        const publicKeyJwk = await (0, $4e0948336b4ea4a7$export$88781b8595a7d2ff)(cachedKeyPair.publicKey);
        const publicKeyJwkString = $e72c2cdc5fe24d6f$var$getSortedObjectString(publicKeyJwk);
        // Base64URL encode public key thumbprint with keyId only: BASE64URL({ kid: "FULL_PUBLIC_KEY_HASH" })
        const encodedKeyIdThumbprint = (0, $6f6986007da7f422$export$9ef804feabbcbaf1)(JSON.stringify({
            kid: kid
        }));
        // Generate header
        const shrHeader = (0, $3c3d586eea595f5f$export$91748d132e6cb9b3).getShrHeaderString({
            ...shrOptions?.header,
            alg: publicKeyJwk.alg,
            kid: encodedKeyIdThumbprint
        });
        const encodedShrHeader = (0, $6f6986007da7f422$export$9ef804feabbcbaf1)(shrHeader);
        // Generate payload
        payload.cnf = {
            jwk: JSON.parse(publicKeyJwkString)
        };
        const encodedPayload = (0, $6f6986007da7f422$export$9ef804feabbcbaf1)(JSON.stringify(payload));
        // Form token string
        const tokenString = `${encodedShrHeader}.${encodedPayload}`;
        // Sign token
        const encoder = new TextEncoder();
        const tokenBuffer = encoder.encode(tokenString);
        const signatureBuffer = await (0, $4e0948336b4ea4a7$export$c5552dfdbc7cec71)(cachedKeyPair.privateKey, tokenBuffer);
        const encodedSignature = (0, $6f6986007da7f422$export$84f5a428c7153a69)(new Uint8Array(signatureBuffer));
        const signedJwt = `${tokenString}.${encodedSignature}`;
        if (signJwtMeasurement) signJwtMeasurement.end({
            success: true
        });
        return signedJwt;
    }
    /**
     * Returns the SHA-256 hash of an input string
     * @param plainText
     */ async hashString(plainText) {
        return (0, $4e0948336b4ea4a7$export$9169be2e06c9c165)(plainText);
    }
}
$e72c2cdc5fe24d6f$export$c274a7f0ebd24b14.POP_KEY_USAGES = [
    "sign",
    "verify"
];
$e72c2cdc5fe24d6f$export$c274a7f0ebd24b14.EXTRACTABLE = true;
function $e72c2cdc5fe24d6f$var$getSortedObjectString(obj) {
    return JSON.stringify(obj, Object.keys(obj).sort());
}


/*! @azure/msal-common v15.7.0 2025-05-30 */ 
/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $df7cbba4fa13e524$export$aab44dc88900a3b(response) {
    return response.hasOwnProperty("authorization_endpoint") && response.hasOwnProperty("token_endpoint") && response.hasOwnProperty("issuer") && response.hasOwnProperty("jwks_uri");
}









/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $f7e197739ae81767$export$b288ea4a1e969e42(response) {
    return response.hasOwnProperty("tenant_discovery_endpoint") && response.hasOwnProperty("metadata");
}


/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $0c23eec3b11a3e26$export$6716273459d383f8(response) {
    return response.hasOwnProperty("error") && response.hasOwnProperty("error_description");
}


/*! @azure/msal-common v15.7.0 2025-05-30 */ 

/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Wraps a function with a performance measurement.
 * Usage: invoke(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5386add07ebe4b6d$export$468cda29b159ee5d = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`Executing function ${eventName}`);
        const inProgressEvent = telemetryClient?.startMeasurement(eventName, correlationId);
        if (correlationId) {
            // Track number of times this API is called in a single request
            const eventCount = eventName + "CallCount";
            telemetryClient?.incrementFields({
                [eventCount]: 1
            }, correlationId);
        }
        try {
            const result = callback(...args);
            inProgressEvent?.end({
                success: true
            });
            logger.trace(`Returning result from ${eventName}`);
            return result;
        } catch (e) {
            logger.trace(`Error occurred in ${eventName}`);
            try {
                logger.trace(JSON.stringify(e));
            } catch (e) {
                logger.trace("Unable to print error message.");
            }
            inProgressEvent?.end({
                success: false
            }, e);
            throw e;
        }
    };
};
/**
 * Wraps an async function with a performance measurement.
 * Usage: invokeAsync(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 *
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5386add07ebe4b6d$export$e4feded94d9adb18 = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`Executing function ${eventName}`);
        const inProgressEvent = telemetryClient?.startMeasurement(eventName, correlationId);
        if (correlationId) {
            // Track number of times this API is called in a single request
            const eventCount = eventName + "CallCount";
            telemetryClient?.incrementFields({
                [eventCount]: 1
            }, correlationId);
        }
        telemetryClient?.setPreQueueTime(eventName, correlationId);
        return callback(...args).then((response)=>{
            logger.trace(`Returning result from ${eventName}`);
            inProgressEvent?.end({
                success: true
            });
            return response;
        }).catch((e)=>{
            logger.trace(`Error occurred in ${eventName}`);
            try {
                logger.trace(JSON.stringify(e));
            } catch (e) {
                logger.trace("Unable to print error message.");
            }
            inProgressEvent?.end({
                success: false
            }, e);
            throw e;
        });
    };
};


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $43ad213520b7a7a8$export$1afa9d0f261ebb47 {
    constructor(networkInterface, logger, performanceClient, correlationId){
        this.networkInterface = networkInterface;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
    }
    /**
     * Detect the region from the application's environment.
     *
     * @returns Promise<string | null>
     */ async detectRegion(environmentRegion, regionDiscoveryMetadata) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryDetectRegion, this.correlationId);
        // Initialize auto detected region with the region from the envrionment
        let autodetectedRegionName = environmentRegion;
        // Check if a region was detected from the environment, if not, attempt to get the region from IMDS
        if (!autodetectedRegionName) {
            const options = $43ad213520b7a7a8$export$1afa9d0f261ebb47.IMDS_OPTIONS;
            try {
                const localIMDSVersionResponse = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getRegionFromIMDS.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.logger, this.performanceClient, this.correlationId)((0, $7c375ae106b964be$export$a002182e51710d39).IMDS_VERSION, options);
                if (localIMDSVersionResponse.status === (0, $7c375ae106b964be$export$2b71909294c66558).SUCCESS) {
                    autodetectedRegionName = localIMDSVersionResponse.body;
                    regionDiscoveryMetadata.region_source = (0, $7c375ae106b964be$export$3d4a3e11df589b40).IMDS;
                }
                // If the response using the local IMDS version failed, try to fetch the current version of IMDS and retry.
                if (localIMDSVersionResponse.status === (0, $7c375ae106b964be$export$2b71909294c66558).BAD_REQUEST) {
                    const currentIMDSVersion = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getCurrentVersion.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryGetCurrentVersion, this.logger, this.performanceClient, this.correlationId)(options);
                    if (!currentIMDSVersion) {
                        regionDiscoveryMetadata.region_source = (0, $7c375ae106b964be$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                        return null;
                    }
                    const currentIMDSVersionResponse = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getRegionFromIMDS.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.logger, this.performanceClient, this.correlationId)(currentIMDSVersion, options);
                    if (currentIMDSVersionResponse.status === (0, $7c375ae106b964be$export$2b71909294c66558).SUCCESS) {
                        autodetectedRegionName = currentIMDSVersionResponse.body;
                        regionDiscoveryMetadata.region_source = (0, $7c375ae106b964be$export$3d4a3e11df589b40).IMDS;
                    }
                }
            } catch (e) {
                regionDiscoveryMetadata.region_source = (0, $7c375ae106b964be$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                return null;
            }
        } else regionDiscoveryMetadata.region_source = (0, $7c375ae106b964be$export$3d4a3e11df589b40).ENVIRONMENT_VARIABLE;
        // If no region was auto detected from the environment or from the IMDS endpoint, mark the attempt as a FAILED_AUTO_DETECTION
        if (!autodetectedRegionName) regionDiscoveryMetadata.region_source = (0, $7c375ae106b964be$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
        return autodetectedRegionName || null;
    }
    /**
     * Make the call to the IMDS endpoint
     *
     * @param imdsEndpointUrl
     * @returns Promise<NetworkResponse<string>>
     */ async getRegionFromIMDS(version, options) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.correlationId);
        return this.networkInterface.sendGetRequestAsync(`${(0, $7c375ae106b964be$export$a002182e51710d39).IMDS_ENDPOINT}?api-version=${version}&format=text`, options, (0, $7c375ae106b964be$export$a002182e51710d39).IMDS_TIMEOUT);
    }
    /**
     * Get the most recent version of the IMDS endpoint available
     *
     * @returns Promise<string | null>
     */ async getCurrentVersion(options) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryGetCurrentVersion, this.correlationId);
        try {
            const response = await this.networkInterface.sendGetRequestAsync(`${(0, $7c375ae106b964be$export$a002182e51710d39).IMDS_ENDPOINT}?format=json`, options);
            // When IMDS endpoint is called without the api version query param, bad request response comes back with latest version.
            if (response.status === (0, $7c375ae106b964be$export$2b71909294c66558).BAD_REQUEST && response.body && response.body["newest-versions"] && response.body["newest-versions"].length > 0) return response.body["newest-versions"][0];
            return null;
        } catch (e) {
            return null;
        }
    }
}
// Options for the IMDS endpoint request
$43ad213520b7a7a8$export$1afa9d0f261ebb47.IMDS_OPTIONS = {
    headers: {
        Metadata: "true"
    }
};








'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The authority class validates the authority URIs used by the user, and retrieves the OpenID Configuration Data from the
 * endpoint. It will store the pertinent config data in this object for use during token calls.
 * @internal
 */ class $77bb430f4568f6e8$export$f1c6ec2e6d68c49c {
    constructor(authority, networkInterface, cacheManager, authorityOptions, logger, correlationId, performanceClient, managedIdentity){
        this.canonicalAuthority = authority;
        this._canonicalAuthority.validateAsUri();
        this.networkInterface = networkInterface;
        this.cacheManager = cacheManager;
        this.authorityOptions = authorityOptions;
        this.regionDiscoveryMetadata = {
            region_used: undefined,
            region_source: undefined,
            region_outcome: undefined
        };
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.managedIdentity = managedIdentity || false;
        this.regionDiscovery = new (0, $43ad213520b7a7a8$export$1afa9d0f261ebb47)(networkInterface, this.logger, this.performanceClient, this.correlationId);
    }
    /**
     * Get {@link AuthorityType}
     * @param authorityUri {@link IUri}
     * @private
     */ getAuthorityType(authorityUri) {
        // CIAM auth url pattern is being standardized as: <tenant>.ciamlogin.com
        if (authorityUri.HostNameAndPort.endsWith((0, $7c375ae106b964be$export$a002182e51710d39).CIAM_AUTH_URL)) return (0, $70363054a03152f4$export$cd82032b224a3839).Ciam;
        const pathSegments = authorityUri.PathSegments;
        if (pathSegments.length) switch(pathSegments[0].toLowerCase()){
            case (0, $7c375ae106b964be$export$a002182e51710d39).ADFS:
                return (0, $70363054a03152f4$export$cd82032b224a3839).Adfs;
            case (0, $7c375ae106b964be$export$a002182e51710d39).DSTS:
                return (0, $70363054a03152f4$export$cd82032b224a3839).Dsts;
        }
        return (0, $70363054a03152f4$export$cd82032b224a3839).Default;
    }
    // See above for AuthorityType
    get authorityType() {
        return this.getAuthorityType(this.canonicalAuthorityUrlComponents);
    }
    /**
     * ProtocolMode enum representing the way endpoints are constructed.
     */ get protocolMode() {
        return this.authorityOptions.protocolMode;
    }
    /**
     * Returns authorityOptions which can be used to reinstantiate a new authority instance
     */ get options() {
        return this.authorityOptions;
    }
    /**
     * A URL that is the authority set by the developer
     */ get canonicalAuthority() {
        return this._canonicalAuthority.urlString;
    }
    /**
     * Sets canonical authority.
     */ set canonicalAuthority(url) {
        this._canonicalAuthority = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(url);
        this._canonicalAuthority.validateAsUri();
        this._canonicalAuthorityUrlComponents = null;
    }
    /**
     * Get authority components.
     */ get canonicalAuthorityUrlComponents() {
        if (!this._canonicalAuthorityUrlComponents) this._canonicalAuthorityUrlComponents = this._canonicalAuthority.getUrlComponents();
        return this._canonicalAuthorityUrlComponents;
    }
    /**
     * Get hostname and port i.e. login.microsoftonline.com
     */ get hostnameAndPort() {
        return this.canonicalAuthorityUrlComponents.HostNameAndPort.toLowerCase();
    }
    /**
     * Get tenant for authority.
     */ get tenant() {
        return this.canonicalAuthorityUrlComponents.PathSegments[0];
    }
    /**
     * OAuth /authorize endpoint for requests
     */ get authorizationEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.authorization_endpoint);
        else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    /**
     * OAuth /token endpoint for requests
     */ get tokenEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint);
        else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    get deviceCodeEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint.replace("/token", "/devicecode"));
        else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    /**
     * OAuth logout endpoint for requests
     */ get endSessionEndpoint() {
        if (this.discoveryComplete()) {
            // ROPC policies may not have end_session_endpoint set
            if (!this.metadata.end_session_endpoint) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c3bd741c16a889f3));
            return this.replacePath(this.metadata.end_session_endpoint);
        } else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    /**
     * OAuth issuer for requests
     */ get selfSignedJwtAudience() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.issuer);
        else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    /**
     * Jwks_uri for token signing keys
     */ get jwksUri() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.jwks_uri);
        else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    /**
     * Returns a flag indicating that tenant name can be replaced in authority {@link IUri}
     * @param authorityUri {@link IUri}
     * @private
     */ canReplaceTenant(authorityUri) {
        return authorityUri.PathSegments.length === 1 && !$77bb430f4568f6e8$export$f1c6ec2e6d68c49c.reservedTenantDomains.has(authorityUri.PathSegments[0]) && this.getAuthorityType(authorityUri) === (0, $70363054a03152f4$export$cd82032b224a3839).Default && this.protocolMode !== (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC;
    }
    /**
     * Replaces tenant in url path with current tenant. Defaults to common.
     * @param urlString
     */ replaceTenant(urlString) {
        return urlString.replace(/{tenant}|{tenantid}/g, this.tenant);
    }
    /**
     * Replaces path such as tenant or policy with the current tenant or policy.
     * @param urlString
     */ replacePath(urlString) {
        let endpoint = urlString;
        const cachedAuthorityUrl = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(this.metadata.canonical_authority);
        const cachedAuthorityUrlComponents = cachedAuthorityUrl.getUrlComponents();
        const cachedAuthorityParts = cachedAuthorityUrlComponents.PathSegments;
        const currentAuthorityParts = this.canonicalAuthorityUrlComponents.PathSegments;
        currentAuthorityParts.forEach((currentPart, index)=>{
            let cachedPart = cachedAuthorityParts[index];
            if (index === 0 && this.canReplaceTenant(cachedAuthorityUrlComponents)) {
                const tenantId = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(this.metadata.authorization_endpoint).getUrlComponents().PathSegments[0];
                /**
                 * Check if AAD canonical authority contains tenant domain name, for example "testdomain.onmicrosoft.com",
                 * by comparing its first path segment to the corresponding authorization endpoint path segment, which is
                 * always resolved with tenant id by OIDC.
                 */ if (cachedPart !== tenantId) {
                    this.logger.verbose(`Replacing tenant domain name ${cachedPart} with id ${tenantId}`);
                    cachedPart = tenantId;
                }
            }
            if (currentPart !== cachedPart) endpoint = endpoint.replace(`/${cachedPart}/`, `/${currentPart}/`);
        });
        return this.replaceTenant(endpoint);
    }
    /**
     * The default open id configuration endpoint for any canonical authority.
     */ get defaultOpenIdConfigurationEndpoint() {
        const canonicalAuthorityHost = this.hostnameAndPort;
        if (this.canonicalAuthority.endsWith("v2.0/") || this.authorityType === (0, $70363054a03152f4$export$cd82032b224a3839).Adfs || this.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC && !this.isAliasOfKnownMicrosoftAuthority(canonicalAuthorityHost)) return `${this.canonicalAuthority}.well-known/openid-configuration`;
        return `${this.canonicalAuthority}v2.0/.well-known/openid-configuration`;
    }
    /**
     * Boolean that returns whether or not tenant discovery has been completed.
     */ discoveryComplete() {
        return !!this.metadata;
    }
    /**
     * Perform endpoint discovery to discover aliases, preferred_cache, preferred_network
     * and the /authorize, /token and logout endpoints.
     */ async resolveEndpointsAsync() {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityResolveEndpointsAsync, this.correlationId);
        const metadataEntity = this.getCurrentMetadataEntity();
        const cloudDiscoverySource = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.updateCloudDiscoveryMetadata.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateCloudDiscoveryMetadata, this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.canonicalAuthority = this.canonicalAuthority.replace(this.hostnameAndPort, metadataEntity.preferred_network);
        const endpointSource = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.updateEndpointMetadata.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateEndpointMetadata, this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.updateCachedMetadata(metadataEntity, cloudDiscoverySource, {
            source: endpointSource
        });
        this.performanceClient?.addFields({
            cloudDiscoverySource: cloudDiscoverySource,
            authorityEndpointSource: endpointSource
        }, this.correlationId);
    }
    /**
     * Returns metadata entity from cache if it exists, otherwiser returns a new metadata entity built
     * from the configured canonical authority
     * @returns
     */ getCurrentMetadataEntity() {
        let metadataEntity = this.cacheManager.getAuthorityMetadataByAlias(this.hostnameAndPort);
        if (!metadataEntity) metadataEntity = {
            aliases: [],
            preferred_cache: this.hostnameAndPort,
            preferred_network: this.hostnameAndPort,
            canonical_authority: this.canonicalAuthority,
            authorization_endpoint: "",
            token_endpoint: "",
            end_session_endpoint: "",
            issuer: "",
            aliasesFromNetwork: false,
            endpointsFromNetwork: false,
            expiresAt: (0, $9ab3d26df56b176d$export$90f464c4238c27e5)(),
            jwks_uri: ""
        };
        return metadataEntity;
    }
    /**
     * Updates cached metadata based on metadata source and sets the instance's metadata
     * property to the same value
     * @param metadataEntity
     * @param cloudDiscoverySource
     * @param endpointMetadataResult
     */ updateCachedMetadata(metadataEntity, cloudDiscoverySource, endpointMetadataResult) {
        if (cloudDiscoverySource !== (0, $7c375ae106b964be$export$5d365d77acfcb55d).CACHE && endpointMetadataResult?.source !== (0, $7c375ae106b964be$export$5d365d77acfcb55d).CACHE) {
            // Reset the expiration time unless both values came from a successful cache lookup
            metadataEntity.expiresAt = (0, $9ab3d26df56b176d$export$90f464c4238c27e5)();
            metadataEntity.canonical_authority = this.canonicalAuthority;
        }
        const cacheKey = this.cacheManager.generateAuthorityMetadataCacheKey(metadataEntity.preferred_cache);
        this.cacheManager.setAuthorityMetadata(cacheKey, metadataEntity);
        this.metadata = metadataEntity;
    }
    /**
     * Update AuthorityMetadataEntity with new endpoints and return where the information came from
     * @param metadataEntity
     */ async updateEndpointMetadata(metadataEntity) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateEndpointMetadata, this.correlationId);
        const localMetadata = this.updateEndpointMetadataFromLocalSources(metadataEntity);
        // Further update may be required for hardcoded metadata if regional metadata is preferred
        if (localMetadata) {
            if (localMetadata.source === (0, $7c375ae106b964be$export$5d365d77acfcb55d).HARDCODED_VALUES) {
                // If the user prefers to use an azure region replace the global endpoints with regional information.
                if (this.authorityOptions.azureRegionConfiguration?.azureRegion) {
                    if (localMetadata.metadata) {
                        const hardcodedMetadata = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.updateMetadataWithRegionalInformation.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.logger, this.performanceClient, this.correlationId)(localMetadata.metadata);
                        (0, $9ab3d26df56b176d$export$ef87e8fbd8af5f96)(metadataEntity, hardcodedMetadata, false);
                        metadataEntity.canonical_authority = this.canonicalAuthority;
                    }
                }
            }
            return localMetadata.source;
        }
        // Get metadata from network if local sources aren't available
        let metadata = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getEndpointMetadataFromNetwork.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityGetEndpointMetadataFromNetwork, this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            // If the user prefers to use an azure region replace the global endpoints with regional information.
            if (this.authorityOptions.azureRegionConfiguration?.azureRegion) metadata = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.updateMetadataWithRegionalInformation.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.logger, this.performanceClient, this.correlationId)(metadata);
            (0, $9ab3d26df56b176d$export$ef87e8fbd8af5f96)(metadataEntity, metadata, true);
            return (0, $7c375ae106b964be$export$5d365d77acfcb55d).NETWORK;
        } else // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$73566da29bc073eb), this.defaultOpenIdConfigurationEndpoint);
    }
    /**
     * Updates endpoint metadata from local sources and returns where the information was retrieved from and the metadata config
     * response if the source is hardcoded metadata
     * @param metadataEntity
     * @returns
     */ updateEndpointMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("Attempting to get endpoint metadata from authority configuration");
        const configMetadata = this.getEndpointMetadataFromConfig();
        if (configMetadata) {
            this.logger.verbose("Found endpoint metadata in authority configuration");
            (0, $9ab3d26df56b176d$export$ef87e8fbd8af5f96)(metadataEntity, configMetadata, false);
            return {
                source: (0, $7c375ae106b964be$export$5d365d77acfcb55d).CONFIG
            };
        }
        this.logger.verbose("Did not find endpoint metadata in the config... Attempting to get endpoint metadata from the hardcoded values.");
        // skipAuthorityMetadataCache is used to bypass hardcoded authority metadata and force a network metadata cache lookup and network metadata request if no cached response is available.
        if (this.authorityOptions.skipAuthorityMetadataCache) this.logger.verbose("Skipping hardcoded metadata cache since skipAuthorityMetadataCache is set to true. Attempting to get endpoint metadata from the network metadata cache.");
        else {
            const hardcodedMetadata = this.getEndpointMetadataFromHardcodedValues();
            if (hardcodedMetadata) {
                (0, $9ab3d26df56b176d$export$ef87e8fbd8af5f96)(metadataEntity, hardcodedMetadata, false);
                return {
                    source: (0, $7c375ae106b964be$export$5d365d77acfcb55d).HARDCODED_VALUES,
                    metadata: hardcodedMetadata
                };
            } else this.logger.verbose("Did not find endpoint metadata in hardcoded values... Attempting to get endpoint metadata from the network metadata cache.");
        }
        // Check cached metadata entity expiration status
        const metadataEntityExpired = (0, $9ab3d26df56b176d$export$b96839cf63a15b0f)(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.endpointsFromNetwork && !metadataEntityExpired) {
            // No need to update
            this.logger.verbose("Found endpoint metadata in the cache.");
            return {
                source: (0, $7c375ae106b964be$export$5d365d77acfcb55d).CACHE
            };
        } else if (metadataEntityExpired) this.logger.verbose("The metadata entity is expired.");
        return null;
    }
    /**
     * Compares the number of url components after the domain to determine if the cached
     * authority metadata can be used for the requested authority. Protects against same domain different
     * authority such as login.microsoftonline.com/tenant and login.microsoftonline.com/tfp/tenant/policy
     * @param metadataEntity
     */ isAuthoritySameType(metadataEntity) {
        const cachedAuthorityUrl = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(metadataEntity.canonical_authority);
        const cachedParts = cachedAuthorityUrl.getUrlComponents().PathSegments;
        return cachedParts.length === this.canonicalAuthorityUrlComponents.PathSegments.length;
    }
    /**
     * Parse authorityMetadata config option
     */ getEndpointMetadataFromConfig() {
        if (this.authorityOptions.authorityMetadata) try {
            return JSON.parse(this.authorityOptions.authorityMetadata);
        } catch (e) {
            throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$edb4d5942bc8ccff));
        }
        return null;
    }
    /**
     * Gets OAuth endpoints from the given OpenID configuration endpoint.
     *
     * @param hasHardcodedMetadata boolean
     */ async getEndpointMetadataFromNetwork() {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityGetEndpointMetadataFromNetwork, this.correlationId);
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ const openIdConfigurationEndpoint = this.defaultOpenIdConfigurationEndpoint;
        this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: attempting to retrieve OAuth endpoints from ${openIdConfigurationEndpoint}`);
        try {
            const response = await this.networkInterface.sendGetRequestAsync(openIdConfigurationEndpoint, options);
            const isValidResponse = (0, $df7cbba4fa13e524$export$aab44dc88900a3b)(response.body);
            if (isValidResponse) return response.body;
            else {
                this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: could not parse response as OpenID configuration`);
                return null;
            }
        } catch (e) {
            this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: ${e}`);
            return null;
        }
    }
    /**
     * Get OAuth endpoints for common authorities.
     */ getEndpointMetadataFromHardcodedValues() {
        if (this.hostnameAndPort in (0, $ff4bd32e3511744b$export$f612854287391207)) return (0, $ff4bd32e3511744b$export$f612854287391207)[this.hostnameAndPort];
        return null;
    }
    /**
     * Update the retrieved metadata with regional information.
     * User selected Azure region will be used if configured.
     */ async updateMetadataWithRegionalInformation(metadata) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.correlationId);
        const userConfiguredAzureRegion = this.authorityOptions.azureRegionConfiguration?.azureRegion;
        if (userConfiguredAzureRegion) {
            if (userConfiguredAzureRegion !== (0, $7c375ae106b964be$export$a002182e51710d39).AZURE_REGION_AUTO_DISCOVER_FLAG) {
                this.regionDiscoveryMetadata.region_outcome = (0, $7c375ae106b964be$export$92a685f9218422bd).CONFIGURED_NO_AUTO_DETECTION;
                this.regionDiscoveryMetadata.region_used = userConfiguredAzureRegion;
                return $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.replaceWithRegionalInformation(metadata, userConfiguredAzureRegion);
            }
            const autodetectedRegionName = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.regionDiscovery.detectRegion.bind(this.regionDiscovery), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryDetectRegion, this.logger, this.performanceClient, this.correlationId)(this.authorityOptions.azureRegionConfiguration?.environmentRegion, this.regionDiscoveryMetadata);
            if (autodetectedRegionName) {
                this.regionDiscoveryMetadata.region_outcome = (0, $7c375ae106b964be$export$92a685f9218422bd).AUTO_DETECTION_REQUESTED_SUCCESSFUL;
                this.regionDiscoveryMetadata.region_used = autodetectedRegionName;
                return $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.replaceWithRegionalInformation(metadata, autodetectedRegionName);
            }
            this.regionDiscoveryMetadata.region_outcome = (0, $7c375ae106b964be$export$92a685f9218422bd).AUTO_DETECTION_REQUESTED_FAILED;
        }
        return metadata;
    }
    /**
     * Updates the AuthorityMetadataEntity with new aliases, preferred_network and preferred_cache
     * and returns where the information was retrieved from
     * @param metadataEntity
     * @returns AuthorityMetadataSource
     */ async updateCloudDiscoveryMetadata(metadataEntity) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateCloudDiscoveryMetadata, this.correlationId);
        const localMetadataSource = this.updateCloudDiscoveryMetadataFromLocalSources(metadataEntity);
        if (localMetadataSource) return localMetadataSource;
        // Fallback to network as metadata source
        const metadata = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getCloudDiscoveryMetadataFromNetwork.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityGetCloudDiscoveryMetadataFromNetwork, this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            (0, $9ab3d26df56b176d$export$6d4972e1d88c8518)(metadataEntity, metadata, true);
            return (0, $7c375ae106b964be$export$5d365d77acfcb55d).NETWORK;
        }
        // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$50c3162fda5f57));
    }
    updateCloudDiscoveryMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("Attempting to get cloud discovery metadata  from authority configuration");
        this.logger.verbosePii(`Known Authorities: ${this.authorityOptions.knownAuthorities || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_APPLICABLE}`);
        this.logger.verbosePii(`Authority Metadata: ${this.authorityOptions.authorityMetadata || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_APPLICABLE}`);
        this.logger.verbosePii(`Canonical Authority: ${metadataEntity.canonical_authority || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_APPLICABLE}`);
        const metadata = this.getCloudDiscoveryMetadataFromConfig();
        if (metadata) {
            this.logger.verbose("Found cloud discovery metadata in authority configuration");
            (0, $9ab3d26df56b176d$export$6d4972e1d88c8518)(metadataEntity, metadata, false);
            return (0, $7c375ae106b964be$export$5d365d77acfcb55d).CONFIG;
        }
        // If the cached metadata came from config but that config was not passed to this instance, we must go to hardcoded values
        this.logger.verbose("Did not find cloud discovery metadata in the config... Attempting to get cloud discovery metadata from the hardcoded values.");
        if (this.options.skipAuthorityMetadataCache) this.logger.verbose("Skipping hardcoded cloud discovery metadata cache since skipAuthorityMetadataCache is set to true. Attempting to get cloud discovery metadata from the network metadata cache.");
        else {
            const hardcodedMetadata = (0, $ff4bd32e3511744b$export$1b1433f93c9873f)(this.hostnameAndPort);
            if (hardcodedMetadata) {
                this.logger.verbose("Found cloud discovery metadata from hardcoded values.");
                (0, $9ab3d26df56b176d$export$6d4972e1d88c8518)(metadataEntity, hardcodedMetadata, false);
                return (0, $7c375ae106b964be$export$5d365d77acfcb55d).HARDCODED_VALUES;
            }
            this.logger.verbose("Did not find cloud discovery metadata in hardcoded values... Attempting to get cloud discovery metadata from the network metadata cache.");
        }
        const metadataEntityExpired = (0, $9ab3d26df56b176d$export$b96839cf63a15b0f)(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.aliasesFromNetwork && !metadataEntityExpired) {
            this.logger.verbose("Found cloud discovery metadata in the cache.");
            // No need to update
            return (0, $7c375ae106b964be$export$5d365d77acfcb55d).CACHE;
        } else if (metadataEntityExpired) this.logger.verbose("The metadata entity is expired.");
        return null;
    }
    /**
     * Parse cloudDiscoveryMetadata config or check knownAuthorities
     */ getCloudDiscoveryMetadataFromConfig() {
        // CIAM does not support cloud discovery metadata
        if (this.authorityType === (0, $70363054a03152f4$export$cd82032b224a3839).Ciam) {
            this.logger.verbose("CIAM authorities do not support cloud discovery metadata, generate the aliases from authority host.");
            return $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        // Check if network response was provided in config
        if (this.authorityOptions.cloudDiscoveryMetadata) {
            this.logger.verbose("The cloud discovery metadata has been provided as a network response, in the config.");
            try {
                this.logger.verbose("Attempting to parse the cloud discovery metadata.");
                const parsedResponse = JSON.parse(this.authorityOptions.cloudDiscoveryMetadata);
                const metadata = (0, $ff4bd32e3511744b$export$6e21098ea6e60dc)(parsedResponse.metadata, this.hostnameAndPort);
                this.logger.verbose("Parsed the cloud discovery metadata.");
                if (metadata) {
                    this.logger.verbose("There is returnable metadata attached to the parsed cloud discovery metadata.");
                    return metadata;
                } else this.logger.verbose("There is no metadata attached to the parsed cloud discovery metadata.");
            } catch (e) {
                this.logger.verbose("Unable to parse the cloud discovery metadata. Throwing Invalid Cloud Discovery Metadata Error.");
                throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$92a2985751150ca5));
            }
        }
        // If cloudDiscoveryMetadata is empty or does not contain the host, check knownAuthorities
        if (this.isInKnownAuthorities()) {
            this.logger.verbose("The host is included in knownAuthorities. Creating new cloud discovery metadata from the host.");
            return $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return null;
    }
    /**
     * Called to get metadata from network if CloudDiscoveryMetadata was not populated by config
     *
     * @param hasHardcodedMetadata boolean
     */ async getCloudDiscoveryMetadataFromNetwork() {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityGetCloudDiscoveryMetadataFromNetwork, this.correlationId);
        const instanceDiscoveryEndpoint = `${(0, $7c375ae106b964be$export$a002182e51710d39).AAD_INSTANCE_DISCOVERY_ENDPT}${this.canonicalAuthority}oauth2/v2.0/authorize`;
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ let match = null;
        try {
            const response = await this.networkInterface.sendGetRequestAsync(instanceDiscoveryEndpoint, options);
            let typedResponseBody;
            let metadata;
            if ((0, $f7e197739ae81767$export$b288ea4a1e969e42)(response.body)) {
                typedResponseBody = response.body;
                metadata = typedResponseBody.metadata;
                this.logger.verbosePii(`tenant_discovery_endpoint is: ${typedResponseBody.tenant_discovery_endpoint}`);
            } else if ((0, $0c23eec3b11a3e26$export$6716273459d383f8)(response.body)) {
                this.logger.warning(`A CloudInstanceDiscoveryErrorResponse was returned. The cloud instance discovery network request's status code is: ${response.status}`);
                typedResponseBody = response.body;
                if (typedResponseBody.error === (0, $7c375ae106b964be$export$a002182e51710d39).INVALID_INSTANCE) {
                    this.logger.error("The CloudInstanceDiscoveryErrorResponse error is invalid_instance.");
                    return null;
                }
                this.logger.warning(`The CloudInstanceDiscoveryErrorResponse error is ${typedResponseBody.error}`);
                this.logger.warning(`The CloudInstanceDiscoveryErrorResponse error description is ${typedResponseBody.error_description}`);
                this.logger.warning("Setting the value of the CloudInstanceDiscoveryMetadata (returned from the network) to []");
                metadata = [];
            } else {
                this.logger.error("AAD did not return a CloudInstanceDiscoveryResponse or CloudInstanceDiscoveryErrorResponse");
                return null;
            }
            this.logger.verbose("Attempting to find a match between the developer's authority and the CloudInstanceDiscoveryMetadata returned from the network request.");
            match = (0, $ff4bd32e3511744b$export$6e21098ea6e60dc)(metadata, this.hostnameAndPort);
        } catch (error) {
            if (error instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) this.logger.error(`There was a network error while attempting to get the cloud discovery instance metadata.\nError: ${error.errorCode}\nError Description: ${error.errorMessage}`);
            else {
                const typedError = error;
                this.logger.error(`A non-MSALJS error was thrown while attempting to get the cloud instance discovery metadata.\nError: ${typedError.name}\nError Description: ${typedError.message}`);
            }
            return null;
        }
        // Custom Domain scenario, host is trusted because Instance Discovery call succeeded
        if (!match) {
            this.logger.warning("The developer's authority was not found within the CloudInstanceDiscoveryMetadata returned from the network request.");
            this.logger.verbose("Creating custom Authority for custom domain scenario.");
            match = $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return match;
    }
    /**
     * Helper function to determine if this host is included in the knownAuthorities config option
     */ isInKnownAuthorities() {
        const matches = this.authorityOptions.knownAuthorities.filter((authority)=>{
            return authority && (0, $f7f911f196324278$export$3abcdca7229e54f2).getDomainFromUrl(authority).toLowerCase() === this.hostnameAndPort;
        });
        return matches.length > 0;
    }
    /**
     * helper function to populate the authority based on azureCloudOptions
     * @param authorityString
     * @param azureCloudOptions
     */ static generateAuthority(authorityString, azureCloudOptions) {
        let authorityAzureCloudInstance;
        if (azureCloudOptions && azureCloudOptions.azureCloudInstance !== (0, $399fa9610e7cb0fb$export$4cda21933050d9ec).None) {
            const tenant = azureCloudOptions.tenant ? azureCloudOptions.tenant : (0, $7c375ae106b964be$export$a002182e51710d39).DEFAULT_COMMON_TENANT;
            authorityAzureCloudInstance = `${azureCloudOptions.azureCloudInstance}/${tenant}/`;
        }
        return authorityAzureCloudInstance ? authorityAzureCloudInstance : authorityString;
    }
    /**
     * Creates cloud discovery metadata object from a given host
     * @param host
     */ static createCloudDiscoveryMetadataFromHost(host) {
        return {
            preferred_network: host,
            preferred_cache: host,
            aliases: [
                host
            ]
        };
    }
    /**
     * helper function to generate environment from authority object
     */ getPreferredCache() {
        if (this.managedIdentity) return (0, $7c375ae106b964be$export$a002182e51710d39).DEFAULT_AUTHORITY_HOST;
        else if (this.discoveryComplete()) return this.metadata.preferred_cache;
        else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    /**
     * Returns whether or not the provided host is an alias of this authority instance
     * @param host
     */ isAlias(host) {
        return this.metadata.aliases.indexOf(host) > -1;
    }
    /**
     * Returns whether or not the provided host is an alias of a known Microsoft authority for purposes of endpoint discovery
     * @param host
     */ isAliasOfKnownMicrosoftAuthority(host) {
        return (0, $ff4bd32e3511744b$export$7d026f079148cd31).has(host);
    }
    /**
     * Checks whether the provided host is that of a public cloud authority
     *
     * @param authority string
     * @returns bool
     */ static isPublicCloudAuthority(host) {
        return (0, $7c375ae106b964be$export$a002182e51710d39).KNOWN_PUBLIC_CLOUDS.indexOf(host) >= 0;
    }
    /**
     * Rebuild the authority string with the region
     *
     * @param host string
     * @param region string
     */ static buildRegionalAuthorityString(host, region, queryString) {
        // Create and validate a Url string object with the initial authority string
        const authorityUrlInstance = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(host);
        authorityUrlInstance.validateAsUri();
        const authorityUrlParts = authorityUrlInstance.getUrlComponents();
        let hostNameAndPort = `${region}.${authorityUrlParts.HostNameAndPort}`;
        if (this.isPublicCloudAuthority(authorityUrlParts.HostNameAndPort)) hostNameAndPort = `${region}.${(0, $7c375ae106b964be$export$a002182e51710d39).REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX}`;
        // Include the query string portion of the url
        const url = (0, $f7f911f196324278$export$3abcdca7229e54f2).constructAuthorityUriFromObject({
            ...authorityUrlInstance.getUrlComponents(),
            HostNameAndPort: hostNameAndPort
        }).urlString;
        // Add the query string if a query string was provided
        if (queryString) return `${url}?${queryString}`;
        return url;
    }
    /**
     * Replace the endpoints in the metadata object with their regional equivalents.
     *
     * @param metadata OpenIdConfigResponse
     * @param azureRegion string
     */ static replaceWithRegionalInformation(metadata, azureRegion) {
        const regionalMetadata = {
            ...metadata
        };
        regionalMetadata.authorization_endpoint = $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.authorization_endpoint, azureRegion);
        regionalMetadata.token_endpoint = $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.token_endpoint, azureRegion);
        if (regionalMetadata.end_session_endpoint) regionalMetadata.end_session_endpoint = $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.end_session_endpoint, azureRegion);
        return regionalMetadata;
    }
    /**
     * Transform CIAM_AUTHORIY as per the below rules:
     * If no path segments found and it is a CIAM authority (hostname ends with .ciamlogin.com), then transform it
     *
     * NOTE: The transformation path should go away once STS supports CIAM with the format: `tenantIdorDomain.ciamlogin.com`
     * `ciamlogin.com` can also change in the future and we should accommodate the same
     *
     * @param authority
     */ static transformCIAMAuthority(authority) {
        let ciamAuthority = authority;
        const authorityUrl = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(authority);
        const authorityUrlComponents = authorityUrl.getUrlComponents();
        // check if transformation is needed
        if (authorityUrlComponents.PathSegments.length === 0 && authorityUrlComponents.HostNameAndPort.endsWith((0, $7c375ae106b964be$export$a002182e51710d39).CIAM_AUTH_URL)) {
            const tenantIdOrDomain = authorityUrlComponents.HostNameAndPort.split(".")[0];
            ciamAuthority = `${ciamAuthority}${tenantIdOrDomain}${(0, $7c375ae106b964be$export$a002182e51710d39).AAD_TENANT_DOMAIN_SUFFIX}`;
        }
        return ciamAuthority;
    }
}
// Reserved tenant domain names that will not be replaced with tenant id
$77bb430f4568f6e8$export$f1c6ec2e6d68c49c.reservedTenantDomains = new Set([
    "{tenant}",
    "{tenantid}",
    (0, $7c375ae106b964be$export$e18ac120172ed505).COMMON,
    (0, $7c375ae106b964be$export$e18ac120172ed505).CONSUMERS,
    (0, $7c375ae106b964be$export$e18ac120172ed505).ORGANIZATIONS
]);
/**
 * Extract tenantId from authority
 */ function $77bb430f4568f6e8$export$6ed5af33d279fbc7(authority) {
    const authorityUrl = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(authority);
    const authorityUrlComponents = authorityUrl.getUrlComponents();
    /**
     * For credential matching purposes, tenantId is the last path segment of the authority URL:
     *  AAD Authority - domain/tenantId -> Credentials are cached with realm = tenantId
     *  B2C Authority - domain/{tenantId}?/.../policy -> Credentials are cached with realm = policy
     *  tenantId is downcased because B2C policies can have mixed case but tfp claim is downcased
     *
     * Note that we may not have any path segments in certain OIDC scenarios.
     */ const tenantId = authorityUrlComponents.PathSegments.slice(-1)[0]?.toLowerCase();
    switch(tenantId){
        case (0, $7c375ae106b964be$export$e18ac120172ed505).COMMON:
        case (0, $7c375ae106b964be$export$e18ac120172ed505).ORGANIZATIONS:
        case (0, $7c375ae106b964be$export$e18ac120172ed505).CONSUMERS:
            return undefined;
        default:
            return tenantId;
    }
}
function $77bb430f4568f6e8$export$4030f3538167cb9e(authorityUri) {
    return authorityUri.endsWith((0, $7c375ae106b964be$export$a002182e51710d39).FORWARD_SLASH) ? authorityUri : `${authorityUri}${(0, $7c375ae106b964be$export$a002182e51710d39).FORWARD_SLASH}`;
}
function $77bb430f4568f6e8$export$2b9ebf6f25078cc0(authOptions) {
    const rawCloudDiscoveryMetadata = authOptions.cloudDiscoveryMetadata;
    let cloudDiscoveryMetadata = undefined;
    if (rawCloudDiscoveryMetadata) try {
        cloudDiscoveryMetadata = JSON.parse(rawCloudDiscoveryMetadata);
    } catch (e) {
        throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$92a2985751150ca5));
    }
    return {
        canonicalAuthority: authOptions.authority ? $77bb430f4568f6e8$export$4030f3538167cb9e(authOptions.authority) : undefined,
        knownAuthorities: authOptions.knownAuthorities,
        cloudDiscoveryMetadata: cloudDiscoveryMetadata
    };
}

/*! @azure/msal-common v15.7.0 2025-05-30 */ 

var $84767569d86b0bc0$exports = {};

$parcel$export($84767569d86b0bc0$exports, "noTokensFound", () => $84767569d86b0bc0$export$e408b083cd212696);
$parcel$export($84767569d86b0bc0$exports, "nativeAccountUnavailable", () => $84767569d86b0bc0$export$3bf2eb3358f5f570);
$parcel$export($84767569d86b0bc0$exports, "refreshTokenExpired", () => $84767569d86b0bc0$export$a90e8b9c10991b49);
$parcel$export($84767569d86b0bc0$exports, "interactionRequired", () => $84767569d86b0bc0$export$cdb77bf88e749c31);
$parcel$export($84767569d86b0bc0$exports, "consentRequired", () => $84767569d86b0bc0$export$ca4e8d96d12fe4c5);
$parcel$export($84767569d86b0bc0$exports, "loginRequired", () => $84767569d86b0bc0$export$402ebc0f96d7decb);
$parcel$export($84767569d86b0bc0$exports, "badToken", () => $84767569d86b0bc0$export$2e3666c77d45a4da);
/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Codes defined by MSAL
const $84767569d86b0bc0$export$e408b083cd212696 = "no_tokens_found";
const $84767569d86b0bc0$export$3bf2eb3358f5f570 = "native_account_unavailable";
const $84767569d86b0bc0$export$a90e8b9c10991b49 = "refresh_token_expired";
// Codes potentially returned by server
const $84767569d86b0bc0$export$cdb77bf88e749c31 = "interaction_required";
const $84767569d86b0bc0$export$ca4e8d96d12fe4c5 = "consent_required";
const $84767569d86b0bc0$export$402ebc0f96d7decb = "login_required";
const $84767569d86b0bc0$export$2e3666c77d45a4da = "bad_token";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * InteractionRequiredServerErrorMessage contains string constants used by error codes and messages returned by the server indicating interaction is required
 */ const $18a94acc3dad87ad$export$e16d6a6c677acec5 = [
    (0, $84767569d86b0bc0$export$cdb77bf88e749c31),
    (0, $84767569d86b0bc0$export$ca4e8d96d12fe4c5),
    (0, $84767569d86b0bc0$export$402ebc0f96d7decb),
    (0, $84767569d86b0bc0$export$2e3666c77d45a4da)
];
const $18a94acc3dad87ad$export$9689959ec6716811 = [
    "message_only",
    "additional_action",
    "basic_action",
    "user_password_expired",
    "consent_required",
    "bad_token"
];
const $18a94acc3dad87ad$var$InteractionRequiredAuthErrorMessages = {
    [(0, $84767569d86b0bc0$export$e408b083cd212696)]: "No refresh token found in the cache. Please sign-in.",
    [(0, $84767569d86b0bc0$export$3bf2eb3358f5f570)]: "The requested account is not available in the native broker. It may have been deleted or logged out. Please sign-in again using an interactive API.",
    [(0, $84767569d86b0bc0$export$a90e8b9c10991b49)]: "Refresh token has expired.",
    [(0, $84767569d86b0bc0$export$2e3666c77d45a4da)]: "Identity provider returned bad_token due to an expired or invalid refresh token. Please invoke an interactive API to resolve."
};
/**
 * Interaction required errors defined by the SDK
 * @deprecated Use InteractionRequiredAuthErrorCodes instead
 */ const $18a94acc3dad87ad$export$d44d3b7b7a580eb6 = {
    noTokensFoundError: {
        code: (0, $84767569d86b0bc0$export$e408b083cd212696),
        desc: $18a94acc3dad87ad$var$InteractionRequiredAuthErrorMessages[0, $84767569d86b0bc0$export$e408b083cd212696]
    },
    native_account_unavailable: {
        code: (0, $84767569d86b0bc0$export$3bf2eb3358f5f570),
        desc: $18a94acc3dad87ad$var$InteractionRequiredAuthErrorMessages[0, $84767569d86b0bc0$export$3bf2eb3358f5f570]
    },
    bad_token: {
        code: (0, $84767569d86b0bc0$export$2e3666c77d45a4da),
        desc: $18a94acc3dad87ad$var$InteractionRequiredAuthErrorMessages[0, $84767569d86b0bc0$export$2e3666c77d45a4da]
    }
};
/**
 * Error thrown when user interaction is required.
 */ class $18a94acc3dad87ad$export$6ba3e818c6bc76ba extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage, subError, timestamp, traceId, correlationId, claims, errorNo){
        super(errorCode, errorMessage, subError);
        Object.setPrototypeOf(this, $18a94acc3dad87ad$export$6ba3e818c6bc76ba.prototype);
        this.timestamp = timestamp || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.traceId = traceId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.correlationId = correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.claims = claims || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.name = "InteractionRequiredAuthError";
        this.errorNo = errorNo;
    }
}
/**
 * Helper function used to determine if an error thrown by the server requires interaction to resolve
 * @param errorCode
 * @param errorString
 * @param subError
 */ function $18a94acc3dad87ad$export$376c3c4c19cb933a(errorCode, errorString, subError) {
    const isInteractionRequiredErrorCode = !!errorCode && $18a94acc3dad87ad$export$e16d6a6c677acec5.indexOf(errorCode) > -1;
    const isInteractionRequiredSubError = !!subError && $18a94acc3dad87ad$export$9689959ec6716811.indexOf(subError) > -1;
    const isInteractionRequiredErrorDesc = !!errorString && $18a94acc3dad87ad$export$e16d6a6c677acec5.some((irErrorCode)=>{
        return errorString.indexOf(irErrorCode) > -1;
    });
    return isInteractionRequiredErrorCode || isInteractionRequiredErrorDesc || isInteractionRequiredSubError;
}
/**
 * Creates an InteractionRequiredAuthError
 */ function $18a94acc3dad87ad$export$8f7a741750c16535(errorCode) {
    return new $18a94acc3dad87ad$export$6ba3e818c6bc76ba(errorCode, $18a94acc3dad87ad$var$InteractionRequiredAuthErrorMessages[errorCode]);
}

/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $762faca86a0f7942$export$2daa8cfcf54c2b48(clientId, request, homeAccountId) {
    return {
        clientId: clientId,
        authority: request.authority,
        scopes: request.scopes,
        homeAccountIdentifier: homeAccountId,
        claims: request.claims,
        authenticationScheme: request.authenticationScheme,
        resourceRequestMethod: request.resourceRequestMethod,
        resourceRequestUri: request.resourceRequestUri,
        shrClaims: request.shrClaims,
        sshKid: request.sshKid,
        embeddedClientId: request.embeddedClientId || request.tokenBodyParameters?.clientId
    };
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 





/*! @azure/msal-browser v4.13.1 2025-06-10 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Cookie life calculation (hours * minutes * seconds * ms)
const $bccaa1af695c1c1d$var$COOKIE_LIFE_MULTIPLIER = 86400000;
const $bccaa1af695c1c1d$export$b18f4dec3e412d34 = {
    Lax: "Lax",
    None: "None"
};
class $bccaa1af695c1c1d$export$dae7d845015939d5 {
    initialize() {
        return Promise.resolve();
    }
    getItem(key) {
        const name = `${encodeURIComponent(key)}`;
        const cookieList = document.cookie.split(";");
        for(let i = 0; i < cookieList.length; i++){
            const cookie = cookieList[i];
            const [key, ...rest] = decodeURIComponent(cookie).trim().split("=");
            const value = rest.join("=");
            if (key === name) return value;
        }
        return "";
    }
    getUserData() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).methodNotImplemented);
    }
    setItem(key, value, cookieLifeDays, secure = true, sameSite = $bccaa1af695c1c1d$export$b18f4dec3e412d34.Lax) {
        let cookieStr = `${encodeURIComponent(key)}=${encodeURIComponent(value)};path=/;SameSite=${sameSite};`;
        if (cookieLifeDays) {
            const expireTime = $bccaa1af695c1c1d$export$b720d871a37fa65(cookieLifeDays);
            cookieStr += `expires=${expireTime};`;
        }
        if (secure || sameSite === $bccaa1af695c1c1d$export$b18f4dec3e412d34.None) // SameSite None requires Secure flag
        cookieStr += "Secure;";
        document.cookie = cookieStr;
    }
    async setUserData() {
        return Promise.reject((0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).methodNotImplemented));
    }
    removeItem(key) {
        // Setting expiration to -1 removes it
        this.setItem(key, "", -1);
    }
    getKeys() {
        const cookieList = document.cookie.split(";");
        const keys = [];
        cookieList.forEach((cookie)=>{
            const cookieParts = decodeURIComponent(cookie).trim().split("=");
            keys.push(cookieParts[0]);
        });
        return keys;
    }
    containsKey(key) {
        return this.getKeys().includes(key);
    }
}
/**
 * Get cookie expiration time
 * @param cookieLifeDays
 */ function $bccaa1af695c1c1d$export$b720d871a37fa65(cookieLifeDays) {
    const today = new Date();
    const expr = new Date(today.getTime() + cookieLifeDays * $bccaa1af695c1c1d$var$COOKIE_LIFE_MULTIPLIER);
    return expr.toUTCString();
}



/*! @azure/msal-browser v4.13.1 2025-06-10 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns a list of cache keys for all known accounts
 * @param storage
 * @returns
 */ function $2ca05ea7e59555fe$export$beb6809f8bbb3df6(storage) {
    const accountKeys = storage.getItem((0, $5ff55562d73e0e2b$export$f6ce23cce692699f).ACCOUNT_KEYS);
    if (accountKeys) return JSON.parse(accountKeys);
    return [];
}
/**
 * Returns a list of cache keys for all known tokens
 * @param clientId
 * @param storage
 * @returns
 */ function $2ca05ea7e59555fe$export$ee837b3b857e6cf8(clientId, storage) {
    const item = storage.getItem(`${(0, $5ff55562d73e0e2b$export$f6ce23cce692699f).TOKEN_KEYS}.${clientId}`);
    if (item) {
        const tokenKeys = JSON.parse(item);
        if (tokenKeys && tokenKeys.hasOwnProperty("idToken") && tokenKeys.hasOwnProperty("accessToken") && tokenKeys.hasOwnProperty("refreshToken")) return tokenKeys;
    }
    return {
        idToken: [],
        accessToken: [],
        refreshToken: []
    };
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $fc08fc8f06eda9dc$var$ENCRYPTION_KEY = "msal.cache.encryption";
const $fc08fc8f06eda9dc$var$BROADCAST_CHANNEL_NAME = "msal.broadcast.cache";
class $fc08fc8f06eda9dc$export$19fffca37ef3e106 {
    constructor(clientId, logger, performanceClient){
        if (!window.localStorage) throw (0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$41d7a3d4e14d6113));
        this.memoryStorage = new (0, $6be83965311b144c$export$d7392285c701ecf5)();
        this.initialized = false;
        this.clientId = clientId;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.broadcast = new BroadcastChannel($fc08fc8f06eda9dc$var$BROADCAST_CHANNEL_NAME);
    }
    async initialize(correlationId) {
        const cookies = new (0, $bccaa1af695c1c1d$export$dae7d845015939d5)();
        const cookieString = cookies.getItem($fc08fc8f06eda9dc$var$ENCRYPTION_KEY);
        let parsedCookie = {
            key: "",
            id: ""
        };
        if (cookieString) try {
            parsedCookie = JSON.parse(cookieString);
        } catch (e) {}
        if (parsedCookie.key && parsedCookie.id) {
            // Encryption key already exists, import
            const baseKey = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)((0, $581fd3df606755c8$export$8f0c237d3e8188bc), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).Base64Decode, this.logger, this.performanceClient, correlationId)(parsedCookie.key);
            this.encryptionCookie = {
                id: parsedCookie.id,
                key: await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$5a71d4e3178f19c4), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateHKDF, this.logger, this.performanceClient, correlationId)(baseKey)
            };
            await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.importExistingCache.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).ImportExistingCache, this.logger, this.performanceClient, correlationId)(correlationId);
        } else {
            // Encryption key doesn't exist or is invalid, generate a new one and clear existing cache
            this.clear();
            const id = (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
            const baseKey = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$1222fa1cada87c76), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateBaseKey, this.logger, this.performanceClient, correlationId)();
            const keyStr = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)((0, $6f6986007da7f422$export$84f5a428c7153a69), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).UrlEncodeArr, this.logger, this.performanceClient, correlationId)(new Uint8Array(baseKey));
            this.encryptionCookie = {
                id: id,
                key: await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$5a71d4e3178f19c4), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateHKDF, this.logger, this.performanceClient, correlationId)(baseKey)
            };
            const cookieData = {
                id: id,
                key: keyStr
            };
            cookies.setItem($fc08fc8f06eda9dc$var$ENCRYPTION_KEY, JSON.stringify(cookieData), 0, true, (0, $bccaa1af695c1c1d$export$b18f4dec3e412d34).None // SameSite must be None to support iframed apps
            );
        }
        // Register listener for cache updates in other tabs
        this.broadcast.addEventListener("message", this.updateCache.bind(this));
        this.initialized = true;
    }
    getItem(key) {
        return window.localStorage.getItem(key);
    }
    getUserData(key) {
        if (!this.initialized) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$436657cdcd7fe2be));
        return this.memoryStorage.getItem(key);
    }
    setItem(key, value) {
        window.localStorage.setItem(key, value);
    }
    async setUserData(key, value, correlationId) {
        if (!this.initialized || !this.encryptionCookie) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$436657cdcd7fe2be));
        const { data: data, nonce: nonce } = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$5b0f6292f11d1d18), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).Encrypt, this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, value, this.getContext(key));
        const encryptedData = {
            id: this.encryptionCookie.id,
            nonce: nonce,
            data: data
        };
        this.memoryStorage.setItem(key, value);
        this.setItem(key, JSON.stringify(encryptedData));
        // Notify other frames to update their in-memory cache
        this.broadcast.postMessage({
            key: key,
            value: value,
            context: this.getContext(key)
        });
    }
    removeItem(key) {
        if (this.memoryStorage.containsKey(key)) {
            this.memoryStorage.removeItem(key);
            this.broadcast.postMessage({
                key: key,
                value: null,
                context: this.getContext(key)
            });
        }
        window.localStorage.removeItem(key);
    }
    getKeys() {
        return Object.keys(window.localStorage);
    }
    containsKey(key) {
        return window.localStorage.hasOwnProperty(key);
    }
    /**
     * Removes all known MSAL keys from the cache
     */ clear() {
        // Removes all remaining MSAL cache items
        this.memoryStorage.clear();
        const accountKeys = (0, $2ca05ea7e59555fe$export$beb6809f8bbb3df6)(this);
        accountKeys.forEach((key)=>this.removeItem(key));
        const tokenKeys = (0, $2ca05ea7e59555fe$export$ee837b3b857e6cf8)(this.clientId, this);
        tokenKeys.idToken.forEach((key)=>this.removeItem(key));
        tokenKeys.accessToken.forEach((key)=>this.removeItem(key));
        tokenKeys.refreshToken.forEach((key)=>this.removeItem(key));
        // Clean up anything left
        this.getKeys().forEach((cacheKey)=>{
            if (cacheKey.startsWith((0, $7c375ae106b964be$export$a002182e51710d39).CACHE_PREFIX) || cacheKey.indexOf(this.clientId) !== -1) this.removeItem(cacheKey);
        });
    }
    /**
     * Helper to decrypt all known MSAL keys in localStorage and save them to inMemory storage
     * @returns
     */ async importExistingCache(correlationId) {
        if (!this.encryptionCookie) return;
        let accountKeys = (0, $2ca05ea7e59555fe$export$beb6809f8bbb3df6)(this);
        accountKeys = await this.importArray(accountKeys, correlationId);
        // Write valid account keys back to map
        this.setItem((0, $5ff55562d73e0e2b$export$f6ce23cce692699f).ACCOUNT_KEYS, JSON.stringify(accountKeys));
        const tokenKeys = (0, $2ca05ea7e59555fe$export$ee837b3b857e6cf8)(this.clientId, this);
        tokenKeys.idToken = await this.importArray(tokenKeys.idToken, correlationId);
        tokenKeys.accessToken = await this.importArray(tokenKeys.accessToken, correlationId);
        tokenKeys.refreshToken = await this.importArray(tokenKeys.refreshToken, correlationId);
        // Write valid token keys back to map
        this.setItem(`${(0, $5ff55562d73e0e2b$export$f6ce23cce692699f).TOKEN_KEYS}.${this.clientId}`, JSON.stringify(tokenKeys));
    }
    /**
     * Helper to decrypt and save cache entries
     * @param key
     * @returns
     */ async getItemFromEncryptedCache(key, correlationId) {
        if (!this.encryptionCookie) return null;
        const rawCache = this.getItem(key);
        if (!rawCache) return null;
        let encObj;
        try {
            encObj = JSON.parse(rawCache);
        } catch (e) {
            // Not a valid encrypted object, remove
            return null;
        }
        if (!encObj.id || !encObj.nonce || !encObj.data) {
            // Data is not encrypted, likely from old version of MSAL. It must be removed because we don't know how old it is.
            this.performanceClient.incrementFields({
                unencryptedCacheCount: 1
            }, correlationId);
            return null;
        }
        if (encObj.id !== this.encryptionCookie.id) {
            // Data was encrypted with a different key. It must be removed because it is from a previous session.
            this.performanceClient.incrementFields({
                encryptedCacheExpiredCount: 1
            }, correlationId);
            return null;
        }
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$e85a0c9a1067c5d3), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).Decrypt, this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, encObj.nonce, this.getContext(key), encObj.data);
    }
    /**
     * Helper to decrypt and save an array of cache keys
     * @param arr
     * @returns Array of keys successfully imported
     */ async importArray(arr, correlationId) {
        const importedArr = [];
        const promiseArr = [];
        arr.forEach((key)=>{
            const promise = this.getItemFromEncryptedCache(key, correlationId).then((value)=>{
                if (value) {
                    this.memoryStorage.setItem(key, value);
                    importedArr.push(key);
                } else // If value is empty, unencrypted or expired remove
                this.removeItem(key);
            });
            promiseArr.push(promise);
        });
        await Promise.all(promiseArr);
        return importedArr;
    }
    /**
     * Gets encryption context for a given cache entry. This is clientId for app specific entries, empty string for shared entries
     * @param key
     * @returns
     */ getContext(key) {
        let context = "";
        if (key.includes(this.clientId)) context = this.clientId; // Used to bind encryption key to this appId
        return context;
    }
    updateCache(event) {
        this.logger.trace("Updating internal cache from broadcast event");
        const perfMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).LocalStorageUpdated);
        perfMeasurement.add({
            isBackground: true
        });
        const { key: key, value: value, context: context } = event.data;
        if (!key) {
            this.logger.error("Broadcast event missing key");
            perfMeasurement.end({
                success: false,
                errorCode: "noKey"
            });
            return;
        }
        if (context && context !== this.clientId) {
            this.logger.trace(`Ignoring broadcast event from clientId: ${context}`);
            perfMeasurement.end({
                success: false,
                errorCode: "contextMismatch"
            });
            return;
        }
        if (!value) {
            this.memoryStorage.removeItem(key);
            this.logger.verbose("Removed item from internal cache");
        } else {
            this.memoryStorage.setItem(key, value);
            this.logger.verbose("Updated item in internal cache");
        }
        perfMeasurement.end({
            success: true
        });
    }
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $514a2dc2ad0988f3$export$2c4b17e1c2e0931 {
    constructor(){
        if (!window.sessionStorage) throw (0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$41d7a3d4e14d6113));
    }
    async initialize() {
    // Session storage does not require initialization
    }
    getItem(key) {
        return window.sessionStorage.getItem(key);
    }
    getUserData(key) {
        return this.getItem(key);
    }
    setItem(key, value) {
        window.sessionStorage.setItem(key, value);
    }
    async setUserData(key, value) {
        this.setItem(key, value);
    }
    removeItem(key) {
        window.sessionStorage.removeItem(key);
    }
    getKeys() {
        return Object.keys(window.sessionStorage);
    }
    containsKey(key) {
        return window.sessionStorage.hasOwnProperty(key);
    }
}







/*! @azure/msal-browser v4.13.1 2025-06-10 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $722bc9eaf0c39f46$export$3d7865934588d77e = {
    INITIALIZE_START: "msal:initializeStart",
    INITIALIZE_END: "msal:initializeEnd",
    ACCOUNT_ADDED: "msal:accountAdded",
    ACCOUNT_REMOVED: "msal:accountRemoved",
    ACTIVE_ACCOUNT_CHANGED: "msal:activeAccountChanged",
    LOGIN_START: "msal:loginStart",
    LOGIN_SUCCESS: "msal:loginSuccess",
    LOGIN_FAILURE: "msal:loginFailure",
    ACQUIRE_TOKEN_START: "msal:acquireTokenStart",
    ACQUIRE_TOKEN_SUCCESS: "msal:acquireTokenSuccess",
    ACQUIRE_TOKEN_FAILURE: "msal:acquireTokenFailure",
    ACQUIRE_TOKEN_NETWORK_START: "msal:acquireTokenFromNetworkStart",
    SSO_SILENT_START: "msal:ssoSilentStart",
    SSO_SILENT_SUCCESS: "msal:ssoSilentSuccess",
    SSO_SILENT_FAILURE: "msal:ssoSilentFailure",
    ACQUIRE_TOKEN_BY_CODE_START: "msal:acquireTokenByCodeStart",
    ACQUIRE_TOKEN_BY_CODE_SUCCESS: "msal:acquireTokenByCodeSuccess",
    ACQUIRE_TOKEN_BY_CODE_FAILURE: "msal:acquireTokenByCodeFailure",
    HANDLE_REDIRECT_START: "msal:handleRedirectStart",
    HANDLE_REDIRECT_END: "msal:handleRedirectEnd",
    POPUP_OPENED: "msal:popupOpened",
    LOGOUT_START: "msal:logoutStart",
    LOGOUT_SUCCESS: "msal:logoutSuccess",
    LOGOUT_FAILURE: "msal:logoutFailure",
    LOGOUT_END: "msal:logoutEnd",
    RESTORE_FROM_BFCACHE: "msal:restoreFromBFCache",
    BROKER_CONNECTION_ESTABLISHED: "msal:brokerConnectionEstablished"
};





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements the cache storage interface for MSAL through browser local or session storage.
 * Cookies are only used if storeAuthStateInCookie is true, and are only used for
 * parameters such as state and nonce, generally.
 */ class $d3981d5134d5331a$export$44d7291b5c8cc149 extends (0, $0c353f04031c78df$export$996e3ea69314b5c6) {
    constructor(clientId, cacheConfig, cryptoImpl, logger, performanceClient, eventHandler, staticAuthorityOptions){
        super(clientId, cryptoImpl, logger, staticAuthorityOptions);
        this.cacheConfig = cacheConfig;
        this.logger = logger;
        this.internalStorage = new (0, $6be83965311b144c$export$d7392285c701ecf5)();
        this.browserStorage = $d3981d5134d5331a$var$getStorageImplementation(clientId, cacheConfig.cacheLocation, logger, performanceClient);
        this.temporaryCacheStorage = $d3981d5134d5331a$var$getStorageImplementation(clientId, cacheConfig.temporaryCacheLocation, logger, performanceClient);
        this.cookieStorage = new (0, $bccaa1af695c1c1d$export$dae7d845015939d5)();
        this.performanceClient = performanceClient;
        this.eventHandler = eventHandler;
    }
    async initialize(correlationId) {
        await this.browserStorage.initialize(correlationId);
        this.trackVersionChanges(correlationId);
    }
    /**
     * Tracks upgrades and downgrades for telemetry and debugging purposes
     */ trackVersionChanges(correlationId) {
        const previousVersion = this.browserStorage.getItem((0, $5ff55562d73e0e2b$export$f6ce23cce692699f).VERSION);
        if (previousVersion) {
            this.logger.info(`MSAL.js was last initialized by version: ${previousVersion}`);
            this.performanceClient.addFields({
                previousLibraryVersion: previousVersion
            }, correlationId);
        }
        if (previousVersion !== (0, $183cce12cb16965c$export$83d89fbfd8236492)) this.browserStorage.setItem((0, $5ff55562d73e0e2b$export$f6ce23cce692699f).VERSION, (0, $183cce12cb16965c$export$83d89fbfd8236492));
    }
    /**
     * Parses passed value as JSON object, JSON.parse() will throw an error.
     * @param input
     */ validateAndParseJson(jsonValue) {
        try {
            const parsedJson = JSON.parse(jsonValue);
            /**
             * There are edge cases in which JSON.parse will successfully parse a non-valid JSON object
             * (e.g. JSON.parse will parse an escaped string into an unescaped string), so adding a type check
             * of the parsed value is necessary in order to be certain that the string represents a valid JSON object.
             *
             */ return parsedJson && typeof parsedJson === "object" ? parsedJson : null;
        } catch (error) {
            return null;
        }
    }
    /**
     * Reads account from cache, deserializes it into an account entity and returns it.
     * If account is not found from the key, returns null and removes key from map.
     * @param accountKey
     * @returns
     */ getAccount(accountKey) {
        this.logger.trace("BrowserCacheManager.getAccount called");
        const serializedAccount = this.browserStorage.getUserData(accountKey);
        if (!serializedAccount) {
            this.removeAccountKeyFromMap(accountKey);
            return null;
        }
        const parsedAccount = this.validateAndParseJson(serializedAccount);
        if (!parsedAccount || !(0, $d6acc4a6126921e0$export$680160523e6bfa6a).isAccountEntity(parsedAccount)) {
            this.removeAccountKeyFromMap(accountKey);
            return null;
        }
        return (0, $0c353f04031c78df$export$996e3ea69314b5c6).toObject(new (0, $d6acc4a6126921e0$export$680160523e6bfa6a)(), parsedAccount);
    }
    /**
     * set account entity in the platform cache
     * @param account
     */ async setAccount(account, correlationId) {
        this.logger.trace("BrowserCacheManager.setAccount called");
        const key = account.generateAccountKey();
        await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.browserStorage.setUserData.bind(this.browserStorage), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SetUserData, this.logger, this.performanceClient)(key, JSON.stringify(account), correlationId);
        const wasAdded = this.addAccountKeyToMap(key);
        /**
         * @deprecated - Remove this in next major version in favor of more consistent LOGIN event
         */ if (this.cacheConfig.cacheLocation === (0, $5ff55562d73e0e2b$export$573384e47a12d835).LocalStorage && wasAdded) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACCOUNT_ADDED, undefined, account.getAccountInfo());
    }
    /**
     * Returns the array of account keys currently cached
     * @returns
     */ getAccountKeys() {
        return (0, $2ca05ea7e59555fe$export$beb6809f8bbb3df6)(this.browserStorage);
    }
    /**
     * Add a new account to the key map
     * @param key
     */ addAccountKeyToMap(key) {
        this.logger.trace("BrowserCacheManager.addAccountKeyToMap called");
        this.logger.tracePii(`BrowserCacheManager.addAccountKeyToMap called with key: ${key}`);
        const accountKeys = this.getAccountKeys();
        if (accountKeys.indexOf(key) === -1) {
            // Only add key if it does not already exist in the map
            accountKeys.push(key);
            this.browserStorage.setItem((0, $5ff55562d73e0e2b$export$f6ce23cce692699f).ACCOUNT_KEYS, JSON.stringify(accountKeys));
            this.logger.verbose("BrowserCacheManager.addAccountKeyToMap account key added");
            return true;
        } else {
            this.logger.verbose("BrowserCacheManager.addAccountKeyToMap account key already exists in map");
            return false;
        }
    }
    /**
     * Remove an account from the key map
     * @param key
     */ removeAccountKeyFromMap(key) {
        this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap called");
        this.logger.tracePii(`BrowserCacheManager.removeAccountKeyFromMap called with key: ${key}`);
        const accountKeys = this.getAccountKeys();
        const removalIndex = accountKeys.indexOf(key);
        if (removalIndex > -1) {
            accountKeys.splice(removalIndex, 1);
            this.browserStorage.setItem((0, $5ff55562d73e0e2b$export$f6ce23cce692699f).ACCOUNT_KEYS, JSON.stringify(accountKeys));
            this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap account key removed");
        } else this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap key not found in existing map");
    }
    /**
     * Extends inherited removeAccount function to include removal of the account key from the map
     * @param key
     */ async removeAccount(key) {
        super.removeAccount(key);
        this.removeAccountKeyFromMap(key);
    }
    /**
     * Removes credentials associated with the provided account
     * @param account
     */ async removeAccountContext(account) {
        await super.removeAccountContext(account);
        /**
         * @deprecated - Remove this in next major version in favor of more consistent LOGOUT event
         */ if (this.cacheConfig.cacheLocation === (0, $5ff55562d73e0e2b$export$573384e47a12d835).LocalStorage) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACCOUNT_REMOVED, undefined, account.getAccountInfo());
    }
    /**
     * Removes given idToken from the cache and from the key map
     * @param key
     */ removeIdToken(key) {
        super.removeIdToken(key);
        this.removeTokenKey(key, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN);
    }
    /**
     * Removes given accessToken from the cache and from the key map
     * @param key
     */ async removeAccessToken(key) {
        super.removeAccessToken(key);
        this.removeTokenKey(key, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN);
    }
    /**
     * Removes given refreshToken from the cache and from the key map
     * @param key
     */ removeRefreshToken(key) {
        super.removeRefreshToken(key);
        this.removeTokenKey(key, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN);
    }
    /**
     * Gets the keys for the cached tokens associated with this clientId
     * @returns
     */ getTokenKeys() {
        return (0, $2ca05ea7e59555fe$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage);
    }
    /**
     * Adds the given key to the token key map
     * @param key
     * @param type
     */ addTokenKey(key, type) {
        this.logger.trace("BrowserCacheManager addTokenKey called");
        const tokenKeys = this.getTokenKeys();
        switch(type){
            case (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN:
                if (tokenKeys.idToken.indexOf(key) === -1) {
                    this.logger.info("BrowserCacheManager: addTokenKey - idToken added to map");
                    tokenKeys.idToken.push(key);
                }
                break;
            case (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN:
                if (tokenKeys.accessToken.indexOf(key) === -1) {
                    this.logger.info("BrowserCacheManager: addTokenKey - accessToken added to map");
                    tokenKeys.accessToken.push(key);
                }
                break;
            case (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN:
                if (tokenKeys.refreshToken.indexOf(key) === -1) {
                    this.logger.info("BrowserCacheManager: addTokenKey - refreshToken added to map");
                    tokenKeys.refreshToken.push(key);
                }
                break;
            default:
                this.logger.error(`BrowserCacheManager:addTokenKey - CredentialType provided invalid. CredentialType: ${type}`);
                throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).unexpectedCredentialType);
        }
        this.browserStorage.setItem(`${(0, $5ff55562d73e0e2b$export$f6ce23cce692699f).TOKEN_KEYS}.${this.clientId}`, JSON.stringify(tokenKeys));
    }
    /**
     * Removes the given key from the token key map
     * @param key
     * @param type
     */ removeTokenKey(key, type) {
        this.logger.trace("BrowserCacheManager removeTokenKey called");
        const tokenKeys = this.getTokenKeys();
        switch(type){
            case (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN:
                this.logger.infoPii(`BrowserCacheManager: removeTokenKey - attempting to remove idToken with key: ${key} from map`);
                const idRemoval = tokenKeys.idToken.indexOf(key);
                if (idRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - idToken removed from map");
                    tokenKeys.idToken.splice(idRemoval, 1);
                } else this.logger.info("BrowserCacheManager: removeTokenKey - idToken does not exist in map. Either it was previously removed or it was never added.");
                break;
            case (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN:
                this.logger.infoPii(`BrowserCacheManager: removeTokenKey - attempting to remove accessToken with key: ${key} from map`);
                const accessRemoval = tokenKeys.accessToken.indexOf(key);
                if (accessRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - accessToken removed from map");
                    tokenKeys.accessToken.splice(accessRemoval, 1);
                } else this.logger.info("BrowserCacheManager: removeTokenKey - accessToken does not exist in map. Either it was previously removed or it was never added.");
                break;
            case (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN:
                this.logger.infoPii(`BrowserCacheManager: removeTokenKey - attempting to remove refreshToken with key: ${key} from map`);
                const refreshRemoval = tokenKeys.refreshToken.indexOf(key);
                if (refreshRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - refreshToken removed from map");
                    tokenKeys.refreshToken.splice(refreshRemoval, 1);
                } else this.logger.info("BrowserCacheManager: removeTokenKey - refreshToken does not exist in map. Either it was previously removed or it was never added.");
                break;
            default:
                this.logger.error(`BrowserCacheManager:removeTokenKey - CredentialType provided invalid. CredentialType: ${type}`);
                throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).unexpectedCredentialType);
        }
        this.browserStorage.setItem(`${(0, $5ff55562d73e0e2b$export$f6ce23cce692699f).TOKEN_KEYS}.${this.clientId}`, JSON.stringify(tokenKeys));
    }
    /**
     * generates idToken entity from a string
     * @param idTokenKey
     */ getIdTokenCredential(idTokenKey) {
        const value = this.browserStorage.getUserData(idTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            this.removeTokenKey(idTokenKey, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN);
            return null;
        }
        const parsedIdToken = this.validateAndParseJson(value);
        if (!parsedIdToken || !(0, $9ab3d26df56b176d$exports).isIdTokenEntity(parsedIdToken)) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            this.removeTokenKey(idTokenKey, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN);
            return null;
        }
        this.logger.trace("BrowserCacheManager.getIdTokenCredential: cache hit");
        return parsedIdToken;
    }
    /**
     * set IdToken credential to the platform cache
     * @param idToken
     */ async setIdTokenCredential(idToken, correlationId) {
        this.logger.trace("BrowserCacheManager.setIdTokenCredential called");
        const idTokenKey = (0, $9ab3d26df56b176d$exports).generateCredentialKey(idToken);
        await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.browserStorage.setUserData.bind(this.browserStorage), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SetUserData, this.logger, this.performanceClient)(idTokenKey, JSON.stringify(idToken), correlationId);
        this.addTokenKey(idTokenKey, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN);
    }
    /**
     * generates accessToken entity from a string
     * @param key
     */ getAccessTokenCredential(accessTokenKey) {
        const value = this.browserStorage.getUserData(accessTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            this.removeTokenKey(accessTokenKey, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN);
            return null;
        }
        const parsedAccessToken = this.validateAndParseJson(value);
        if (!parsedAccessToken || !(0, $9ab3d26df56b176d$exports).isAccessTokenEntity(parsedAccessToken)) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            this.removeTokenKey(accessTokenKey, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN);
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAccessTokenCredential: cache hit");
        return parsedAccessToken;
    }
    /**
     * set accessToken credential to the platform cache
     * @param accessToken
     */ async setAccessTokenCredential(accessToken, correlationId) {
        this.logger.trace("BrowserCacheManager.setAccessTokenCredential called");
        const accessTokenKey = (0, $9ab3d26df56b176d$exports).generateCredentialKey(accessToken);
        await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.browserStorage.setUserData.bind(this.browserStorage), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SetUserData, this.logger, this.performanceClient)(accessTokenKey, JSON.stringify(accessToken), correlationId);
        this.addTokenKey(accessTokenKey, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN);
    }
    /**
     * generates refreshToken entity from a string
     * @param refreshTokenKey
     */ getRefreshTokenCredential(refreshTokenKey) {
        const value = this.browserStorage.getUserData(refreshTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            this.removeTokenKey(refreshTokenKey, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN);
            return null;
        }
        const parsedRefreshToken = this.validateAndParseJson(value);
        if (!parsedRefreshToken || !(0, $9ab3d26df56b176d$exports).isRefreshTokenEntity(parsedRefreshToken)) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            this.removeTokenKey(refreshTokenKey, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN);
            return null;
        }
        this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: cache hit");
        return parsedRefreshToken;
    }
    /**
     * set refreshToken credential to the platform cache
     * @param refreshToken
     */ async setRefreshTokenCredential(refreshToken, correlationId) {
        this.logger.trace("BrowserCacheManager.setRefreshTokenCredential called");
        const refreshTokenKey = (0, $9ab3d26df56b176d$exports).generateCredentialKey(refreshToken);
        await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.browserStorage.setUserData.bind(this.browserStorage), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SetUserData, this.logger, this.performanceClient)(refreshTokenKey, JSON.stringify(refreshToken), correlationId);
        this.addTokenKey(refreshTokenKey, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN);
    }
    /**
     * fetch appMetadata entity from the platform cache
     * @param appMetadataKey
     */ getAppMetadata(appMetadataKey) {
        const value = this.browserStorage.getItem(appMetadataKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (!parsedMetadata || !(0, $9ab3d26df56b176d$exports).isAppMetadataEntity(appMetadataKey, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAppMetadata: cache hit");
        return parsedMetadata;
    }
    /**
     * set appMetadata entity to the platform cache
     * @param appMetadata
     */ setAppMetadata(appMetadata) {
        this.logger.trace("BrowserCacheManager.setAppMetadata called");
        const appMetadataKey = (0, $9ab3d26df56b176d$exports).generateAppMetadataKey(appMetadata);
        this.browserStorage.setItem(appMetadataKey, JSON.stringify(appMetadata));
    }
    /**
     * fetch server telemetry entity from the platform cache
     * @param serverTelemetryKey
     */ getServerTelemetry(serverTelemetryKey) {
        const value = this.browserStorage.getItem(serverTelemetryKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        const parsedEntity = this.validateAndParseJson(value);
        if (!parsedEntity || !(0, $9ab3d26df56b176d$exports).isServerTelemetryEntity(serverTelemetryKey, parsedEntity)) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getServerTelemetry: cache hit");
        return parsedEntity;
    }
    /**
     * set server telemetry entity to the platform cache
     * @param serverTelemetryKey
     * @param serverTelemetry
     */ setServerTelemetry(serverTelemetryKey, serverTelemetry) {
        this.logger.trace("BrowserCacheManager.setServerTelemetry called");
        this.browserStorage.setItem(serverTelemetryKey, JSON.stringify(serverTelemetry));
    }
    /**
     *
     */ getAuthorityMetadata(key) {
        const value = this.internalStorage.getItem(key);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: called, no cache hit");
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (parsedMetadata && (0, $9ab3d26df56b176d$exports).isAuthorityMetadataEntity(key, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: cache hit");
            return parsedMetadata;
        }
        return null;
    }
    /**
     *
     */ getAuthorityMetadataKeys() {
        const allKeys = this.internalStorage.getKeys();
        return allKeys.filter((key)=>{
            return this.isAuthorityMetadata(key);
        });
    }
    /**
     * Sets wrapper metadata in memory
     * @param wrapperSKU
     * @param wrapperVersion
     */ setWrapperMetadata(wrapperSKU, wrapperVersion) {
        this.internalStorage.setItem((0, $5ff55562d73e0e2b$export$8f546f90896bcfa9).WRAPPER_SKU, wrapperSKU);
        this.internalStorage.setItem((0, $5ff55562d73e0e2b$export$8f546f90896bcfa9).WRAPPER_VER, wrapperVersion);
    }
    /**
     * Returns wrapper metadata from in-memory storage
     */ getWrapperMetadata() {
        const sku = this.internalStorage.getItem((0, $5ff55562d73e0e2b$export$8f546f90896bcfa9).WRAPPER_SKU) || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        const version = this.internalStorage.getItem((0, $5ff55562d73e0e2b$export$8f546f90896bcfa9).WRAPPER_VER) || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        return [
            sku,
            version
        ];
    }
    /**
     *
     * @param entity
     */ setAuthorityMetadata(key, entity) {
        this.logger.trace("BrowserCacheManager.setAuthorityMetadata called");
        this.internalStorage.setItem(key, JSON.stringify(entity));
    }
    /**
     * Gets the active account
     */ getActiveAccount() {
        const activeAccountKeyFilters = this.generateCacheKey((0, $7c375ae106b964be$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT_FILTERS);
        const activeAccountValueFilters = this.browserStorage.getItem(activeAccountKeyFilters);
        if (!activeAccountValueFilters) {
            this.logger.trace("BrowserCacheManager.getActiveAccount: No active account filters found");
            return null;
        }
        const activeAccountValueObj = this.validateAndParseJson(activeAccountValueFilters);
        if (activeAccountValueObj) {
            this.logger.trace("BrowserCacheManager.getActiveAccount: Active account filters schema found");
            return this.getAccountInfoFilteredBy({
                homeAccountId: activeAccountValueObj.homeAccountId,
                localAccountId: activeAccountValueObj.localAccountId,
                tenantId: activeAccountValueObj.tenantId
            });
        }
        this.logger.trace("BrowserCacheManager.getActiveAccount: No active account found");
        return null;
    }
    /**
     * Sets the active account's localAccountId in cache
     * @param account
     */ setActiveAccount(account) {
        const activeAccountKey = this.generateCacheKey((0, $7c375ae106b964be$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT_FILTERS);
        if (account) {
            this.logger.verbose("setActiveAccount: Active account set");
            const activeAccountValue = {
                homeAccountId: account.homeAccountId,
                localAccountId: account.localAccountId,
                tenantId: account.tenantId
            };
            this.browserStorage.setItem(activeAccountKey, JSON.stringify(activeAccountValue));
        } else {
            this.logger.verbose("setActiveAccount: No account passed, active account not set");
            this.browserStorage.removeItem(activeAccountKey);
        }
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACTIVE_ACCOUNT_CHANGED);
    }
    /**
     * fetch throttling entity from the platform cache
     * @param throttlingCacheKey
     */ getThrottlingCache(throttlingCacheKey) {
        const value = this.browserStorage.getItem(throttlingCacheKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        const parsedThrottlingCache = this.validateAndParseJson(value);
        if (!parsedThrottlingCache || !(0, $9ab3d26df56b176d$exports).isThrottlingEntity(throttlingCacheKey, parsedThrottlingCache)) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getThrottlingCache: cache hit");
        return parsedThrottlingCache;
    }
    /**
     * set throttling entity to the platform cache
     * @param throttlingCacheKey
     * @param throttlingCache
     */ setThrottlingCache(throttlingCacheKey, throttlingCache) {
        this.logger.trace("BrowserCacheManager.setThrottlingCache called");
        this.browserStorage.setItem(throttlingCacheKey, JSON.stringify(throttlingCache));
    }
    /**
     * Gets cache item with given key.
     * Will retrieve from cookies if storeAuthStateInCookie is set to true.
     * @param key
     */ getTemporaryCache(cacheKey, generateKey) {
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        if (this.cacheConfig.storeAuthStateInCookie) {
            const itemCookie = this.cookieStorage.getItem(key);
            if (itemCookie) {
                this.logger.trace("BrowserCacheManager.getTemporaryCache: storeAuthStateInCookies set to true, retrieving from cookies");
                return itemCookie;
            }
        }
        const value = this.temporaryCacheStorage.getItem(key);
        if (!value) {
            // If temp cache item not found in session/memory, check local storage for items set by old versions
            if (this.cacheConfig.cacheLocation === (0, $5ff55562d73e0e2b$export$573384e47a12d835).LocalStorage) {
                const item = this.browserStorage.getItem(key);
                if (item) {
                    this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item found in local storage");
                    return item;
                }
            }
            this.logger.trace("BrowserCacheManager.getTemporaryCache: No cache item found in local storage");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item returned");
        return value;
    }
    /**
     * Sets the cache item with the key and value given.
     * Stores in cookie if storeAuthStateInCookie is set to true.
     * This can cause cookie overflow if used incorrectly.
     * @param key
     * @param value
     */ setTemporaryCache(cacheKey, value, generateKey) {
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        this.temporaryCacheStorage.setItem(key, value);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.setTemporaryCache: storeAuthStateInCookie set to true, setting item cookie");
            this.cookieStorage.setItem(key, value, undefined, this.cacheConfig.secureCookies);
        }
    }
    /**
     * Removes the cache item with the given key.
     * @param key
     */ removeItem(key) {
        this.browserStorage.removeItem(key);
    }
    /**
     * Removes the temporary cache item with the given key.
     * Will also clear the cookie item if storeAuthStateInCookie is set to true.
     * @param key
     */ removeTemporaryItem(key) {
        this.temporaryCacheStorage.removeItem(key);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.removeItem: storeAuthStateInCookie is true, clearing item cookie");
            this.cookieStorage.removeItem(key);
        }
    }
    /**
     * Gets all keys in window.
     */ getKeys() {
        return this.browserStorage.getKeys();
    }
    /**
     * Clears all cache entries created by MSAL.
     */ async clear() {
        // Removes all accounts and their credentials
        await this.removeAllAccounts();
        this.removeAppMetadata();
        // Remove temp storage first to make sure any cookies are cleared
        this.temporaryCacheStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf((0, $7c375ae106b964be$export$a002182e51710d39).CACHE_PREFIX) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.removeTemporaryItem(cacheKey);
        });
        // Removes all remaining MSAL cache items
        this.browserStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf((0, $7c375ae106b964be$export$a002182e51710d39).CACHE_PREFIX) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.browserStorage.removeItem(cacheKey);
        });
        this.internalStorage.clear();
    }
    /**
     * Clears all access tokes that have claims prior to saving the current one
     * @param performanceClient {IPerformanceClient}
     * @param correlationId {string} correlation id
     * @returns
     */ async clearTokensAndKeysWithClaims(performanceClient, correlationId) {
        performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).ClearTokensAndKeysWithClaims, correlationId);
        const tokenKeys = this.getTokenKeys();
        const removedAccessTokens = [];
        tokenKeys.accessToken.forEach((key)=>{
            // if the access token has claims in its key, remove the token key and the token
            const credential = this.getAccessTokenCredential(key);
            if (credential?.requestedClaimsHash && key.includes(credential.requestedClaimsHash.toLowerCase())) removedAccessTokens.push(this.removeAccessToken(key));
        });
        await Promise.all(removedAccessTokens);
        // warn if any access tokens are removed
        if (removedAccessTokens.length > 0) this.logger.warning(`${removedAccessTokens.length} access tokens with claims in the cache keys have been removed from the cache.`);
    }
    /**
     * Prepend msal.<client-id> to each key; Skip for any JSON object as Key (defined schemas do not need the key appended: AccessToken Keys or the upcoming schema)
     * @param key
     * @param addInstanceId
     */ generateCacheKey(key) {
        const generatedKey = this.validateAndParseJson(key);
        if (!generatedKey) {
            if ((0, $442eacaa0418a38d$export$ecc754f99843e759).startsWith(key, (0, $7c375ae106b964be$export$a002182e51710d39).CACHE_PREFIX)) return key;
            return `${(0, $7c375ae106b964be$export$a002182e51710d39).CACHE_PREFIX}.${this.clientId}.${key}`;
        }
        return JSON.stringify(key);
    }
    /**
     * Reset all temporary cache items
     * @param state
     */ resetRequestCache() {
        this.logger.trace("BrowserCacheManager.resetRequestCache called");
        this.removeTemporaryItem(this.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).REQUEST_PARAMS));
        this.removeTemporaryItem(this.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).VERIFIER));
        this.removeTemporaryItem(this.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).ORIGIN_URI));
        this.removeTemporaryItem(this.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).URL_HASH));
        this.removeTemporaryItem(this.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).NATIVE_REQUEST));
        this.setInteractionInProgress(false);
    }
    cacheAuthorizeRequest(authCodeRequest, codeVerifier) {
        this.logger.trace("BrowserCacheManager.cacheAuthorizeRequest called");
        const encodedValue = (0, $6f6986007da7f422$export$e510a73ee562749)(JSON.stringify(authCodeRequest));
        this.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).REQUEST_PARAMS, encodedValue, true);
        if (codeVerifier) {
            const encodedVerifier = (0, $6f6986007da7f422$export$e510a73ee562749)(codeVerifier);
            this.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).VERIFIER, encodedVerifier, true);
        }
    }
    /**
     * Gets the token exchange parameters from the cache. Throws an error if nothing is found.
     */ getCachedRequest() {
        this.logger.trace("BrowserCacheManager.getCachedRequest called");
        // Get token request from cache and parse as TokenExchangeParameters.
        const encodedTokenRequest = this.getTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).REQUEST_PARAMS, true);
        if (!encodedTokenRequest) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$8b51939fb2aab3d7));
        const encodedVerifier = this.getTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).VERIFIER, true);
        let parsedRequest;
        let verifier = "";
        try {
            parsedRequest = JSON.parse((0, $581fd3df606755c8$export$c62426fdd000a97e)(encodedTokenRequest));
            if (encodedVerifier) verifier = (0, $581fd3df606755c8$export$c62426fdd000a97e)(encodedVerifier);
        } catch (e) {
            this.logger.errorPii(`Attempted to parse: ${encodedTokenRequest}`);
            this.logger.error(`Parsing cached token request threw with error: ${e}`);
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$f3ae24cdfaab4488));
        }
        return [
            parsedRequest,
            verifier
        ];
    }
    /**
     * Gets cached native request for redirect flows
     */ getCachedNativeRequest() {
        this.logger.trace("BrowserCacheManager.getCachedNativeRequest called");
        const cachedRequest = this.getTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).NATIVE_REQUEST, true);
        if (!cachedRequest) {
            this.logger.trace("BrowserCacheManager.getCachedNativeRequest: No cached native request found");
            return null;
        }
        const parsedRequest = this.validateAndParseJson(cachedRequest);
        if (!parsedRequest) {
            this.logger.error("BrowserCacheManager.getCachedNativeRequest: Unable to parse native request");
            return null;
        }
        return parsedRequest;
    }
    isInteractionInProgress(matchClientId) {
        const clientId = this.getInteractionInProgress()?.clientId;
        if (matchClientId) return clientId === this.clientId;
        else return !!clientId;
    }
    getInteractionInProgress() {
        const key = `${(0, $7c375ae106b964be$export$a002182e51710d39).CACHE_PREFIX}.${(0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).INTERACTION_STATUS_KEY}`;
        const value = this.getTemporaryCache(key, false);
        try {
            return value ? JSON.parse(value) : null;
        } catch (e) {
            // Remove interaction and other temp keys if interaction status can't be parsed
            this.logger.error(`Cannot parse interaction status. Removing temporary cache items and clearing url hash. Retrying interaction should fix the error`);
            this.removeTemporaryItem(key);
            this.resetRequestCache();
            (0, $3003b661a087a867$export$a20c3032ba81d6aa)(window);
            return null;
        }
    }
    setInteractionInProgress(inProgress, type = (0, $5ff55562d73e0e2b$export$dc1d3aa5f3837765).SIGNIN) {
        // Ensure we don't overwrite interaction in progress for a different clientId
        const key = `${(0, $7c375ae106b964be$export$a002182e51710d39).CACHE_PREFIX}.${(0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).INTERACTION_STATUS_KEY}`;
        if (inProgress) {
            if (this.getInteractionInProgress()) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$2700dc1c133d227e));
            else // No interaction is in progress
            this.setTemporaryCache(key, JSON.stringify({
                clientId: this.clientId,
                type: type
            }), false);
        } else if (!inProgress && this.getInteractionInProgress()?.clientId === this.clientId) this.removeTemporaryItem(key);
    }
    /**
     * Builds credential entities from AuthenticationResult object and saves the resulting credentials to the cache
     * @param result
     * @param request
     */ async hydrateCache(result, request) {
        const idTokenEntity = (0, $9ab3d26df56b176d$exports).createIdTokenEntity(result.account?.homeAccountId, result.account?.environment, result.idToken, this.clientId, result.tenantId);
        let claimsHash;
        if (request.claims) claimsHash = await this.cryptoImpl.hashString(request.claims);
        /**
         * meta data for cache stores time in seconds from epoch
         * AuthenticationResult returns expiresOn and extExpiresOn in milliseconds (as a Date object which is in ms)
         * We need to map these for the cache when building tokens from AuthenticationResult
         *
         * The next MSAL VFuture should map these both to same value if possible
         */ const accessTokenEntity = (0, $9ab3d26df56b176d$exports).createAccessTokenEntity(result.account?.homeAccountId, result.account.environment, result.accessToken, this.clientId, result.tenantId, result.scopes.join(" "), // Access token expiresOn stored in seconds, converting from AuthenticationResult expiresOn stored as Date
        result.expiresOn ? (0, $0a4a8f22735f9ff5$exports).toSecondsFromDate(result.expiresOn) : 0, result.extExpiresOn ? (0, $0a4a8f22735f9ff5$exports).toSecondsFromDate(result.extExpiresOn) : 0, (0, $581fd3df606755c8$export$c62426fdd000a97e), undefined, result.tokenType, undefined, request.sshKid, request.claims, claimsHash);
        const cacheRecord = {
            idToken: idTokenEntity,
            accessToken: accessTokenEntity
        };
        return this.saveCacheRecord(cacheRecord, result.correlationId);
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param storeInCache {?StoreInCache}
     * @param correlationId {?string} correlation id
     */ async saveCacheRecord(cacheRecord, correlationId, storeInCache) {
        try {
            await super.saveCacheRecord(cacheRecord, correlationId, storeInCache);
        } catch (e) {
            if (e instanceof (0, $531f2a6dee41cfa4$export$78ff06e91c3de382) && this.performanceClient && correlationId) try {
                const tokenKeys = this.getTokenKeys();
                this.performanceClient.addFields({
                    cacheRtCount: tokenKeys.refreshToken.length,
                    cacheIdCount: tokenKeys.idToken.length,
                    cacheAtCount: tokenKeys.accessToken.length
                }, correlationId);
            } catch (e) {}
            throw e;
        }
    }
}
/**
 * Returns a window storage class implementing the IWindowStorage interface that corresponds to the configured cacheLocation.
 * @param cacheLocation
 */ function $d3981d5134d5331a$var$getStorageImplementation(clientId, cacheLocation, logger, performanceClient) {
    try {
        switch(cacheLocation){
            case (0, $5ff55562d73e0e2b$export$573384e47a12d835).LocalStorage:
                return new (0, $fc08fc8f06eda9dc$export$19fffca37ef3e106)(clientId, logger, performanceClient);
            case (0, $5ff55562d73e0e2b$export$573384e47a12d835).SessionStorage:
                return new (0, $514a2dc2ad0988f3$export$2c4b17e1c2e0931)();
            case (0, $5ff55562d73e0e2b$export$573384e47a12d835).MemoryStorage:
            default:
                break;
        }
    } catch (e) {
        logger.error(e);
    }
    return new (0, $6be83965311b144c$export$d7392285c701ecf5)();
}
const $d3981d5134d5331a$export$8e2d54002f8f6e5d = (clientId, logger, performanceClient, eventHandler)=>{
    const cacheOptions = {
        cacheLocation: (0, $5ff55562d73e0e2b$export$573384e47a12d835).MemoryStorage,
        temporaryCacheLocation: (0, $5ff55562d73e0e2b$export$573384e47a12d835).MemoryStorage,
        storeAuthStateInCookie: false,
        secureCookies: false,
        cacheMigrationEnabled: false,
        claimsBasedCachingEnabled: false
    };
    return new $d3981d5134d5331a$export$44d7291b5c8cc149(clientId, cacheOptions, (0, $dd88ab1a0b4d3851$export$865f57d401606752), logger, performanceClient, eventHandler);
};


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
 * @param accountFilter - (Optional) filter to narrow down the accounts returned
 * @returns Array of AccountInfo objects in cache
 */ function $807e525bbe19e865$export$a4fc43c2a99143cd(logger, browserStorage, isInBrowser, accountFilter) {
    logger.verbose("getAllAccounts called");
    return isInBrowser ? browserStorage.getAllAccounts(accountFilter) : [];
}
/**
 * Returns the first account found in the cache that matches the account filter passed in.
 * @param accountFilter
 * @returns The first account found in the cache matching the provided filter or null if no account could be found.
 */ function $807e525bbe19e865$export$4f9234baf34abd0(accountFilter, logger, browserStorage) {
    logger.trace("getAccount called");
    if (Object.keys(accountFilter).length === 0) {
        logger.warning("getAccount: No accountFilter provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy(accountFilter);
    if (account) {
        logger.verbose("getAccount: Account matching provided filter found, returning");
        return account;
    } else {
        logger.verbose("getAccount: No matching account found, returning null");
        return null;
    }
}
/**
 * Returns the signed in account matching username.
 * (the account object is created at the time of successful login)
 * or null when no matching account is found.
 * This API is provided for convenience but getAccountById should be used for best reliability
 * @param username
 * @returns The account object stored in MSAL
 */ function $807e525bbe19e865$export$d915baf55d86927d(username, logger, browserStorage) {
    logger.trace("getAccountByUsername called");
    if (!username) {
        logger.warning("getAccountByUsername: No username provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy({
        username: username
    });
    if (account) {
        logger.verbose("getAccountByUsername: Account matching username found, returning");
        logger.verbosePii(`getAccountByUsername: Returning signed-in accounts matching username: ${username}`);
        return account;
    } else {
        logger.verbose("getAccountByUsername: No matching account found, returning null");
        return null;
    }
}
/**
 * Returns the signed in account matching homeAccountId.
 * (the account object is created at the time of successful login)
 * or null when no matching account is found
 * @param homeAccountId
 * @returns The account object stored in MSAL
 */ function $807e525bbe19e865$export$d6fa7d1e8099998e(homeAccountId, logger, browserStorage) {
    logger.trace("getAccountByHomeId called");
    if (!homeAccountId) {
        logger.warning("getAccountByHomeId: No homeAccountId provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy({
        homeAccountId: homeAccountId
    });
    if (account) {
        logger.verbose("getAccountByHomeId: Account matching homeAccountId found, returning");
        logger.verbosePii(`getAccountByHomeId: Returning signed-in accounts matching homeAccountId: ${homeAccountId}`);
        return account;
    } else {
        logger.verbose("getAccountByHomeId: No matching account found, returning null");
        return null;
    }
}
/**
 * Returns the signed in account matching localAccountId.
 * (the account object is created at the time of successful login)
 * or null when no matching account is found
 * @param localAccountId
 * @returns The account object stored in MSAL
 */ function $807e525bbe19e865$export$7ac8aa09fdf78340(localAccountId, logger, browserStorage) {
    logger.trace("getAccountByLocalId called");
    if (!localAccountId) {
        logger.warning("getAccountByLocalId: No localAccountId provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy({
        localAccountId: localAccountId
    });
    if (account) {
        logger.verbose("getAccountByLocalId: Account matching localAccountId found, returning");
        logger.verbosePii(`getAccountByLocalId: Returning signed-in accounts matching localAccountId: ${localAccountId}`);
        return account;
    } else {
        logger.verbose("getAccountByLocalId: No matching account found, returning null");
        return null;
    }
}
/**
 * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
 * @param account
 */ function $807e525bbe19e865$export$c55c3d25cf1bcd99(account, browserStorage) {
    browserStorage.setActiveAccount(account);
}
/**
 * Gets the currently active account
 */ function $807e525bbe19e865$export$13dd2e33a23839ad(browserStorage) {
    return browserStorage.getActiveAccount();
}





/*! @azure/msal-browser v4.13.1 2025-06-10 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9f61ab73b66f619a$var$BROADCAST_CHANNEL_NAME = "msal.broadcast.event";
class $9f61ab73b66f619a$export$ce0ba2422a1c7815 {
    constructor(logger){
        this.eventCallbacks = new Map();
        this.logger = logger || new (0, $0bf1d54ef751a29c$export$efa9a398d6368992)({});
        if (typeof BroadcastChannel !== "undefined") this.broadcastChannel = new BroadcastChannel($9f61ab73b66f619a$var$BROADCAST_CHANNEL_NAME);
        this.invokeCrossTabCallbacks = this.invokeCrossTabCallbacks.bind(this);
    }
    /**
     * Adds event callbacks to array
     * @param callback - callback to be invoked when an event is raised
     * @param eventTypes - list of events that this callback will be invoked for, if not provided callback will be invoked for all events
     * @param callbackId - Identifier for the callback, used to locate and remove the callback when no longer required
     */ addEventCallback(callback, eventTypes, callbackId) {
        if (typeof window !== "undefined") {
            const id = callbackId || (0, $3003b661a087a867$export$7571c350ed9fec74)();
            if (this.eventCallbacks.has(id)) {
                this.logger.error(`Event callback with id: ${id} is already registered. Please provide a unique id or remove the existing callback and try again.`);
                return null;
            }
            this.eventCallbacks.set(id, [
                callback,
                eventTypes || []
            ]);
            this.logger.verbose(`Event callback registered with id: ${id}`);
            return id;
        }
        return null;
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventCallbacks.delete(callbackId);
        this.logger.verbose(`Event callback ${callbackId} removed.`);
    }
    /**
     * Emits events by calling callback with event message
     * @param eventType
     * @param interactionType
     * @param payload
     * @param error
     */ emitEvent(eventType, interactionType, payload, error) {
        const message = {
            eventType: eventType,
            interactionType: interactionType || null,
            payload: payload || null,
            error: error || null,
            timestamp: Date.now()
        };
        switch(eventType){
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACCOUNT_ADDED:
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACCOUNT_REMOVED:
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACTIVE_ACCOUNT_CHANGED:
                // Send event to other open tabs / MSAL instances on same domain
                this.broadcastChannel?.postMessage(message);
                break;
            default:
                // Emit event to callbacks registered in this instance
                this.invokeCallbacks(message);
                break;
        }
    }
    /**
     * Invoke registered callbacks
     * @param message
     */ invokeCallbacks(message) {
        this.eventCallbacks.forEach(([callback, eventTypes], callbackId)=>{
            if (eventTypes.length === 0 || eventTypes.includes(message.eventType)) {
                this.logger.verbose(`Emitting event to callback ${callbackId}: ${message.eventType}`);
                callback.apply(null, [
                    message
                ]);
            }
        });
    }
    /**
     * Wrapper around invokeCallbacks to handle broadcast events received from other tabs/instances
     * @param event
     */ invokeCrossTabCallbacks(event) {
        const message = event.data;
        this.invokeCallbacks(message);
    }
    /**
     * Listen for events broadcasted from other tabs/instances
     */ subscribeCrossTab() {
        this.broadcastChannel?.addEventListener("message", this.invokeCrossTabCallbacks);
    }
    /**
     * Unsubscribe from broadcast events
     */ unsubscribeCrossTab() {
        this.broadcastChannel?.removeEventListener("message", this.invokeCrossTabCallbacks);
    }
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 
/*! @azure/msal-browser v4.13.1 2025-06-10 */ /*! @azure/msal-common v15.7.0 2025-05-30 */ /*! @azure/msal-common v15.7.0 2025-05-30 */ 



/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $feda987e240ac148$export$17b7b3ac1abef49f = {
    HOME_ACCOUNT_ID: "home_account_id",
    UPN: "UPN"
};



var $7d3a00eb36d325b3$exports = {};

$parcel$export($7d3a00eb36d325b3$exports, "instrumentBrokerParams", () => $7d3a00eb36d325b3$export$7153a1ee4346fa3b);
$parcel$export($7d3a00eb36d325b3$exports, "addResponseType", () => $7d3a00eb36d325b3$export$3e2fd8b32dd28470);
$parcel$export($7d3a00eb36d325b3$exports, "addResponseMode", () => $7d3a00eb36d325b3$export$f1c153626c2c2d91);
$parcel$export($7d3a00eb36d325b3$exports, "addNativeBroker", () => $7d3a00eb36d325b3$export$8c305b8d324c4edb);
$parcel$export($7d3a00eb36d325b3$exports, "addScopes", () => $7d3a00eb36d325b3$export$c213bf8f125826ba);
$parcel$export($7d3a00eb36d325b3$exports, "addClientId", () => $7d3a00eb36d325b3$export$8360c651f9cc692b);
$parcel$export($7d3a00eb36d325b3$exports, "addRedirectUri", () => $7d3a00eb36d325b3$export$6758d6264f4f06);
$parcel$export($7d3a00eb36d325b3$exports, "addPostLogoutRedirectUri", () => $7d3a00eb36d325b3$export$bb8081db67b059c0);
$parcel$export($7d3a00eb36d325b3$exports, "addIdTokenHint", () => $7d3a00eb36d325b3$export$c6f34f6f67740950);
$parcel$export($7d3a00eb36d325b3$exports, "addDomainHint", () => $7d3a00eb36d325b3$export$1bd007a9d7fec290);
$parcel$export($7d3a00eb36d325b3$exports, "addLoginHint", () => $7d3a00eb36d325b3$export$65f43fd4b28bba5f);
$parcel$export($7d3a00eb36d325b3$exports, "addCcsUpn", () => $7d3a00eb36d325b3$export$aa9cca16bcc29d2d);
$parcel$export($7d3a00eb36d325b3$exports, "addCcsOid", () => $7d3a00eb36d325b3$export$68a633ecf634a2ea);
$parcel$export($7d3a00eb36d325b3$exports, "addSid", () => $7d3a00eb36d325b3$export$9d8531b0fa366b30);
$parcel$export($7d3a00eb36d325b3$exports, "addClaims", () => $7d3a00eb36d325b3$export$b04c3bca9165ed02);
$parcel$export($7d3a00eb36d325b3$exports, "addClientCapabilitiesToClaims", () => $7d3a00eb36d325b3$export$f40e790983a9797e);
$parcel$export($7d3a00eb36d325b3$exports, "addCorrelationId", () => $7d3a00eb36d325b3$export$8a224ff809946e9c);
$parcel$export($7d3a00eb36d325b3$exports, "addLibraryInfo", () => $7d3a00eb36d325b3$export$3ecac3764b147c3f);
$parcel$export($7d3a00eb36d325b3$exports, "addApplicationTelemetry", () => $7d3a00eb36d325b3$export$37ec1b76d865654a);
$parcel$export($7d3a00eb36d325b3$exports, "addPrompt", () => $7d3a00eb36d325b3$export$e982ccd37a61cde6);
$parcel$export($7d3a00eb36d325b3$exports, "addState", () => $7d3a00eb36d325b3$export$4a8b8c14090dd065);
$parcel$export($7d3a00eb36d325b3$exports, "addNonce", () => $7d3a00eb36d325b3$export$87b1d5d886e84b11);
$parcel$export($7d3a00eb36d325b3$exports, "addCodeChallengeParams", () => $7d3a00eb36d325b3$export$57a984e7ed784e16);
$parcel$export($7d3a00eb36d325b3$exports, "addAuthorizationCode", () => $7d3a00eb36d325b3$export$ff027aab2d77a49c);
$parcel$export($7d3a00eb36d325b3$exports, "addDeviceCode", () => $7d3a00eb36d325b3$export$8999dc4307159304);
$parcel$export($7d3a00eb36d325b3$exports, "addRefreshToken", () => $7d3a00eb36d325b3$export$b9e8ccbb425b80a3);
$parcel$export($7d3a00eb36d325b3$exports, "addCodeVerifier", () => $7d3a00eb36d325b3$export$dceb49e3b4703cbb);
$parcel$export($7d3a00eb36d325b3$exports, "addClientSecret", () => $7d3a00eb36d325b3$export$8df84bbb0e2465bc);
$parcel$export($7d3a00eb36d325b3$exports, "addClientAssertion", () => $7d3a00eb36d325b3$export$2d3d772920e2496e);
$parcel$export($7d3a00eb36d325b3$exports, "addClientAssertionType", () => $7d3a00eb36d325b3$export$55ad911d12112f00);
$parcel$export($7d3a00eb36d325b3$exports, "addOboAssertion", () => $7d3a00eb36d325b3$export$34b131001eea36b1);
$parcel$export($7d3a00eb36d325b3$exports, "addRequestTokenUse", () => $7d3a00eb36d325b3$export$b6d65fd125460167);
$parcel$export($7d3a00eb36d325b3$exports, "addGrantType", () => $7d3a00eb36d325b3$export$e5f700fdeb4022b2);
$parcel$export($7d3a00eb36d325b3$exports, "addClientInfo", () => $7d3a00eb36d325b3$export$86b85a101d45e918);
$parcel$export($7d3a00eb36d325b3$exports, "addInstanceAware", () => $7d3a00eb36d325b3$export$50b40dfb1d11b77a);
$parcel$export($7d3a00eb36d325b3$exports, "addExtraQueryParameters", () => $7d3a00eb36d325b3$export$1a9f676bcc5d37da);
$parcel$export($7d3a00eb36d325b3$exports, "addUsername", () => $7d3a00eb36d325b3$export$d38c772efe03a690);
$parcel$export($7d3a00eb36d325b3$exports, "addPassword", () => $7d3a00eb36d325b3$export$bfe833e59aa823e8);
$parcel$export($7d3a00eb36d325b3$exports, "addPopToken", () => $7d3a00eb36d325b3$export$6dfc34809d8c4096);
$parcel$export($7d3a00eb36d325b3$exports, "addSshJwk", () => $7d3a00eb36d325b3$export$f004de9a266b8070);
$parcel$export($7d3a00eb36d325b3$exports, "addServerTelemetry", () => $7d3a00eb36d325b3$export$79fb524b159705e9);
$parcel$export($7d3a00eb36d325b3$exports, "addThrottling", () => $7d3a00eb36d325b3$export$26592ae2037df9de);
$parcel$export($7d3a00eb36d325b3$exports, "addLogoutHint", () => $7d3a00eb36d325b3$export$e0d4676d7288bded);
$parcel$export($7d3a00eb36d325b3$exports, "addBrokerParameters", () => $7d3a00eb36d325b3$export$5ea4577e2a518c27);
$parcel$export($7d3a00eb36d325b3$exports, "addEARParameters", () => $7d3a00eb36d325b3$export$ec0b476da4a9fb0);
/*! @azure/msal-common v15.7.0 2025-05-30 */ 
var $b00a7f221d8fdf60$exports = {};

$parcel$export($b00a7f221d8fdf60$exports, "CLIENT_ID", () => $b00a7f221d8fdf60$export$c7b1b63f5b60f8e);
$parcel$export($b00a7f221d8fdf60$exports, "REDIRECT_URI", () => $b00a7f221d8fdf60$export$89711068e98820c5);
$parcel$export($b00a7f221d8fdf60$exports, "RESPONSE_TYPE", () => $b00a7f221d8fdf60$export$af70b7209f1c7f6e);
$parcel$export($b00a7f221d8fdf60$exports, "RESPONSE_MODE", () => $b00a7f221d8fdf60$export$2ae8b352eb8edff7);
$parcel$export($b00a7f221d8fdf60$exports, "GRANT_TYPE", () => $b00a7f221d8fdf60$export$47f09697d0642170);
$parcel$export($b00a7f221d8fdf60$exports, "CLAIMS", () => $b00a7f221d8fdf60$export$c9b29cc9615296dd);
$parcel$export($b00a7f221d8fdf60$exports, "SCOPE", () => $b00a7f221d8fdf60$export$1c5a554c78c0cd12);
$parcel$export($b00a7f221d8fdf60$exports, "ERROR", () => $b00a7f221d8fdf60$export$103bedf43ba882db);
$parcel$export($b00a7f221d8fdf60$exports, "ERROR_DESCRIPTION", () => $b00a7f221d8fdf60$export$a9d2d02ea6b73527);
$parcel$export($b00a7f221d8fdf60$exports, "ACCESS_TOKEN", () => $b00a7f221d8fdf60$export$cdbdf26448f9da5b);
$parcel$export($b00a7f221d8fdf60$exports, "ID_TOKEN", () => $b00a7f221d8fdf60$export$9e690c458f1b1eda);
$parcel$export($b00a7f221d8fdf60$exports, "REFRESH_TOKEN", () => $b00a7f221d8fdf60$export$2a2261c5a58ac0);
$parcel$export($b00a7f221d8fdf60$exports, "EXPIRES_IN", () => $b00a7f221d8fdf60$export$a9f2539254087dfb);
$parcel$export($b00a7f221d8fdf60$exports, "REFRESH_TOKEN_EXPIRES_IN", () => $b00a7f221d8fdf60$export$97e3ac17371277);
$parcel$export($b00a7f221d8fdf60$exports, "STATE", () => $b00a7f221d8fdf60$export$63b4527a2777036f);
$parcel$export($b00a7f221d8fdf60$exports, "NONCE", () => $b00a7f221d8fdf60$export$8646168ae3eb91e1);
$parcel$export($b00a7f221d8fdf60$exports, "PROMPT", () => $b00a7f221d8fdf60$export$19855bb42e55939d);
$parcel$export($b00a7f221d8fdf60$exports, "SESSION_STATE", () => $b00a7f221d8fdf60$export$3edd0f3d0bfcddba);
$parcel$export($b00a7f221d8fdf60$exports, "CLIENT_INFO", () => $b00a7f221d8fdf60$export$476989d62bcb4c85);
$parcel$export($b00a7f221d8fdf60$exports, "CODE", () => $b00a7f221d8fdf60$export$ec5856072852bd7f);
$parcel$export($b00a7f221d8fdf60$exports, "CODE_CHALLENGE", () => $b00a7f221d8fdf60$export$58d2be3216991fee);
$parcel$export($b00a7f221d8fdf60$exports, "CODE_CHALLENGE_METHOD", () => $b00a7f221d8fdf60$export$129e6f0601e36303);
$parcel$export($b00a7f221d8fdf60$exports, "CODE_VERIFIER", () => $b00a7f221d8fdf60$export$a5a34ec10c757281);
$parcel$export($b00a7f221d8fdf60$exports, "CLIENT_REQUEST_ID", () => $b00a7f221d8fdf60$export$633c8d7cd18ad9a9);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_SKU", () => $b00a7f221d8fdf60$export$fe2f04d04881f19d);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_VER", () => $b00a7f221d8fdf60$export$d0d0201281a553c0);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_OS", () => $b00a7f221d8fdf60$export$35497983a44f9406);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_CPU", () => $b00a7f221d8fdf60$export$d14a6ca469cd1d2b);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_CURR_TELEM", () => $b00a7f221d8fdf60$export$770dc090fda61e98);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_LAST_TELEM", () => $b00a7f221d8fdf60$export$99d6087ff3bfb0d3);
$parcel$export($b00a7f221d8fdf60$exports, "X_MS_LIB_CAPABILITY", () => $b00a7f221d8fdf60$export$c5cd103a582a276);
$parcel$export($b00a7f221d8fdf60$exports, "X_APP_NAME", () => $b00a7f221d8fdf60$export$6101af169595a2ae);
$parcel$export($b00a7f221d8fdf60$exports, "X_APP_VER", () => $b00a7f221d8fdf60$export$a8707209cc4254a);
$parcel$export($b00a7f221d8fdf60$exports, "POST_LOGOUT_URI", () => $b00a7f221d8fdf60$export$965624bb436bcb2);
$parcel$export($b00a7f221d8fdf60$exports, "ID_TOKEN_HINT", () => $b00a7f221d8fdf60$export$8d6737236a319b56);
$parcel$export($b00a7f221d8fdf60$exports, "DEVICE_CODE", () => $b00a7f221d8fdf60$export$a575303545717aec);
$parcel$export($b00a7f221d8fdf60$exports, "CLIENT_SECRET", () => $b00a7f221d8fdf60$export$69f7aececf3ea5d7);
$parcel$export($b00a7f221d8fdf60$exports, "CLIENT_ASSERTION", () => $b00a7f221d8fdf60$export$cddd1d85c78cca51);
$parcel$export($b00a7f221d8fdf60$exports, "CLIENT_ASSERTION_TYPE", () => $b00a7f221d8fdf60$export$21aecb34d0e7d9c0);
$parcel$export($b00a7f221d8fdf60$exports, "TOKEN_TYPE", () => $b00a7f221d8fdf60$export$5706a68daf4f000a);
$parcel$export($b00a7f221d8fdf60$exports, "REQ_CNF", () => $b00a7f221d8fdf60$export$427afb3f9eefe31e);
$parcel$export($b00a7f221d8fdf60$exports, "OBO_ASSERTION", () => $b00a7f221d8fdf60$export$3529b31b0ae94ae0);
$parcel$export($b00a7f221d8fdf60$exports, "REQUESTED_TOKEN_USE", () => $b00a7f221d8fdf60$export$97bc1bf63f077c4a);
$parcel$export($b00a7f221d8fdf60$exports, "ON_BEHALF_OF", () => $b00a7f221d8fdf60$export$4aca5741d44e318e);
$parcel$export($b00a7f221d8fdf60$exports, "FOCI", () => $b00a7f221d8fdf60$export$a03331b9d99609d6);
$parcel$export($b00a7f221d8fdf60$exports, "CCS_HEADER", () => $b00a7f221d8fdf60$export$773357fabf610b1f);
$parcel$export($b00a7f221d8fdf60$exports, "RETURN_SPA_CODE", () => $b00a7f221d8fdf60$export$f58b98a40c1faa68);
$parcel$export($b00a7f221d8fdf60$exports, "NATIVE_BROKER", () => $b00a7f221d8fdf60$export$830ff7e6cf071f86);
$parcel$export($b00a7f221d8fdf60$exports, "LOGOUT_HINT", () => $b00a7f221d8fdf60$export$a96ff88ff08babe2);
$parcel$export($b00a7f221d8fdf60$exports, "SID", () => $b00a7f221d8fdf60$export$e9405f9e95799b52);
$parcel$export($b00a7f221d8fdf60$exports, "LOGIN_HINT", () => $b00a7f221d8fdf60$export$defd6be6e02aaeb3);
$parcel$export($b00a7f221d8fdf60$exports, "DOMAIN_HINT", () => $b00a7f221d8fdf60$export$41459bac1e74ba19);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_EXTRA_SKU", () => $b00a7f221d8fdf60$export$493429868d5ba9bc);
$parcel$export($b00a7f221d8fdf60$exports, "BROKER_CLIENT_ID", () => $b00a7f221d8fdf60$export$3f910906fd5fe047);
$parcel$export($b00a7f221d8fdf60$exports, "BROKER_REDIRECT_URI", () => $b00a7f221d8fdf60$export$c3ecf58e7e228261);
$parcel$export($b00a7f221d8fdf60$exports, "INSTANCE_AWARE", () => $b00a7f221d8fdf60$export$d72b25d13120919d);
$parcel$export($b00a7f221d8fdf60$exports, "EAR_JWK", () => $b00a7f221d8fdf60$export$1e9ebf38b05380ef);
$parcel$export($b00a7f221d8fdf60$exports, "EAR_JWE_CRYPTO", () => $b00a7f221d8fdf60$export$79d2fd0e357f5119);
/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $b00a7f221d8fdf60$export$c7b1b63f5b60f8e = "client_id";
const $b00a7f221d8fdf60$export$89711068e98820c5 = "redirect_uri";
const $b00a7f221d8fdf60$export$af70b7209f1c7f6e = "response_type";
const $b00a7f221d8fdf60$export$2ae8b352eb8edff7 = "response_mode";
const $b00a7f221d8fdf60$export$47f09697d0642170 = "grant_type";
const $b00a7f221d8fdf60$export$c9b29cc9615296dd = "claims";
const $b00a7f221d8fdf60$export$1c5a554c78c0cd12 = "scope";
const $b00a7f221d8fdf60$export$103bedf43ba882db = "error";
const $b00a7f221d8fdf60$export$a9d2d02ea6b73527 = "error_description";
const $b00a7f221d8fdf60$export$cdbdf26448f9da5b = "access_token";
const $b00a7f221d8fdf60$export$9e690c458f1b1eda = "id_token";
const $b00a7f221d8fdf60$export$2a2261c5a58ac0 = "refresh_token";
const $b00a7f221d8fdf60$export$a9f2539254087dfb = "expires_in";
const $b00a7f221d8fdf60$export$97e3ac17371277 = "refresh_token_expires_in";
const $b00a7f221d8fdf60$export$63b4527a2777036f = "state";
const $b00a7f221d8fdf60$export$8646168ae3eb91e1 = "nonce";
const $b00a7f221d8fdf60$export$19855bb42e55939d = "prompt";
const $b00a7f221d8fdf60$export$3edd0f3d0bfcddba = "session_state";
const $b00a7f221d8fdf60$export$476989d62bcb4c85 = "client_info";
const $b00a7f221d8fdf60$export$ec5856072852bd7f = "code";
const $b00a7f221d8fdf60$export$58d2be3216991fee = "code_challenge";
const $b00a7f221d8fdf60$export$129e6f0601e36303 = "code_challenge_method";
const $b00a7f221d8fdf60$export$a5a34ec10c757281 = "code_verifier";
const $b00a7f221d8fdf60$export$633c8d7cd18ad9a9 = "client-request-id";
const $b00a7f221d8fdf60$export$fe2f04d04881f19d = "x-client-SKU";
const $b00a7f221d8fdf60$export$d0d0201281a553c0 = "x-client-VER";
const $b00a7f221d8fdf60$export$35497983a44f9406 = "x-client-OS";
const $b00a7f221d8fdf60$export$d14a6ca469cd1d2b = "x-client-CPU";
const $b00a7f221d8fdf60$export$770dc090fda61e98 = "x-client-current-telemetry";
const $b00a7f221d8fdf60$export$99d6087ff3bfb0d3 = "x-client-last-telemetry";
const $b00a7f221d8fdf60$export$c5cd103a582a276 = "x-ms-lib-capability";
const $b00a7f221d8fdf60$export$6101af169595a2ae = "x-app-name";
const $b00a7f221d8fdf60$export$a8707209cc4254a = "x-app-ver";
const $b00a7f221d8fdf60$export$965624bb436bcb2 = "post_logout_redirect_uri";
const $b00a7f221d8fdf60$export$8d6737236a319b56 = "id_token_hint";
const $b00a7f221d8fdf60$export$a575303545717aec = "device_code";
const $b00a7f221d8fdf60$export$69f7aececf3ea5d7 = "client_secret";
const $b00a7f221d8fdf60$export$cddd1d85c78cca51 = "client_assertion";
const $b00a7f221d8fdf60$export$21aecb34d0e7d9c0 = "client_assertion_type";
const $b00a7f221d8fdf60$export$5706a68daf4f000a = "token_type";
const $b00a7f221d8fdf60$export$427afb3f9eefe31e = "req_cnf";
const $b00a7f221d8fdf60$export$3529b31b0ae94ae0 = "assertion";
const $b00a7f221d8fdf60$export$97bc1bf63f077c4a = "requested_token_use";
const $b00a7f221d8fdf60$export$4aca5741d44e318e = "on_behalf_of";
const $b00a7f221d8fdf60$export$a03331b9d99609d6 = "foci";
const $b00a7f221d8fdf60$export$773357fabf610b1f = "X-AnchorMailbox";
const $b00a7f221d8fdf60$export$f58b98a40c1faa68 = "return_spa_code";
const $b00a7f221d8fdf60$export$830ff7e6cf071f86 = "nativebroker";
const $b00a7f221d8fdf60$export$a96ff88ff08babe2 = "logout_hint";
const $b00a7f221d8fdf60$export$e9405f9e95799b52 = "sid";
const $b00a7f221d8fdf60$export$defd6be6e02aaeb3 = "login_hint";
const $b00a7f221d8fdf60$export$41459bac1e74ba19 = "domain_hint";
const $b00a7f221d8fdf60$export$493429868d5ba9bc = "x-client-xtra-sku";
const $b00a7f221d8fdf60$export$3f910906fd5fe047 = "brk_client_id";
const $b00a7f221d8fdf60$export$c3ecf58e7e228261 = "brk_redirect_uri";
const $b00a7f221d8fdf60$export$d72b25d13120919d = "instance_aware";
const $b00a7f221d8fdf60$export$1e9ebf38b05380ef = "ear_jwk";
const $b00a7f221d8fdf60$export$79d2fd0e357f5119 = "ear_jwe_crypto";





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $7d3a00eb36d325b3$export$7153a1ee4346fa3b(parameters, correlationId, performanceClient) {
    if (!correlationId) return;
    const clientId = parameters.get((0, $b00a7f221d8fdf60$export$c7b1b63f5b60f8e));
    if (clientId && parameters.has((0, $b00a7f221d8fdf60$export$3f910906fd5fe047))) performanceClient?.addFields({
        embeddedClientId: clientId,
        embeddedRedirectUri: parameters.get((0, $b00a7f221d8fdf60$export$89711068e98820c5))
    }, correlationId);
}
/**
 * Add the given response_type
 * @param parameters
 * @param responseType
 */ function $7d3a00eb36d325b3$export$3e2fd8b32dd28470(parameters, responseType) {
    parameters.set((0, $b00a7f221d8fdf60$export$af70b7209f1c7f6e), responseType);
}
/**
 * add response_mode. defaults to query.
 * @param responseMode
 */ function $7d3a00eb36d325b3$export$f1c153626c2c2d91(parameters, responseMode) {
    parameters.set((0, $b00a7f221d8fdf60$export$2ae8b352eb8edff7), responseMode ? responseMode : (0, $7c375ae106b964be$export$f990a5bae1260b8c).QUERY);
}
/**
 * Add flag to indicate STS should attempt to use WAM if available
 */ function $7d3a00eb36d325b3$export$8c305b8d324c4edb(parameters) {
    parameters.set((0, $b00a7f221d8fdf60$export$830ff7e6cf071f86), "1");
}
/**
 * add scopes. set addOidcScopes to false to prevent default scopes in non-user scenarios
 * @param scopeSet
 * @param addOidcScopes
 */ function $7d3a00eb36d325b3$export$c213bf8f125826ba(parameters, scopes, addOidcScopes = true, defaultScopes = (0, $7c375ae106b964be$export$893b1b5b686d84ef)) {
    // Always add openid to the scopes when adding OIDC scopes
    if (addOidcScopes && !defaultScopes.includes("openid") && !scopes.includes("openid")) defaultScopes.push("openid");
    const requestScopes = addOidcScopes ? [
        ...scopes || [],
        ...defaultScopes
    ] : scopes || [];
    const scopeSet = new (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99)(requestScopes);
    parameters.set((0, $b00a7f221d8fdf60$export$1c5a554c78c0cd12), scopeSet.printScopes());
}
/**
 * add clientId
 * @param clientId
 */ function $7d3a00eb36d325b3$export$8360c651f9cc692b(parameters, clientId) {
    parameters.set((0, $b00a7f221d8fdf60$export$c7b1b63f5b60f8e), clientId);
}
/**
 * add redirect_uri
 * @param redirectUri
 */ function $7d3a00eb36d325b3$export$6758d6264f4f06(parameters, redirectUri) {
    parameters.set((0, $b00a7f221d8fdf60$export$89711068e98820c5), redirectUri);
}
/**
 * add post logout redirectUri
 * @param redirectUri
 */ function $7d3a00eb36d325b3$export$bb8081db67b059c0(parameters, redirectUri) {
    parameters.set((0, $b00a7f221d8fdf60$export$965624bb436bcb2), redirectUri);
}
/**
 * add id_token_hint to logout request
 * @param idTokenHint
 */ function $7d3a00eb36d325b3$export$c6f34f6f67740950(parameters, idTokenHint) {
    parameters.set((0, $b00a7f221d8fdf60$export$8d6737236a319b56), idTokenHint);
}
/**
 * add domain_hint
 * @param domainHint
 */ function $7d3a00eb36d325b3$export$1bd007a9d7fec290(parameters, domainHint) {
    parameters.set((0, $b00a7f221d8fdf60$export$41459bac1e74ba19), domainHint);
}
/**
 * add login_hint
 * @param loginHint
 */ function $7d3a00eb36d325b3$export$65f43fd4b28bba5f(parameters, loginHint) {
    parameters.set((0, $b00a7f221d8fdf60$export$defd6be6e02aaeb3), loginHint);
}
/**
 * Adds the CCS (Cache Credential Service) query parameter for login_hint
 * @param loginHint
 */ function $7d3a00eb36d325b3$export$aa9cca16bcc29d2d(parameters, loginHint) {
    parameters.set((0, $7c375ae106b964be$export$28d77f87efed1d88).CCS_HEADER, `UPN:${loginHint}`);
}
/**
 * Adds the CCS (Cache Credential Service) query parameter for account object
 * @param loginHint
 */ function $7d3a00eb36d325b3$export$68a633ecf634a2ea(parameters, clientInfo) {
    parameters.set((0, $7c375ae106b964be$export$28d77f87efed1d88).CCS_HEADER, `Oid:${clientInfo.uid}@${clientInfo.utid}`);
}
/**
 * add sid
 * @param sid
 */ function $7d3a00eb36d325b3$export$9d8531b0fa366b30(parameters, sid) {
    parameters.set((0, $b00a7f221d8fdf60$export$e9405f9e95799b52), sid);
}
/**
 * add claims
 * @param claims
 */ function $7d3a00eb36d325b3$export$b04c3bca9165ed02(parameters, claims, clientCapabilities) {
    const mergedClaims = $7d3a00eb36d325b3$export$f40e790983a9797e(claims, clientCapabilities);
    try {
        JSON.parse(mergedClaims);
    } catch (e) {
        throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$96e755c70e0d0e34));
    }
    parameters.set((0, $b00a7f221d8fdf60$export$c9b29cc9615296dd), mergedClaims);
}
/**
 * add correlationId
 * @param correlationId
 */ function $7d3a00eb36d325b3$export$8a224ff809946e9c(parameters, correlationId) {
    parameters.set((0, $b00a7f221d8fdf60$export$633c8d7cd18ad9a9), correlationId);
}
/**
 * add library info query params
 * @param libraryInfo
 */ function $7d3a00eb36d325b3$export$3ecac3764b147c3f(parameters, libraryInfo) {
    // Telemetry Info
    parameters.set((0, $b00a7f221d8fdf60$export$fe2f04d04881f19d), libraryInfo.sku);
    parameters.set((0, $b00a7f221d8fdf60$export$d0d0201281a553c0), libraryInfo.version);
    if (libraryInfo.os) parameters.set((0, $b00a7f221d8fdf60$export$35497983a44f9406), libraryInfo.os);
    if (libraryInfo.cpu) parameters.set((0, $b00a7f221d8fdf60$export$d14a6ca469cd1d2b), libraryInfo.cpu);
}
/**
 * Add client telemetry parameters
 * @param appTelemetry
 */ function $7d3a00eb36d325b3$export$37ec1b76d865654a(parameters, appTelemetry) {
    if (appTelemetry?.appName) parameters.set((0, $b00a7f221d8fdf60$export$6101af169595a2ae), appTelemetry.appName);
    if (appTelemetry?.appVersion) parameters.set((0, $b00a7f221d8fdf60$export$a8707209cc4254a), appTelemetry.appVersion);
}
/**
 * add prompt
 * @param prompt
 */ function $7d3a00eb36d325b3$export$e982ccd37a61cde6(parameters, prompt) {
    parameters.set((0, $b00a7f221d8fdf60$export$19855bb42e55939d), prompt);
}
/**
 * add state
 * @param state
 */ function $7d3a00eb36d325b3$export$4a8b8c14090dd065(parameters, state) {
    if (state) parameters.set((0, $b00a7f221d8fdf60$export$63b4527a2777036f), state);
}
/**
 * add nonce
 * @param nonce
 */ function $7d3a00eb36d325b3$export$87b1d5d886e84b11(parameters, nonce) {
    parameters.set((0, $b00a7f221d8fdf60$export$8646168ae3eb91e1), nonce);
}
/**
 * add code_challenge and code_challenge_method
 * - throw if either of them are not passed
 * @param codeChallenge
 * @param codeChallengeMethod
 */ function $7d3a00eb36d325b3$export$57a984e7ed784e16(parameters, codeChallenge, codeChallengeMethod) {
    if (codeChallenge && codeChallengeMethod) {
        parameters.set((0, $b00a7f221d8fdf60$export$58d2be3216991fee), codeChallenge);
        parameters.set((0, $b00a7f221d8fdf60$export$129e6f0601e36303), codeChallengeMethod);
    } else throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$2da3866b327f1753));
}
/**
 * add the `authorization_code` passed by the user to exchange for a token
 * @param code
 */ function $7d3a00eb36d325b3$export$ff027aab2d77a49c(parameters, code) {
    parameters.set((0, $b00a7f221d8fdf60$export$ec5856072852bd7f), code);
}
/**
 * add the `authorization_code` passed by the user to exchange for a token
 * @param code
 */ function $7d3a00eb36d325b3$export$8999dc4307159304(parameters, code) {
    parameters.set((0, $b00a7f221d8fdf60$export$a575303545717aec), code);
}
/**
 * add the `refreshToken` passed by the user
 * @param refreshToken
 */ function $7d3a00eb36d325b3$export$b9e8ccbb425b80a3(parameters, refreshToken) {
    parameters.set((0, $b00a7f221d8fdf60$export$2a2261c5a58ac0), refreshToken);
}
/**
 * add the `code_verifier` passed by the user to exchange for a token
 * @param codeVerifier
 */ function $7d3a00eb36d325b3$export$dceb49e3b4703cbb(parameters, codeVerifier) {
    parameters.set((0, $b00a7f221d8fdf60$export$a5a34ec10c757281), codeVerifier);
}
/**
 * add client_secret
 * @param clientSecret
 */ function $7d3a00eb36d325b3$export$8df84bbb0e2465bc(parameters, clientSecret) {
    parameters.set((0, $b00a7f221d8fdf60$export$69f7aececf3ea5d7), clientSecret);
}
/**
 * add clientAssertion for confidential client flows
 * @param clientAssertion
 */ function $7d3a00eb36d325b3$export$2d3d772920e2496e(parameters, clientAssertion) {
    if (clientAssertion) parameters.set((0, $b00a7f221d8fdf60$export$cddd1d85c78cca51), clientAssertion);
}
/**
 * add clientAssertionType for confidential client flows
 * @param clientAssertionType
 */ function $7d3a00eb36d325b3$export$55ad911d12112f00(parameters, clientAssertionType) {
    if (clientAssertionType) parameters.set((0, $b00a7f221d8fdf60$export$21aecb34d0e7d9c0), clientAssertionType);
}
/**
 * add OBO assertion for confidential client flows
 * @param clientAssertion
 */ function $7d3a00eb36d325b3$export$34b131001eea36b1(parameters, oboAssertion) {
    parameters.set((0, $b00a7f221d8fdf60$export$3529b31b0ae94ae0), oboAssertion);
}
/**
 * add grant type
 * @param grantType
 */ function $7d3a00eb36d325b3$export$b6d65fd125460167(parameters, tokenUse) {
    parameters.set((0, $b00a7f221d8fdf60$export$97bc1bf63f077c4a), tokenUse);
}
/**
 * add grant type
 * @param grantType
 */ function $7d3a00eb36d325b3$export$e5f700fdeb4022b2(parameters, grantType) {
    parameters.set((0, $b00a7f221d8fdf60$export$47f09697d0642170), grantType);
}
/**
 * add client info
 *
 */ function $7d3a00eb36d325b3$export$86b85a101d45e918(parameters) {
    parameters.set((0, $7c375ae106b964be$export$476989d62bcb4c85), "1");
}
function $7d3a00eb36d325b3$export$50b40dfb1d11b77a(parameters) {
    if (!parameters.has((0, $b00a7f221d8fdf60$export$d72b25d13120919d))) parameters.set((0, $b00a7f221d8fdf60$export$d72b25d13120919d), "true");
}
/**
 * add extraQueryParams
 * @param eQParams
 */ function $7d3a00eb36d325b3$export$1a9f676bcc5d37da(parameters, eQParams) {
    Object.entries(eQParams).forEach(([key, value])=>{
        if (!parameters.has(key) && value) parameters.set(key, value);
    });
}
function $7d3a00eb36d325b3$export$f40e790983a9797e(claims, clientCapabilities) {
    let mergedClaims;
    // Parse provided claims into JSON object or initialize empty object
    if (!claims) mergedClaims = {};
    else try {
        mergedClaims = JSON.parse(claims);
    } catch (e) {
        throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$96e755c70e0d0e34));
    }
    if (clientCapabilities && clientCapabilities.length > 0) {
        if (!mergedClaims.hasOwnProperty((0, $7c375ae106b964be$export$c125cda26c71ef54).ACCESS_TOKEN)) // Add access_token key to claims object
        mergedClaims[(0, $7c375ae106b964be$export$c125cda26c71ef54).ACCESS_TOKEN] = {};
        // Add xms_cc claim with provided clientCapabilities to access_token key
        mergedClaims[(0, $7c375ae106b964be$export$c125cda26c71ef54).ACCESS_TOKEN][(0, $7c375ae106b964be$export$c125cda26c71ef54).XMS_CC] = {
            values: clientCapabilities
        };
    }
    return JSON.stringify(mergedClaims);
}
/**
 * adds `username` for Password Grant flow
 * @param username
 */ function $7d3a00eb36d325b3$export$d38c772efe03a690(parameters, username) {
    parameters.set((0, $7c375ae106b964be$export$fa8b29062cab1da).username, username);
}
/**
 * adds `password` for Password Grant flow
 * @param password
 */ function $7d3a00eb36d325b3$export$bfe833e59aa823e8(parameters, password) {
    parameters.set((0, $7c375ae106b964be$export$fa8b29062cab1da).password, password);
}
/**
 * add pop_jwk to query params
 * @param cnfString
 */ function $7d3a00eb36d325b3$export$6dfc34809d8c4096(parameters, cnfString) {
    if (cnfString) {
        parameters.set((0, $b00a7f221d8fdf60$export$5706a68daf4f000a), (0, $7c375ae106b964be$export$901491a717da2ba5).POP);
        parameters.set((0, $b00a7f221d8fdf60$export$427afb3f9eefe31e), cnfString);
    }
}
/**
 * add SSH JWK and key ID to query params
 */ function $7d3a00eb36d325b3$export$f004de9a266b8070(parameters, sshJwkString) {
    if (sshJwkString) {
        parameters.set((0, $b00a7f221d8fdf60$export$5706a68daf4f000a), (0, $7c375ae106b964be$export$901491a717da2ba5).SSH);
        parameters.set((0, $b00a7f221d8fdf60$export$427afb3f9eefe31e), sshJwkString);
    }
}
/**
 * add server telemetry fields
 * @param serverTelemetryManager
 */ function $7d3a00eb36d325b3$export$79fb524b159705e9(parameters, serverTelemetryManager) {
    parameters.set((0, $b00a7f221d8fdf60$export$770dc090fda61e98), serverTelemetryManager.generateCurrentRequestHeaderValue());
    parameters.set((0, $b00a7f221d8fdf60$export$99d6087ff3bfb0d3), serverTelemetryManager.generateLastRequestHeaderValue());
}
/**
 * Adds parameter that indicates to the server that throttling is supported
 */ function $7d3a00eb36d325b3$export$26592ae2037df9de(parameters) {
    parameters.set((0, $b00a7f221d8fdf60$export$c5cd103a582a276), (0, $7c375ae106b964be$export$a2330d6808e6d893).X_MS_LIB_CAPABILITY_VALUE);
}
/**
 * Adds logout_hint parameter for "silent" logout which prevent server account picker
 */ function $7d3a00eb36d325b3$export$e0d4676d7288bded(parameters, logoutHint) {
    parameters.set((0, $b00a7f221d8fdf60$export$a96ff88ff08babe2), logoutHint);
}
function $7d3a00eb36d325b3$export$5ea4577e2a518c27(parameters, brokerClientId, brokerRedirectUri) {
    if (!parameters.has((0, $b00a7f221d8fdf60$export$3f910906fd5fe047))) parameters.set((0, $b00a7f221d8fdf60$export$3f910906fd5fe047), brokerClientId);
    if (!parameters.has((0, $b00a7f221d8fdf60$export$c3ecf58e7e228261))) parameters.set((0, $b00a7f221d8fdf60$export$c3ecf58e7e228261), brokerRedirectUri);
}
/**
 * Add EAR (Encrypted Authorize Response) request parameters
 * @param parameters
 * @param jwk
 */ function $7d3a00eb36d325b3$export$ec0b476da4a9fb0(parameters, jwk) {
    parameters.set((0, $b00a7f221d8fdf60$export$1e9ebf38b05380ef), encodeURIComponent(jwk));
    // ear_jwe_crypto will always have value: {"alg":"dir","enc":"A256GCM"} so we can hardcode this
    const jweCryptoB64Encoded = "eyJhbGciOiJkaXIiLCJlbmMiOiJBMjU2R0NNIn0";
    parameters.set((0, $b00a7f221d8fdf60$export$79d2fd0e357f5119), jweCryptoB64Encoded);
}



var $ef8a264971d8166d$exports = {};

$parcel$export($ef8a264971d8166d$exports, "createDiscoveredInstance", () => $ef8a264971d8166d$export$ab9db5e7e572e7da);
/*! @azure/msal-common v15.7.0 2025-05-30 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Create an authority object of the correct type based on the url
 * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
 *
 * Also performs endpoint discovery.
 *
 * @param authorityUri
 * @param networkClient
 * @param protocolMode
 * @internal
 */ async function $ef8a264971d8166d$export$ab9db5e7e572e7da(authorityUri, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient) {
    performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityFactoryCreateDiscoveredInstance, correlationId);
    const authorityUriFinal = (0, $77bb430f4568f6e8$export$f1c6ec2e6d68c49c).transformCIAMAuthority((0, $77bb430f4568f6e8$export$4030f3538167cb9e)(authorityUri));
    // Initialize authority and perform discovery endpoint check.
    const acquireTokenAuthority = new (0, $77bb430f4568f6e8$export$f1c6ec2e6d68c49c)(authorityUriFinal, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient);
    try {
        await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(acquireTokenAuthority.resolveEndpointsAsync.bind(acquireTokenAuthority), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityResolveEndpointsAsync, logger, performanceClient, correlationId)();
        return acquireTokenAuthority;
    } catch (e) {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
}



/*! @azure/msal-common v15.7.0 2025-05-30 */ 
/*! @azure/msal-common v15.7.0 2025-05-30 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error with the server code, for example, unavailability.
 */ class $016e46db2c2afa86$export$ea52035eac03daf0 extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage, subError, errorNo, status){
        super(errorCode, errorMessage, subError);
        this.name = "ServerError";
        this.errorNo = errorNo;
        this.status = status;
        Object.setPrototypeOf(this, $016e46db2c2afa86$export$ea52035eac03daf0.prototype);
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $38fc8bee021018e9$export$c060a619741dd765 {
    /**
     * Prepares a RequestThumbprint to be stored as a key.
     * @param thumbprint
     */ static generateThrottlingStorageKey(thumbprint) {
        return `${(0, $7c375ae106b964be$export$a2330d6808e6d893).THROTTLING_PREFIX}.${JSON.stringify(thumbprint)}`;
    }
    /**
     * Performs necessary throttling checks before a network request.
     * @param cacheManager
     * @param thumbprint
     */ static preProcess(cacheManager, thumbprint) {
        const key = $38fc8bee021018e9$export$c060a619741dd765.generateThrottlingStorageKey(thumbprint);
        const value = cacheManager.getThrottlingCache(key);
        if (value) {
            if (value.throttleTime < Date.now()) {
                cacheManager.removeItem(key);
                return;
            }
            throw new (0, $016e46db2c2afa86$export$ea52035eac03daf0)(value.errorCodes?.join(" ") || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, value.errorMessage, value.subError);
        }
    }
    /**
     * Performs necessary throttling checks after a network request.
     * @param cacheManager
     * @param thumbprint
     * @param response
     */ static postProcess(cacheManager, thumbprint, response) {
        if ($38fc8bee021018e9$export$c060a619741dd765.checkResponseStatus(response) || $38fc8bee021018e9$export$c060a619741dd765.checkResponseForRetryAfter(response)) {
            const thumbprintValue = {
                throttleTime: $38fc8bee021018e9$export$c060a619741dd765.calculateThrottleTime(parseInt(response.headers[(0, $7c375ae106b964be$export$28d77f87efed1d88).RETRY_AFTER])),
                error: response.body.error,
                errorCodes: response.body.error_codes,
                errorMessage: response.body.error_description,
                subError: response.body.suberror
            };
            cacheManager.setThrottlingCache($38fc8bee021018e9$export$c060a619741dd765.generateThrottlingStorageKey(thumbprint), thumbprintValue);
        }
    }
    /**
     * Checks a NetworkResponse object's status codes against 429 or 5xx
     * @param response
     */ static checkResponseStatus(response) {
        return response.status === 429 || response.status >= 500 && response.status < 600;
    }
    /**
     * Checks a NetworkResponse object's RetryAfter header
     * @param response
     */ static checkResponseForRetryAfter(response) {
        if (response.headers) return response.headers.hasOwnProperty((0, $7c375ae106b964be$export$28d77f87efed1d88).RETRY_AFTER) && (response.status < 200 || response.status >= 300);
        return false;
    }
    /**
     * Calculates the Unix-time value for a throttle to expire given throttleTime in seconds.
     * @param throttleTime
     */ static calculateThrottleTime(throttleTime) {
        const time = throttleTime <= 0 ? 0 : throttleTime;
        const currentSeconds = Date.now() / 1000;
        return Math.floor(Math.min(currentSeconds + (time || (0, $7c375ae106b964be$export$a2330d6808e6d893).DEFAULT_THROTTLE_TIME_SECONDS), currentSeconds + (0, $7c375ae106b964be$export$a2330d6808e6d893).DEFAULT_MAX_THROTTLE_TIME_SECONDS) * 1000);
    }
    static removeThrottle(cacheManager, clientId, request, homeAccountIdentifier) {
        const thumbprint = (0, $762faca86a0f7942$export$2daa8cfcf54c2b48)(clientId, request, homeAccountIdentifier);
        const key = this.generateThrottlingStorageKey(thumbprint);
        cacheManager.removeItem(key);
    }
}







'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base application class which will construct requests to send to and handle responses from the Microsoft STS using the authorization code flow.
 * @internal
 */ class $3b13384e79a725db$export$4f22f74eddb7716a {
    constructor(configuration, performanceClient){
        // Set the configuration
        this.config = (0, $d21eb39178ebb5ae$export$57a091701dcdabb2)(configuration);
        // Initialize the logger
        this.logger = new (0, $0bf1d54ef751a29c$export$efa9a398d6368992)(this.config.loggerOptions, (0, $4c1e49235f95193e$export$a8ff84c12d48cfa6), (0, $4c1e49235f95193e$export$83d89fbfd8236492));
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
    }
    /**
     * Creates default headers for requests to token endpoint
     */ createTokenRequestHeaders(ccsCred) {
        const headers = {};
        headers[(0, $7c375ae106b964be$export$28d77f87efed1d88).CONTENT_TYPE] = (0, $7c375ae106b964be$export$a002182e51710d39).URL_FORM_CONTENT_TYPE;
        if (!this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
            case (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $7aacd5d6e6d7482c$export$63508a6d6b7dbe07)(ccsCred.credential);
                    headers[(0, $7c375ae106b964be$export$28d77f87efed1d88).CCS_HEADER] = `Oid:${clientInfo.uid}@${clientInfo.utid}`;
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $feda987e240ac148$export$17b7b3ac1abef49f).UPN:
                headers[(0, $7c375ae106b964be$export$28d77f87efed1d88).CCS_HEADER] = `UPN: ${ccsCred.credential}`;
                break;
        }
        return headers;
    }
    /**
     * Http post to token endpoint
     * @param tokenEndpoint
     * @param queryString
     * @param headers
     * @param thumbprint
     */ async executePostToTokenEndpoint(tokenEndpoint, queryString, headers, thumbprint, correlationId, queuedEvent) {
        if (queuedEvent) this.performanceClient?.addQueueMeasurement(queuedEvent, correlationId);
        const response = await this.sendPostRequest(thumbprint, tokenEndpoint, {
            body: queryString,
            headers: headers
        }, correlationId);
        if (this.config.serverTelemetryManager && response.status < 500 && response.status !== 429) // Telemetry data successfully logged by server, clear Telemetry cache
        this.config.serverTelemetryManager.clearTelemetryCache();
        return response;
    }
    /**
     * Wraps sendPostRequestAsync with necessary preflight and postflight logic
     * @param thumbprint - Request thumbprint for throttling
     * @param tokenEndpoint - Endpoint to make the POST to
     * @param options - Body and Headers to include on the POST request
     * @param correlationId - CorrelationId for telemetry
     */ async sendPostRequest(thumbprint, tokenEndpoint, options, correlationId) {
        (0, $38fc8bee021018e9$export$c060a619741dd765).preProcess(this.cacheManager, thumbprint);
        let response;
        try {
            response = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.networkClient.sendPostRequestAsync.bind(this.networkClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).NetworkClientSendPostRequestAsync, this.logger, this.performanceClient, correlationId)(tokenEndpoint, options);
            const responseHeaders = response.headers || {};
            this.performanceClient?.addFields({
                refreshTokenSize: response.body.refresh_token?.length || 0,
                httpVerToken: responseHeaders[(0, $7c375ae106b964be$export$28d77f87efed1d88).X_MS_HTTP_VERSION] || "",
                requestId: responseHeaders[(0, $7c375ae106b964be$export$28d77f87efed1d88).X_MS_REQUEST_ID] || ""
            }, correlationId);
        } catch (e) {
            if (e instanceof (0, $01c2dbbf2115e471$export$bae979e68e4dc802)) {
                const responseHeaders = e.responseHeaders;
                if (responseHeaders) this.performanceClient?.addFields({
                    httpVerToken: responseHeaders[(0, $7c375ae106b964be$export$28d77f87efed1d88).X_MS_HTTP_VERSION] || "",
                    requestId: responseHeaders[(0, $7c375ae106b964be$export$28d77f87efed1d88).X_MS_REQUEST_ID] || "",
                    contentTypeHeader: responseHeaders[(0, $7c375ae106b964be$export$28d77f87efed1d88).CONTENT_TYPE] || undefined,
                    contentLengthHeader: responseHeaders[(0, $7c375ae106b964be$export$28d77f87efed1d88).CONTENT_LENGTH] || undefined,
                    httpStatus: e.httpStatus
                }, correlationId);
                throw e.error;
            }
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) throw e;
            else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$4358cbadf08aa73));
        }
        (0, $38fc8bee021018e9$export$c060a619741dd765).postProcess(this.cacheManager, thumbprint, response);
        return response;
    }
    /**
     * Updates the authority object of the client. Endpoint discovery must be completed.
     * @param updatedAuthority
     */ async updateAuthority(cloudInstanceHostname, correlationId) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).UpdateTokenEndpointAuthority, correlationId);
        const cloudInstanceAuthorityUri = `https://${cloudInstanceHostname}/${this.authority.tenant}/`;
        const cloudInstanceAuthority = await (0, $ef8a264971d8166d$export$ab9db5e7e572e7da)(cloudInstanceAuthorityUri, this.networkClient, this.cacheManager, this.authority.options, this.logger, correlationId, this.performanceClient);
        this.authority = cloudInstanceAuthority;
    }
    /**
     * Creates query string for the /token request
     * @param request
     */ createTokenQueryParameters(request) {
        const parameters = new Map();
        if (request.embeddedClientId) (0, $7d3a00eb36d325b3$export$5ea4577e2a518c27)(parameters, this.config.authOptions.clientId, this.config.authOptions.redirectUri);
        if (request.tokenQueryParameters) (0, $7d3a00eb36d325b3$export$1a9f676bcc5d37da)(parameters, request.tokenQueryParameters);
        (0, $7d3a00eb36d325b3$export$8a224ff809946e9c)(parameters, request.correlationId);
        (0, $7d3a00eb36d325b3$export$7153a1ee4346fa3b)(parameters, request.correlationId, this.performanceClient);
        return (0, $0763983a1d35c4b8$export$44d4663acf79cde2)(parameters);
    }
}







/*! @azure/msal-common v15.7.0 2025-05-30 */ 




/*! @azure/msal-common v15.7.0 2025-05-30 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which provides helpers for OAuth 2.0 protocol specific values
 */ class $18d0dfe50b7b79f1$export$871e33217042c65e {
    /**
     * Appends user state with random guid, or returns random guid.
     * @param userState
     * @param randomGuid
     */ static setRequestState(cryptoObj, userState, meta) {
        const libraryState = $18d0dfe50b7b79f1$export$871e33217042c65e.generateLibraryState(cryptoObj, meta);
        return userState ? `${libraryState}${(0, $7c375ae106b964be$export$a002182e51710d39).RESOURCE_DELIM}${userState}` : libraryState;
    }
    /**
     * Generates the state value used by the common library.
     * @param randomGuid
     * @param cryptoObj
     */ static generateLibraryState(cryptoObj, meta) {
        if (!cryptoObj) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c39e501a22cba395));
        // Create a state object containing a unique id and the timestamp of the request creation
        const stateObj = {
            id: cryptoObj.createNewGuid()
        };
        if (meta) stateObj.meta = meta;
        const stateString = JSON.stringify(stateObj);
        return cryptoObj.base64Encode(stateString);
    }
    /**
     * Parses the state into the RequestStateObject, which contains the LibraryState info and the state passed by the user.
     * @param state
     * @param cryptoObj
     */ static parseRequestState(cryptoObj, state) {
        if (!cryptoObj) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c39e501a22cba395));
        if (!state) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$72a77317632c052b));
        try {
            // Split the state between library state and user passed state and decode them separately
            const splitState = state.split((0, $7c375ae106b964be$export$a002182e51710d39).RESOURCE_DELIM);
            const libraryState = splitState[0];
            const userState = splitState.length > 1 ? splitState.slice(1).join((0, $7c375ae106b964be$export$a002182e51710d39).RESOURCE_DELIM) : (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
            const libraryStateString = cryptoObj.base64Decode(libraryState);
            const libraryStateObj = JSON.parse(libraryStateString);
            return {
                userRequestState: userState || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
                libraryState: libraryStateObj
            };
        } catch (e) {
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$72a77317632c052b));
        }
    }
}



/*! @azure/msal-common v15.7.0 2025-05-30 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $942a44945e07e21d$var$KeyLocation = {
    SW: "sw",
    UHW: "uhw"
};
/** @internal */ class $942a44945e07e21d$export$3dd8467151c83e3e {
    constructor(cryptoUtils, performanceClient){
        this.cryptoUtils = cryptoUtils;
        this.performanceClient = performanceClient;
    }
    /**
     * Generates the req_cnf validated at the RP in the POP protocol for SHR parameters
     * and returns an object containing the keyid, the full req_cnf string and the req_cnf string hash
     * @param request
     * @returns
     */ async generateCnf(request, logger) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateCnf, request.correlationId);
        const reqCnf = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.generateKid.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateCnf, logger, this.performanceClient, request.correlationId)(request);
        const reqCnfString = this.cryptoUtils.base64UrlEncode(JSON.stringify(reqCnf));
        return {
            kid: reqCnf.kid,
            reqCnfString: reqCnfString
        };
    }
    /**
     * Generates key_id for a SHR token request
     * @param request
     * @returns
     */ async generateKid(request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateKid, request.correlationId);
        const kidThumbprint = await this.cryptoUtils.getPublicKeyThumbprint(request);
        return {
            kid: kidThumbprint,
            xms_ksl: $942a44945e07e21d$var$KeyLocation.SW
        };
    }
    /**
     * Signs the POP access_token with the local generated key-pair
     * @param accessToken
     * @param request
     * @returns
     */ async signPopToken(accessToken, keyId, request) {
        return this.signPayload(accessToken, keyId, request);
    }
    /**
     * Utility function to generate the signed JWT for an access_token
     * @param payload
     * @param kid
     * @param request
     * @param claims
     * @returns
     */ async signPayload(payload, keyId, request, claims) {
        // Deconstruct request to extract SHR parameters
        const { resourceRequestMethod: resourceRequestMethod, resourceRequestUri: resourceRequestUri, shrClaims: shrClaims, shrNonce: shrNonce, shrOptions: shrOptions } = request;
        const resourceUrlString = resourceRequestUri ? new (0, $f7f911f196324278$export$3abcdca7229e54f2)(resourceRequestUri) : undefined;
        const resourceUrlComponents = resourceUrlString?.getUrlComponents();
        return this.cryptoUtils.signJwt({
            at: payload,
            ts: (0, $0a4a8f22735f9ff5$export$ae62599a119ac50a)(),
            m: resourceRequestMethod?.toUpperCase(),
            u: resourceUrlComponents?.HostNameAndPort,
            nonce: shrNonce || this.cryptoUtils.createNewGuid(),
            p: resourceUrlComponents?.AbsolutePath,
            q: resourceUrlComponents?.QueryString ? [
                [],
                resourceUrlComponents.QueryString
            ] : undefined,
            client_claims: shrClaims || undefined,
            ...claims
        }, keyId, shrOptions, request.correlationId);
    }
}


/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class instance helps track the memory changes facilitating
 * decisions to read from and write to the persistent cache
 */ class $a01edd09af59ca7b$export$500ab620f6bcc747 {
    constructor(tokenCache, hasChanged){
        this.cache = tokenCache;
        this.hasChanged = hasChanged;
    }
    /**
     * boolean which indicates the changes in cache
     */ get cacheHasChanged() {
        return this.hasChanged;
    }
    /**
     * function to retrieve the token cache
     */ get tokenCache() {
        return this.cache;
    }
}









'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class that handles response parsing.
 * @internal
 */ class $4039fad97bcf28f6$export$f456c9835cc63582 {
    constructor(clientId, cacheStorage, cryptoObj, logger, serializableCache, persistencePlugin, performanceClient){
        this.clientId = clientId;
        this.cacheStorage = cacheStorage;
        this.cryptoObj = cryptoObj;
        this.logger = logger;
        this.serializableCache = serializableCache;
        this.persistencePlugin = persistencePlugin;
        this.performanceClient = performanceClient;
    }
    /**
     * Function which validates server authorization token response.
     * @param serverResponse
     * @param refreshAccessToken
     */ validateTokenResponse(serverResponse, refreshAccessToken) {
        // Check for error
        if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
            const errString = `Error(s): ${serverResponse.error_codes || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_AVAILABLE} - Timestamp: ${serverResponse.timestamp || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_AVAILABLE} - Description: ${serverResponse.error_description || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_AVAILABLE} - Correlation ID: ${serverResponse.correlation_id || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_AVAILABLE} - Trace ID: ${serverResponse.trace_id || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_AVAILABLE}`;
            const serverErrorNo = serverResponse.error_codes?.length ? serverResponse.error_codes[0] : undefined;
            const serverError = new (0, $016e46db2c2afa86$export$ea52035eac03daf0)(serverResponse.error, errString, serverResponse.suberror, serverErrorNo, serverResponse.status);
            // check if 500 error
            if (refreshAccessToken && serverResponse.status && serverResponse.status >= (0, $7c375ae106b964be$export$2b71909294c66558).SERVER_ERROR_RANGE_START && serverResponse.status <= (0, $7c375ae106b964be$export$2b71909294c66558).SERVER_ERROR_RANGE_END) {
                this.logger.warning(`executeTokenRequest:validateTokenResponse - AAD is currently unavailable and the access token is unable to be refreshed.\n${serverError}`);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            // check if 400 error
            } else if (refreshAccessToken && serverResponse.status && serverResponse.status >= (0, $7c375ae106b964be$export$2b71909294c66558).CLIENT_ERROR_RANGE_START && serverResponse.status <= (0, $7c375ae106b964be$export$2b71909294c66558).CLIENT_ERROR_RANGE_END) {
                this.logger.warning(`executeTokenRequest:validateTokenResponse - AAD is currently available but is unable to refresh the access token.\n${serverError}`);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            }
            if ((0, $18a94acc3dad87ad$export$376c3c4c19cb933a)(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)(serverResponse.error, serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, serverResponse.trace_id || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, serverResponse.correlation_id || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, serverResponse.claims || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, serverErrorNo);
            throw serverError;
        }
    }
    /**
     * Returns a constructed token response based on given string. Also manages the cache updates and cleanups.
     * @param serverTokenResponse
     * @param authority
     */ async handleServerTokenResponse(serverTokenResponse, authority, reqTimestamp, request, authCodePayload, userAssertionHash, handlingRefreshTokenResponse, forceCacheRefreshTokenResponse, serverRequestId) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleServerTokenResponse, serverTokenResponse.correlation_id);
        // create an idToken object (not entity)
        let idTokenClaims;
        if (serverTokenResponse.id_token) {
            idTokenClaims = (0, $b29e27fb146a7ddd$export$8a59e6f35fb00518)(serverTokenResponse.id_token || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, this.cryptoObj.base64Decode);
            // token nonce check (TODO: Add a warning if no nonce is given?)
            if (authCodePayload && authCodePayload.nonce) {
                if (idTokenClaims.nonce !== authCodePayload.nonce) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$edd0491c2c280be7));
            }
            // token max_age check
            if (request.maxAge || request.maxAge === 0) {
                const authTime = idTokenClaims.auth_time;
                if (!authTime) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$43356944266c945e));
                (0, $b29e27fb146a7ddd$export$ee7a34ea7880144c)(authTime, request.maxAge);
            }
        }
        // generate homeAccountId
        this.homeAccountIdentifier = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).generateHomeAccountId(serverTokenResponse.client_info || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, authority.authorityType, this.logger, this.cryptoObj, idTokenClaims);
        // save the response tokens
        let requestStateObj;
        if (!!authCodePayload && !!authCodePayload.state) requestStateObj = (0, $18d0dfe50b7b79f1$export$871e33217042c65e).parseRequestState(this.cryptoObj, authCodePayload.state);
        // Add keyId from request to serverTokenResponse if defined
        serverTokenResponse.key_id = serverTokenResponse.key_id || request.sshKid || undefined;
        const cacheRecord = this.generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload);
        let cacheContext;
        try {
            if (this.persistencePlugin && this.serializableCache) {
                this.logger.verbose("Persistence enabled, calling beforeCacheAccess");
                cacheContext = new (0, $a01edd09af59ca7b$export$500ab620f6bcc747)(this.serializableCache, true);
                await this.persistencePlugin.beforeCacheAccess(cacheContext);
            }
            /*
             * When saving a refreshed tokens to the cache, it is expected that the account that was used is present in the cache.
             * If not present, we should return null, as it's the case that another application called removeAccount in between
             * the calls to getAllAccounts and acquireTokenSilent. We should not overwrite that removal, unless explicitly flagged by
             * the developer, as in the case of refresh token flow used in ADAL Node to MSAL Node migration.
             */ if (handlingRefreshTokenResponse && !forceCacheRefreshTokenResponse && cacheRecord.account) {
                const key = cacheRecord.account.generateAccountKey();
                const account = this.cacheStorage.getAccount(key);
                if (!account) {
                    this.logger.warning("Account used to refresh tokens not in persistence, refreshed tokens will not be stored in the cache");
                    return await $4039fad97bcf28f6$export$f456c9835cc63582.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenClaims, requestStateObj, undefined, serverRequestId);
                }
            }
            await this.cacheStorage.saveCacheRecord(cacheRecord, request.correlationId, request.storeInCache);
        } finally{
            if (this.persistencePlugin && this.serializableCache && cacheContext) {
                this.logger.verbose("Persistence enabled, calling afterCacheAccess");
                await this.persistencePlugin.afterCacheAccess(cacheContext);
            }
        }
        return $4039fad97bcf28f6$export$f456c9835cc63582.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenClaims, requestStateObj, serverTokenResponse, serverRequestId);
    }
    /**
     * Generates CacheRecord
     * @param serverTokenResponse
     * @param idTokenObj
     * @param authority
     */ generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload) {
        const env = authority.getPreferredCache();
        if (!env) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$dedc648643245fa1));
        const claimsTenantId = (0, $da8f9f8eb56c5a02$export$8e1decb9a5e2932)(idTokenClaims);
        // IdToken: non AAD scenarios can have empty realm
        let cachedIdToken;
        let cachedAccount;
        if (serverTokenResponse.id_token && !!idTokenClaims) {
            cachedIdToken = (0, $9ab3d26df56b176d$export$d8a173a23f325769)(this.homeAccountIdentifier, env, serverTokenResponse.id_token, this.clientId, claimsTenantId || "");
            cachedAccount = $4039fad97bcf28f6$export$73b84062d58a1307(this.cacheStorage, authority, this.homeAccountIdentifier, this.cryptoObj.base64Decode, idTokenClaims, serverTokenResponse.client_info, env, claimsTenantId, authCodePayload, undefined, this.logger);
        }
        // AccessToken
        let cachedAccessToken = null;
        if (serverTokenResponse.access_token) {
            // If scopes not returned in server response, use request scopes
            const responseScopes = serverTokenResponse.scope ? (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(serverTokenResponse.scope) : new (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99)(request.scopes || []);
            /*
             * Use timestamp calculated before request
             * Server may return timestamps as strings, parse to numbers if so.
             */ const expiresIn = (typeof serverTokenResponse.expires_in === "string" ? parseInt(serverTokenResponse.expires_in, 10) : serverTokenResponse.expires_in) || 0;
            const extExpiresIn = (typeof serverTokenResponse.ext_expires_in === "string" ? parseInt(serverTokenResponse.ext_expires_in, 10) : serverTokenResponse.ext_expires_in) || 0;
            const refreshIn = (typeof serverTokenResponse.refresh_in === "string" ? parseInt(serverTokenResponse.refresh_in, 10) : serverTokenResponse.refresh_in) || undefined;
            const tokenExpirationSeconds = reqTimestamp + expiresIn;
            const extendedTokenExpirationSeconds = tokenExpirationSeconds + extExpiresIn;
            const refreshOnSeconds = refreshIn && refreshIn > 0 ? reqTimestamp + refreshIn : undefined;
            // non AAD scenarios can have empty realm
            cachedAccessToken = (0, $9ab3d26df56b176d$export$fa005e75d915b6db)(this.homeAccountIdentifier, env, serverTokenResponse.access_token, this.clientId, claimsTenantId || authority.tenant || "", responseScopes.printScopes(), tokenExpirationSeconds, extendedTokenExpirationSeconds, this.cryptoObj.base64Decode, refreshOnSeconds, serverTokenResponse.token_type, userAssertionHash, serverTokenResponse.key_id, request.claims, request.requestedClaimsHash);
        }
        // refreshToken
        let cachedRefreshToken = null;
        if (serverTokenResponse.refresh_token) {
            let rtExpiresOn;
            if (serverTokenResponse.refresh_token_expires_in) {
                const rtExpiresIn = typeof serverTokenResponse.refresh_token_expires_in === "string" ? parseInt(serverTokenResponse.refresh_token_expires_in, 10) : serverTokenResponse.refresh_token_expires_in;
                rtExpiresOn = reqTimestamp + rtExpiresIn;
            }
            cachedRefreshToken = (0, $9ab3d26df56b176d$export$9095b5885dfa55cc)(this.homeAccountIdentifier, env, serverTokenResponse.refresh_token, this.clientId, serverTokenResponse.foci, userAssertionHash, rtExpiresOn);
        }
        // appMetadata
        let cachedAppMetadata = null;
        if (serverTokenResponse.foci) cachedAppMetadata = {
            clientId: this.clientId,
            environment: env,
            familyId: serverTokenResponse.foci
        };
        return {
            account: cachedAccount,
            idToken: cachedIdToken,
            accessToken: cachedAccessToken,
            refreshToken: cachedRefreshToken,
            appMetadata: cachedAppMetadata
        };
    }
    /**
     * Creates an @AuthenticationResult from @CacheRecord , @IdToken , and a boolean that states whether or not the result is from cache.
     *
     * Optionally takes a state string that is set as-is in the response.
     *
     * @param cacheRecord
     * @param idTokenObj
     * @param fromTokenCache
     * @param stateString
     */ static async generateAuthenticationResult(cryptoObj, authority, cacheRecord, fromTokenCache, request, idTokenClaims, requestState, serverTokenResponse, requestId) {
        let accessToken = (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        let responseScopes = [];
        let expiresOn = null;
        let extExpiresOn;
        let refreshOn;
        let familyId = (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        if (cacheRecord.accessToken) {
            /*
             * if the request object has `popKid` property, `signPopToken` will be set to false and
             * the token will be returned unsigned
             */ if (cacheRecord.accessToken.tokenType === (0, $7c375ae106b964be$export$901491a717da2ba5).POP && !request.popKid) {
                const popTokenGenerator = new (0, $942a44945e07e21d$export$3dd8467151c83e3e)(cryptoObj);
                const { secret: secret, keyId: keyId } = cacheRecord.accessToken;
                if (!keyId) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$3c9338a50e294d1));
                accessToken = await popTokenGenerator.signPopToken(secret, keyId, request);
            } else accessToken = cacheRecord.accessToken.secret;
            responseScopes = (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(cacheRecord.accessToken.target).asArray();
            // Access token expiresOn cached in seconds, converting to Date for AuthenticationResult
            expiresOn = (0, $0a4a8f22735f9ff5$export$dcee164673849555)(cacheRecord.accessToken.expiresOn);
            extExpiresOn = (0, $0a4a8f22735f9ff5$export$dcee164673849555)(cacheRecord.accessToken.extendedExpiresOn);
            if (cacheRecord.accessToken.refreshOn) refreshOn = (0, $0a4a8f22735f9ff5$export$dcee164673849555)(cacheRecord.accessToken.refreshOn);
        }
        if (cacheRecord.appMetadata) familyId = cacheRecord.appMetadata.familyId === (0, $7c375ae106b964be$export$978fe7ab5e74b539) ? (0, $7c375ae106b964be$export$978fe7ab5e74b539) : "";
        const uid = idTokenClaims?.oid || idTokenClaims?.sub || "";
        const tid = idTokenClaims?.tid || "";
        // for hybrid + native bridge enablement, send back the native account Id
        if (serverTokenResponse?.spa_accountid && !!cacheRecord.account) cacheRecord.account.nativeAccountId = serverTokenResponse?.spa_accountid;
        const accountInfo = cacheRecord.account ? (0, $54830df9a5d9a12c$export$452a054c78b83dad)(cacheRecord.account.getAccountInfo(), undefined, idTokenClaims, cacheRecord.idToken?.secret) : null;
        return {
            authority: authority.canonicalAuthority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes,
            account: accountInfo,
            idToken: cacheRecord?.idToken?.secret || "",
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken,
            fromCache: fromTokenCache,
            expiresOn: expiresOn,
            extExpiresOn: extExpiresOn,
            refreshOn: refreshOn,
            correlationId: request.correlationId,
            requestId: requestId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            familyId: familyId,
            tokenType: cacheRecord.accessToken?.tokenType || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            state: requestState ? requestState.userRequestState : (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            cloudGraphHostName: cacheRecord.account?.cloudGraphHostName || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            msGraphHost: cacheRecord.account?.msGraphHost || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            code: serverTokenResponse?.spa_code,
            fromNativeBroker: false
        };
    }
}
function $4039fad97bcf28f6$export$73b84062d58a1307(cacheStorage, authority, homeAccountId, base64Decode, idTokenClaims, clientInfo, environment, claimsTenantId, authCodePayload, nativeAccountId, logger) {
    logger?.verbose("setCachedAccount called");
    // Check if base account is already cached
    const accountKeys = cacheStorage.getAccountKeys();
    const baseAccountKey = accountKeys.find((accountKey)=>{
        return accountKey.startsWith(homeAccountId);
    });
    let cachedAccount = null;
    if (baseAccountKey) cachedAccount = cacheStorage.getAccount(baseAccountKey);
    const baseAccount = cachedAccount || (0, $d6acc4a6126921e0$export$680160523e6bfa6a).createAccount({
        homeAccountId: homeAccountId,
        idTokenClaims: idTokenClaims,
        clientInfo: clientInfo,
        environment: environment,
        cloudGraphHostName: authCodePayload?.cloud_graph_host_name,
        msGraphHost: authCodePayload?.msgraph_host,
        nativeAccountId: nativeAccountId
    }, authority, base64Decode);
    const tenantProfiles = baseAccount.tenantProfiles || [];
    const tenantId = claimsTenantId || baseAccount.realm;
    if (tenantId && !tenantProfiles.find((tenantProfile)=>{
        return tenantProfile.tenantId === tenantId;
    })) {
        const newTenantProfile = (0, $54830df9a5d9a12c$export$924857724cb21ba4)(homeAccountId, baseAccount.localAccountId, tenantId, idTokenClaims);
        tenantProfiles.push(newTenantProfile);
    }
    baseAccount.tenantProfiles = tenantProfiles;
    return baseAccount;
}










/*! @azure/msal-common v15.7.0 2025-05-30 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Validates server consumable params from the "request" objects
 */ class $5a78012ce109fb77$export$9800b929b6984365 {
    /**
     * Utility to check if the `redirectUri` in the request is a non-null value
     * @param redirectUri
     */ static validateRedirectUri(redirectUri) {
        if (!redirectUri) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$7a02f9bdce79dd4e));
    }
    /**
     * Utility to validate prompt sent by the user in the request
     * @param prompt
     */ static validatePrompt(prompt) {
        const promptValues = [];
        for(const value in 0, $7c375ae106b964be$export$49a06cbda5acaa5)promptValues.push((0, $7c375ae106b964be$export$49a06cbda5acaa5)[value]);
        if (promptValues.indexOf(prompt) < 0) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$ccbe5d2d7c960c35));
    }
    static validateClaims(claims) {
        try {
            JSON.parse(claims);
        } catch (e) {
            throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$96e755c70e0d0e34));
        }
    }
    /**
     * Utility to validate code_challenge and code_challenge_method
     * @param codeChallenge
     * @param codeChallengeMethod
     */ static validateCodeChallengeParams(codeChallenge, codeChallengeMethod) {
        if (!codeChallenge || !codeChallengeMethod) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$2da3866b327f1753));
        else this.validateCodeChallengeMethod(codeChallengeMethod);
    }
    /**
     * Utility to validate code_challenge_method
     * @param codeChallengeMethod
     */ static validateCodeChallengeMethod(codeChallengeMethod) {
        if ([
            (0, $7c375ae106b964be$export$a1fe36237c1cc863).PLAIN,
            (0, $7c375ae106b964be$export$a1fe36237c1cc863).S256
        ].indexOf(codeChallengeMethod) < 0) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$b8d8b332f17376dc));
    }
}




/*! @azure/msal-common v15.7.0 2025-05-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ async function $e4969f34ccbe14ce$export$620d3a93bf8b59fb(clientAssertion, clientId, tokenEndpoint) {
    if (typeof clientAssertion === "string") return clientAssertion;
    else {
        const config = {
            clientId: clientId,
            tokenEndpoint: tokenEndpoint
        };
        return clientAssertion(config);
    }
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Oauth2.0 Authorization Code client
 * @internal
 */ class $7e4376d17ecbf639$export$8538731fd397fb90 extends (0, $3b13384e79a725db$export$4f22f74eddb7716a) {
    constructor(configuration, performanceClient){
        super(configuration, performanceClient);
        // Flag to indicate if client is for hybrid spa auth code redemption
        this.includeRedirectUri = true;
        this.oidcDefaultScopes = this.config.authOptions.authority.options.OIDCOptions?.defaultScopes;
    }
    /**
     * API to acquire a token in exchange of 'authorization_code` acquired by the user in the first leg of the
     * authorization_code_grant
     * @param request
     */ async acquireToken(request, authCodePayload) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientAcquireToken, request.correlationId);
        if (!request.code) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$4ac9fb1f531eded7));
        const reqTimestamp = (0, $0a4a8f22735f9ff5$export$ae62599a119ac50a)();
        const response = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.executeTokenRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientExecuteTokenRequest, this.logger, this.performanceClient, request.correlationId)(this.authority, request);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[(0, $7c375ae106b964be$export$28d77f87efed1d88).X_MS_REQUEST_ID];
        const responseHandler = new (0, $4039fad97bcf28f6$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin, this.performanceClient);
        // Validate response. This function throws a server error if an error is returned by the server.
        responseHandler.validateTokenResponse(response.body);
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleServerTokenResponse, this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, authCodePayload, undefined, undefined, undefined, requestId);
    }
    /**
     * Used to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param authorityUri
     */ getLogoutUri(logoutRequest) {
        // Throw error if logoutRequest is null/undefined
        if (!logoutRequest) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$9eb2eeb401492d88));
        const queryString = this.createLogoutUrlQueryString(logoutRequest);
        // Construct logout URI
        return (0, $f7f911f196324278$export$3abcdca7229e54f2).appendQueryString(this.authority.endSessionEndpoint, queryString);
    }
    /**
     * Executes POST request to token endpoint
     * @param authority
     * @param request
     */ async executeTokenRequest(authority, request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientExecuteTokenRequest, request.correlationId);
        const queryParametersString = this.createTokenQueryParameters(request);
        const endpoint = (0, $f7f911f196324278$export$3abcdca7229e54f2).appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createTokenRequestBody.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientCreateTokenRequestBody, this.logger, this.performanceClient, request.correlationId)(request);
        let ccsCredential = undefined;
        if (request.clientInfo) try {
            const clientInfo = (0, $7aacd5d6e6d7482c$export$575e1419cfbab7f8)(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCredential = {
                credential: `${clientInfo.uid}${(0, $7c375ae106b964be$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR}${clientInfo.utid}`,
                type: (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose("Could not parse client info for CCS Header: " + e);
        }
        const headers = this.createTokenRequestHeaders(ccsCredential || request.ccsCredential);
        const thumbprint = (0, $762faca86a0f7942$export$2daa8cfcf54c2b48)(this.config.authOptions.clientId, request);
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.executePostToTokenEndpoint.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorizationCodeClientExecutePostToTokenEndpoint, this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorizationCodeClientExecutePostToTokenEndpoint);
    }
    /**
     * Generates a map for all the params to be sent to the service
     * @param request
     */ async createTokenRequestBody(request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientCreateTokenRequestBody, request.correlationId);
        const parameters = new Map();
        (0, $7d3a00eb36d325b3$export$8360c651f9cc692b)(parameters, request.embeddedClientId || request.tokenBodyParameters?.[0, $b00a7f221d8fdf60$export$c7b1b63f5b60f8e] || this.config.authOptions.clientId);
        /*
         * For hybrid spa flow, there will be a code but no verifier
         * In this scenario, don't include redirect uri as auth code will not be bound to redirect URI
         */ if (!this.includeRedirectUri) // Just validate
        (0, $5a78012ce109fb77$export$9800b929b6984365).validateRedirectUri(request.redirectUri);
        else // Validate and include redirect uri
        (0, $7d3a00eb36d325b3$export$6758d6264f4f06)(parameters, request.redirectUri);
        // Add scope array, parameter builder will add default scopes and dedupe
        (0, $7d3a00eb36d325b3$export$c213bf8f125826ba)(parameters, request.scopes, true, this.oidcDefaultScopes);
        // add code: user set, not validated
        (0, $7d3a00eb36d325b3$export$ff027aab2d77a49c)(parameters, request.code);
        // Add library metadata
        (0, $7d3a00eb36d325b3$export$3ecac3764b147c3f)(parameters, this.config.libraryInfo);
        (0, $7d3a00eb36d325b3$export$37ec1b76d865654a)(parameters, this.config.telemetry.application);
        (0, $7d3a00eb36d325b3$export$26592ae2037df9de)(parameters);
        if (this.serverTelemetryManager && !(0, $d21eb39178ebb5ae$export$25afa7198c2ed9b9)(this.config)) (0, $7d3a00eb36d325b3$export$79fb524b159705e9)(parameters, this.serverTelemetryManager);
        // add code_verifier if passed
        if (request.codeVerifier) (0, $7d3a00eb36d325b3$export$dceb49e3b4703cbb)(parameters, request.codeVerifier);
        if (this.config.clientCredentials.clientSecret) (0, $7d3a00eb36d325b3$export$8df84bbb0e2465bc)(parameters, this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            (0, $7d3a00eb36d325b3$export$2d3d772920e2496e)(parameters, await (0, $e4969f34ccbe14ce$export$620d3a93bf8b59fb)(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            (0, $7d3a00eb36d325b3$export$55ad911d12112f00)(parameters, clientAssertion.assertionType);
        }
        (0, $7d3a00eb36d325b3$export$e5f700fdeb4022b2)(parameters, (0, $7c375ae106b964be$export$ce68f19b50b39c0b).AUTHORIZATION_CODE_GRANT);
        (0, $7d3a00eb36d325b3$export$86b85a101d45e918)(parameters);
        if (request.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).POP) {
            const popTokenGenerator = new (0, $942a44945e07e21d$export$3dd8467151c83e3e)(this.cryptoUtils, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            (0, $7d3a00eb36d325b3$export$6dfc34809d8c4096)(parameters, reqCnfData);
        } else if (request.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).SSH) {
            if (request.sshJwk) (0, $7d3a00eb36d325b3$export$f004de9a266b8070)(parameters, request.sshJwk);
            else throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$8fbed44b22d9136f));
        }
        if (!(0, $442eacaa0418a38d$export$ecc754f99843e759).isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) (0, $7d3a00eb36d325b3$export$b04c3bca9165ed02)(parameters, request.claims, this.config.authOptions.clientCapabilities);
        let ccsCred = undefined;
        if (request.clientInfo) try {
            const clientInfo = (0, $7aacd5d6e6d7482c$export$575e1419cfbab7f8)(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCred = {
                credential: `${clientInfo.uid}${(0, $7c375ae106b964be$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR}${clientInfo.utid}`,
                type: (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose("Could not parse client info for CCS Header: " + e);
        }
        else ccsCred = request.ccsCredential;
        // Adds these as parameters in the request instead of headers to prevent CORS preflight request
        if (this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
            case (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $7aacd5d6e6d7482c$export$63508a6d6b7dbe07)(ccsCred.credential);
                    (0, $7d3a00eb36d325b3$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $feda987e240ac148$export$17b7b3ac1abef49f).UPN:
                (0, $7d3a00eb36d325b3$export$aa9cca16bcc29d2d)(parameters, ccsCred.credential);
                break;
        }
        if (request.embeddedClientId) (0, $7d3a00eb36d325b3$export$5ea4577e2a518c27)(parameters, this.config.authOptions.clientId, this.config.authOptions.redirectUri);
        if (request.tokenBodyParameters) (0, $7d3a00eb36d325b3$export$1a9f676bcc5d37da)(parameters, request.tokenBodyParameters);
        // Add hybrid spa parameters if not already provided
        if (request.enableSpaAuthorizationCode && (!request.tokenBodyParameters || !request.tokenBodyParameters[0, $b00a7f221d8fdf60$export$f58b98a40c1faa68])) (0, $7d3a00eb36d325b3$export$1a9f676bcc5d37da)(parameters, {
            [(0, $b00a7f221d8fdf60$export$f58b98a40c1faa68)]: "1"
        });
        (0, $7d3a00eb36d325b3$export$7153a1ee4346fa3b)(parameters, request.correlationId, this.performanceClient);
        return (0, $0763983a1d35c4b8$export$44d4663acf79cde2)(parameters);
    }
    /**
     * This API validates the `EndSessionRequest` and creates a URL
     * @param request
     */ createLogoutUrlQueryString(request) {
        const parameters = new Map();
        if (request.postLogoutRedirectUri) (0, $7d3a00eb36d325b3$export$bb8081db67b059c0)(parameters, request.postLogoutRedirectUri);
        if (request.correlationId) (0, $7d3a00eb36d325b3$export$8a224ff809946e9c)(parameters, request.correlationId);
        if (request.idTokenHint) (0, $7d3a00eb36d325b3$export$c6f34f6f67740950)(parameters, request.idTokenHint);
        if (request.state) (0, $7d3a00eb36d325b3$export$4a8b8c14090dd065)(parameters, request.state);
        if (request.logoutHint) (0, $7d3a00eb36d325b3$export$e0d4676d7288bded)(parameters, request.logoutHint);
        if (request.extraQueryParameters) (0, $7d3a00eb36d325b3$export$1a9f676bcc5d37da)(parameters, request.extraQueryParameters);
        if (this.config.authOptions.instanceAware) (0, $7d3a00eb36d325b3$export$50b40dfb1d11b77a)(parameters);
        return (0, $0763983a1d35c4b8$export$44d4663acf79cde2)(parameters, this.config.authOptions.encodeExtraQueryParams, request.extraQueryParameters);
    }
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ /*! @azure/msal-common v15.7.0 2025-05-30 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9c3cb45936be6b04$var$skuGroupSeparator = ",";
const $9c3cb45936be6b04$var$skuValueSeparator = "|";
function $9c3cb45936be6b04$var$makeExtraSkuString(params) {
    const { skus: skus, libraryName: libraryName, libraryVersion: libraryVersion, extensionName: extensionName, extensionVersion: extensionVersion } = params;
    const skuMap = new Map([
        [
            0,
            [
                libraryName,
                libraryVersion
            ]
        ],
        [
            2,
            [
                extensionName,
                extensionVersion
            ]
        ]
    ]);
    let skuArr = [];
    if (skus?.length) {
        skuArr = skus.split($9c3cb45936be6b04$var$skuGroupSeparator);
        // Ignore invalid input sku param
        if (skuArr.length < 4) return skus;
    } else skuArr = Array.from({
        length: 4
    }, ()=>$9c3cb45936be6b04$var$skuValueSeparator);
    skuMap.forEach((value, key)=>{
        if (value.length === 2 && value[0]?.length && value[1]?.length) $9c3cb45936be6b04$var$setSku({
            skuArr: skuArr,
            index: key,
            skuName: value[0],
            skuVersion: value[1]
        });
    });
    return skuArr.join($9c3cb45936be6b04$var$skuGroupSeparator);
}
function $9c3cb45936be6b04$var$setSku(params) {
    const { skuArr: skuArr, index: index, skuName: skuName, skuVersion: skuVersion } = params;
    if (index >= skuArr.length) return;
    skuArr[index] = [
        skuName,
        skuVersion
    ].join($9c3cb45936be6b04$var$skuValueSeparator);
}
/** @internal */ class $9c3cb45936be6b04$export$bddbbc43a3ca9c53 {
    constructor(telemetryRequest, cacheManager){
        this.cacheOutcome = (0, $7c375ae106b964be$export$aa4af185ea049f6b).NOT_APPLICABLE;
        this.cacheManager = cacheManager;
        this.apiId = telemetryRequest.apiId;
        this.correlationId = telemetryRequest.correlationId;
        this.wrapperSKU = telemetryRequest.wrapperSKU || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.wrapperVer = telemetryRequest.wrapperVer || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.telemetryCacheKey = (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).CACHE_KEY + (0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR + telemetryRequest.clientId;
    }
    /**
     * API to add MSER Telemetry to request
     */ generateCurrentRequestHeaderValue() {
        const request = `${this.apiId}${(0, $7c375ae106b964be$export$30fa4ad28fb9feeb).VALUE_SEPARATOR}${this.cacheOutcome}`;
        const platformFieldsArr = [
            this.wrapperSKU,
            this.wrapperVer
        ];
        const nativeBrokerErrorCode = this.getNativeBrokerErrorCode();
        if (nativeBrokerErrorCode?.length) platformFieldsArr.push(`broker_error=${nativeBrokerErrorCode}`);
        const platformFields = platformFieldsArr.join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        const regionDiscoveryFields = this.getRegionDiscoveryFields();
        const requestWithRegionDiscoveryFields = [
            request,
            regionDiscoveryFields
        ].join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        return [
            (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).SCHEMA_VERSION,
            requestWithRegionDiscoveryFields,
            platformFields
        ].join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).CATEGORY_SEPARATOR);
    }
    /**
     * API to add MSER Telemetry for the last failed request
     */ generateLastRequestHeaderValue() {
        const lastRequests = this.getLastRequests();
        const maxErrors = $9c3cb45936be6b04$export$bddbbc43a3ca9c53.maxErrorsToSend(lastRequests);
        const failedRequests = lastRequests.failedRequests.slice(0, 2 * maxErrors).join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        const errors = lastRequests.errors.slice(0, maxErrors).join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        const errorCount = lastRequests.errors.length;
        // Indicate whether this header contains all data or partial data
        const overflow = maxErrors < errorCount ? (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).OVERFLOW_TRUE : (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).OVERFLOW_FALSE;
        const platformFields = [
            errorCount,
            overflow
        ].join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        return [
            (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).SCHEMA_VERSION,
            lastRequests.cacheHits,
            failedRequests,
            errors,
            platformFields
        ].join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).CATEGORY_SEPARATOR);
    }
    /**
     * API to cache token failures for MSER data capture
     * @param error
     */ cacheFailedRequest(error) {
        const lastRequests = this.getLastRequests();
        if (lastRequests.errors.length >= (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).MAX_CACHED_ERRORS) {
            // Remove a cached error to make room, first in first out
            lastRequests.failedRequests.shift(); // apiId
            lastRequests.failedRequests.shift(); // correlationId
            lastRequests.errors.shift();
        }
        lastRequests.failedRequests.push(this.apiId, this.correlationId);
        if (error instanceof Error && !!error && error.toString()) {
            if (error instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                if (error.subError) lastRequests.errors.push(error.subError);
                else if (error.errorCode) lastRequests.errors.push(error.errorCode);
                else lastRequests.errors.push(error.toString());
            } else lastRequests.errors.push(error.toString());
        } else lastRequests.errors.push((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).UNKNOWN_ERROR);
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests);
        return;
    }
    /**
     * Update server telemetry cache entry by incrementing cache hit counter
     */ incrementCacheHits() {
        const lastRequests = this.getLastRequests();
        lastRequests.cacheHits += 1;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests);
        return lastRequests.cacheHits;
    }
    /**
     * Get the server telemetry entity from cache or initialize a new one
     */ getLastRequests() {
        const initialValue = {
            failedRequests: [],
            errors: [],
            cacheHits: 0
        };
        const lastRequests = this.cacheManager.getServerTelemetry(this.telemetryCacheKey);
        return lastRequests || initialValue;
    }
    /**
     * Remove server telemetry cache entry
     */ clearTelemetryCache() {
        const lastRequests = this.getLastRequests();
        const numErrorsFlushed = $9c3cb45936be6b04$export$bddbbc43a3ca9c53.maxErrorsToSend(lastRequests);
        const errorCount = lastRequests.errors.length;
        if (numErrorsFlushed === errorCount) // All errors were sent on last request, clear Telemetry cache
        this.cacheManager.removeItem(this.telemetryCacheKey);
        else {
            // Partial data was flushed to server, construct a new telemetry cache item with errors that were not flushed
            const serverTelemEntity = {
                failedRequests: lastRequests.failedRequests.slice(numErrorsFlushed * 2),
                errors: lastRequests.errors.slice(numErrorsFlushed),
                cacheHits: 0
            };
            this.cacheManager.setServerTelemetry(this.telemetryCacheKey, serverTelemEntity);
        }
    }
    /**
     * Returns the maximum number of errors that can be flushed to the server in the next network request
     * @param serverTelemetryEntity
     */ static maxErrorsToSend(serverTelemetryEntity) {
        let i;
        let maxErrors = 0;
        let dataSize = 0;
        const errorCount = serverTelemetryEntity.errors.length;
        for(i = 0; i < errorCount; i++){
            // failedRequests parameter contains pairs of apiId and correlationId, multiply index by 2 to preserve pairs
            const apiId = serverTelemetryEntity.failedRequests[2 * i] || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
            const correlationId = serverTelemetryEntity.failedRequests[2 * i + 1] || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
            const errorCode = serverTelemetryEntity.errors[i] || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
            // Count number of characters that would be added to header, each character is 1 byte. Add 3 at the end to account for separators
            dataSize += apiId.toString().length + correlationId.toString().length + errorCode.length + 3;
            if (dataSize < (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).MAX_LAST_HEADER_BYTES) // Adding this entry to the header would still keep header size below the limit
            maxErrors += 1;
            else break;
        }
        return maxErrors;
    }
    /**
     * Get the region discovery fields
     *
     * @returns string
     */ getRegionDiscoveryFields() {
        const regionDiscoveryFields = [];
        regionDiscoveryFields.push(this.regionUsed || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING);
        regionDiscoveryFields.push(this.regionSource || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING);
        regionDiscoveryFields.push(this.regionOutcome || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING);
        return regionDiscoveryFields.join(",");
    }
    /**
     * Update the region discovery metadata
     *
     * @param regionDiscoveryMetadata
     * @returns void
     */ updateRegionDiscoveryMetadata(regionDiscoveryMetadata) {
        this.regionUsed = regionDiscoveryMetadata.region_used;
        this.regionSource = regionDiscoveryMetadata.region_source;
        this.regionOutcome = regionDiscoveryMetadata.region_outcome;
    }
    /**
     * Set cache outcome
     */ setCacheOutcome(cacheOutcome) {
        this.cacheOutcome = cacheOutcome;
    }
    setNativeBrokerErrorCode(errorCode) {
        const lastRequests = this.getLastRequests();
        lastRequests.nativeBrokerErrorCode = errorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests);
    }
    getNativeBrokerErrorCode() {
        return this.getLastRequests().nativeBrokerErrorCode;
    }
    clearNativeBrokerErrorCode() {
        const lastRequests = this.getLastRequests();
        delete lastRequests.nativeBrokerErrorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests);
    }
    static makeExtraSkuString(params) {
        return $9c3cb45936be6b04$var$makeExtraSkuString(params);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $cf81b85efeb3dcd5$export$d858565f81c03f1f {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, platformAuthProvider, correlationId){
        this.config = config;
        this.browserStorage = storageImpl;
        this.browserCrypto = browserCrypto;
        this.networkClient = this.config.system.networkClient;
        this.eventHandler = eventHandler;
        this.navigationClient = navigationClient;
        this.platformAuthProvider = platformAuthProvider;
        this.correlationId = correlationId || (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
        this.logger = logger.clone((0, $5ff55562d73e0e2b$export$a0a689e4294b9880).MSAL_SKU, (0, $183cce12cb16965c$export$83d89fbfd8236492), this.correlationId);
        this.performanceClient = performanceClient;
    }
    async clearCacheOnLogout(account) {
        if (account) {
            if ((0, $d6acc4a6126921e0$export$680160523e6bfa6a).accountInfoIsEqual(account, this.browserStorage.getActiveAccount(), false)) {
                this.logger.verbose("Setting active account to null");
                this.browserStorage.setActiveAccount(null);
            }
            // Clear given account.
            try {
                await this.browserStorage.removeAccount((0, $d6acc4a6126921e0$export$680160523e6bfa6a).generateAccountCacheKey(account));
                this.logger.verbose("Cleared cache items belonging to the account provided in the logout request.");
            } catch (error) {
                this.logger.error("Account provided in logout request was not found. Local cache unchanged.");
            }
        } else try {
            this.logger.verbose("No account provided in logout request, clearing all cache items.", this.correlationId);
            // Clear all accounts and tokens
            await this.browserStorage.clear();
            // Clear any stray keys from IndexedDB
            await this.browserCrypto.clearKeystore();
        } catch (e) {
            this.logger.error("Attempted to clear all MSAL cache items and failed. Local cache unchanged.");
        }
    }
    /**
     *
     * Use to get the redirect uri configured in MSAL or null.
     * @param requestRedirectUri
     * @returns Redirect URL
     *
     */ getRedirectUri(requestRedirectUri) {
        this.logger.verbose("getRedirectUri called");
        const redirectUri = requestRedirectUri || this.config.auth.redirectUri;
        return (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl(redirectUri, (0, $3003b661a087a867$export$1204531fbbf6ecde)());
    }
    /**
     *
     * @param apiId
     * @param correlationId
     * @param forceRefresh
     */ initializeServerTelemetryManager(apiId, forceRefresh) {
        this.logger.verbose("initializeServerTelemetryManager called");
        const telemetryPayload = {
            clientId: this.config.auth.clientId,
            correlationId: this.correlationId,
            apiId: apiId,
            forceRefresh: forceRefresh || false,
            wrapperSKU: this.browserStorage.getWrapperMetadata()[0],
            wrapperVer: this.browserStorage.getWrapperMetadata()[1]
        };
        return new (0, $9c3cb45936be6b04$export$bddbbc43a3ca9c53)(telemetryPayload, this.browserStorage);
    }
    /**
     * Used to get a discovered version of the default authority.
     * @param params {
     *         requestAuthority?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async getDiscoveredAuthority(params) {
        const { account: account } = params;
        const instanceAwareEQ = params.requestExtraQueryParameters && params.requestExtraQueryParameters.hasOwnProperty("instance_aware") ? params.requestExtraQueryParameters["instance_aware"] : undefined;
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.correlationId);
        const authorityOptions = {
            protocolMode: this.config.auth.protocolMode,
            OIDCOptions: this.config.auth.OIDCOptions,
            knownAuthorities: this.config.auth.knownAuthorities,
            cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
            authorityMetadata: this.config.auth.authorityMetadata,
            skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache
        };
        // build authority string based on auth params, precedence - azureCloudInstance + tenant >> authority
        const resolvedAuthority = params.requestAuthority || this.config.auth.authority;
        const resolvedInstanceAware = instanceAwareEQ?.length ? instanceAwareEQ === "true" : this.config.auth.instanceAware;
        const userAuthority = account && resolvedInstanceAware ? this.config.auth.authority.replace((0, $f7f911f196324278$export$3abcdca7229e54f2).getDomainFromUrl(resolvedAuthority), account.environment) : resolvedAuthority;
        // fall back to the authority from config
        const builtAuthority = (0, $77bb430f4568f6e8$export$f1c6ec2e6d68c49c).generateAuthority(userAuthority, params.requestAzureCloudOptions || this.config.auth.azureCloudOptions);
        const discoveredAuthority = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $ef8a264971d8166d$exports).createDiscoveredInstance, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityFactoryCreateDiscoveredInstance, this.logger, this.performanceClient, this.correlationId)(builtAuthority, this.config.system.networkClient, this.browserStorage, authorityOptions, this.logger, this.correlationId, this.performanceClient);
        if (account && !discoveredAuthority.isAlias(account.environment)) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).authorityMismatch);
        return discoveredAuthority;
    }
}






/*! @azure/msal-browser v4.13.1 2025-06-10 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Initializer function for all request APIs
 * @param request
 */ async function $550ae9dc1dae1add$export$8e461fcf1fd6910b(request, config, performanceClient, logger) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeBaseRequest, request.correlationId);
    const authority = request.authority || config.auth.authority;
    const scopes = [
        ...request && request.scopes || []
    ];
    const validatedRequest = {
        ...request,
        correlationId: request.correlationId,
        authority: authority,
        scopes: scopes
    };
    // Set authenticationScheme to BEARER if not explicitly set in the request
    if (!validatedRequest.authenticationScheme) {
        validatedRequest.authenticationScheme = (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER;
        logger.verbose('Authentication Scheme wasn\'t explicitly set in request, defaulting to "Bearer" request');
    } else {
        if (validatedRequest.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).SSH) {
            if (!request.sshJwk) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).missingSshJwk);
            if (!request.sshKid) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).missingSshKid);
        }
        logger.verbose(`Authentication Scheme set to "${validatedRequest.authenticationScheme}" as configured in Auth request`);
    }
    // Set requested claims hash if claims-based caching is enabled and claims were requested
    if (config.cache.claimsBasedCachingEnabled && request.claims && // Checks for empty stringified object "{}" which doesn't qualify as requested claims
    !(0, $442eacaa0418a38d$export$ecc754f99843e759).isEmptyObj(request.claims)) validatedRequest.requestedClaimsHash = await (0, $4e0948336b4ea4a7$export$9169be2e06c9c165)(request.claims);
    return validatedRequest;
}
async function $550ae9dc1dae1add$export$4c8aa78c426811d4(request, account, config, performanceClient, logger) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeSilentRequest, request.correlationId);
    const baseRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)($550ae9dc1dae1add$export$8e461fcf1fd6910b, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeBaseRequest, logger, performanceClient, request.correlationId)(request, config, performanceClient, logger);
    return {
        ...request,
        ...baseRequest,
        account: account,
        forceRefresh: request.forceRefresh || false
    };
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Defines the class structure and helper functions used by the "standard", non-brokered auth flows (popup, redirect, silent (RT), silent (iframe))
 */ class $5d00224fcf1f9e62$export$fa9179cade3eb05a extends (0, $cf81b85efeb3dcd5$export$d858565f81c03f1f) {
    /**
     * Initializer for the logout request.
     * @param logoutRequest
     */ initializeLogoutRequest(logoutRequest) {
        this.logger.verbose("initializeLogoutRequest called", logoutRequest?.correlationId);
        const validLogoutRequest = {
            correlationId: this.correlationId || (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)(),
            ...logoutRequest
        };
        /**
         * Set logout_hint to be login_hint from ID Token Claims if present
         * and logoutHint attribute wasn't manually set in logout request
         */ if (logoutRequest) {
            // If logoutHint isn't set and an account was passed in, try to extract logoutHint from ID Token Claims
            if (!logoutRequest.logoutHint) {
                if (logoutRequest.account) {
                    const logoutHint = this.getLogoutHintFromIdTokenClaims(logoutRequest.account);
                    if (logoutHint) {
                        this.logger.verbose("Setting logoutHint to login_hint ID Token Claim value for the account provided");
                        validLogoutRequest.logoutHint = logoutHint;
                    }
                } else this.logger.verbose("logoutHint was not set and account was not passed into logout request, logoutHint will not be set");
            } else this.logger.verbose("logoutHint has already been set in logoutRequest");
        } else this.logger.verbose("logoutHint will not be set since no logout request was configured");
        /*
         * Only set redirect uri if logout request isn't provided or the set uri isn't null.
         * Otherwise, use passed uri, config, or current page.
         */ if (!logoutRequest || logoutRequest.postLogoutRedirectUri !== null) {
            if (logoutRequest && logoutRequest.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to uri set on logout request", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl(logoutRequest.postLogoutRedirectUri, (0, $3003b661a087a867$export$1204531fbbf6ecde)());
            } else if (this.config.auth.postLogoutRedirectUri === null) this.logger.verbose("postLogoutRedirectUri configured as null and no uri set on request, not passing post logout redirect", validLogoutRequest.correlationId);
            else if (this.config.auth.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to configured uri", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl(this.config.auth.postLogoutRedirectUri, (0, $3003b661a087a867$export$1204531fbbf6ecde)());
            } else {
                this.logger.verbose("Setting postLogoutRedirectUri to current page", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl((0, $3003b661a087a867$export$1204531fbbf6ecde)(), (0, $3003b661a087a867$export$1204531fbbf6ecde)());
            }
        } else this.logger.verbose("postLogoutRedirectUri passed as null, not setting post logout redirect uri", validLogoutRequest.correlationId);
        return validLogoutRequest;
    }
    /**
     * Parses login_hint ID Token Claim out of AccountInfo object to be used as
     * logout_hint in end session request.
     * @param account
     */ getLogoutHintFromIdTokenClaims(account) {
        const idTokenClaims = account.idTokenClaims;
        if (idTokenClaims) {
            if (idTokenClaims.login_hint) return idTokenClaims.login_hint;
            else this.logger.verbose("The ID Token Claims tied to the provided account do not contain a login_hint claim, logoutHint will not be added to logout request");
        } else this.logger.verbose("The provided account does not contain ID Token Claims, logoutHint will not be added to logout request");
        return null;
    }
    /**
     * Creates an Authorization Code Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createAuthCodeClient(params) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.correlationId);
        // Create auth module.
        const clientConfig = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)(params);
        return new (0, $7e4376d17ecbf639$export$8538731fd397fb90)(clientConfig, this.performanceClient);
    }
    /**
     * Creates a Client Configuration object with the given request authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         requestAuthority?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: boolean;
     *         account?: AccountInfo;
     *        }
     */ async getClientConfiguration(params) {
        const { serverTelemetryManager: serverTelemetryManager, requestAuthority: requestAuthority, requestAzureCloudOptions: requestAzureCloudOptions, requestExtraQueryParameters: requestExtraQueryParameters, account: account } = params;
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.correlationId);
        const discoveredAuthority = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, this.correlationId)({
            requestAuthority: requestAuthority,
            requestAzureCloudOptions: requestAzureCloudOptions,
            requestExtraQueryParameters: requestExtraQueryParameters,
            account: account
        });
        const logger = this.config.system.loggerOptions;
        return {
            authOptions: {
                clientId: this.config.auth.clientId,
                authority: discoveredAuthority,
                clientCapabilities: this.config.auth.clientCapabilities,
                redirectUri: this.config.auth.redirectUri
            },
            systemOptions: {
                tokenRenewalOffsetSeconds: this.config.system.tokenRenewalOffsetSeconds,
                preventCorsPreflight: true
            },
            loggerOptions: {
                loggerCallback: logger.loggerCallback,
                piiLoggingEnabled: logger.piiLoggingEnabled,
                logLevel: logger.logLevel,
                correlationId: this.correlationId
            },
            cacheOptions: {
                claimsBasedCachingEnabled: this.config.cache.claimsBasedCachingEnabled
            },
            cryptoInterface: this.browserCrypto,
            networkInterface: this.networkClient,
            storageInterface: this.browserStorage,
            serverTelemetryManager: serverTelemetryManager,
            libraryInfo: {
                sku: (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).MSAL_SKU,
                version: (0, $183cce12cb16965c$export$83d89fbfd8236492),
                cpu: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
                os: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
            },
            telemetry: this.config.telemetry
        };
    }
    /**
     * Helper to initialize required request parameters for interactive APIs and ssoSilent()
     * @param request
     * @param interactionType
     */ async initializeAuthorizationRequest(request, interactionType) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.correlationId);
        const redirectUri = this.getRedirectUri(request.redirectUri);
        const browserState = {
            interactionType: interactionType
        };
        const state = (0, $18d0dfe50b7b79f1$export$871e33217042c65e).setRequestState(this.browserCrypto, request && request.state || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, browserState);
        const baseRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $550ae9dc1dae1add$export$8e461fcf1fd6910b), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeBaseRequest, this.logger, this.performanceClient, this.correlationId)({
            ...request,
            correlationId: this.correlationId
        }, this.config, this.performanceClient, this.logger);
        const validatedRequest = {
            ...baseRequest,
            redirectUri: redirectUri,
            state: state,
            nonce: request.nonce || (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)(),
            responseMode: this.config.auth.OIDCOptions.serverResponseType
        };
        // Skip active account lookup if either login hint or session id is set
        if (request.loginHint || request.sid) return validatedRequest;
        const account = request.account || this.browserStorage.getActiveAccount();
        if (account) {
            this.logger.verbose("Setting validated request account", this.correlationId);
            this.logger.verbosePii(`Setting validated request account: ${account.homeAccountId}`, this.correlationId);
            validatedRequest.account = account;
        }
        return validatedRequest;
    }
}






/*! @azure/msal-browser v4.13.1 2025-06-10 */ 

/*! @azure/msal-browser v4.13.1 2025-06-10 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extracts the BrowserStateObject from the state string.
 * @param browserCrypto
 * @param state
 */ function $6ec519bc7bf28780$export$68ec87f530f5f536(browserCrypto, state) {
    if (!state) return null;
    try {
        const requestStateObj = (0, $18d0dfe50b7b79f1$export$871e33217042c65e).parseRequestState(browserCrypto, state);
        return requestStateObj.libraryState.meta;
    } catch (e) {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).invalidState);
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9c7efd3c039fd7d9$export$e64c1808ed72a7c(responseString, responseLocation, logger) {
    // Deserialize hash fragment response parameters.
    const serverParams = (0, $0763983a1d35c4b8$exports).getDeserializedResponse(responseString);
    if (!serverParams) {
        if (!(0, $0763983a1d35c4b8$exports).stripLeadingHashOrQuery(responseString)) {
            // Hash or Query string is empty
            logger.error(`The request has returned to the redirectUri but a ${responseLocation} is not present. It's likely that the ${responseLocation} has been removed or the page has been redirected by code running on the redirectUri page.`);
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$a29c42a1dd414317));
        } else {
            logger.error(`A ${responseLocation} is present in the iframe but it does not contain known properties. It's likely that the ${responseLocation} has been replaced by code running on the redirectUri page.`);
            logger.errorPii(`The ${responseLocation} detected is: ${responseString}`);
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$5743873a5ba5d124));
        }
    }
    return serverParams;
}
/**
 * Returns the interaction type that the response object belongs to
 */ function $9c7efd3c039fd7d9$export$af0c72d18284aa0(response, browserCrypto, interactionType) {
    if (!response.state) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$211c8e8843a8d278));
    const platformStateObj = (0, $6ec519bc7bf28780$export$68ec87f530f5f536)(browserCrypto, response.state);
    if (!platformStateObj) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$237bdd0b913cb30c));
    if (platformStateObj.interactionType !== interactionType) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$499b1b95c97a1c75));
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ var $bfa307c523b8b81c$exports = {};

$parcel$export($bfa307c523b8b81c$exports, "getStandardAuthorizeRequestParameters", () => $bfa307c523b8b81c$export$61cf790f71e46219);
$parcel$export($bfa307c523b8b81c$exports, "getAuthorizeUrl", () => $bfa307c523b8b81c$export$e397eb426c115a0a);
$parcel$export($bfa307c523b8b81c$exports, "getAuthorizationCodePayload", () => $bfa307c523b8b81c$export$36c64a7d10cf377b);
$parcel$export($bfa307c523b8b81c$exports, "validateAuthorizationResponse", () => $bfa307c523b8b81c$export$9979de10627480c5);
/*! @azure/msal-common v15.7.0 2025-05-30 */ 









'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns map of parameters that are applicable to all calls to /authorize whether using PKCE or EAR
 * @param config
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 */ function $bfa307c523b8b81c$export$61cf790f71e46219(authOptions, request, logger, performanceClient) {
    // generate the correlationId if not set by the user and add
    const correlationId = request.correlationId;
    const parameters = new Map();
    (0, $7d3a00eb36d325b3$export$8360c651f9cc692b)(parameters, request.embeddedClientId || request.extraQueryParameters?.[0, $b00a7f221d8fdf60$export$c7b1b63f5b60f8e] || authOptions.clientId);
    const requestScopes = [
        ...request.scopes || [],
        ...request.extraScopesToConsent || []
    ];
    (0, $7d3a00eb36d325b3$export$c213bf8f125826ba)(parameters, requestScopes, true, authOptions.authority.options.OIDCOptions?.defaultScopes);
    (0, $7d3a00eb36d325b3$export$6758d6264f4f06)(parameters, request.redirectUri);
    (0, $7d3a00eb36d325b3$export$8a224ff809946e9c)(parameters, correlationId);
    // add response_mode. If not passed in it defaults to query.
    (0, $7d3a00eb36d325b3$export$f1c153626c2c2d91)(parameters, request.responseMode);
    // add client_info=1
    (0, $7d3a00eb36d325b3$export$86b85a101d45e918)(parameters);
    if (request.prompt) {
        (0, $7d3a00eb36d325b3$export$e982ccd37a61cde6)(parameters, request.prompt);
        performanceClient?.addFields({
            prompt: request.prompt
        }, correlationId);
    }
    if (request.domainHint) {
        (0, $7d3a00eb36d325b3$export$1bd007a9d7fec290)(parameters, request.domainHint);
        performanceClient?.addFields({
            domainHintFromRequest: true
        }, correlationId);
    }
    // Add sid or loginHint with preference for login_hint claim (in request) -> sid -> loginHint (upn/email) -> username of AccountInfo object
    if (request.prompt !== (0, $7c375ae106b964be$export$49a06cbda5acaa5).SELECT_ACCOUNT) {
        // AAD will throw if prompt=select_account is passed with an account hint
        if (request.sid && request.prompt === (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE) {
            // SessionID is only used in silent calls
            logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from request");
            (0, $7d3a00eb36d325b3$export$9d8531b0fa366b30)(parameters, request.sid);
            performanceClient?.addFields({
                sidFromRequest: true
            }, correlationId);
        } else if (request.account) {
            const accountSid = $bfa307c523b8b81c$var$extractAccountSid(request.account);
            let accountLoginHintClaim = $bfa307c523b8b81c$var$extractLoginHint(request.account);
            if (accountLoginHintClaim && request.domainHint) {
                logger.warning(`AuthorizationCodeClient.createAuthCodeUrlQueryString: "domainHint" param is set, skipping opaque "login_hint" claim. Please consider not passing domainHint`);
                accountLoginHintClaim = null;
            }
            // If login_hint claim is present, use it over sid/username
            if (accountLoginHintClaim) {
                logger.verbose("createAuthCodeUrlQueryString: login_hint claim present on account");
                (0, $7d3a00eb36d325b3$export$65f43fd4b28bba5f)(parameters, accountLoginHintClaim);
                performanceClient?.addFields({
                    loginHintFromClaim: true
                }, correlationId);
                try {
                    const clientInfo = (0, $7aacd5d6e6d7482c$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                    (0, $7d3a00eb36d325b3$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                }
            } else if (accountSid && request.prompt === (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE) {
                /*
                 * If account and loginHint are provided, we will check account first for sid before adding loginHint
                 * SessionId is only used in silent calls
                 */ logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from account");
                (0, $7d3a00eb36d325b3$export$9d8531b0fa366b30)(parameters, accountSid);
                performanceClient?.addFields({
                    sidFromClaim: true
                }, correlationId);
                try {
                    const clientInfo = (0, $7aacd5d6e6d7482c$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                    (0, $7d3a00eb36d325b3$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                }
            } else if (request.loginHint) {
                logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from request");
                (0, $7d3a00eb36d325b3$export$65f43fd4b28bba5f)(parameters, request.loginHint);
                (0, $7d3a00eb36d325b3$export$aa9cca16bcc29d2d)(parameters, request.loginHint);
                performanceClient?.addFields({
                    loginHintFromRequest: true
                }, correlationId);
            } else if (request.account.username) {
                // Fallback to account username if provided
                logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from account");
                (0, $7d3a00eb36d325b3$export$65f43fd4b28bba5f)(parameters, request.account.username);
                performanceClient?.addFields({
                    loginHintFromUpn: true
                }, correlationId);
                try {
                    const clientInfo = (0, $7aacd5d6e6d7482c$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                    (0, $7d3a00eb36d325b3$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                }
            }
        } else if (request.loginHint) {
            logger.verbose("createAuthCodeUrlQueryString: No account, adding login_hint from request");
            (0, $7d3a00eb36d325b3$export$65f43fd4b28bba5f)(parameters, request.loginHint);
            (0, $7d3a00eb36d325b3$export$aa9cca16bcc29d2d)(parameters, request.loginHint);
            performanceClient?.addFields({
                loginHintFromRequest: true
            }, correlationId);
        }
    } else logger.verbose("createAuthCodeUrlQueryString: Prompt is select_account, ignoring account hints");
    if (request.nonce) (0, $7d3a00eb36d325b3$export$87b1d5d886e84b11)(parameters, request.nonce);
    if (request.state) (0, $7d3a00eb36d325b3$export$4a8b8c14090dd065)(parameters, request.state);
    if (request.claims || authOptions.clientCapabilities && authOptions.clientCapabilities.length > 0) (0, $7d3a00eb36d325b3$export$b04c3bca9165ed02)(parameters, request.claims, authOptions.clientCapabilities);
    if (request.embeddedClientId) (0, $7d3a00eb36d325b3$export$5ea4577e2a518c27)(parameters, authOptions.clientId, authOptions.redirectUri);
    // If extraQueryParameters includes instance_aware its value will be added when extraQueryParameters are added
    if (authOptions.instanceAware && (!request.extraQueryParameters || !Object.keys(request.extraQueryParameters).includes((0, $b00a7f221d8fdf60$export$d72b25d13120919d)))) (0, $7d3a00eb36d325b3$export$50b40dfb1d11b77a)(parameters);
    return parameters;
}
/**
 * Returns authorize endpoint with given request parameters in the query string
 * @param authority
 * @param requestParameters
 * @returns
 */ function $bfa307c523b8b81c$export$e397eb426c115a0a(authority, requestParameters, encodeParams, extraQueryParameters) {
    const queryString = (0, $0763983a1d35c4b8$export$44d4663acf79cde2)(requestParameters, encodeParams, extraQueryParameters);
    return (0, $f7f911f196324278$export$3abcdca7229e54f2).appendQueryString(authority.authorizationEndpoint, queryString);
}
/**
 * Handles the hash fragment response from public client code request. Returns a code response used by
 * the client to exchange for a token in acquireToken.
 * @param serverParams
 * @param cachedState
 */ function $bfa307c523b8b81c$export$36c64a7d10cf377b(serverParams, cachedState) {
    // Get code response
    $bfa307c523b8b81c$export$9979de10627480c5(serverParams, cachedState);
    // throw when there is no auth code in the response
    if (!serverParams.code) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$93625fc864d26bba));
    return serverParams;
}
/**
 * Function which validates server authorization code response.
 * @param serverResponseHash
 * @param requestState
 */ function $bfa307c523b8b81c$export$9979de10627480c5(serverResponse, requestState) {
    if (!serverResponse.state || !requestState) throw serverResponse.state ? (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$ef9214cfa5960fc), "Cached State") : (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$ef9214cfa5960fc), "Server State");
    let decodedServerResponseState;
    let decodedRequestState;
    try {
        decodedServerResponseState = decodeURIComponent(serverResponse.state);
    } catch (e) {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$72a77317632c052b), serverResponse.state);
    }
    try {
        decodedRequestState = decodeURIComponent(requestState);
    } catch (e) {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$72a77317632c052b), serverResponse.state);
    }
    if (decodedServerResponseState !== decodedRequestState) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$6a56d8f882843cd8));
    // Check for error
    if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
        const serverErrorNo = $bfa307c523b8b81c$var$parseServerErrorNo(serverResponse);
        if ((0, $18a94acc3dad87ad$export$376c3c4c19cb933a)(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)(serverResponse.error || "", serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || "", serverResponse.trace_id || "", serverResponse.correlation_id || "", serverResponse.claims || "", serverErrorNo);
        throw new (0, $016e46db2c2afa86$export$ea52035eac03daf0)(serverResponse.error || "", serverResponse.error_description, serverResponse.suberror, serverErrorNo);
    }
}
/**
 * Get server error No from the error_uri
 * @param serverResponse
 * @returns
 */ function $bfa307c523b8b81c$var$parseServerErrorNo(serverResponse) {
    const errorCodePrefix = "code=";
    const errorCodePrefixIndex = serverResponse.error_uri?.lastIndexOf(errorCodePrefix);
    return errorCodePrefixIndex && errorCodePrefixIndex >= 0 ? serverResponse.error_uri?.substring(errorCodePrefixIndex + errorCodePrefix.length) : undefined;
}
/**
 * Helper to get sid from account. Returns null if idTokenClaims are not present or sid is not present.
 * @param account
 */ function $bfa307c523b8b81c$var$extractAccountSid(account) {
    return account.idTokenClaims?.sid || null;
}
function $bfa307c523b8b81c$var$extractLoginHint(account) {
    return account.idTokenClaims?.login_hint || null;
}






/*! @azure/msal-browser v4.13.1 2025-06-10 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Abstract class which defines operations for a browser interaction handling class.
 */ class $e330ed825f42f772$export$a30cd982b4e89bdb {
    constructor(authCodeModule, storageImpl, authCodeRequest, logger, performanceClient){
        this.authModule = authCodeModule;
        this.browserStorage = storageImpl;
        this.authCodeRequest = authCodeRequest;
        this.logger = logger;
        this.performanceClient = performanceClient;
    }
    /**
     * Function to handle response parameters from hash.
     * @param locationHash
     */ async handleCodeResponse(response, request) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleCodeResponse, request.correlationId);
        let authCodeResponse;
        try {
            authCodeResponse = (0, $bfa307c523b8b81c$exports).getAuthorizationCodePayload(response, request.state);
        } catch (e) {
            if (e instanceof (0, $016e46db2c2afa86$export$ea52035eac03daf0) && e.subError === (0, $0780bb28b98eb888$export$6bae303c5e922702)) // Translate server error caused by user closing native prompt to corresponding first class MSAL error
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6bae303c5e922702));
            else throw e;
        }
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.handleCodeResponseFromServer.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleCodeResponseFromServer, this.logger, this.performanceClient, request.correlationId)(authCodeResponse, request);
    }
    /**
     * Process auth code response from AAD
     * @param authCodeResponse
     * @param state
     * @param authority
     * @param networkModule
     * @returns
     */ async handleCodeResponseFromServer(authCodeResponse, request, validateNonce = true) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleCodeResponseFromServer, request.correlationId);
        this.logger.trace("InteractionHandler.handleCodeResponseFromServer called");
        // Assign code to request
        this.authCodeRequest.code = authCodeResponse.code;
        // Check for new cloud instance
        if (authCodeResponse.cloud_instance_host_name) await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.authModule.updateAuthority.bind(this.authModule), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).UpdateTokenEndpointAuthority, this.logger, this.performanceClient, request.correlationId)(authCodeResponse.cloud_instance_host_name, request.correlationId);
        // Nonce validation not needed when redirect not involved (e.g. hybrid spa, renewing token via rt)
        if (validateNonce) // TODO: Assigning "response nonce" to "request nonce" is confusing. Refactor the function doing validation to accept request nonce directly
        authCodeResponse.nonce = request.nonce || undefined;
        authCodeResponse.state = request.state;
        // Add CCS parameters if available
        if (authCodeResponse.client_info) this.authCodeRequest.clientInfo = authCodeResponse.client_info;
        else {
            const ccsCred = this.createCcsCredentials(request);
            if (ccsCred) this.authCodeRequest.ccsCredential = ccsCred;
        }
        // Acquire token with retrieved code.
        const tokenResponse = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.authModule.acquireToken.bind(this.authModule), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(this.authCodeRequest, authCodeResponse);
        return tokenResponse;
    }
    /**
     * Build ccs creds if available
     */ createCcsCredentials(request) {
        if (request.account) return {
            credential: request.account.homeAccountId,
            type: (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
        };
        else if (request.loginHint) return {
            credential: request.loginHint,
            type: (0, $feda987e240ac148$export$17b7b3ac1abef49f).UPN
        };
        return null;
    }
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 

/*! @azure/msal-browser v4.13.1 2025-06-10 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $ad0863ed8e4325cb$export$fbe5ac8608048ea9 = "ContentError";
const $ad0863ed8e4325cb$export$966ec8558e4d7922 = "user_switch";


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Status Codes that can be thrown by WAM
const $2f685d09a8b3d741$export$e0aac30e542b316c = "USER_INTERACTION_REQUIRED";
const $2f685d09a8b3d741$export$bec5e49cc27c5c10 = "USER_CANCEL";
const $2f685d09a8b3d741$export$3c68b4973c91ba = "NO_NETWORK";
const $2f685d09a8b3d741$export$b17f0b3cc10a2593 = "PERSISTENT_ERROR";
const $2f685d09a8b3d741$export$8cd212c10b4124d2 = "DISABLED";
const $2f685d09a8b3d741$export$f4c2bddc98c93ffc = "ACCOUNT_UNAVAILABLE";



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $a5e5dee51df551c2$var$INVALID_METHOD_ERROR = -2147186943;
const $a5e5dee51df551c2$export$9a1233b0d52ed7cd = {
    [(0, $ad0863ed8e4325cb$export$966ec8558e4d7922)]: "User attempted to switch accounts in the native broker, which is not allowed. All new accounts must sign-in through the standard web flow first, please try again."
};
class $a5e5dee51df551c2$export$4b8a4f6256e840ab extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, description, ext){
        super(errorCode, description);
        Object.setPrototypeOf(this, $a5e5dee51df551c2$export$4b8a4f6256e840ab.prototype);
        this.name = "NativeAuthError";
        this.ext = ext;
    }
}
/**
 * These errors should result in a fallback to the 'standard' browser based auth flow.
 */ function $a5e5dee51df551c2$export$f21e42e365baeb50(error) {
    if (error.ext && error.ext.status && (error.ext.status === (0, $2f685d09a8b3d741$export$b17f0b3cc10a2593) || error.ext.status === (0, $2f685d09a8b3d741$export$8cd212c10b4124d2))) return true;
    if (error.ext && error.ext.error && error.ext.error === $a5e5dee51df551c2$var$INVALID_METHOD_ERROR) return true;
    switch(error.errorCode){
        case 0, $ad0863ed8e4325cb$export$fbe5ac8608048ea9:
            return true;
        default:
            return false;
    }
}
/**
 * Create the appropriate error object based on the WAM status code.
 * @param code
 * @param description
 * @param ext
 * @returns
 */ function $a5e5dee51df551c2$export$9154414ec87d187b(code, description, ext) {
    if (ext && ext.status) switch(ext.status){
        case 0, $2f685d09a8b3d741$export$f4c2bddc98c93ffc:
            return (0, $18a94acc3dad87ad$export$8f7a741750c16535)((0, $84767569d86b0bc0$exports).nativeAccountUnavailable);
        case 0, $2f685d09a8b3d741$export$e0aac30e542b316c:
            return new (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)(code, description);
        case 0, $2f685d09a8b3d741$export$bec5e49cc27c5c10:
            return (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6bae303c5e922702));
        case 0, $2f685d09a8b3d741$export$3c68b4973c91ba:
            return (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$31ae862f18c3b2b7));
    }
    return new $a5e5dee51df551c2$export$4b8a4f6256e840ab(code, $a5e5dee51df551c2$export$9a1233b0d52ed7cd[code] || description, ext);
}



/*! @azure/msal-browser v4.13.1 2025-06-10 */ 
/*! @azure/msal-common v15.7.0 2025-05-30 */ 










'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $da9f8d1ce5c4543c$export$e344f5b12c464597 extends (0, $3b13384e79a725db$export$4f22f74eddb7716a) {
    constructor(configuration, performanceClient){
        super(configuration, performanceClient);
    }
    /**
     * Retrieves token from cache or throws an error if it must be refreshed.
     * @param request
     */ async acquireCachedToken(request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentFlowClientAcquireCachedToken, request.correlationId);
        let lastCacheOutcome = (0, $7c375ae106b964be$export$aa4af185ea049f6b).NOT_APPLICABLE;
        if (request.forceRefresh || !this.config.cacheOptions.claimsBasedCachingEnabled && !(0, $442eacaa0418a38d$export$ecc754f99843e759).isEmptyObj(request.claims)) {
            // Must refresh due to present force_refresh flag.
            this.setCacheOutcome((0, $7c375ae106b964be$export$aa4af185ea049f6b).FORCE_REFRESH_OR_CLAIMS, request.correlationId);
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$e23b692cce0c7779));
        }
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$5a3c7d1c90ac9220));
        const requestTenantId = request.account.tenantId || (0, $77bb430f4568f6e8$export$6ed5af33d279fbc7)(request.authority);
        const tokenKeys = this.cacheManager.getTokenKeys();
        const cachedAccessToken = this.cacheManager.getAccessToken(request.account, request, tokenKeys, requestTenantId, this.performanceClient, request.correlationId);
        if (!cachedAccessToken) {
            // must refresh due to non-existent access_token
            this.setCacheOutcome((0, $7c375ae106b964be$export$aa4af185ea049f6b).NO_CACHED_ACCESS_TOKEN, request.correlationId);
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$e23b692cce0c7779));
        } else if ((0, $0a4a8f22735f9ff5$export$8961be72dcbc368e)(cachedAccessToken.cachedAt) || (0, $0a4a8f22735f9ff5$export$b007d77a962aa175)(cachedAccessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) {
            // must refresh due to the expires_in value
            this.setCacheOutcome((0, $7c375ae106b964be$export$aa4af185ea049f6b).CACHED_ACCESS_TOKEN_EXPIRED, request.correlationId);
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$e23b692cce0c7779));
        } else if (cachedAccessToken.refreshOn && (0, $0a4a8f22735f9ff5$export$b007d77a962aa175)(cachedAccessToken.refreshOn, 0)) // must refresh (in the background) due to the refresh_in value
        lastCacheOutcome = (0, $7c375ae106b964be$export$aa4af185ea049f6b).PROACTIVELY_REFRESHED;
        const environment = request.authority || this.authority.getPreferredCache();
        const cacheRecord = {
            account: this.cacheManager.readAccountFromCache(request.account),
            accessToken: cachedAccessToken,
            idToken: this.cacheManager.getIdToken(request.account, tokenKeys, requestTenantId, this.performanceClient, request.correlationId),
            refreshToken: null,
            appMetadata: this.cacheManager.readAppMetadataFromCache(environment)
        };
        this.setCacheOutcome(lastCacheOutcome, request.correlationId);
        if (this.config.serverTelemetryManager) this.config.serverTelemetryManager.incrementCacheHits();
        return [
            await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.generateResultFromCacheRecord.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentFlowClientGenerateResultFromCacheRecord, this.logger, this.performanceClient, request.correlationId)(cacheRecord, request),
            lastCacheOutcome
        ];
    }
    setCacheOutcome(cacheOutcome, correlationId) {
        this.serverTelemetryManager?.setCacheOutcome(cacheOutcome);
        this.performanceClient?.addFields({
            cacheOutcome: cacheOutcome
        }, correlationId);
        if (cacheOutcome !== (0, $7c375ae106b964be$export$aa4af185ea049f6b).NOT_APPLICABLE) this.logger.info(`Token refresh is required due to cache outcome: ${cacheOutcome}`);
    }
    /**
     * Helper function to build response object from the CacheRecord
     * @param cacheRecord
     */ async generateResultFromCacheRecord(cacheRecord, request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentFlowClientGenerateResultFromCacheRecord, request.correlationId);
        let idTokenClaims;
        if (cacheRecord.idToken) idTokenClaims = (0, $b29e27fb146a7ddd$export$8a59e6f35fb00518)(cacheRecord.idToken.secret, this.config.cryptoInterface.base64Decode);
        // token max_age check
        if (request.maxAge || request.maxAge === 0) {
            const authTime = idTokenClaims?.auth_time;
            if (!authTime) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$43356944266c945e));
            (0, $b29e27fb146a7ddd$export$ee7a34ea7880144c)(authTime, request.maxAge);
        }
        return (0, $4039fad97bcf28f6$export$f456c9835cc63582).generateAuthenticationResult(this.cryptoUtils, this.authority, cacheRecord, true, request, idTokenClaims);
    }
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $5d2b86ff94a0079d$export$59d4f873ee62d01e extends (0, $5d00224fcf1f9e62$export$fa9179cade3eb05a) {
    /**
     * Returns unexpired tokens from the cache, if available
     * @param silentRequest
     */ async acquireToken(silentRequest) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentCacheClientAcquireToken, silentRequest.correlationId);
        // Telemetry manager only used to increment cacheHits here
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenSilent_silentFlow);
        const clientConfig = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: serverTelemetryManager,
            requestAuthority: silentRequest.authority,
            requestAzureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        const silentAuthClient = new (0, $da9f8d1ce5c4543c$export$e344f5b12c464597)(clientConfig, this.performanceClient);
        this.logger.verbose("Silent auth client created");
        try {
            const response = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(silentAuthClient.acquireCachedToken.bind(silentAuthClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentFlowClientAcquireCachedToken, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
            const authResponse = response[0];
            this.performanceClient.addFields({
                fromCache: true
            }, silentRequest.correlationId);
            return authResponse;
        } catch (error) {
            if (error instanceof (0, $6e0b7bb04b1e6592$export$f8eb6760ca13876a) && error.errorCode === (0, $0780bb28b98eb888$export$a416b0eceb5c15df)) this.logger.verbose("Signing keypair for bound access token not found. Refreshing bound access token and generating a new crypto keypair.");
            throw error;
        }
    }
    /**
     * API to silenty clear the browser cache.
     * @param logoutRequest
     */ logout(logoutRequest) {
        this.logger.verbose("logoutRedirect called");
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        return this.clearCacheOnLogout(validLogoutRequest?.account);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $e6f06a03b9c6516d$export$3f89612b3fd8831f extends (0, $cf81b85efeb3dcd5$export$d858565f81c03f1f) {
    constructor(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, provider, accountId, nativeStorageImpl, correlationId){
        super(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, performanceClient, provider, correlationId);
        this.apiId = apiId;
        this.accountId = accountId;
        this.platformAuthProvider = provider;
        this.nativeStorageManager = nativeStorageImpl;
        this.silentCacheClient = new (0, $5d2b86ff94a0079d$export$59d4f873ee62d01e)(config, this.nativeStorageManager, browserCrypto, logger, eventHandler, navigationClient, performanceClient, provider, correlationId);
        const extensionName = this.platformAuthProvider.getExtensionName();
        this.skus = (0, $9c3cb45936be6b04$export$bddbbc43a3ca9c53).makeExtraSkuString({
            libraryName: (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).MSAL_SKU,
            libraryVersion: (0, $183cce12cb16965c$export$83d89fbfd8236492),
            extensionName: extensionName,
            extensionVersion: this.platformAuthProvider.getExtensionVersion()
        });
    }
    /**
     * Adds SKUs to request extra query parameters
     * @param request {PlatformAuthRequest}
     * @private
     */ addRequestSKUs(request) {
        request.extraParameters = {
            ...request.extraParameters,
            [(0, $b00a7f221d8fdf60$exports).X_CLIENT_EXTRA_SKU]: this.skus
        };
    }
    /**
     * Acquire token from native platform via browser extension
     * @param request
     */ async acquireToken(request, cacheLookupPolicy) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, request.correlationId);
        this.logger.trace("NativeInteractionClient - acquireToken called.");
        // start the perf measurement
        const nativeATMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, request.correlationId);
        const reqTimestamp = (0, $0a4a8f22735f9ff5$exports).nowSeconds();
        const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
        try {
            // initialize native request
            const nativeRequest = await this.initializeNativeRequest(request);
            // check if the tokens can be retrieved from internal cache
            try {
                const result = await this.acquireTokensFromCache(this.accountId, nativeRequest);
                nativeATMeasurement.end({
                    success: true,
                    isNativeBroker: false,
                    fromCache: true
                });
                return result;
            } catch (e) {
                if (cacheLookupPolicy === (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessToken) {
                    this.logger.info("MSAL internal Cache does not contain tokens, return error as per cache policy");
                    throw e;
                }
                // continue with a native call for any and all errors
                this.logger.info("MSAL internal Cache does not contain tokens, proceed to make a native call");
            }
            const validatedResponse = await this.platformAuthProvider.sendMessage(nativeRequest);
            return await this.handleNativeResponse(validatedResponse, nativeRequest, reqTimestamp).then((result)=>{
                nativeATMeasurement.end({
                    success: true,
                    isNativeBroker: true,
                    requestId: result.requestId
                });
                serverTelemetryManager.clearNativeBrokerErrorCode();
                return result;
            }).catch((error)=>{
                nativeATMeasurement.end({
                    success: false,
                    errorCode: error.errorCode,
                    subErrorCode: error.subError,
                    isNativeBroker: true
                });
                throw error;
            });
        } catch (e) {
            if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab)) serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
            throw e;
        }
    }
    /**
     * Creates silent flow request
     * @param request
     * @param cachedAccount
     * @returns CommonSilentFlowRequest
     */ createSilentCacheRequest(request, cachedAccount) {
        return {
            authority: request.authority,
            correlationId: this.correlationId,
            scopes: (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(request.scope).asArray(),
            account: cachedAccount,
            forceRefresh: false
        };
    }
    /**
     * Fetches the tokens from the cache if un-expired
     * @param nativeAccountId
     * @param request
     * @returns authenticationResult
     */ async acquireTokensFromCache(nativeAccountId, request) {
        if (!nativeAccountId) {
            this.logger.warning("NativeInteractionClient:acquireTokensFromCache - No nativeAccountId provided");
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).noAccountFound);
        }
        // fetch the account from browser cache
        const account = this.browserStorage.getBaseAccountInfo({
            nativeAccountId: nativeAccountId
        });
        if (!account) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).noAccountFound);
        // leverage silent flow for cached tokens retrieval
        try {
            const silentRequest = this.createSilentCacheRequest(request, account);
            const result = await this.silentCacheClient.acquireToken(silentRequest);
            const fullAccount = {
                ...account,
                idTokenClaims: result?.idTokenClaims,
                idToken: result?.idToken
            };
            return {
                ...result,
                account: fullAccount
            };
        } catch (e) {
            throw e;
        }
    }
    /**
     * Acquires a token from native platform then redirects to the redirectUri instead of returning the response
     * @param {RedirectRequest} request
     * @param {InProgressPerformanceEvent} rootMeasurement
     */ async acquireTokenRedirect(request, rootMeasurement) {
        this.logger.trace("NativeInteractionClient - acquireTokenRedirect called.");
        const { ...remainingParameters } = request;
        delete remainingParameters.onRedirectNavigate;
        const nativeRequest = await this.initializeNativeRequest(remainingParameters);
        try {
            await this.platformAuthProvider.sendMessage(nativeRequest);
        } catch (e) {
            // Only throw fatal errors here to allow application to fallback to regular redirect. Otherwise proceed and the error will be thrown in handleRedirectPromise
            if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab)) {
                const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
                serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
                if ((0, $a5e5dee51df551c2$export$f21e42e365baeb50)(e)) throw e;
            }
        }
        this.browserStorage.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).NATIVE_REQUEST, JSON.stringify(nativeRequest), true);
        const navigationOptions = {
            apiId: (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenRedirect,
            timeout: this.config.system.redirectNavigationTimeout,
            noHistory: false
        };
        const redirectUri = this.config.auth.navigateToLoginRequestUrl ? window.location.href : this.getRedirectUri(request.redirectUri);
        rootMeasurement.end({
            success: true
        });
        await this.navigationClient.navigateExternal(redirectUri, navigationOptions); // Need to treat this as external to ensure handleRedirectPromise is run again
    }
    /**
     * If the previous page called native platform for a token using redirect APIs, send the same request again and return the response
     * @param performanceClient {IPerformanceClient?}
     * @param correlationId {string?} correlation identifier
     */ async handleRedirectPromise(performanceClient, correlationId) {
        this.logger.trace("NativeInteractionClient - handleRedirectPromise called.");
        if (!this.browserStorage.isInteractionInProgress(true)) {
            this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
            return null;
        }
        // remove prompt from the request to prevent WAM from prompting twice
        const cachedRequest = this.browserStorage.getCachedNativeRequest();
        if (!cachedRequest) {
            this.logger.verbose("NativeInteractionClient - handleRedirectPromise called but there is no cached request, returning null.");
            if (performanceClient && correlationId) performanceClient?.addFields({
                errorCode: "no_cached_request"
            }, correlationId);
            return null;
        }
        const { prompt: prompt, ...request } = cachedRequest;
        if (prompt) this.logger.verbose("NativeInteractionClient - handleRedirectPromise called and prompt was included in the original request, removing prompt from cached request to prevent second interaction with native broker window.");
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).NATIVE_REQUEST));
        const reqTimestamp = (0, $0a4a8f22735f9ff5$exports).nowSeconds();
        try {
            this.logger.verbose("NativeInteractionClient - handleRedirectPromise sending message to native broker.");
            const response = await this.platformAuthProvider.sendMessage(request);
            const authResult = await this.handleNativeResponse(response, request, reqTimestamp);
            const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
            serverTelemetryManager.clearNativeBrokerErrorCode();
            return authResult;
        } catch (e) {
            throw e;
        }
    }
    /**
     * Logout from native platform via browser extension
     * @param request
     */ logout() {
        this.logger.trace("NativeInteractionClient - logout called.");
        return Promise.reject("Logout not implemented yet");
    }
    /**
     * Transform response from native platform into AuthenticationResult object which will be returned to the end user
     * @param response
     * @param request
     * @param reqTimestamp
     */ async handleNativeResponse(response, request, reqTimestamp) {
        this.logger.trace("NativeInteractionClient - handleNativeResponse called.");
        // generate identifiers
        const idTokenClaims = (0, $b29e27fb146a7ddd$exports).extractTokenClaims(response.id_token, (0, $581fd3df606755c8$export$c62426fdd000a97e));
        const homeAccountIdentifier = this.createHomeAccountIdentifier(response, idTokenClaims);
        const cachedhomeAccountId = this.browserStorage.getAccountInfoFilteredBy({
            nativeAccountId: request.accountId
        })?.homeAccountId;
        // add exception for double brokering, please note this is temporary and will be fortified in future
        if (request.extraParameters?.child_client_id && response.account.id !== request.accountId) this.logger.info("handleNativeServerResponse: Double broker flow detected, ignoring accountId mismatch");
        else if (homeAccountIdentifier !== cachedhomeAccountId && response.account.id !== request.accountId) // User switch in native broker prompt is not supported. All users must first sign in through web flow to ensure server state is in sync
        throw (0, $a5e5dee51df551c2$export$9154414ec87d187b)((0, $ad0863ed8e4325cb$export$966ec8558e4d7922));
        // Get the preferred_cache domain for the given authority
        const authority = await this.getDiscoveredAuthority({
            requestAuthority: request.authority
        });
        const baseAccount = (0, $4039fad97bcf28f6$export$73b84062d58a1307)(this.browserStorage, authority, homeAccountIdentifier, (0, $581fd3df606755c8$export$c62426fdd000a97e), idTokenClaims, response.client_info, undefined, idTokenClaims.tid, undefined, response.account.id, this.logger);
        // Ensure expires_in is in number format
        response.expires_in = Number(response.expires_in);
        // generate authenticationResult
        const result = await this.generateAuthenticationResult(response, request, idTokenClaims, baseAccount, authority.canonicalAuthority, reqTimestamp);
        // cache accounts and tokens in the appropriate storage
        await this.cacheAccount(baseAccount);
        await this.cacheNativeTokens(response, request, homeAccountIdentifier, idTokenClaims, response.access_token, result.tenantId, reqTimestamp);
        return result;
    }
    /**
     * creates an homeAccountIdentifier for the account
     * @param response
     * @param idTokenObj
     * @returns
     */ createHomeAccountIdentifier(response, idTokenClaims) {
        // Save account in browser storage
        const homeAccountIdentifier = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).generateHomeAccountId(response.client_info || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, (0, $70363054a03152f4$export$cd82032b224a3839).Default, this.logger, this.browserCrypto, idTokenClaims);
        return homeAccountIdentifier;
    }
    /**
     * Helper to generate scopes
     * @param response
     * @param request
     * @returns
     */ generateScopes(requestScopes, responseScopes) {
        return responseScopes ? (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(responseScopes) : (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(requestScopes);
    }
    /**
     * If PoP token is requesred, records the PoP token if returned from the WAM, else generates one in the browser
     * @param request
     * @param response
     */ async generatePopAccessToken(response, request) {
        if (request.tokenType === (0, $7c375ae106b964be$export$901491a717da2ba5).POP && request.signPopToken) {
            /**
             * This code prioritizes SHR returned from the native layer. In case of error/SHR not calculated from WAM and the AT
             * is still received, SHR is calculated locally
             */ // Check if native layer returned an SHR token
            if (response.shr) {
                this.logger.trace("handleNativeServerResponse: SHR is enabled in native layer");
                return response.shr;
            }
            // Generate SHR in msal js if WAM does not compute it when POP is enabled
            const popTokenGenerator = new (0, $942a44945e07e21d$export$3dd8467151c83e3e)(this.browserCrypto);
            const shrParameters = {
                resourceRequestMethod: request.resourceRequestMethod,
                resourceRequestUri: request.resourceRequestUri,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce
            };
            /**
             * KeyID must be present in the native request from when the PoP key was generated in order for
             * PopTokenGenerator to query the full key for signing
             */ if (!request.keyId) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).keyIdMissing);
            return popTokenGenerator.signPopToken(response.access_token, request.keyId, shrParameters);
        } else return response.access_token;
    }
    /**
     * Generates authentication result
     * @param response
     * @param request
     * @param idTokenObj
     * @param accountEntity
     * @param authority
     * @param reqTimestamp
     * @returns
     */ async generateAuthenticationResult(response, request, idTokenClaims, accountEntity, authority, reqTimestamp) {
        // Add Native Broker fields to Telemetry
        const mats = this.addTelemetryFromNativeResponse(response.properties.MATS);
        // If scopes not returned in server response, use request scopes
        const responseScopes = this.generateScopes(request.scope, response.scope);
        const accountProperties = response.account.properties || {};
        const uid = accountProperties["UID"] || idTokenClaims.oid || idTokenClaims.sub || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        const tid = accountProperties["TenantId"] || idTokenClaims.tid || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        const accountInfo = (0, $54830df9a5d9a12c$export$452a054c78b83dad)(accountEntity.getAccountInfo(), undefined, idTokenClaims, response.id_token);
        /**
         * In pairwise broker flows, this check prevents the broker's native account id
         * from being returned over the embedded app's account id.
         */ if (accountInfo.nativeAccountId !== response.account.id) accountInfo.nativeAccountId = response.account.id;
        // generate PoP token as needed
        const responseAccessToken = await this.generatePopAccessToken(response, request);
        const tokenType = request.tokenType === (0, $7c375ae106b964be$export$901491a717da2ba5).POP ? (0, $7c375ae106b964be$export$901491a717da2ba5).POP : (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER;
        const result = {
            authority: authority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes.asArray(),
            account: accountInfo,
            idToken: response.id_token,
            idTokenClaims: idTokenClaims,
            accessToken: responseAccessToken,
            fromCache: mats ? this.isResponseFromCache(mats) : false,
            // Request timestamp and NativeResponse expires_in are in seconds, converting to Date for AuthenticationResult
            expiresOn: (0, $0a4a8f22735f9ff5$exports).toDateFromSeconds(reqTimestamp + response.expires_in),
            tokenType: tokenType,
            correlationId: this.correlationId,
            state: response.state,
            fromNativeBroker: true
        };
        return result;
    }
    /**
     * cache the account entity in browser storage
     * @param accountEntity
     */ async cacheAccount(accountEntity) {
        // Store the account info and hence `nativeAccountId` in browser cache
        await this.browserStorage.setAccount(accountEntity, this.correlationId);
        // Remove any existing cached tokens for this account in browser storage
        this.browserStorage.removeAccountContext(accountEntity).catch((e)=>{
            this.logger.error(`Error occurred while removing account context from browser storage. ${e}`);
        });
    }
    /**
     * Stores the access_token and id_token in inmemory storage
     * @param response
     * @param request
     * @param homeAccountIdentifier
     * @param idTokenObj
     * @param responseAccessToken
     * @param tenantId
     * @param reqTimestamp
     */ cacheNativeTokens(response, request, homeAccountIdentifier, idTokenClaims, responseAccessToken, tenantId, reqTimestamp) {
        const cachedIdToken = (0, $9ab3d26df56b176d$exports).createIdTokenEntity(homeAccountIdentifier, request.authority, response.id_token || "", request.clientId, idTokenClaims.tid || "");
        // cache accessToken in inmemory storage
        const expiresIn = request.tokenType === (0, $7c375ae106b964be$export$901491a717da2ba5).POP ? (0, $7c375ae106b964be$export$a002182e51710d39).SHR_NONCE_VALIDITY : (typeof response.expires_in === "string" ? parseInt(response.expires_in, 10) : response.expires_in) || 0;
        const tokenExpirationSeconds = reqTimestamp + expiresIn;
        const responseScopes = this.generateScopes(response.scope, request.scope);
        const cachedAccessToken = (0, $9ab3d26df56b176d$exports).createAccessTokenEntity(homeAccountIdentifier, request.authority, responseAccessToken, request.clientId, idTokenClaims.tid || tenantId, responseScopes.printScopes(), tokenExpirationSeconds, 0, (0, $581fd3df606755c8$export$c62426fdd000a97e), undefined, request.tokenType, undefined, request.keyId);
        const nativeCacheRecord = {
            idToken: cachedIdToken,
            accessToken: cachedAccessToken
        };
        return this.nativeStorageManager.saveCacheRecord(nativeCacheRecord, this.correlationId, request.storeInCache);
    }
    getExpiresInValue(tokenType, expiresIn) {
        return tokenType === (0, $7c375ae106b964be$export$901491a717da2ba5).POP ? (0, $7c375ae106b964be$export$a002182e51710d39).SHR_NONCE_VALIDITY : (typeof expiresIn === "string" ? parseInt(expiresIn, 10) : expiresIn) || 0;
    }
    addTelemetryFromNativeResponse(matsResponse) {
        const mats = this.getMATSFromResponse(matsResponse);
        if (!mats) return null;
        this.performanceClient.addFields({
            extensionId: this.platformAuthProvider.getExtensionId(),
            extensionVersion: this.platformAuthProvider.getExtensionVersion(),
            matsBrokerVersion: mats.broker_version,
            matsAccountJoinOnStart: mats.account_join_on_start,
            matsAccountJoinOnEnd: mats.account_join_on_end,
            matsDeviceJoin: mats.device_join,
            matsPromptBehavior: mats.prompt_behavior,
            matsApiErrorCode: mats.api_error_code,
            matsUiVisible: mats.ui_visible,
            matsSilentCode: mats.silent_code,
            matsSilentBiSubCode: mats.silent_bi_sub_code,
            matsSilentMessage: mats.silent_message,
            matsSilentStatus: mats.silent_status,
            matsHttpStatus: mats.http_status,
            matsHttpEventCount: mats.http_event_count
        }, this.correlationId);
        return mats;
    }
    /**
     * Gets MATS telemetry from native response
     * @param response
     * @returns
     */ getMATSFromResponse(matsResponse) {
        if (matsResponse) try {
            return JSON.parse(matsResponse);
        } catch (e) {
            this.logger.error("NativeInteractionClient - Error parsing MATS telemetry, returning null instead");
        }
        return null;
    }
    /**
     * Returns whether or not response came from native cache
     * @param response
     * @returns
     */ isResponseFromCache(mats) {
        if (typeof mats.is_cached === "undefined") {
            this.logger.verbose("NativeInteractionClient - MATS telemetry does not contain field indicating if response was served from cache. Returning false.");
            return false;
        }
        return !!mats.is_cached;
    }
    /**
     * Translates developer provided request object into NativeRequest object
     * @param request
     */ async initializeNativeRequest(request) {
        this.logger.trace("NativeInteractionClient - initializeNativeRequest called");
        const canonicalAuthority = await this.getCanonicalAuthority(request);
        // scopes are expected to be received by the native broker as "scope" and will be added to the request below. Other properties that should be dropped from the request to the native broker can be included in the object destructuring here.
        const { scopes: scopes, ...remainingProperties } = request;
        const scopeSet = new (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99)(scopes || []);
        scopeSet.appendScopes((0, $7c375ae106b964be$export$893b1b5b686d84ef));
        const validatedRequest = {
            ...remainingProperties,
            accountId: this.accountId,
            clientId: this.config.auth.clientId,
            authority: canonicalAuthority.urlString,
            scope: scopeSet.printScopes(),
            redirectUri: this.getRedirectUri(request.redirectUri),
            prompt: this.getPrompt(request.prompt),
            correlationId: this.correlationId,
            tokenType: request.authenticationScheme,
            windowTitleSubstring: document.title,
            extraParameters: {
                ...request.extraQueryParameters,
                ...request.tokenQueryParameters
            },
            extendedExpiryToken: false,
            keyId: request.popKid
        };
        // Check for PoP token requests: signPopToken should only be set to true if popKid is not set
        if (validatedRequest.signPopToken && !!request.popKid) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$f6f43ae33ad04b91));
        this.handleExtraBrokerParams(validatedRequest);
        validatedRequest.extraParameters = validatedRequest.extraParameters || {};
        validatedRequest.extraParameters.telemetry = (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).MATS_TELEMETRY;
        if (request.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).POP) {
            // add POP request type
            const shrParameters = {
                resourceRequestUri: request.resourceRequestUri,
                resourceRequestMethod: request.resourceRequestMethod,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce
            };
            const popTokenGenerator = new (0, $942a44945e07e21d$export$3dd8467151c83e3e)(this.browserCrypto);
            // generate reqCnf if not provided in the request
            let reqCnfData;
            if (!validatedRequest.keyId) {
                const generatedReqCnfData = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(shrParameters, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
                validatedRequest.keyId = generatedReqCnfData.kid;
                validatedRequest.signPopToken = true;
            } else {
                reqCnfData = this.browserCrypto.base64UrlEncode(JSON.stringify({
                    kid: validatedRequest.keyId
                }));
                validatedRequest.signPopToken = false;
            }
            // SPAs require whole string to be passed to broker
            validatedRequest.reqCnf = reqCnfData;
        }
        this.addRequestSKUs(validatedRequest);
        return validatedRequest;
    }
    async getCanonicalAuthority(request) {
        const requestAuthority = request.authority || this.config.auth.authority;
        if (request.account) // validate authority
        await this.getDiscoveredAuthority({
            requestAuthority: requestAuthority,
            requestAzureCloudOptions: request.azureCloudOptions,
            account: request.account
        });
        const canonicalAuthority = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(requestAuthority);
        canonicalAuthority.validateAsUri();
        return canonicalAuthority;
    }
    getPrompt(prompt) {
        // If request is silent, prompt is always none
        switch(this.apiId){
            case (0, $5ff55562d73e0e2b$export$192d74ad69b40705).ssoSilent:
            case (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenSilent_silentFlow:
                this.logger.trace("initializeNativeRequest: silent request sets prompt to none");
                return (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE;
        }
        // Prompt not provided, request may proceed and native broker decides if it needs to prompt
        if (!prompt) {
            this.logger.trace("initializeNativeRequest: prompt was not provided");
            return undefined;
        }
        // If request is interactive, check if prompt provided is allowed to go directly to native broker
        switch(prompt){
            case (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE:
            case (0, $7c375ae106b964be$export$49a06cbda5acaa5).CONSENT:
            case (0, $7c375ae106b964be$export$49a06cbda5acaa5).LOGIN:
                this.logger.trace("initializeNativeRequest: prompt is compatible with native flow");
                return prompt;
            default:
                this.logger.trace(`initializeNativeRequest: prompt = ${prompt} is not compatible with native flow`);
                throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$62fdd8848aa75547));
        }
    }
    /**
     * Handles extra broker request parameters
     * @param request {PlatformAuthRequest}
     * @private
     */ handleExtraBrokerParams(request) {
        const hasExtraBrokerParams = request.extraParameters && request.extraParameters.hasOwnProperty((0, $b00a7f221d8fdf60$exports).BROKER_CLIENT_ID) && request.extraParameters.hasOwnProperty((0, $b00a7f221d8fdf60$exports).BROKER_REDIRECT_URI) && request.extraParameters.hasOwnProperty((0, $b00a7f221d8fdf60$exports).CLIENT_ID);
        if (!request.embeddedClientId && !hasExtraBrokerParams) return;
        let child_client_id = "";
        const child_redirect_uri = request.redirectUri;
        if (request.embeddedClientId) {
            request.redirectUri = this.config.auth.redirectUri;
            child_client_id = request.embeddedClientId;
        } else if (request.extraParameters) {
            request.redirectUri = request.extraParameters[(0, $b00a7f221d8fdf60$exports).BROKER_REDIRECT_URI];
            child_client_id = request.extraParameters[(0, $b00a7f221d8fdf60$exports).CLIENT_ID];
        }
        request.extraParameters = {
            child_client_id: child_client_id,
            child_redirect_uri: child_redirect_uri
        };
        this.performanceClient?.addFields({
            embeddedClientId: child_client_id,
            embeddedRedirectUri: child_redirect_uri
        }, request.correlationId);
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns map of parameters that are applicable to all calls to /authorize whether using PKCE or EAR
 * @param config
 * @param authority
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 */ async function $2a64db28ce4fd109$var$getStandardParameters(config, authority, request, logger, performanceClient) {
    const parameters = (0, $bfa307c523b8b81c$exports).getStandardAuthorizeRequestParameters({
        ...config.auth,
        authority: authority
    }, request, logger, performanceClient);
    (0, $7d3a00eb36d325b3$exports).addLibraryInfo(parameters, {
        sku: (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).MSAL_SKU,
        version: (0, $183cce12cb16965c$export$83d89fbfd8236492),
        os: "",
        cpu: ""
    });
    if (config.auth.protocolMode !== (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC) (0, $7d3a00eb36d325b3$exports).addApplicationTelemetry(parameters, config.telemetry.application);
    if (request.platformBroker) {
        // signal ests that this is a WAM call
        (0, $7d3a00eb36d325b3$exports).addNativeBroker(parameters);
        // pass the req_cnf for POP
        if (request.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).POP) {
            const cryptoOps = new (0, $e72c2cdc5fe24d6f$export$c274a7f0ebd24b14)(logger, performanceClient);
            const popTokenGenerator = new (0, $942a44945e07e21d$export$3dd8467151c83e3e)(cryptoOps);
            // req_cnf is always sent as a string for SPAs
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateCnf, logger, performanceClient, request.correlationId)(request, logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = cryptoOps.encodeKid(request.popKid);
            (0, $7d3a00eb36d325b3$exports).addPopToken(parameters, reqCnfData);
        }
    }
    (0, $7d3a00eb36d325b3$exports).instrumentBrokerParams(parameters, request.correlationId, performanceClient);
    return parameters;
}
/**
 * Gets the full /authorize URL with request parameters when using Auth Code + PKCE
 * @param config
 * @param authority
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 */ async function $2a64db28ce4fd109$export$a256231ce8625983(config, authority, request, logger, performanceClient) {
    if (!request.codeChallenge) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).pkceParamsMissing);
    const parameters = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)($2a64db28ce4fd109$var$getStandardParameters, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GetStandardParams, logger, performanceClient, request.correlationId)(config, authority, request, logger, performanceClient);
    (0, $7d3a00eb36d325b3$exports).addResponseType(parameters, (0, $7c375ae106b964be$export$5ef2b2ebd3da3e04).CODE);
    (0, $7d3a00eb36d325b3$exports).addCodeChallengeParams(parameters, request.codeChallenge, (0, $7c375ae106b964be$export$a002182e51710d39).S256_CODE_CHALLENGE_METHOD);
    (0, $7d3a00eb36d325b3$exports).addExtraQueryParameters(parameters, request.extraQueryParameters || {});
    return (0, $bfa307c523b8b81c$exports).getAuthorizeUrl(authority, parameters, config.auth.encodeExtraQueryParams, request.extraQueryParameters);
}
/**
 * Gets the form that will be posted to /authorize with request parameters when using EAR
 */ async function $2a64db28ce4fd109$export$3c140ef19fa8de34(frame, config, authority, request, logger, performanceClient) {
    if (!request.earJwk) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$2c031f99d3e081ff));
    const parameters = await $2a64db28ce4fd109$var$getStandardParameters(config, authority, request, logger, performanceClient);
    (0, $7d3a00eb36d325b3$exports).addResponseType(parameters, (0, $7c375ae106b964be$export$5ef2b2ebd3da3e04).IDTOKEN_TOKEN_REFRESHTOKEN);
    (0, $7d3a00eb36d325b3$exports).addEARParameters(parameters, request.earJwk);
    const queryParams = new Map();
    (0, $7d3a00eb36d325b3$exports).addExtraQueryParameters(queryParams, request.extraQueryParameters || {});
    const url = (0, $bfa307c523b8b81c$exports).getAuthorizeUrl(authority, queryParams, config.auth.encodeExtraQueryParams, request.extraQueryParameters);
    return $2a64db28ce4fd109$var$createForm(frame, url, parameters);
}
/**
 * Creates form element in the provided document with auth parameters in the post body
 * @param frame
 * @param authorizeUrl
 * @param parameters
 * @returns
 */ function $2a64db28ce4fd109$var$createForm(frame, authorizeUrl, parameters) {
    const form = frame.createElement("form");
    form.method = "post";
    form.action = authorizeUrl;
    parameters.forEach((value, key)=>{
        const param = frame.createElement("input");
        param.hidden = true;
        param.name = key;
        param.value = value;
        form.appendChild(param);
    });
    frame.body.appendChild(form);
    return form;
}
/**
 * Response handler when server returns accountId on the /authorize request
 * @param request
 * @param accountId
 * @param apiId
 * @param config
 * @param browserStorage
 * @param nativeStorage
 * @param eventHandler
 * @param logger
 * @param performanceClient
 * @param nativeMessageHandler
 * @returns
 */ async function $2a64db28ce4fd109$export$51c4d8201b4a42eb(request, accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    logger.verbose("Account id found, calling WAM for token");
    if (!platformAuthProvider) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$7b7357e3538624aa));
    const browserCrypto = new (0, $e72c2cdc5fe24d6f$export$c274a7f0ebd24b14)(logger, performanceClient);
    const nativeInteractionClient = new (0, $e6f06a03b9c6516d$export$3f89612b3fd8831f)(config, browserStorage, browserCrypto, logger, eventHandler, config.system.navigationClient, apiId, performanceClient, platformAuthProvider, accountId, nativeStorage, request.correlationId);
    const { userRequestState: userRequestState } = (0, $18d0dfe50b7b79f1$export$871e33217042c65e).parseRequestState(browserCrypto, request.state);
    return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(nativeInteractionClient.acquireToken.bind(nativeInteractionClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, logger, performanceClient, request.correlationId)({
        ...request,
        state: userRequestState,
        prompt: undefined
    });
}
/**
 * Response handler when server returns code on the /authorize request
 * @param request
 * @param response
 * @param codeVerifier
 * @param authClient
 * @param browserStorage
 * @param logger
 * @param performanceClient
 * @returns
 */ async function $2a64db28ce4fd109$export$907304a743d3578a(request, response, codeVerifier, apiId, config, authClient, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    // Remove throttle if it exists
    (0, $38fc8bee021018e9$export$c060a619741dd765).removeThrottle(browserStorage, config.auth.clientId, request);
    if (response.accountId) return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)($2a64db28ce4fd109$export$51c4d8201b4a42eb, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleResponsePlatformBroker, logger, performanceClient, request.correlationId)(request, response.accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider);
    const authCodeRequest = {
        ...request,
        code: response.code || "",
        codeVerifier: codeVerifier
    };
    // Create popup interaction handler.
    const interactionHandler = new (0, $e330ed825f42f772$export$a30cd982b4e89bdb)(authClient, browserStorage, authCodeRequest, logger, performanceClient);
    // Handle response from hash string.
    const result = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(interactionHandler.handleCodeResponse.bind(interactionHandler), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleCodeResponse, logger, performanceClient, request.correlationId)(response, request);
    return result;
}
/**
 * Response handler when server returns ear_jwe on the /authorize request
 * @param request
 * @param response
 * @param apiId
 * @param config
 * @param authority
 * @param browserStorage
 * @param nativeStorage
 * @param eventHandler
 * @param logger
 * @param performanceClient
 * @param nativeMessageHandler
 * @returns
 */ async function $2a64db28ce4fd109$export$21aeb02dac823516(request, response, apiId, config, authority, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    // Remove throttle if it exists
    (0, $38fc8bee021018e9$export$c060a619741dd765).removeThrottle(browserStorage, config.auth.clientId, request);
    // Validate state & check response for errors
    (0, $bfa307c523b8b81c$exports).validateAuthorizationResponse(response, request.state);
    if (!response.ear_jwe) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$b9f7c47ac4054f3d));
    if (!request.earJwk) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$2c031f99d3e081ff));
    const decryptedData = JSON.parse(await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$13b9c776ab498ef3), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).DecryptEarResponse, logger, performanceClient, request.correlationId)(request.earJwk, response.ear_jwe));
    if (decryptedData.accountId) return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)($2a64db28ce4fd109$export$51c4d8201b4a42eb, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleResponsePlatformBroker, logger, performanceClient, request.correlationId)(request, decryptedData.accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider);
    const responseHandler = new (0, $4039fad97bcf28f6$export$f456c9835cc63582)(config.auth.clientId, browserStorage, new (0, $e72c2cdc5fe24d6f$export$c274a7f0ebd24b14)(logger, performanceClient), logger, null, null, performanceClient);
    // Validate response. This function throws a server error if an error is returned by the server.
    responseHandler.validateTokenResponse(decryptedData);
    // Temporary until response handler is refactored to be more flow agnostic.
    const additionalData = {
        code: "",
        state: request.state,
        nonce: request.nonce,
        client_info: decryptedData.client_info,
        cloud_graph_host_name: decryptedData.cloud_graph_host_name,
        cloud_instance_host_name: decryptedData.cloud_instance_host_name,
        cloud_instance_name: decryptedData.cloud_instance_name,
        msgraph_host: decryptedData.msgraph_host
    };
    return await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleServerTokenResponse, logger, performanceClient, request.correlationId)(decryptedData, authority, (0, $0a4a8f22735f9ff5$exports).nowSeconds(), request, additionalData, undefined, undefined, undefined, undefined);
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Constant byte array length
const $cab7ad26b4a73b7b$var$RANDOM_BYTE_ARR_LENGTH = 32;
/**
 * This file defines APIs to generate PKCE codes and code verifiers.
 */ /**
 * Generates PKCE Codes. See the RFC for more information: https://tools.ietf.org/html/rfc7636
 */ async function $cab7ad26b4a73b7b$export$91d5e5a023803853(performanceClient, logger, correlationId) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).GeneratePkceCodes, correlationId);
    const codeVerifier = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)($cab7ad26b4a73b7b$var$generateCodeVerifier, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateCodeVerifier, logger, performanceClient, correlationId)(performanceClient, logger, correlationId);
    const codeChallenge = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)($cab7ad26b4a73b7b$var$generateCodeChallengeFromVerifier, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateCodeChallengeFromVerifier, logger, performanceClient, correlationId)(codeVerifier, performanceClient, logger, correlationId);
    return {
        verifier: codeVerifier,
        challenge: codeChallenge
    };
}
/**
 * Generates a random 32 byte buffer and returns the base64
 * encoded string to be used as a PKCE Code Verifier
 */ function $cab7ad26b4a73b7b$var$generateCodeVerifier(performanceClient, logger, correlationId) {
    try {
        // Generate random values as utf-8
        const buffer = new Uint8Array($cab7ad26b4a73b7b$var$RANDOM_BYTE_ARR_LENGTH);
        (0, $5386add07ebe4b6d$export$468cda29b159ee5d)((0, $4e0948336b4ea4a7$export$960b9ff25e7d4257), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GetRandomValues, logger, performanceClient, correlationId)(buffer);
        // encode verifier as base64
        const pkceCodeVerifierB64 = (0, $6f6986007da7f422$export$84f5a428c7153a69)(buffer);
        return pkceCodeVerifierB64;
    } catch (e) {
        throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$ee549107fa376fc1));
    }
}
/**
 * Creates a base64 encoded PKCE Code Challenge string from the
 * hash created from the PKCE Code Verifier supplied
 */ async function $cab7ad26b4a73b7b$var$generateCodeChallengeFromVerifier(pkceCodeVerifier, performanceClient, logger, correlationId) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateCodeChallengeFromVerifier, correlationId);
    try {
        // hashed verifier
        const pkceHashedCodeVerifier = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$52caff7bddbaf316), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).Sha256Digest, logger, performanceClient, correlationId)(pkceCodeVerifier, performanceClient, correlationId);
        // encode hash as base64
        return (0, $6f6986007da7f422$export$84f5a428c7153a69)(new Uint8Array(pkceHashedCodeVerifier));
    } catch (e) {
        throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$ee549107fa376fc1));
    }
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $baeb759c53a00ffc$export$de4c158ddf8b89f6 {
    constructor(logger, handshakeTimeoutMs, performanceClient, extensionId){
        this.logger = logger;
        this.handshakeTimeoutMs = handshakeTimeoutMs;
        this.extensionId = extensionId;
        this.resolvers = new Map(); // Used for non-handshake messages
        this.handshakeResolvers = new Map(); // Used for handshake messages
        this.messageChannel = new MessageChannel();
        this.windowListener = this.onWindowMessage.bind(this); // Window event callback doesn't have access to 'this' unless it's bound
        this.performanceClient = performanceClient;
        this.handshakeEvent = performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).NativeMessageHandlerHandshake);
        this.platformAuthType = (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).PLATFORM_EXTENSION_PROVIDER;
    }
    /**
     * Sends a given message to the extension and resolves with the extension response
     * @param request
     */ async sendMessage(request) {
        this.logger.trace(this.platformAuthType + " - sendMessage called.");
        // fall back to native calls
        const messageBody = {
            method: (0, $5ff55562d73e0e2b$export$3536098be6c7dadb).GetToken,
            request: request
        };
        const req = {
            channel: (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)(),
            body: messageBody
        };
        this.logger.trace(this.platformAuthType + " - Sending request to browser extension");
        this.logger.tracePii(this.platformAuthType + ` - Sending request to browser extension: ${JSON.stringify(req)}`);
        this.messageChannel.port1.postMessage(req);
        const response = await new Promise((resolve, reject)=>{
            this.resolvers.set(req.responseId, {
                resolve: resolve,
                reject: reject
            });
        });
        const validatedResponse = this.validatePlatformBrokerResponse(response);
        return validatedResponse;
    }
    /**
     * Returns an instance of the MessageHandler that has successfully established a connection with an extension
     * @param {Logger} logger
     * @param {number} handshakeTimeoutMs
     * @param {IPerformanceClient} performanceClient
     * @param {ICrypto} crypto
     */ static async createProvider(logger, handshakeTimeoutMs, performanceClient) {
        logger.trace("PlatformAuthExtensionHandler - createProvider called.");
        try {
            const preferredProvider = new $baeb759c53a00ffc$export$de4c158ddf8b89f6(logger, handshakeTimeoutMs, performanceClient, (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).PREFERRED_EXTENSION_ID);
            await preferredProvider.sendHandshakeRequest();
            return preferredProvider;
        } catch (e) {
            // If preferred extension fails for whatever reason, fallback to using any installed extension
            const backupProvider = new $baeb759c53a00ffc$export$de4c158ddf8b89f6(logger, handshakeTimeoutMs, performanceClient);
            await backupProvider.sendHandshakeRequest();
            return backupProvider;
        }
    }
    /**
     * Send handshake request helper.
     */ async sendHandshakeRequest() {
        this.logger.trace(this.platformAuthType + " - sendHandshakeRequest called.");
        // Register this event listener before sending handshake
        window.addEventListener("message", this.windowListener, false); // false is important, because content script message processing should work first
        const req = {
            channel: (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)(),
            body: {
                method: (0, $5ff55562d73e0e2b$export$3536098be6c7dadb).HandshakeRequest
            }
        };
        this.handshakeEvent.add({
            extensionId: this.extensionId,
            extensionHandshakeTimeoutMs: this.handshakeTimeoutMs
        });
        this.messageChannel.port1.onmessage = (event)=>{
            this.onChannelMessage(event);
        };
        window.postMessage(req, window.origin, [
            this.messageChannel.port2
        ]);
        return new Promise((resolve, reject)=>{
            this.handshakeResolvers.set(req.responseId, {
                resolve: resolve,
                reject: reject
            });
            this.timeoutId = window.setTimeout(()=>{
                /*
                 * Throw an error if neither HandshakeResponse nor original Handshake request are received in a reasonable timeframe.
                 * This typically suggests an event handler stopped propagation of the Handshake request but did not respond to it on the MessageChannel port
                 */ window.removeEventListener("message", this.windowListener, false);
                this.messageChannel.port1.close();
                this.messageChannel.port2.close();
                this.handshakeEvent.end({
                    extensionHandshakeTimedOut: true,
                    success: false
                });
                reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$4747c302ef0117fd)));
                this.handshakeResolvers.delete(req.responseId);
            }, this.handshakeTimeoutMs); // Use a reasonable timeout in milliseconds here
        });
    }
    /**
     * Invoked when a message is posted to the window. If a handshake request is received it means the extension is not installed.
     * @param event
     */ onWindowMessage(event) {
        this.logger.trace(this.platformAuthType + " - onWindowMessage called");
        // We only accept messages from ourselves
        if (event.source !== window) return;
        const request = event.data;
        if (!request.channel || request.channel !== (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).CHANNEL_ID) return;
        if (request.extensionId && request.extensionId !== this.extensionId) return;
        if (request.body.method === (0, $5ff55562d73e0e2b$export$3536098be6c7dadb).HandshakeRequest) {
            const handshakeResolver = this.handshakeResolvers.get(request.responseId);
            /*
             * Filter out responses with no matched resolvers sooner to keep channel ports open while waiting for
             * the proper response.
             */ if (!handshakeResolver) {
                this.logger.trace(this.platformAuthType + `.onWindowMessage - resolver can't be found for request ${request.responseId}`);
                return;
            }
            // If we receive this message back it means no extension intercepted the request, meaning no extension supporting handshake protocol is installed
            this.logger.verbose(request.extensionId ? `Extension with id: ${request.extensionId} not installed` : "No extension installed");
            clearTimeout(this.timeoutId);
            this.messageChannel.port1.close();
            this.messageChannel.port2.close();
            window.removeEventListener("message", this.windowListener, false);
            this.handshakeEvent.end({
                success: false,
                extensionInstalled: false
            });
            handshakeResolver.reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$59080ea2398ee306)));
        }
    }
    /**
     * Invoked when a message is received from the extension on the MessageChannel port
     * @param event
     */ onChannelMessage(event) {
        this.logger.trace(this.platformAuthType + " - onChannelMessage called.");
        const request = event.data;
        const resolver = this.resolvers.get(request.responseId);
        const handshakeResolver = this.handshakeResolvers.get(request.responseId);
        try {
            const method = request.body.method;
            if (method === (0, $5ff55562d73e0e2b$export$3536098be6c7dadb).Response) {
                if (!resolver) return;
                const response = request.body.response;
                this.logger.trace(this.platformAuthType + " - Received response from browser extension");
                this.logger.tracePii(this.platformAuthType + ` - Received response from browser extension: ${JSON.stringify(response)}`);
                if (response.status !== "Success") resolver.reject((0, $a5e5dee51df551c2$export$9154414ec87d187b)(response.code, response.description, response.ext));
                else if (response.result) {
                    if (response.result["code"] && response.result["description"]) resolver.reject((0, $a5e5dee51df551c2$export$9154414ec87d187b)(response.result["code"], response.result["description"], response.result["ext"]));
                    else resolver.resolve(response.result);
                } else throw (0, $0ff8310393c4d2db$export$eb157f7636c79bd2)((0, $1a08d0bb87f43eeb$exports).unexpectedError, "Event does not contain result.");
                this.resolvers.delete(request.responseId);
            } else if (method === (0, $5ff55562d73e0e2b$export$3536098be6c7dadb).HandshakeResponse) {
                if (!handshakeResolver) {
                    this.logger.trace(this.platformAuthType + `.onChannelMessage - resolver can't be found for request ${request.responseId}`);
                    return;
                }
                clearTimeout(this.timeoutId); // Clear setTimeout
                window.removeEventListener("message", this.windowListener, false); // Remove 'No extension' listener
                this.extensionId = request.extensionId;
                this.extensionVersion = request.body.version;
                this.logger.verbose(this.platformAuthType + ` - Received HandshakeResponse from extension: ${this.extensionId}`);
                this.handshakeEvent.end({
                    extensionInstalled: true,
                    success: true
                });
                handshakeResolver.resolve();
                this.handshakeResolvers.delete(request.responseId);
            }
        // Do nothing if method is not Response or HandshakeResponse
        } catch (err) {
            this.logger.error("Error parsing response from WAM Extension");
            this.logger.errorPii(`Error parsing response from WAM Extension: ${err}`);
            this.logger.errorPii(`Unable to parse ${event}`);
            if (resolver) resolver.reject(err);
            else if (handshakeResolver) handshakeResolver.reject(err);
        }
    }
    /**
     * Validates native platform response before processing
     * @param response
     */ validatePlatformBrokerResponse(response) {
        if (response.hasOwnProperty("access_token") && response.hasOwnProperty("id_token") && response.hasOwnProperty("client_info") && response.hasOwnProperty("account") && response.hasOwnProperty("scope") && response.hasOwnProperty("expires_in")) return response;
        else throw (0, $0ff8310393c4d2db$export$eb157f7636c79bd2)((0, $1a08d0bb87f43eeb$exports).unexpectedError, "Response missing expected properties.");
    }
    /**
     * Returns the Id for the browser extension this handler is communicating with
     * @returns
     */ getExtensionId() {
        return this.extensionId;
    }
    /**
     * Returns the version for the browser extension this handler is communicating with
     * @returns
     */ getExtensionVersion() {
        return this.extensionVersion;
    }
    getExtensionName() {
        return this.getExtensionId() === (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).PREFERRED_EXTENSION_ID ? "chrome" : this.getExtensionId()?.length ? "unknown" : undefined;
    }
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $952fbef31257d8ea$export$aa8591dfbb8a4c65 {
    constructor(logger, performanceClient, correlationId){
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.platformAuthType = (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).PLATFORM_DOM_PROVIDER;
    }
    static async createProvider(logger, performanceClient, correlationId) {
        logger.trace("PlatformAuthDOMHandler: createProvider called");
        // @ts-ignore
        if (window.navigator?.platformAuthentication) {
            const supportedContracts = // @ts-ignore
            await window.navigator.platformAuthentication.getSupportedContracts((0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).MICROSOFT_ENTRA_BROKERID);
            if (supportedContracts?.includes((0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).PLATFORM_DOM_APIS)) {
                logger.trace("Platform auth api available in DOM");
                return new $952fbef31257d8ea$export$aa8591dfbb8a4c65(logger, performanceClient, correlationId);
            }
        }
        return undefined;
    }
    /**
     * Returns the Id for the broker extension this handler is communicating with
     * @returns
     */ getExtensionId() {
        return (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).MICROSOFT_ENTRA_BROKERID;
    }
    getExtensionVersion() {
        return "";
    }
    getExtensionName() {
        return (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).DOM_API_NAME;
    }
    /**
     * Send token request to platform broker via browser DOM API
     * @param request
     * @returns
     */ async sendMessage(request) {
        this.logger.trace(this.platformAuthType + " - Sending request to browser DOM API");
        try {
            const platformDOMRequest = this.initializePlatformDOMRequest(request);
            const response = // @ts-ignore
            await window.navigator.platformAuthentication.executeGetToken(platformDOMRequest);
            return this.validatePlatformBrokerResponse(response);
        } catch (e) {
            this.logger.error(this.platformAuthType + " - executeGetToken DOM API error");
            throw e;
        }
    }
    initializePlatformDOMRequest(request) {
        this.logger.trace(this.platformAuthType + " - initializeNativeDOMRequest called");
        const { accountId: accountId, clientId: clientId, authority: authority, scope: scope, redirectUri: redirectUri, correlationId: correlationId, state: state, storeInCache: storeInCache, embeddedClientId: embeddedClientId, extraParameters: extraParameters, ...remainingProperties } = request;
        const validExtraParameters = this.getDOMExtraParams(remainingProperties);
        const platformDOMRequest = {
            accountId: accountId,
            brokerId: this.getExtensionId(),
            authority: authority,
            clientId: clientId,
            correlationId: correlationId || this.correlationId,
            extraParameters: {
                ...extraParameters,
                ...validExtraParameters
            },
            isSecurityTokenService: false,
            redirectUri: redirectUri,
            scope: scope,
            state: state,
            storeInCache: storeInCache,
            embeddedClientId: embeddedClientId
        };
        return platformDOMRequest;
    }
    validatePlatformBrokerResponse(response) {
        if (response.hasOwnProperty("isSuccess")) {
            if (response.hasOwnProperty("accessToken") && response.hasOwnProperty("idToken") && response.hasOwnProperty("clientInfo") && response.hasOwnProperty("account") && response.hasOwnProperty("scopes") && response.hasOwnProperty("expiresIn")) {
                this.logger.trace(this.platformAuthType + " - platform broker returned successful and valid response");
                return this.convertToPlatformBrokerResponse(response);
            } else if (response.hasOwnProperty("error")) {
                const errorResponse = response;
                if (errorResponse.isSuccess === false && errorResponse.error && errorResponse.error.code) {
                    this.logger.trace(this.platformAuthType + " - platform broker returned error response");
                    throw (0, $a5e5dee51df551c2$export$9154414ec87d187b)(errorResponse.error.code, errorResponse.error.description, {
                        error: parseInt(errorResponse.error.errorCode),
                        protocol_error: errorResponse.error.protocolError,
                        status: errorResponse.error.status,
                        properties: errorResponse.error.properties
                    });
                }
            }
        }
        throw (0, $0ff8310393c4d2db$export$eb157f7636c79bd2)((0, $1a08d0bb87f43eeb$exports).unexpectedError, "Response missing expected properties.");
    }
    convertToPlatformBrokerResponse(response) {
        this.logger.trace(this.platformAuthType + " - convertToNativeResponse called");
        const nativeResponse = {
            access_token: response.accessToken,
            id_token: response.idToken,
            client_info: response.clientInfo,
            account: response.account,
            expires_in: response.expiresIn,
            scope: response.scopes,
            state: response.state || "",
            properties: response.properties || {},
            extendedLifetimeToken: response.extendedLifetimeToken ?? false,
            shr: response.proofOfPossessionPayload
        };
        return nativeResponse;
    }
    getDOMExtraParams(extraParameters) {
        const stringifiedParams = Object.entries(extraParameters).reduce((record, [key, value])=>{
            record[key] = String(value);
            return record;
        }, {});
        const validExtraParams = {
            ...stringifiedParams
        };
        return validExtraParams;
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Checks if the platform broker is available in the current environment.
 * @param loggerOptions
 * @param perfClient
 * @returns
 */ async function $1ef3eb788d38d5ed$export$bce61db0d62ff8e2(loggerOptions, perfClient, correlationId) {
    const logger = new (0, $0bf1d54ef751a29c$export$efa9a398d6368992)(loggerOptions || {}, (0, $183cce12cb16965c$export$a8ff84c12d48cfa6), (0, $183cce12cb16965c$export$83d89fbfd8236492));
    logger.trace("isPlatformBrokerAvailable called");
    const performanceClient = perfClient || new (0, $c21b15fc7f6dcd1f$export$c70f2989a65fda3e)();
    if (typeof window === "undefined") {
        logger.trace("Non-browser environment detected, returning false");
        return false;
    }
    return !!await $1ef3eb788d38d5ed$export$b2c9df3607dc771a(logger, performanceClient, correlationId || (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)());
}
async function $1ef3eb788d38d5ed$export$b2c9df3607dc771a(logger, performanceClient, correlationId, nativeBrokerHandshakeTimeout) {
    logger.trace("getPlatformAuthProvider called", correlationId);
    const enablePlatformBrokerDOMSupport = $1ef3eb788d38d5ed$export$3292f7607679b3bc();
    logger.trace("Has client allowed platform auth via DOM API: " + enablePlatformBrokerDOMSupport);
    let platformAuthProvider;
    try {
        if (enablePlatformBrokerDOMSupport) // Check if DOM platform API is supported first
        platformAuthProvider = await (0, $952fbef31257d8ea$export$aa8591dfbb8a4c65).createProvider(logger, performanceClient, correlationId);
        if (!platformAuthProvider) {
            logger.trace("Platform auth via DOM API not available, checking for extension");
            /*
             * If DOM APIs are not available, check if browser extension is available.
             * Platform authentication via DOM APIs is preferred over extension APIs.
             */ platformAuthProvider = await (0, $baeb759c53a00ffc$export$de4c158ddf8b89f6).createProvider(logger, nativeBrokerHandshakeTimeout || (0, $68fb5a78014bcfe7$export$73d1d87a8b7ddb57), performanceClient);
        }
    } catch (e) {
        logger.trace("Platform auth not available", e);
    }
    return platformAuthProvider;
}
/**
 * Returns true if the DOM API support for platform auth is enabled in session storage
 * @returns boolean
 * @deprecated
 */ function $1ef3eb788d38d5ed$export$3292f7607679b3bc() {
    let sessionStorage;
    try {
        sessionStorage = window[(0, $5ff55562d73e0e2b$export$573384e47a12d835).SessionStorage];
        // Mute errors if it's a non-browser environment or cookies are blocked.
        return sessionStorage?.getItem((0, $5ff55562d73e0e2b$export$43c3e4cbd5e04b77)) === "true";
    } catch (e) {
        return false;
    }
}
/**
 * Returns boolean indicating whether or not the request should attempt to use native broker
 * @param logger
 * @param config
 * @param platformAuthProvider
 * @param authenticationScheme
 */ function $1ef3eb788d38d5ed$export$4815cc9f88d4f6a5(config, logger, platformAuthProvider, authenticationScheme) {
    logger.trace("isBrokerAvailable called");
    if (!config.system.allowPlatformBroker) {
        logger.trace("isBrokerAvailable: allowPlatformBroker is not enabled, returning false");
        // Developer disabled WAM
        return false;
    }
    if (!platformAuthProvider) {
        logger.trace("isBrokerAvailable: Platform auth provider is not initialized, returning false");
        // Platform broker auth providers are not available
        return false;
    }
    if (authenticationScheme) switch(authenticationScheme){
        case (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER:
        case (0, $7c375ae106b964be$export$901491a717da2ba5).POP:
            logger.trace("isBrokerAvailable: authenticationScheme is supported, returning true");
            return true;
        default:
            logger.trace("isBrokerAvailable: authenticationScheme is not supported, returning false");
            return false;
    }
    return true;
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $674f66832275a4d9$export$43b0fce132d066f4 extends (0, $5d00224fcf1f9e62$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, platformAuthHandler, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, platformAuthHandler, correlationId);
        // Properly sets this reference for the unload event.
        this.unloadWindow = this.unloadWindow.bind(this);
        this.nativeStorage = nativeStorageImpl;
        this.eventHandler = eventHandler;
    }
    /**
     * Acquires tokens by opening a popup window to the /authorize endpoint of the authority
     * @param request
     * @param pkceCodes
     */ acquireToken(request, pkceCodes) {
        try {
            const popupName = this.generatePopupName(request.scopes || (0, $7c375ae106b964be$export$893b1b5b686d84ef), request.authority || this.config.auth.authority);
            const popupParams = {
                popupName: popupName,
                popupWindowAttributes: request.popupWindowAttributes || {},
                popupWindowParent: request.popupWindowParent ?? window
            };
            this.performanceClient.addFields({
                isAsyncPopup: this.config.system.asyncPopups
            }, this.correlationId);
            // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (this.config.system.asyncPopups) {
                this.logger.verbose("asyncPopups set to true, acquiring token");
                // Passes on popup position and dimensions if in request
                return this.acquireTokenPopupAsync(request, popupParams, pkceCodes);
            } else {
                // asyncPopups flag is set to false. Opens popup before acquiring token.
                this.logger.verbose("asyncPopup set to false, opening popup before acquiring token");
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.acquireTokenPopupAsync(request, popupParams, pkceCodes);
            }
        } catch (e) {
            return Promise.reject(e);
        }
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logout(logoutRequest) {
        try {
            this.logger.verbose("logoutPopup called");
            const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
            const popupParams = {
                popupName: this.generateLogoutPopupName(validLogoutRequest),
                popupWindowAttributes: logoutRequest?.popupWindowAttributes || {},
                popupWindowParent: logoutRequest?.popupWindowParent ?? window
            };
            const authority = logoutRequest && logoutRequest.authority;
            const mainWindowRedirectUri = logoutRequest && logoutRequest.mainWindowRedirectUri;
            // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (this.config.system.asyncPopups) {
                this.logger.verbose("asyncPopups set to true");
                // Passes on popup position and dimensions if in request
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            } else {
                // asyncPopups flag is set to false. Opens popup before logging out.
                this.logger.verbose("asyncPopup set to false, opening popup");
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            }
        } catch (e) {
            // Since this function is synchronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Helper which obtains an access_token for your API via opening a popup window in the user's browser
     * @param request
     * @param popupParams
     * @param pkceCodes
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopupAsync(request, popupParams, pkceCodes) {
        this.logger.verbose("acquireTokenPopupAsync called");
        const validRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(request, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup);
        /*
         * Skip pre-connect for async popups to reduce time between user interaction and popup window creation to avoid
         * popup from being blocked by browsers with shorter popup timers
         */ if (popupParams.popup) (0, $3003b661a087a867$export$a0816fa17a9e79be)(validRequest.authority);
        const isPlatformBroker = (0, $1ef3eb788d38d5ed$export$4815cc9f88d4f6a5)(this.config, this.logger, this.platformAuthProvider, request.authenticationScheme);
        validRequest.platformBroker = isPlatformBroker;
        if (this.config.auth.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).EAR) return this.executeEarFlow(validRequest, popupParams);
        else return this.executeCodeFlow(validRequest, popupParams, pkceCodes);
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @param popupParams
     * @param pkceCodes
     * @returns
     */ async executeCodeFlow(request, popupParams, pkceCodes) {
        const correlationId = request.correlationId;
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenPopup);
        const pkce = pkceCodes || await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $cab7ad26b4a73b7b$export$91d5e5a023803853), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const popupRequest = {
            ...request,
            codeChallenge: pkce.challenge
        };
        try {
            // Initialize the client
            const authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: popupRequest.authority,
                requestAzureCloudOptions: popupRequest.azureCloudOptions,
                requestExtraQueryParameters: popupRequest.extraQueryParameters,
                account: popupRequest.account
            });
            // Create acquire token url.
            const navigateUrl = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$a256231ce8625983), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GetAuthCodeUrl, this.logger, this.performanceClient, correlationId)(this.config, authClient.authority, popupRequest, this.logger, this.performanceClient);
            // Show the UI once the url has been created. Get the window handle for the popup.
            const popupWindow = this.initiateAuthRequest(navigateUrl, popupParams);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).POPUP_OPENED, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, {
                popupWindow: popupWindow
            }, null);
            // Monitor the window for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
            const responseString = await this.monitorPopupForHash(popupWindow, popupParams.popupWindowParent);
            const serverParams = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)((0, $9c7efd3c039fd7d9$export$e64c1808ed72a7c), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.serverResponseType, this.logger);
            return await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$907304a743d3578a), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleResponseCode, this.logger, this.performanceClient, correlationId)(request, serverParams, pkce.verifier, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenPopup, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request, popupParams) {
        const correlationId = request.correlationId;
        // Get the frame handle for the silent request
        const discoveredAuthority = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)({
            requestAuthority: request.authority,
            requestAzureCloudOptions: request.azureCloudOptions,
            requestExtraQueryParameters: request.extraQueryParameters,
            account: request.account
        });
        const earJwk = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$95528b8a314880d1), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateEarKey, this.logger, this.performanceClient, correlationId)();
        const popupRequest = {
            ...request,
            earJwk: earJwk
        };
        const popupWindow = popupParams.popup || this.openPopup("about:blank", popupParams);
        const form = await (0, $2a64db28ce4fd109$export$3c140ef19fa8de34)(popupWindow.document, this.config, discoveredAuthority, popupRequest, this.logger, this.performanceClient);
        form.submit();
        // Monitor the popup for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.monitorPopupForHash.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(popupWindow, popupParams.popupWindowParent);
        const serverParams = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)((0, $9c7efd3c039fd7d9$export$e64c1808ed72a7c), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.serverResponseType, this.logger);
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$21aeb02dac823516), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleResponseEar, this.logger, this.performanceClient, correlationId)(popupRequest, serverParams, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenPopup, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     *
     * @param validRequest
     * @param popupName
     * @param requestAuthority
     * @param popup
     * @param mainWindowRedirectUri
     * @param popupWindowAttributes
     */ async logoutPopupAsync(validRequest, popupParams, requestAuthority, mainWindowRedirectUri) {
        this.logger.verbose("logoutPopupAsync called");
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, validRequest);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).logoutPopup);
        try {
            // Clear cache on logout
            await this.clearCacheOnLogout(validRequest.account);
            // Initialize the client
            const authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: requestAuthority,
                account: validRequest.account || undefined
            });
            try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validRequest.account?.homeAccountId && validRequest.postLogoutRedirectUri && authClient.authority.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC) {
                    this.browserStorage.removeAccount(validRequest.account?.homeAccountId);
                    this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, validRequest);
                    if (mainWindowRedirectUri) {
                        const navigationOptions = {
                            apiId: (0, $5ff55562d73e0e2b$export$192d74ad69b40705).logoutPopup,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: false
                        };
                        const absoluteUrl = (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl(mainWindowRedirectUri, (0, $3003b661a087a867$export$1204531fbbf6ecde)());
                        await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
                    }
                    popupParams.popup?.close();
                    return;
                }
            }
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validRequest);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, validRequest);
            // Open the popup window to requestUrl.
            const popupWindow = this.openPopup(logoutUri, popupParams);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).POPUP_OPENED, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, {
                popupWindow: popupWindow
            }, null);
            await this.monitorPopupForHash(popupWindow, popupParams.popupWindowParent).catch(()=>{
            // Swallow any errors related to monitoring the window. Server logout is best effort
            });
            if (mainWindowRedirectUri) {
                const navigationOptions = {
                    apiId: (0, $5ff55562d73e0e2b$export$192d74ad69b40705).logoutPopup,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: false
                };
                const absoluteUrl = (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl(mainWindowRedirectUri, (0, $3003b661a087a867$export$1204531fbbf6ecde)());
                this.logger.verbose("Redirecting main window to url specified in the request");
                this.logger.verbosePii(`Redirecting main window to: ${absoluteUrl}`);
                await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
            } else this.logger.verbose("No main window navigation requested");
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, null, e);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_END, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup);
            throw e;
        }
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_END, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup);
    }
    /**
     * Opens a popup window with given request Url.
     * @param requestUrl
     */ initiateAuthRequest(requestUrl, params) {
        // Check that request url is not empty.
        if (requestUrl) {
            this.logger.infoPii(`Navigate to: ${requestUrl}`);
            // Open the popup window to requestUrl.
            return this.openPopup(requestUrl, params);
        } else {
            // Throw error if request URL is empty.
            this.logger.error("Navigate url is empty");
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$be9285c64f247822));
        }
    }
    /**
     * Monitors a window until it loads a url with the same origin.
     * @param popupWindow - window that is being monitored
     * @param timeout - timeout for processing hash once popup is redirected back to application
     */ monitorPopupForHash(popupWindow, popupWindowParent) {
        return new Promise((resolve, reject)=>{
            this.logger.verbose("PopupHandler.monitorPopupForHash - polling started");
            const intervalId = setInterval(()=>{
                // Window is closed
                if (popupWindow.closed) {
                    this.logger.error("PopupHandler.monitorPopupForHash - window closed");
                    clearInterval(intervalId);
                    reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6bae303c5e922702)));
                    return;
                }
                let href = "";
                try {
                    /*
                     * Will throw if cross origin,
                     * which should be caught and ignored
                     * since we need the interval to keep running while on STS UI.
                     */ href = popupWindow.location.href;
                } catch (e) {}
                // Don't process blank pages or cross domain
                if (!href || href === "about:blank") return;
                clearInterval(intervalId);
                let responseString = "";
                const responseType = this.config.auth.OIDCOptions.serverResponseType;
                if (popupWindow) {
                    if (responseType === (0, $7c375ae106b964be$export$b34cb6fbea2adc44).QUERY) responseString = popupWindow.location.search;
                    else responseString = popupWindow.location.hash;
                }
                this.logger.verbose("PopupHandler.monitorPopupForHash - popup window is on same origin as caller");
                resolve(responseString);
            }, this.config.system.pollIntervalMilliseconds);
        }).finally(()=>{
            this.cleanPopup(popupWindow, popupWindowParent);
        });
    }
    /**
     * @hidden
     *
     * Configures popup window for login.
     *
     * @param urlNavigate
     * @param title
     * @param popUpWidth
     * @param popUpHeight
     * @param popupWindowAttributes
     * @ignore
     * @hidden
     */ openPopup(urlNavigate, popupParams) {
        try {
            let popupWindow;
            // Popup window passed in, setting url to navigate to
            if (popupParams.popup) {
                popupWindow = popupParams.popup;
                this.logger.verbosePii(`Navigating popup window to: ${urlNavigate}`);
                popupWindow.location.assign(urlNavigate);
            } else if (typeof popupParams.popup === "undefined") {
                // Popup will be undefined if it was not passed in
                this.logger.verbosePii(`Opening popup window to: ${urlNavigate}`);
                popupWindow = this.openSizedPopup(urlNavigate, popupParams);
            }
            // Popup will be null if popups are blocked
            if (!popupWindow) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$5e827e513523a576));
            if (popupWindow.focus) popupWindow.focus();
            this.currentWindow = popupWindow;
            popupParams.popupWindowParent.addEventListener("beforeunload", this.unloadWindow);
            return popupWindow;
        } catch (e) {
            this.logger.error("error opening popup " + e.message);
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$f1b7091ee48d0b3e));
        }
    }
    /**
     * Helper function to set popup window dimensions and position
     * @param urlNavigate
     * @param popupName
     * @param popupWindowAttributes
     * @returns
     */ openSizedPopup(urlNavigate, { popupName: popupName, popupWindowAttributes: popupWindowAttributes, popupWindowParent: popupWindowParent }) {
        /**
         * adding winLeft and winTop to account for dual monitor
         * using screenLeft and screenTop for IE8 and earlier
         */ const winLeft = popupWindowParent.screenLeft ? popupWindowParent.screenLeft : popupWindowParent.screenX;
        const winTop = popupWindowParent.screenTop ? popupWindowParent.screenTop : popupWindowParent.screenY;
        /**
         * window.innerWidth displays browser window"s height and width excluding toolbars
         * using document.documentElement.clientWidth for IE8 and earlier
         */ const winWidth = popupWindowParent.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const winHeight = popupWindowParent.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        let width = popupWindowAttributes.popupSize?.width;
        let height = popupWindowAttributes.popupSize?.height;
        let top = popupWindowAttributes.popupPosition?.top;
        let left = popupWindowAttributes.popupPosition?.left;
        if (!width || width < 0 || width > winWidth) {
            this.logger.verbose("Default popup window width used. Window width not configured or invalid.");
            width = (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_WIDTH;
        }
        if (!height || height < 0 || height > winHeight) {
            this.logger.verbose("Default popup window height used. Window height not configured or invalid.");
            height = (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_HEIGHT;
        }
        if (!top || top < 0 || top > winHeight) {
            this.logger.verbose("Default popup window top position used. Window top not configured or invalid.");
            top = Math.max(0, winHeight / 2 - (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_HEIGHT / 2 + winTop);
        }
        if (!left || left < 0 || left > winWidth) {
            this.logger.verbose("Default popup window left position used. Window left not configured or invalid.");
            left = Math.max(0, winWidth / 2 - (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_WIDTH / 2 + winLeft);
        }
        return popupWindowParent.open(urlNavigate, popupName, `width=${width}, height=${height}, top=${top}, left=${left}, scrollbars=yes`);
    }
    /**
     * Event callback to unload main window.
     */ unloadWindow(e) {
        if (this.currentWindow) this.currentWindow.close();
        // Guarantees browser unload will happen, so no other errors will be thrown.
        e.preventDefault();
    }
    /**
     * Closes popup, removes any state vars created during popup calls.
     * @param popupWindow
     */ cleanPopup(popupWindow, popupWindowParent) {
        // Close window.
        popupWindow.close();
        // Remove window unload function
        popupWindowParent.removeEventListener("beforeunload", this.unloadWindow);
    }
    /**
     * Generates the name for the popup based on the client id and request
     * @param clientId
     * @param request
     */ generatePopupName(scopes, authority) {
        return `${(0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${scopes.join("-")}.${authority}.${this.correlationId}`;
    }
    /**
     * Generates the name for the popup based on the client id and request for logouts
     * @param clientId
     * @param request
     */ generateLogoutPopupName(request) {
        const homeAccountId = request.account && request.account.homeAccountId;
        return `${(0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${homeAccountId}.${this.correlationId}`;
    }
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 











'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9c96cbdf0340174c$var$getNavigationType() {
    if (typeof window === "undefined" || typeof window.performance === "undefined" || typeof window.performance.getEntriesByType !== "function") return undefined;
    const navigationEntries = window.performance.getEntriesByType("navigation");
    const navigation = navigationEntries.length ? navigationEntries[0] : undefined;
    return navigation?.type;
}
class $9c96cbdf0340174c$export$a368977effbc1ed6 extends (0, $5d00224fcf1f9e62$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, platformAuthHandler, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, platformAuthHandler, correlationId);
        this.nativeStorage = nativeStorageImpl;
    }
    /**
     * Redirects the page to the /authorize endpoint of the IDP
     * @param request
     */ async acquireToken(request) {
        const validRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(request, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
        validRequest.platformBroker = (0, $1ef3eb788d38d5ed$export$4815cc9f88d4f6a5)(this.config, this.logger, this.platformAuthProvider, request.authenticationScheme);
        const handleBackButton = (event)=>{
            // Clear temporary cache if the back button is clicked during the redirect flow.
            if (event.persisted) {
                this.logger.verbose("Page was restored from back/forward cache. Clearing temporary cache.");
                this.browserStorage.resetRequestCache();
                this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).RESTORE_FROM_BFCACHE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
            }
        };
        const redirectStartPage = this.getRedirectStartPage(request.redirectStartPage);
        this.logger.verbosePii(`Redirect start page: ${redirectStartPage}`);
        // Cache start page, returns to this page after redirectUri if navigateToLoginRequestUrl is true
        this.browserStorage.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).ORIGIN_URI, redirectStartPage, true);
        // Clear temporary cache if the back button is clicked during the redirect flow.
        window.addEventListener("pageshow", handleBackButton);
        try {
            if (this.config.auth.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).EAR) await this.executeEarFlow(validRequest);
            else await this.executeCodeFlow(validRequest, request.onRedirectNavigate);
        } catch (e) {
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) e.setCorrelationId(this.correlationId);
            window.removeEventListener("pageshow", handleBackButton);
            throw e;
        }
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @returns
     */ async executeCodeFlow(request, onRedirectNavigate) {
        const correlationId = request.correlationId;
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenRedirect);
        const pkceCodes = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $cab7ad26b4a73b7b$export$91d5e5a023803853), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const redirectRequest = {
            ...request,
            codeChallenge: pkceCodes.challenge
        };
        this.browserStorage.cacheAuthorizeRequest(redirectRequest, pkceCodes.verifier);
        try {
            // Initialize the client
            const authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: redirectRequest.authority,
                requestAzureCloudOptions: redirectRequest.azureCloudOptions,
                requestExtraQueryParameters: redirectRequest.extraQueryParameters,
                account: redirectRequest.account
            });
            // Create acquire token url.
            const navigateUrl = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$a256231ce8625983), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GetAuthCodeUrl, this.logger, this.performanceClient, request.correlationId)(this.config, authClient.authority, redirectRequest, this.logger, this.performanceClient);
            // Show the UI once the url has been created. Response will come back in the hash, which will be handled in the handleRedirectCallback function.
            return await this.initiateAuthRequest(navigateUrl, onRedirectNavigate);
        } catch (e) {
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request) {
        const correlationId = request.correlationId;
        // Get the frame handle for the silent request
        const discoveredAuthority = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)({
            requestAuthority: request.authority,
            requestAzureCloudOptions: request.azureCloudOptions,
            requestExtraQueryParameters: request.extraQueryParameters,
            account: request.account
        });
        const earJwk = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$95528b8a314880d1), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateEarKey, this.logger, this.performanceClient, correlationId)();
        const redirectRequest = {
            ...request,
            earJwk: earJwk
        };
        this.browserStorage.cacheAuthorizeRequest(redirectRequest);
        const form = await (0, $2a64db28ce4fd109$export$3c140ef19fa8de34)(document, this.config, discoveredAuthority, redirectRequest, this.logger, this.performanceClient);
        form.submit();
    }
    /**
     * Checks if navigateToLoginRequestUrl is set, and:
     * - if true, performs logic to cache and navigate
     * - if false, handles hash string and parses response
     * @param hash {string} url hash
     * @param parentMeasurement {InProgressPerformanceEvent} parent measurement
     */ async handleRedirectPromise(hash = "", request, pkceVerifier, parentMeasurement) {
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).handleRedirectPromise);
        try {
            const [serverParams, responseString] = this.getRedirectResponse(hash || "");
            if (!serverParams) {
                // Not a recognized server response hash or hash not associated with a redirect request
                this.logger.info("handleRedirectPromise did not detect a response as a result of a redirect. Cleaning temporary cache.");
                this.browserStorage.resetRequestCache();
                // Do not instrument "no_server_response" if user clicked back button
                if ($9c96cbdf0340174c$var$getNavigationType() !== "back_forward") parentMeasurement.event.errorCode = "no_server_response";
                else this.logger.verbose("Back navigation event detected. Muting no_server_response error");
                return null;
            }
            // If navigateToLoginRequestUrl is true, get the url where the redirect request was initiated
            const loginRequestUrl = this.browserStorage.getTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).ORIGIN_URI, true) || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
            const loginRequestUrlNormalized = (0, $f7f911f196324278$export$3abcdca7229e54f2).removeHashFromUrl(loginRequestUrl);
            const currentUrlNormalized = (0, $f7f911f196324278$export$3abcdca7229e54f2).removeHashFromUrl(window.location.href);
            if (loginRequestUrlNormalized === currentUrlNormalized && this.config.auth.navigateToLoginRequestUrl) {
                // We are on the page we need to navigate to - handle hash
                this.logger.verbose("Current page is loginRequestUrl, handling response");
                if (loginRequestUrl.indexOf("#") > -1) // Replace current hash with non-msal hash, if present
                (0, $3003b661a087a867$export$9bf2691bda54425c)(loginRequestUrl);
                const handleHashResult = await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
                return handleHashResult;
            } else if (!this.config.auth.navigateToLoginRequestUrl) {
                this.logger.verbose("NavigateToLoginRequestUrl set to false, handling response");
                return await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
            } else if (!(0, $3003b661a087a867$export$9f140ed41af5108c)() || this.config.system.allowRedirectInIframe) {
                /*
                 * Returned from authority using redirect - need to perform navigation before processing response
                 * Cache the hash to be retrieved after the next redirect
                 */ this.browserStorage.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).URL_HASH, responseString, true);
                const navigationOptions = {
                    apiId: (0, $5ff55562d73e0e2b$export$192d74ad69b40705).handleRedirectPromise,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: true
                };
                /**
                 * Default behavior is to redirect to the start page and not process the hash now.
                 * The start page is expected to also call handleRedirectPromise which will process the hash in one of the checks above.
                 */ let processHashOnRedirect = true;
                if (!loginRequestUrl || loginRequestUrl === "null") {
                    // Redirect to home page if login request url is null (real null or the string null)
                    const homepage = (0, $3003b661a087a867$export$60785768478b4ffc)();
                    // Cache the homepage under ORIGIN_URI to ensure cached hash is processed on homepage
                    this.browserStorage.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).ORIGIN_URI, homepage, true);
                    this.logger.warning("Unable to get valid login request url from cache, redirecting to home page");
                    processHashOnRedirect = await this.navigationClient.navigateInternal(homepage, navigationOptions);
                } else {
                    // Navigate to page that initiated the redirect request
                    this.logger.verbose(`Navigating to loginRequestUrl: ${loginRequestUrl}`);
                    processHashOnRedirect = await this.navigationClient.navigateInternal(loginRequestUrl, navigationOptions);
                }
                // If navigateInternal implementation returns false, handle the hash now
                if (!processHashOnRedirect) return await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
            }
            return null;
        } catch (e) {
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Gets the response hash for a redirect request
     * Returns null if interactionType in the state value is not "redirect" or the hash does not contain known properties
     * @param hash
     */ getRedirectResponse(userProvidedResponse) {
        this.logger.verbose("getRedirectResponseHash called");
        // Get current location hash from window or cache.
        let responseString = userProvidedResponse;
        if (!responseString) {
            if (this.config.auth.OIDCOptions.serverResponseType === (0, $7c375ae106b964be$export$b34cb6fbea2adc44).QUERY) responseString = window.location.search;
            else responseString = window.location.hash;
        }
        let response = (0, $0763983a1d35c4b8$exports).getDeserializedResponse(responseString);
        if (response) {
            try {
                (0, $9c7efd3c039fd7d9$export$af0c72d18284aa0)(response, this.browserCrypto, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
            } catch (e) {
                if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) this.logger.error(`Interaction type validation failed due to ${e.errorCode}: ${e.errorMessage}`);
                return [
                    null,
                    ""
                ];
            }
            (0, $3003b661a087a867$export$a20c3032ba81d6aa)(window);
            this.logger.verbose("Hash contains known properties, returning response hash");
            return [
                response,
                responseString
            ];
        }
        const cachedHash = this.browserStorage.getTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).URL_HASH, true);
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).URL_HASH));
        if (cachedHash) {
            response = (0, $0763983a1d35c4b8$exports).getDeserializedResponse(cachedHash);
            if (response) {
                this.logger.verbose("Hash does not contain known properties, returning cached hash");
                return [
                    response,
                    cachedHash
                ];
            }
        }
        return [
            null,
            ""
        ];
    }
    /**
     * Checks if hash exists and handles in window.
     * @param hash
     * @param state
     */ async handleResponse(serverParams, request, codeVerifier, serverTelemetryManager) {
        const state = serverParams.state;
        if (!state) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$211c8e8843a8d278));
        if (serverParams.ear_jwe) {
            const discoveredAuthority = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, request.correlationId)({
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account
            });
            return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$21aeb02dac823516), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleResponseEar, this.logger, this.performanceClient, request.correlationId)(request, serverParams, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenRedirect, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        }
        const authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: serverTelemetryManager,
            requestAuthority: request.authority
        });
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$907304a743d3578a), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleResponseCode, this.logger, this.performanceClient, request.correlationId)(request, serverParams, codeVerifier, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenRedirect, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     * Redirects window to given URL.
     * @param urlNavigate
     * @param onRedirectNavigateRequest - onRedirectNavigate callback provided on the request
     */ async initiateAuthRequest(requestUrl, onRedirectNavigateRequest) {
        this.logger.verbose("RedirectHandler.initiateAuthRequest called");
        // Navigate if valid URL
        if (requestUrl) {
            this.logger.infoPii(`RedirectHandler.initiateAuthRequest: Navigate to: ${requestUrl}`);
            const navigationOptions = {
                apiId: (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenRedirect,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: false
            };
            const onRedirectNavigate = onRedirectNavigateRequest || this.config.auth.onRedirectNavigate;
            // If onRedirectNavigate is implemented, invoke it and provide requestUrl
            if (typeof onRedirectNavigate === "function") {
                this.logger.verbose("RedirectHandler.initiateAuthRequest: Invoking onRedirectNavigate callback");
                const navigate = onRedirectNavigate(requestUrl);
                // Returning false from onRedirectNavigate will stop navigation
                if (navigate !== false) {
                    this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate did not return false, navigating");
                    await this.navigationClient.navigateExternal(requestUrl, navigationOptions);
                    return;
                } else {
                    this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate returned false, stopping navigation");
                    return;
                }
            } else {
                // Navigate window to request URL
                this.logger.verbose("RedirectHandler.initiateAuthRequest: Navigating window to navigate url");
                await this.navigationClient.navigateExternal(requestUrl, navigationOptions);
                return;
            }
        } else {
            // Throw error if request URL is empty.
            this.logger.info("RedirectHandler.initiateAuthRequest: Navigate url is empty");
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$be9285c64f247822));
        }
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logout(logoutRequest) {
        this.logger.verbose("logoutRedirect called");
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).logout);
        try {
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, logoutRequest);
            // Clear cache on logout
            await this.clearCacheOnLogout(validLogoutRequest.account);
            const navigationOptions = {
                apiId: (0, $5ff55562d73e0e2b$export$192d74ad69b40705).logout,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: false
            };
            const authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: logoutRequest && logoutRequest.authority,
                requestExtraQueryParameters: logoutRequest?.extraQueryParameters,
                account: logoutRequest && logoutRequest.account || undefined
            });
            if (authClient.authority.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC) try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validLogoutRequest.account?.homeAccountId) {
                    this.browserStorage.removeAccount(validLogoutRequest.account?.homeAccountId);
                    this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, validLogoutRequest);
                    return;
                }
            }
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validLogoutRequest);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, validLogoutRequest);
            // Check if onRedirectNavigate is implemented, and invoke it if so
            if (logoutRequest && typeof logoutRequest.onRedirectNavigate === "function") {
                const navigate = logoutRequest.onRedirectNavigate(logoutUri);
                if (navigate !== false) {
                    this.logger.verbose("Logout onRedirectNavigate did not return false, navigating");
                    // Ensure interaction is in progress
                    if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true, (0, $5ff55562d73e0e2b$export$dc1d3aa5f3837765).SIGNOUT);
                    await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                    return;
                } else {
                    // Ensure interaction is not in progress
                    this.browserStorage.setInteractionInProgress(false);
                    this.logger.verbose("Logout onRedirectNavigate returned false, stopping navigation");
                }
            } else {
                // Ensure interaction is in progress
                if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true, (0, $5ff55562d73e0e2b$export$dc1d3aa5f3837765).SIGNOUT);
                await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                return;
            }
        } catch (e) {
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, null, e);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_END, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
            throw e;
        }
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_END, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
    }
    /**
     * Use to get the redirectStartPage either from request or use current window
     * @param requestStartPage
     */ getRedirectStartPage(requestStartPage) {
        const redirectStartPage = requestStartPage || window.location.href;
        return (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl(redirectStartPage, (0, $3003b661a087a867$export$1204531fbbf6ecde)());
    }
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 



/*! @azure/msal-browser v4.13.1 2025-06-10 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Creates a hidden iframe to given URL using user-requested scopes as an id.
 * @param urlNavigate
 * @param userRequestScopes
 */ async function $b4d2944d1c7d2c68$export$b5cc8574c3c26d11(requestUrl, performanceClient, logger, correlationId, navigateFrameWait) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, correlationId);
    if (!requestUrl) {
        // Throw error if request URL is empty.
        logger.info("Navigate url is empty");
        throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$be9285c64f247822));
    }
    if (navigateFrameWait) return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)($b4d2944d1c7d2c68$var$loadFrame, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerLoadFrame, logger, performanceClient, correlationId)(requestUrl, navigateFrameWait, performanceClient, correlationId);
    return (0, $5386add07ebe4b6d$export$468cda29b159ee5d)($b4d2944d1c7d2c68$var$loadFrameSync, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerLoadFrameSync, logger, performanceClient, correlationId)(requestUrl);
}
async function $b4d2944d1c7d2c68$export$dfeea08a8aa03859(config, authority, request, logger, performanceClient) {
    const frame = $b4d2944d1c7d2c68$var$createHiddenIframe();
    if (!frame.contentDocument) throw "No document associated with iframe!";
    const form = await (0, $2a64db28ce4fd109$export$3c140ef19fa8de34)(frame.contentDocument, config, authority, request, logger, performanceClient);
    form.submit();
    return frame;
}
/**
 * Monitors an iframe content window until it loads a url with a known hash, or hits a specified timeout.
 * @param iframe
 * @param timeout
 */ async function $b4d2944d1c7d2c68$export$9ee275d2f26db8a7(iframe, timeout, pollIntervalMilliseconds, performanceClient, logger, correlationId, responseType) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, correlationId);
    return new Promise((resolve, reject)=>{
        if (timeout < (0, $68fb5a78014bcfe7$export$f3ffe700be354b19)) logger.warning(`system.loadFrameTimeout or system.iframeHashTimeout set to lower (${timeout}ms) than the default (${(0, $68fb5a78014bcfe7$export$f3ffe700be354b19)}ms). This may result in timeouts.`);
        /*
         * Polling for iframes can be purely timing based,
         * since we don't need to account for interaction.
         */ const timeoutId = window.setTimeout(()=>{
            window.clearInterval(intervalId);
            reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$c8b6efb19551013d)));
        }, timeout);
        const intervalId = window.setInterval(()=>{
            let href = "";
            const contentWindow = iframe.contentWindow;
            try {
                /*
                 * Will throw if cross origin,
                 * which should be caught and ignored
                 * since we need the interval to keep running while on STS UI.
                 */ href = contentWindow ? contentWindow.location.href : "";
            } catch (e) {}
            if (!href || href === "about:blank") return;
            let responseString = "";
            if (contentWindow) {
                if (responseType === (0, $7c375ae106b964be$export$b34cb6fbea2adc44).QUERY) responseString = contentWindow.location.search;
                else responseString = contentWindow.location.hash;
            }
            window.clearTimeout(timeoutId);
            window.clearInterval(intervalId);
            resolve(responseString);
        }, pollIntervalMilliseconds);
    }).finally(()=>{
        (0, $5386add07ebe4b6d$export$468cda29b159ee5d)($b4d2944d1c7d2c68$var$removeHiddenIframe, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RemoveHiddenIframe, logger, performanceClient, correlationId)(iframe);
    });
}
/**
 * @hidden
 * Loads iframe with authorization endpoint URL
 * @ignore
 * @deprecated
 */ function $b4d2944d1c7d2c68$var$loadFrame(urlNavigate, navigateFrameWait, performanceClient, correlationId) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerLoadFrame, correlationId);
    /*
     * This trick overcomes iframe navigation in IE
     * IE does not load the page consistently in iframe
     */ return new Promise((resolve, reject)=>{
        const frameHandle = $b4d2944d1c7d2c68$var$createHiddenIframe();
        window.setTimeout(()=>{
            if (!frameHandle) {
                reject("Unable to load iframe");
                return;
            }
            frameHandle.src = urlNavigate;
            resolve(frameHandle);
        }, navigateFrameWait);
    });
}
/**
 * @hidden
 * Loads the iframe synchronously when the navigateTimeFrame is set to `0`
 * @param urlNavigate
 * @param frameName
 * @param logger
 */ function $b4d2944d1c7d2c68$var$loadFrameSync(urlNavigate) {
    const frameHandle = $b4d2944d1c7d2c68$var$createHiddenIframe();
    frameHandle.src = urlNavigate;
    return frameHandle;
}
/**
 * @hidden
 * Creates a new hidden iframe or gets an existing one for silent token renewal.
 * @ignore
 */ function $b4d2944d1c7d2c68$var$createHiddenIframe() {
    const authFrame = document.createElement("iframe");
    authFrame.className = "msalSilentIframe";
    authFrame.style.visibility = "hidden";
    authFrame.style.position = "absolute";
    authFrame.style.width = authFrame.style.height = "0";
    authFrame.style.border = "0";
    authFrame.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms");
    document.body.appendChild(authFrame);
    return authFrame;
}
/**
 * @hidden
 * Removes a hidden iframe from the page.
 * @ignore
 */ function $b4d2944d1c7d2c68$var$removeHiddenIframe(iframe) {
    if (document.body === iframe.parentNode) document.body.removeChild(iframe);
}









'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $73772bb7ece2a11b$export$e81c7938bccef977 extends (0, $5d00224fcf1f9e62$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, nativeStorageImpl, platformAuthProvider, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, platformAuthProvider, correlationId);
        this.apiId = apiId;
        this.nativeStorage = nativeStorageImpl;
    }
    /**
     * Acquires a token silently by opening a hidden iframe to the /authorize endpoint with prompt=none or prompt=no_session
     * @param request
     */ async acquireToken(request) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentIframeClientAcquireToken, request.correlationId);
        // Check that we have some SSO data
        if (!request.loginHint && !request.sid && (!request.account || !request.account.username)) this.logger.warning("No user hint provided. The authorization server may need more information to complete this request.");
        // Check the prompt value
        const inputRequest = {
            ...request
        };
        if (inputRequest.prompt) {
            if (inputRequest.prompt !== (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE && inputRequest.prompt !== (0, $7c375ae106b964be$export$49a06cbda5acaa5).NO_SESSION) {
                this.logger.warning(`SilentIframeClient. Replacing invalid prompt ${inputRequest.prompt} with ${(0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE}`);
                inputRequest.prompt = (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE;
            }
        } else inputRequest.prompt = (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE;
        // Create silent request
        const silentRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, request.correlationId)(inputRequest, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent);
        silentRequest.platformBroker = (0, $1ef3eb788d38d5ed$export$4815cc9f88d4f6a5)(this.config, this.logger, this.platformAuthProvider, silentRequest.authenticationScheme);
        (0, $3003b661a087a867$export$a0816fa17a9e79be)(silentRequest.authority);
        if (this.config.auth.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).EAR) return this.executeEarFlow(silentRequest);
        else return this.executeCodeFlow(silentRequest);
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @returns
     */ async executeCodeFlow(request) {
        let authClient;
        const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
        try {
            // Initialize the client
            authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, request.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account
            });
            return await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.silentTokenHelper.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, this.logger, this.performanceClient, request.correlationId)(authClient, request);
        } catch (e) {
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            if (!authClient || !(e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) || e.errorCode !== (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).INVALID_GRANT_ERROR) throw e;
            this.performanceClient.addFields({
                retryError: e.errorCode
            }, this.correlationId);
            return await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.silentTokenHelper.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, this.logger, this.performanceClient, this.correlationId)(authClient, request);
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request) {
        const correlationId = request.correlationId;
        const discoveredAuthority = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)({
            requestAuthority: request.authority,
            requestAzureCloudOptions: request.azureCloudOptions,
            requestExtraQueryParameters: request.extraQueryParameters,
            account: request.account
        });
        const earJwk = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$95528b8a314880d1), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateEarKey, this.logger, this.performanceClient, correlationId)();
        const silentRequest = {
            ...request,
            earJwk: earJwk
        };
        const msalFrame = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $b4d2944d1c7d2c68$export$dfeea08a8aa03859), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, this.logger, this.performanceClient, correlationId)(this.config, discoveredAuthority, silentRequest, this.logger, this.performanceClient);
        const responseType = this.config.auth.OIDCOptions.serverResponseType;
        // Monitor the window for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $b4d2944d1c7d2c68$export$9ee275d2f26db8a7), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(msalFrame, this.config.system.iframeHashTimeout, this.config.system.pollIntervalMilliseconds, this.performanceClient, this.logger, correlationId, responseType);
        const serverParams = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)((0, $9c7efd3c039fd7d9$export$e64c1808ed72a7c), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, correlationId)(responseString, responseType, this.logger);
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$21aeb02dac823516), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleResponseEar, this.logger, this.performanceClient, correlationId)(silentRequest, serverParams, this.apiId, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$78523a40be105a03)));
    }
    /**
     * Helper which acquires an authorization code silently using a hidden iframe from given url
     * using the scopes requested as part of the id, and exchanges the code for a set of OAuth tokens.
     * @param navigateUrl
     * @param userRequestScopes
     */ async silentTokenHelper(authClient, request) {
        const correlationId = request.correlationId;
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, correlationId);
        const pkceCodes = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $cab7ad26b4a73b7b$export$91d5e5a023803853), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const silentRequest = {
            ...request,
            codeChallenge: pkceCodes.challenge
        };
        // Create authorize request url
        const navigateUrl = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$a256231ce8625983), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GetAuthCodeUrl, this.logger, this.performanceClient, correlationId)(this.config, authClient.authority, silentRequest, this.logger, this.performanceClient);
        // Get the frame handle for the silent request
        const msalFrame = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $b4d2944d1c7d2c68$export$b5cc8574c3c26d11), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, this.logger, this.performanceClient, correlationId)(navigateUrl, this.performanceClient, this.logger, correlationId, this.config.system.navigateFrameWait);
        const responseType = this.config.auth.OIDCOptions.serverResponseType;
        // Monitor the window for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $b4d2944d1c7d2c68$export$9ee275d2f26db8a7), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(msalFrame, this.config.system.iframeHashTimeout, this.config.system.pollIntervalMilliseconds, this.performanceClient, this.logger, correlationId, responseType);
        const serverParams = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)((0, $9c7efd3c039fd7d9$export$e64c1808ed72a7c), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, correlationId)(responseString, responseType, this.logger);
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$907304a743d3578a), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleResponseCode, this.logger, this.performanceClient, correlationId)(request, serverParams, pkceCodes.verifier, this.apiId, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 
/*! @azure/msal-common v15.7.0 2025-05-30 */ 
























'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $bf3b67e227c05f73$var$DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS = 300; // 5 Minutes
/**
 * OAuth2.0 refresh token client
 * @internal
 */ class $bf3b67e227c05f73$export$9cb096b89b92d8a8 extends (0, $3b13384e79a725db$export$4f22f74eddb7716a) {
    constructor(configuration, performanceClient){
        super(configuration, performanceClient);
    }
    async acquireToken(request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireToken, request.correlationId);
        const reqTimestamp = (0, $0a4a8f22735f9ff5$export$ae62599a119ac50a)();
        const response = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.executeTokenRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientExecuteTokenRequest, this.logger, this.performanceClient, request.correlationId)(request, this.authority);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[(0, $7c375ae106b964be$export$28d77f87efed1d88).X_MS_REQUEST_ID];
        const responseHandler = new (0, $4039fad97bcf28f6$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
        responseHandler.validateTokenResponse(response.body);
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleServerTokenResponse, this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, undefined, undefined, true, request.forceCache, requestId);
    }
    /**
     * Gets cached refresh token and attaches to request, then calls acquireToken API
     * @param request
     */ async acquireTokenByRefreshToken(request) {
        // Cannot renew token if no request object is given.
        if (!request) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$eca67ff7a91fed9d));
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenByRefreshToken, request.correlationId);
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$5a3c7d1c90ac9220));
        // try checking if FOCI is enabled for the given application
        const isFOCI = this.cacheManager.isAppMetadataFOCI(request.account.environment);
        // if the app is part of the family, retrive a Family refresh token if present and make a refreshTokenRequest
        if (isFOCI) try {
            return await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, true);
        } catch (e) {
            const noFamilyRTInCache = e instanceof (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba) && e.errorCode === (0, $84767569d86b0bc0$export$e408b083cd212696);
            const clientMismatchErrorWithFamilyRT = e instanceof (0, $016e46db2c2afa86$export$ea52035eac03daf0) && e.errorCode === (0, $7c375ae106b964be$export$b8e9cd941e8016ac).INVALID_GRANT_ERROR && e.subError === (0, $7c375ae106b964be$export$b8e9cd941e8016ac).CLIENT_MISMATCH_ERROR;
            // if family Refresh Token (FRT) cache acquisition fails or if client_mismatch error is seen with FRT, reattempt with application Refresh Token (ART)
            if (noFamilyRTInCache || clientMismatchErrorWithFamilyRT) return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, false);
            else throw e;
        }
        // fall back to application refresh token acquisition
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, false);
    }
    /**
     * makes a network call to acquire tokens by exchanging RefreshToken available in userCache; throws if refresh token is not cached
     * @param request
     */ async acquireTokenWithCachedRefreshToken(request, foci) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
        // fetches family RT or application RT based on FOCI value
        const refreshToken = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)(this.cacheManager.getRefreshToken.bind(this.cacheManager), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).CacheManagerGetRefreshToken, this.logger, this.performanceClient, request.correlationId)(request.account, foci, undefined, this.performanceClient, request.correlationId);
        if (!refreshToken) throw (0, $18a94acc3dad87ad$export$8f7a741750c16535)((0, $84767569d86b0bc0$export$e408b083cd212696));
        if (refreshToken.expiresOn && (0, $0a4a8f22735f9ff5$export$b007d77a962aa175)(refreshToken.expiresOn, request.refreshTokenExpirationOffsetSeconds || $bf3b67e227c05f73$var$DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS)) {
            this.performanceClient?.addFields({
                rtExpiresOnMs: Number(refreshToken.expiresOn)
            }, request.correlationId);
            throw (0, $18a94acc3dad87ad$export$8f7a741750c16535)((0, $84767569d86b0bc0$export$a90e8b9c10991b49));
        }
        // attach cached RT size to the current measurement
        const refreshTokenRequest = {
            ...request,
            refreshToken: refreshToken.secret,
            authenticationScheme: request.authenticationScheme || (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER,
            ccsCredential: {
                credential: request.account.homeAccountId,
                type: (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            }
        };
        try {
            return await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireToken.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(refreshTokenRequest);
        } catch (e) {
            if (e instanceof (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)) {
                this.performanceClient?.addFields({
                    rtExpiresOnMs: Number(refreshToken.expiresOn)
                }, request.correlationId);
                if (e.subError === (0, $84767569d86b0bc0$export$2e3666c77d45a4da)) {
                    // Remove bad refresh token from cache
                    this.logger.verbose("acquireTokenWithRefreshToken: bad refresh token, removing from cache");
                    const badRefreshTokenKey = (0, $9ab3d26df56b176d$export$1aaa1362083ec7a3)(refreshToken);
                    this.cacheManager.removeRefreshToken(badRefreshTokenKey);
                }
            }
            throw e;
        }
    }
    /**
     * Constructs the network message and makes a NW call to the underlying secure token service
     * @param request
     * @param authority
     */ async executeTokenRequest(request, authority) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientExecuteTokenRequest, request.correlationId);
        const queryParametersString = this.createTokenQueryParameters(request);
        const endpoint = (0, $f7f911f196324278$export$3abcdca7229e54f2).appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createTokenRequestBody.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientCreateTokenRequestBody, this.logger, this.performanceClient, request.correlationId)(request);
        const headers = this.createTokenRequestHeaders(request.ccsCredential);
        const thumbprint = (0, $762faca86a0f7942$export$2daa8cfcf54c2b48)(this.config.authOptions.clientId, request);
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.executePostToTokenEndpoint.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientExecutePostToTokenEndpoint, this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientExecutePostToTokenEndpoint);
    }
    /**
     * Helper function to create the token request body
     * @param request
     */ async createTokenRequestBody(request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientCreateTokenRequestBody, request.correlationId);
        const parameters = new Map();
        (0, $7d3a00eb36d325b3$export$8360c651f9cc692b)(parameters, request.embeddedClientId || request.tokenBodyParameters?.[0, $b00a7f221d8fdf60$export$c7b1b63f5b60f8e] || this.config.authOptions.clientId);
        if (request.redirectUri) (0, $7d3a00eb36d325b3$export$6758d6264f4f06)(parameters, request.redirectUri);
        (0, $7d3a00eb36d325b3$export$c213bf8f125826ba)(parameters, request.scopes, true, this.config.authOptions.authority.options.OIDCOptions?.defaultScopes);
        (0, $7d3a00eb36d325b3$export$e5f700fdeb4022b2)(parameters, (0, $7c375ae106b964be$export$ce68f19b50b39c0b).REFRESH_TOKEN_GRANT);
        (0, $7d3a00eb36d325b3$export$86b85a101d45e918)(parameters);
        (0, $7d3a00eb36d325b3$export$3ecac3764b147c3f)(parameters, this.config.libraryInfo);
        (0, $7d3a00eb36d325b3$export$37ec1b76d865654a)(parameters, this.config.telemetry.application);
        (0, $7d3a00eb36d325b3$export$26592ae2037df9de)(parameters);
        if (this.serverTelemetryManager && !(0, $d21eb39178ebb5ae$export$25afa7198c2ed9b9)(this.config)) (0, $7d3a00eb36d325b3$export$79fb524b159705e9)(parameters, this.serverTelemetryManager);
        (0, $7d3a00eb36d325b3$export$b9e8ccbb425b80a3)(parameters, request.refreshToken);
        if (this.config.clientCredentials.clientSecret) (0, $7d3a00eb36d325b3$export$8df84bbb0e2465bc)(parameters, this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            (0, $7d3a00eb36d325b3$export$2d3d772920e2496e)(parameters, await (0, $e4969f34ccbe14ce$export$620d3a93bf8b59fb)(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            (0, $7d3a00eb36d325b3$export$55ad911d12112f00)(parameters, clientAssertion.assertionType);
        }
        if (request.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).POP) {
            const popTokenGenerator = new (0, $942a44945e07e21d$export$3dd8467151c83e3e)(this.cryptoUtils, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            (0, $7d3a00eb36d325b3$export$6dfc34809d8c4096)(parameters, reqCnfData);
        } else if (request.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).SSH) {
            if (request.sshJwk) (0, $7d3a00eb36d325b3$export$f004de9a266b8070)(parameters, request.sshJwk);
            else throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$8fbed44b22d9136f));
        }
        if (!(0, $442eacaa0418a38d$export$ecc754f99843e759).isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) (0, $7d3a00eb36d325b3$export$b04c3bca9165ed02)(parameters, request.claims, this.config.authOptions.clientCapabilities);
        if (this.config.systemOptions.preventCorsPreflight && request.ccsCredential) switch(request.ccsCredential.type){
            case (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $7aacd5d6e6d7482c$export$63508a6d6b7dbe07)(request.ccsCredential.credential);
                    (0, $7d3a00eb36d325b3$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $feda987e240ac148$export$17b7b3ac1abef49f).UPN:
                (0, $7d3a00eb36d325b3$export$aa9cca16bcc29d2d)(parameters, request.ccsCredential.credential);
                break;
        }
        if (request.embeddedClientId) (0, $7d3a00eb36d325b3$export$5ea4577e2a518c27)(parameters, this.config.authOptions.clientId, this.config.authOptions.redirectUri);
        if (request.tokenBodyParameters) (0, $7d3a00eb36d325b3$export$1a9f676bcc5d37da)(parameters, request.tokenBodyParameters);
        (0, $7d3a00eb36d325b3$export$7153a1ee4346fa3b)(parameters, request.correlationId, this.performanceClient);
        return (0, $0763983a1d35c4b8$export$44d4663acf79cde2)(parameters);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9a90898a8c83eb8c$export$b4a36596822a5d2 extends (0, $5d00224fcf1f9e62$export$fa9179cade3eb05a) {
    /**
     * Exchanges the refresh token for new tokens
     * @param request
     */ async acquireToken(request) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentRefreshClientAcquireToken, request.correlationId);
        const baseRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $550ae9dc1dae1add$export$8e461fcf1fd6910b), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeBaseRequest, this.logger, this.performanceClient, request.correlationId)(request, this.config, this.performanceClient, this.logger);
        const silentRequest = {
            ...request,
            ...baseRequest
        };
        if (request.redirectUri) // Make sure any passed redirectUri is converted to an absolute URL - redirectUri is not a required parameter for refresh token redemption so only include if explicitly provided
        silentRequest.redirectUri = this.getRedirectUri(request.redirectUri);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenSilent_silentFlow);
        const refreshTokenClient = await this.createRefreshTokenClient({
            serverTelemetryManager: serverTelemetryManager,
            authorityUrl: silentRequest.authority,
            azureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        // Send request to renew token. Auth module will throw errors if token cannot be renewed.
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(refreshTokenClient.acquireTokenByRefreshToken.bind(refreshTokenClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenByRefreshToken, this.logger, this.performanceClient, request.correlationId)(silentRequest).catch((e)=>{
            e.setCorrelationId(this.correlationId);
            serverTelemetryManager.cacheFailedRequest(e);
            throw e;
        });
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$78523a40be105a03)));
    }
    /**
     * Creates a Refresh Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         azureCloudOptions?: AzureCloudOptions;
     *         extraQueryParams?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createRefreshTokenClient(params) {
        // Create auth module.
        const clientConfig = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: params.serverTelemetryManager,
            requestAuthority: params.authorityUrl,
            requestAzureCloudOptions: params.azureCloudOptions,
            requestExtraQueryParameters: params.extraQueryParameters,
            account: params.account
        });
        return new (0, $bf3b67e227c05f73$export$9cb096b89b92d8a8)(clientConfig, this.performanceClient);
    }
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Token cache manager
 */ class $dc748a126de75897$export$ed5d1a18907a1001 {
    constructor(configuration, storage, logger, cryptoObj){
        this.isBrowserEnvironment = typeof window !== "undefined";
        this.config = configuration;
        this.storage = storage;
        this.logger = logger;
        this.cryptoObj = cryptoObj;
    }
    // Move getAllAccounts here and cache utility APIs
    /**
     * API to load tokens to msal-browser cache.
     * @param request
     * @param response
     * @param options
     * @returns `AuthenticationResult` for the response that was loaded.
     */ async loadExternalTokens(request, response, options) {
        if (!this.isBrowserEnvironment) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$932e0f52d657f7fb));
        const correlationId = request.correlationId || (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
        const idTokenClaims = response.id_token ? (0, $b29e27fb146a7ddd$exports).extractTokenClaims(response.id_token, (0, $581fd3df606755c8$export$c62426fdd000a97e)) : undefined;
        const authorityOptions = {
            protocolMode: this.config.auth.protocolMode,
            knownAuthorities: this.config.auth.knownAuthorities,
            cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
            authorityMetadata: this.config.auth.authorityMetadata,
            skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache
        };
        const authority = request.authority ? new (0, $77bb430f4568f6e8$export$f1c6ec2e6d68c49c)((0, $77bb430f4568f6e8$export$f1c6ec2e6d68c49c).generateAuthority(request.authority, request.azureCloudOptions), this.config.system.networkClient, this.storage, authorityOptions, this.logger, request.correlationId || (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)()) : undefined;
        const cacheRecordAccount = await this.loadAccount(request, options.clientInfo || response.client_info || "", correlationId, idTokenClaims, authority);
        const idToken = await this.loadIdToken(response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, cacheRecordAccount.realm, correlationId);
        const accessToken = await this.loadAccessToken(request, response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, cacheRecordAccount.realm, options, correlationId);
        const refreshToken = await this.loadRefreshToken(response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, correlationId);
        return this.generateAuthenticationResult(request, {
            account: cacheRecordAccount,
            idToken: idToken,
            accessToken: accessToken,
            refreshToken: refreshToken
        }, idTokenClaims, authority);
    }
    /**
     * Helper function to load account to msal-browser cache
     * @param idToken
     * @param environment
     * @param clientInfo
     * @param authorityType
     * @param requestHomeAccountId
     * @returns `AccountEntity`
     */ async loadAccount(request, clientInfo, correlationId, idTokenClaims, authority) {
        this.logger.verbose("TokenCache - loading account");
        if (request.account) {
            const accountEntity = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).createFromAccountInfo(request.account);
            await this.storage.setAccount(accountEntity, correlationId);
            return accountEntity;
        } else if (!authority || !clientInfo && !idTokenClaims) {
            this.logger.error("TokenCache - if an account is not provided on the request, authority and either clientInfo or idToken must be provided instead.");
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6acf650331eb5f5f));
        }
        const homeAccountId = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).generateHomeAccountId(clientInfo, authority.authorityType, this.logger, this.cryptoObj, idTokenClaims);
        const claimsTenantId = idTokenClaims?.tid;
        const cachedAccount = (0, $4039fad97bcf28f6$export$73b84062d58a1307)(this.storage, authority, homeAccountId, (0, $581fd3df606755c8$export$c62426fdd000a97e), idTokenClaims, clientInfo, authority.hostnameAndPort, claimsTenantId, undefined, undefined, this.logger);
        await this.storage.setAccount(cachedAccount, correlationId);
        return cachedAccount;
    }
    /**
     * Helper function to load id tokens to msal-browser cache
     * @param idToken
     * @param homeAccountId
     * @param environment
     * @param tenantId
     * @returns `IdTokenEntity`
     */ async loadIdToken(response, homeAccountId, environment, tenantId, correlationId) {
        if (!response.id_token) {
            this.logger.verbose("TokenCache - no id token found in response");
            return null;
        }
        this.logger.verbose("TokenCache - loading id token");
        const idTokenEntity = (0, $9ab3d26df56b176d$exports).createIdTokenEntity(homeAccountId, environment, response.id_token, this.config.auth.clientId, tenantId);
        await this.storage.setIdTokenCredential(idTokenEntity, correlationId);
        return idTokenEntity;
    }
    /**
     * Helper function to load access tokens to msal-browser cache
     * @param request
     * @param response
     * @param homeAccountId
     * @param environment
     * @param tenantId
     * @returns `AccessTokenEntity`
     */ async loadAccessToken(request, response, homeAccountId, environment, tenantId, options, correlationId) {
        if (!response.access_token) {
            this.logger.verbose("TokenCache - no access token found in response");
            return null;
        } else if (!response.expires_in) {
            this.logger.error("TokenCache - no expiration set on the access token. Cannot add it to the cache.");
            return null;
        } else if (!response.scope && (!request.scopes || !request.scopes.length)) {
            this.logger.error("TokenCache - scopes not specified in the request or response. Cannot add token to the cache.");
            return null;
        }
        this.logger.verbose("TokenCache - loading access token");
        const scopes = response.scope ? (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(response.scope) : new (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99)(request.scopes);
        const expiresOn = options.expiresOn || response.expires_in + (0, $0a4a8f22735f9ff5$exports).nowSeconds();
        const extendedExpiresOn = options.extendedExpiresOn || (response.ext_expires_in || response.expires_in) + (0, $0a4a8f22735f9ff5$exports).nowSeconds();
        const accessTokenEntity = (0, $9ab3d26df56b176d$exports).createAccessTokenEntity(homeAccountId, environment, response.access_token, this.config.auth.clientId, tenantId, scopes.printScopes(), expiresOn, extendedExpiresOn, (0, $581fd3df606755c8$export$c62426fdd000a97e));
        await this.storage.setAccessTokenCredential(accessTokenEntity, correlationId);
        return accessTokenEntity;
    }
    /**
     * Helper function to load refresh tokens to msal-browser cache
     * @param request
     * @param response
     * @param homeAccountId
     * @param environment
     * @returns `RefreshTokenEntity`
     */ async loadRefreshToken(response, homeAccountId, environment, correlationId) {
        if (!response.refresh_token) {
            this.logger.verbose("TokenCache - no refresh token found in response");
            return null;
        }
        this.logger.verbose("TokenCache - loading refresh token");
        const refreshTokenEntity = (0, $9ab3d26df56b176d$exports).createRefreshTokenEntity(homeAccountId, environment, response.refresh_token, this.config.auth.clientId, response.foci, undefined, response.refresh_token_expires_in);
        await this.storage.setRefreshTokenCredential(refreshTokenEntity, correlationId);
        return refreshTokenEntity;
    }
    /**
     * Helper function to generate an `AuthenticationResult` for the result.
     * @param request
     * @param idTokenObj
     * @param cacheRecord
     * @param authority
     * @returns `AuthenticationResult`
     */ generateAuthenticationResult(request, cacheRecord, idTokenClaims, authority) {
        let accessToken = "";
        let responseScopes = [];
        let expiresOn = null;
        let extExpiresOn;
        if (cacheRecord?.accessToken) {
            accessToken = cacheRecord.accessToken.secret;
            responseScopes = (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(cacheRecord.accessToken.target).asArray();
            // Access token expiresOn stored in seconds, converting to Date for AuthenticationResult
            expiresOn = (0, $0a4a8f22735f9ff5$exports).toDateFromSeconds(cacheRecord.accessToken.expiresOn);
            extExpiresOn = (0, $0a4a8f22735f9ff5$exports).toDateFromSeconds(cacheRecord.accessToken.extendedExpiresOn);
        }
        const accountEntity = cacheRecord.account;
        return {
            authority: authority ? authority.canonicalAuthority : "",
            uniqueId: cacheRecord.account.localAccountId,
            tenantId: cacheRecord.account.realm,
            scopes: responseScopes,
            account: accountEntity.getAccountInfo(),
            idToken: cacheRecord.idToken?.secret || "",
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken,
            fromCache: true,
            expiresOn: expiresOn,
            correlationId: request.correlationId || "",
            requestId: "",
            extExpiresOn: extExpiresOn,
            familyId: cacheRecord.refreshToken?.familyId || "",
            tokenType: cacheRecord?.accessToken?.tokenType || "",
            state: request.state || "",
            cloudGraphHostName: accountEntity.cloudGraphHostName || "",
            msGraphHost: accountEntity.msGraphHost || "",
            fromNativeBroker: false
        };
    }
}





/*! @azure/msal-browser v4.13.1 2025-06-10 */ 



/*! @azure/msal-browser v4.13.1 2025-06-10 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $2c25b6e1fc2d7d09$export$a2dbbd28e9bce542 extends (0, $7e4376d17ecbf639$export$8538731fd397fb90) {
    constructor(config){
        super(config);
        this.includeRedirectUri = false;
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $74f7d1cf2fd01491$export$d7f5ef311b3e9fca extends (0, $5d00224fcf1f9e62$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, platformAuthProvider, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, platformAuthProvider, correlationId);
        this.apiId = apiId;
    }
    /**
     * Acquires a token silently by redeeming an authorization code against the /token endpoint
     * @param request
     */ async acquireToken(request) {
        // Auth code payload is required
        if (!request.code) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$e502d98cd8d2da43));
        // Create silent request
        const silentRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, request.correlationId)(request, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent);
        const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
        try {
            // Create auth code request (PKCE not needed)
            const authCodeRequest = {
                ...silentRequest,
                code: request.code
            };
            // Initialize the client
            const clientConfig = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, request.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: silentRequest.authority,
                requestAzureCloudOptions: silentRequest.azureCloudOptions,
                requestExtraQueryParameters: silentRequest.extraQueryParameters,
                account: silentRequest.account
            });
            const authClient = new (0, $2c25b6e1fc2d7d09$export$a2dbbd28e9bce542)(clientConfig);
            this.logger.verbose("Auth code client created");
            // Create silent handler
            const interactionHandler = new (0, $e330ed825f42f772$export$a30cd982b4e89bdb)(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
            // Handle auth code parameters from request
            return await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(interactionHandler.handleCodeResponseFromServer.bind(interactionHandler), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleCodeResponseFromServer, this.logger, this.performanceClient, request.correlationId)({
                code: request.code,
                msgraph_host: request.msGraphHost,
                cloud_graph_host_name: request.cloudGraphHostName,
                cloud_instance_host_name: request.cloudInstanceHostName
            }, silentRequest, false);
        } catch (e) {
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$78523a40be105a03)));
    }
}







/*! @azure/msal-browser v4.13.1 2025-06-10 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $ae095a3d7bff7e6f$export$fe0570c25bf19cec(currentClientId, performanceEvent, logger) {
    const frameInstances = // @ts-ignore
    window.msal?.clientIds || [];
    const msalInstanceCount = frameInstances.length;
    const sameClientIdInstanceCount = frameInstances.filter((i)=>i === currentClientId).length;
    if (sameClientIdInstanceCount > 1) logger.warning("There is already an instance of MSAL.js in the window with the same client id.");
    performanceEvent.add({
        msalInstanceCount: msalInstanceCount,
        sameClientIdInstanceCount: sameClientIdInstanceCount
    });
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $1d9f6519fe722240$var$getAccountType(account) {
    const idTokenClaims = account?.idTokenClaims;
    if (idTokenClaims?.tfp || idTokenClaims?.acr) return "B2C";
    if (!idTokenClaims?.tid) return undefined;
    else if (idTokenClaims?.tid === "9188040d-6c67-4c5b-b112-36a304b66dad") return "MSA";
    return "AAD";
}
function $1d9f6519fe722240$var$preflightCheck(initialized, performanceEvent) {
    try {
        (0, $3003b661a087a867$export$4dd091cbdc98b52e)(initialized);
    } catch (e) {
        performanceEvent.end({
            success: false
        }, e);
        throw e;
    }
}
class $1d9f6519fe722240$export$e9d1ef1cb8705404 {
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     */ constructor(operatingContext){
        this.operatingContext = operatingContext;
        this.isBrowserEnvironment = this.operatingContext.isBrowserEnvironment();
        // Set the configuration.
        this.config = operatingContext.getConfig();
        this.initialized = false;
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize the network module class.
        this.networkClient = this.config.system.networkClient;
        // Initialize the navigation client class.
        this.navigationClient = this.config.system.navigationClient;
        // Initialize redirectResponse Map
        this.redirectResponse = new Map();
        // Initial hybrid spa map
        this.hybridAuthCodeResponses = new Map();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        // Initialize the crypto class.
        this.browserCrypto = this.isBrowserEnvironment ? new (0, $e72c2cdc5fe24d6f$export$c274a7f0ebd24b14)(this.logger, this.performanceClient) : (0, $dd88ab1a0b4d3851$export$865f57d401606752);
        this.eventHandler = new (0, $9f61ab73b66f619a$export$ce0ba2422a1c7815)(this.logger);
        // Initialize the browser storage class.
        this.browserStorage = this.isBrowserEnvironment ? new (0, $d3981d5134d5331a$export$44d7291b5c8cc149)(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler, (0, $77bb430f4568f6e8$export$2b9ebf6f25078cc0)(this.config.auth)) : (0, $d3981d5134d5331a$export$8e2d54002f8f6e5d)(this.config.auth.clientId, this.logger, this.performanceClient, this.eventHandler);
        // initialize in memory storage for native flows
        const nativeCacheOptions = {
            cacheLocation: (0, $5ff55562d73e0e2b$export$573384e47a12d835).MemoryStorage,
            temporaryCacheLocation: (0, $5ff55562d73e0e2b$export$573384e47a12d835).MemoryStorage,
            storeAuthStateInCookie: false,
            secureCookies: false,
            cacheMigrationEnabled: false,
            claimsBasedCachingEnabled: false
        };
        this.nativeInternalStorage = new (0, $d3981d5134d5331a$export$44d7291b5c8cc149)(this.config.auth.clientId, nativeCacheOptions, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler);
        // Initialize the token cache
        this.tokenCache = new (0, $dc748a126de75897$export$ed5d1a18907a1001)(this.config, this.browserStorage, this.logger, this.browserCrypto);
        this.activeSilentTokenRequests = new Map();
        // Register listener functions
        this.trackPageVisibility = this.trackPageVisibility.bind(this);
        // Register listener functions
        this.trackPageVisibilityWithMeasurement = this.trackPageVisibilityWithMeasurement.bind(this);
    }
    static async createController(operatingContext, request) {
        const controller = new $1d9f6519fe722240$export$e9d1ef1cb8705404(operatingContext);
        await controller.initialize(request);
        return controller;
    }
    trackPageVisibility(correlationId) {
        if (!correlationId) return;
        this.logger.info("Perf: Visibility change detected");
        this.performanceClient.incrementFields({
            visibilityChangeCount: 1
        }, correlationId);
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest} correlation id
     */ async initialize(request, isBroker) {
        this.logger.trace("initialize called");
        if (this.initialized) {
            this.logger.info("initialize has already been called, exiting early.");
            return;
        }
        if (!this.isBrowserEnvironment) {
            this.logger.info("in non-browser environment, exiting early.");
            this.initialized = true;
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).INITIALIZE_END);
            return;
        }
        const initCorrelationId = request?.correlationId || this.getRequestCorrelationId();
        const allowPlatformBroker = this.config.system.allowPlatformBroker;
        const initMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeClientApplication, initCorrelationId);
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).INITIALIZE_START);
        // Broker applications are initialized twice, so we avoid double-counting it
        if (!isBroker) try {
            this.logMultipleInstances(initMeasurement);
        } catch  {}
        await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.browserStorage.initialize.bind(this.browserStorage), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeCache, this.logger, this.performanceClient, initCorrelationId)(initCorrelationId);
        if (allowPlatformBroker) try {
            // check if platform authentication is available via DOM or browser extension and create relevant handlers
            this.platformAuthProvider = await (0, $1ef3eb788d38d5ed$export$b2c9df3607dc771a)(this.logger, this.performanceClient, initCorrelationId, this.config.system.nativeBrokerHandshakeTimeout);
        } catch (e) {
            this.logger.verbose(e);
        }
        if (!this.config.cache.claimsBasedCachingEnabled) {
            this.logger.verbose("Claims-based caching is disabled. Clearing the previous cache with claims");
            await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.browserStorage.clearTokensAndKeysWithClaims.bind(this.browserStorage), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).ClearTokensAndKeysWithClaims, this.logger, this.performanceClient, initCorrelationId)(this.performanceClient, initCorrelationId);
        }
        this.config.system.asyncPopups && await this.preGeneratePkceCodes(initCorrelationId);
        this.initialized = true;
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).INITIALIZE_END);
        initMeasurement.end({
            allowPlatformBroker: allowPlatformBroker,
            success: true
        });
    }
    // #region Redirect Flow
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ async handleRedirectPromise(hash) {
        this.logger.verbose("handleRedirectPromise called");
        // Block token acquisition before initialize has been called
        (0, $3003b661a087a867$export$630119c5db8b5529)(this.initialized);
        if (this.isBrowserEnvironment) {
            /**
             * Store the promise on the PublicClientApplication instance if this is the first invocation of handleRedirectPromise,
             * otherwise return the promise from the first invocation. Prevents race conditions when handleRedirectPromise is called
             * several times concurrently.
             */ const redirectResponseKey = hash || "";
            let response = this.redirectResponse.get(redirectResponseKey);
            if (typeof response === "undefined") {
                response = this.handleRedirectPromiseInternal(hash);
                this.redirectResponse.set(redirectResponseKey, response);
                this.logger.verbose("handleRedirectPromise has been called for the first time, storing the promise");
            } else this.logger.verbose("handleRedirectPromise has been called previously, returning the result from the first call");
            return response;
        }
        this.logger.verbose("handleRedirectPromise returns null, not browser environment");
        return null;
    }
    /**
     * The internal details of handleRedirectPromise. This is separated out to a helper to allow handleRedirectPromise to memoize requests
     * @param hash
     * @returns
     */ async handleRedirectPromiseInternal(hash) {
        if (!this.browserStorage.isInteractionInProgress(true)) {
            this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
            return null;
        }
        const interactionType = this.browserStorage.getInteractionInProgress()?.type;
        if (interactionType === (0, $5ff55562d73e0e2b$export$dc1d3aa5f3837765).SIGNOUT) {
            this.logger.verbose("handleRedirectPromise removing interaction_in_progress flag and returning null after sign-out");
            this.browserStorage.setInteractionInProgress(false);
            return Promise.resolve(null);
        }
        const loggedInAccounts = this.getAllAccounts();
        const platformBrokerRequest = this.browserStorage.getCachedNativeRequest();
        const useNative = platformBrokerRequest && this.platformAuthProvider && !hash;
        let rootMeasurement;
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).HANDLE_REDIRECT_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
        let redirectResponse;
        try {
            if (useNative && this.platformAuthProvider) {
                rootMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenRedirect, platformBrokerRequest?.correlationId || "");
                this.logger.trace("handleRedirectPromise - acquiring token from native platform");
                const nativeClient = new (0, $e6f06a03b9c6516d$export$3f89612b3fd8831f)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).handleRedirectPromise, this.performanceClient, this.platformAuthProvider, platformBrokerRequest.accountId, this.nativeInternalStorage, platformBrokerRequest.correlationId);
                redirectResponse = (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(nativeClient.handleRedirectPromise.bind(nativeClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleNativeRedirectPromiseMeasurement, this.logger, this.performanceClient, rootMeasurement.event.correlationId)(this.performanceClient, rootMeasurement.event.correlationId);
            } else {
                const [standardRequest, codeVerifier] = this.browserStorage.getCachedRequest();
                const correlationId = standardRequest.correlationId;
                // Reset rootMeasurement now that we have correlationId
                rootMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenRedirect, correlationId);
                this.logger.trace("handleRedirectPromise - acquiring token from web flow");
                const redirectClient = this.createRedirectClient(correlationId);
                redirectResponse = (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(redirectClient.handleRedirectPromise.bind(redirectClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleRedirectPromiseMeasurement, this.logger, this.performanceClient, rootMeasurement.event.correlationId)(hash, standardRequest, codeVerifier, rootMeasurement);
            }
        } catch (e) {
            this.browserStorage.resetRequestCache();
            throw e;
        }
        return redirectResponse.then((result)=>{
            if (result) {
                this.browserStorage.resetRequestCache();
                // Emit login event if number of accounts change
                const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
                if (isLoggingIn) {
                    this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, result);
                    this.logger.verbose("handleRedirectResponse returned result, login success");
                } else {
                    this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, result);
                    this.logger.verbose("handleRedirectResponse returned result, acquire token success");
                }
                rootMeasurement.end({
                    success: true,
                    accountType: $1d9f6519fe722240$var$getAccountType(result.account)
                });
            } else /*
                 * Instrument an event only if an error code is set. Otherwise, discard it when the redirect response
                 * is empty and the error code is missing.
                 */ if (rootMeasurement.event.errorCode) rootMeasurement.end({
                success: false
            });
            else rootMeasurement.discard();
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).HANDLE_REDIRECT_END, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
            return result;
        }).catch((e)=>{
            this.browserStorage.resetRequestCache();
            const eventError = e;
            // Emit login event if there is an account
            if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, null, eventError);
            else this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, null, eventError);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).HANDLE_REDIRECT_END, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
            rootMeasurement.end({
                success: false
            }, eventError);
            throw e;
        });
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async acquireTokenRedirect(request) {
        // Preflight request
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("acquireTokenRedirect called", correlationId);
        const atrMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenPreRedirect, correlationId);
        atrMeasurement.add({
            accountType: $1d9f6519fe722240$var$getAccountType(request.account),
            scenarioId: request.scenarioId
        });
        // Override on request only if set, as onRedirectNavigate field is deprecated
        const onRedirectNavigateCb = request.onRedirectNavigate;
        if (onRedirectNavigateCb) request.onRedirectNavigate = (url)=>{
            const navigate = typeof onRedirectNavigateCb === "function" ? onRedirectNavigateCb(url) : undefined;
            if (navigate !== false) atrMeasurement.end({
                success: true
            });
            else atrMeasurement.discard();
            return navigate;
        };
        else {
            const configOnRedirectNavigateCb = this.config.auth.onRedirectNavigate;
            this.config.auth.onRedirectNavigate = (url)=>{
                const navigate = typeof configOnRedirectNavigateCb === "function" ? configOnRedirectNavigateCb(url) : undefined;
                if (navigate !== false) atrMeasurement.end({
                    success: true
                });
                else atrMeasurement.discard();
                return navigate;
            };
        }
        // If logged in, emit acquire token events
        const isLoggedIn = this.getAllAccounts().length > 0;
        try {
            (0, $3003b661a087a867$export$62c8f4fdca4df60f)(this.initialized, this.config);
            this.browserStorage.setInteractionInProgress(true, (0, $5ff55562d73e0e2b$export$dc1d3aa5f3837765).SIGNIN);
            if (isLoggedIn) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, request);
            else this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, request);
            let result;
            if (this.platformAuthProvider && this.canUsePlatformBroker(request)) {
                const nativeClient = new (0, $e6f06a03b9c6516d$export$3f89612b3fd8831f)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenRedirect, this.performanceClient, this.platformAuthProvider, this.getNativeAccountId(request), this.nativeInternalStorage, correlationId);
                result = nativeClient.acquireTokenRedirect(request, atrMeasurement).catch((e)=>{
                    if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab) && (0, $a5e5dee51df551c2$export$f21e42e365baeb50)(e)) {
                        this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    } else if (e instanceof (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)) {
                        this.logger.verbose("acquireTokenRedirect - Resolving interaction required error thrown by native broker by falling back to web flow");
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    }
                    throw e;
                });
            } else {
                const redirectClient = this.createRedirectClient(correlationId);
                result = redirectClient.acquireToken(request);
            }
            return await result;
        } catch (e) {
            this.browserStorage.resetRequestCache();
            atrMeasurement.end({
                success: false
            }, e);
            if (isLoggedIn) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, null, e);
            else this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, null, e);
            throw e;
        }
    }
    // #endregion
    // #region Popup Flow
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atPopupMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenPopup, correlationId);
        atPopupMeasurement.add({
            scenarioId: request.scenarioId,
            accountType: $1d9f6519fe722240$var$getAccountType(request.account)
        });
        try {
            this.logger.verbose("acquireTokenPopup called", correlationId);
            $1d9f6519fe722240$var$preflightCheck(this.initialized, atPopupMeasurement);
            this.browserStorage.setInteractionInProgress(true, (0, $5ff55562d73e0e2b$export$dc1d3aa5f3837765).SIGNIN);
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
        // If logged in, emit acquire token events
        const loggedInAccounts = this.getAllAccounts();
        if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, request);
        else this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, request);
        let result;
        const pkce = this.getPreGeneratedPkceCodes(correlationId);
        if (this.canUsePlatformBroker(request)) result = this.acquireTokenNative({
            ...request,
            correlationId: correlationId
        }, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenPopup).then((response)=>{
            atPopupMeasurement.end({
                success: true,
                isNativeBroker: true,
                accountType: $1d9f6519fe722240$var$getAccountType(response.account)
            });
            return response;
        }).catch((e)=>{
            if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab) && (0, $a5e5dee51df551c2$export$f21e42e365baeb50)(e)) {
                this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                const popupClient = this.createPopupClient(correlationId);
                return popupClient.acquireToken(request, pkce);
            } else if (e instanceof (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)) {
                this.logger.verbose("acquireTokenPopup - Resolving interaction required error thrown by native broker by falling back to web flow");
                const popupClient = this.createPopupClient(correlationId);
                return popupClient.acquireToken(request, pkce);
            }
            throw e;
        });
        else {
            const popupClient = this.createPopupClient(correlationId);
            result = popupClient.acquireToken(request, pkce);
        }
        return result.then((result)=>{
            /*
             *  If logged in, emit acquire token events
             */ const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
            if (isLoggingIn) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, result);
            else this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, result);
            atPopupMeasurement.end({
                success: true,
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length,
                accountType: $1d9f6519fe722240$var$getAccountType(result.account)
            });
            return result;
        }).catch((e)=>{
            if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, null, e);
            else this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e);
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }).finally(async ()=>{
            this.browserStorage.setInteractionInProgress(false);
            if (this.config.system.asyncPopups) await this.preGeneratePkceCodes(correlationId);
        });
    }
    trackPageVisibilityWithMeasurement() {
        const measurement = this.ssoSilentMeasurement || this.acquireTokenByCodeAsyncMeasurement;
        if (!measurement) return;
        this.logger.info("Perf: Visibility change detected in ", measurement.event.name);
        measurement.increment({
            visibilityChangeCount: 1
        });
    }
    // #endregion
    // #region Silent Flow
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async ssoSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const validRequest = {
            ...request,
            // will be PromptValue.NONE or PromptValue.NO_SESSION
            prompt: request.prompt,
            correlationId: correlationId
        };
        this.ssoSilentMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SsoSilent, correlationId);
        this.ssoSilentMeasurement?.add({
            scenarioId: request.scenarioId,
            accountType: $1d9f6519fe722240$var$getAccountType(request.account)
        });
        $1d9f6519fe722240$var$preflightCheck(this.initialized, this.ssoSilentMeasurement);
        this.ssoSilentMeasurement?.increment({
            visibilityChangeCount: 0
        });
        document.addEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        this.logger.verbose("ssoSilent called", correlationId);
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, validRequest);
        let result;
        if (this.canUsePlatformBroker(validRequest)) result = this.acquireTokenNative(validRequest, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).ssoSilent).catch((e)=>{
            // If native token acquisition fails for availability reasons fallback to standard flow
            if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab) && (0, $a5e5dee51df551c2$export$f21e42e365baeb50)(e)) {
                this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
                return silentIframeClient.acquireToken(validRequest);
            }
            throw e;
        });
        else {
            const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
            result = silentIframeClient.acquireToken(validRequest);
        }
        return result.then((response)=>{
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, response);
            this.ssoSilentMeasurement?.end({
                success: true,
                isNativeBroker: response.fromNativeBroker,
                accessTokenSize: response.accessToken.length,
                idTokenSize: response.idToken.length,
                accountType: $1d9f6519fe722240$var$getAccountType(response.account)
            });
            return response;
        }).catch((e)=>{
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, null, e);
            this.ssoSilentMeasurement?.end({
                success: false
            }, e);
            throw e;
        }).finally(()=>{
            document.removeEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        });
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenByCode(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("acquireTokenByCode called", correlationId);
        const atbcMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenByCode, correlationId);
        $1d9f6519fe722240$var$preflightCheck(this.initialized, atbcMeasurement);
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, request);
        atbcMeasurement.add({
            scenarioId: request.scenarioId
        });
        try {
            if (request.code && request.nativeAccountId) // Throw error in case server returns both spa_code and spa_accountid in exchange for auth code.
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$1efb009e9d75bbe4));
            else if (request.code) {
                const hybridAuthCode = request.code;
                let response = this.hybridAuthCodeResponses.get(hybridAuthCode);
                if (!response) {
                    this.logger.verbose("Initiating new acquireTokenByCode request", correlationId);
                    response = this.acquireTokenByCodeAsync({
                        ...request,
                        correlationId: correlationId
                    }).then((result)=>{
                        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, result);
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        atbcMeasurement.end({
                            success: true,
                            isNativeBroker: result.fromNativeBroker,
                            accessTokenSize: result.accessToken.length,
                            idTokenSize: result.idToken.length,
                            accountType: $1d9f6519fe722240$var$getAccountType(result.account)
                        });
                        return result;
                    }).catch((error)=>{
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, null, error);
                        atbcMeasurement.end({
                            success: false
                        }, error);
                        throw error;
                    });
                    this.hybridAuthCodeResponses.set(hybridAuthCode, response);
                } else {
                    this.logger.verbose("Existing acquireTokenByCode request found", correlationId);
                    atbcMeasurement.discard();
                }
                return await response;
            } else if (request.nativeAccountId) {
                if (this.canUsePlatformBroker(request, request.nativeAccountId)) {
                    const result = await this.acquireTokenNative({
                        ...request,
                        correlationId: correlationId
                    }, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenByCode, request.nativeAccountId).catch((e)=>{
                        // If native token acquisition fails for availability reasons fallback to standard flow
                        if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab) && (0, $a5e5dee51df551c2$export$f21e42e365baeb50)(e)) this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                        throw e;
                    });
                    atbcMeasurement.end({
                        accountType: $1d9f6519fe722240$var$getAccountType(result.account),
                        success: true
                    });
                    return result;
                } else throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$b897bbe2c683def2));
            } else throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$8bea68053103eaeb));
        } catch (e) {
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, null, e);
            atbcMeasurement.end({
                success: false
            }, e);
            throw e;
        }
    }
    /**
     * Creates a SilentAuthCodeClient to redeem an authorization code.
     * @param request
     * @returns Result of the operation to redeem the authorization code
     */ async acquireTokenByCodeAsync(request) {
        this.logger.trace("acquireTokenByCodeAsync called", request.correlationId);
        this.acquireTokenByCodeAsyncMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenByCodeAsync, request.correlationId);
        this.acquireTokenByCodeAsyncMeasurement?.increment({
            visibilityChangeCount: 0
        });
        document.addEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        const silentAuthCodeClient = this.createSilentAuthCodeClient(request.correlationId);
        const silentTokenResult = await silentAuthCodeClient.acquireToken(request).then((response)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: true,
                fromCache: response.fromCache,
                isNativeBroker: response.fromNativeBroker
            });
            return response;
        }).catch((tokenRenewalError)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: false
            }, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            document.removeEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        });
        return silentTokenResult;
    }
    /**
     * Attempt to acquire an access token from the cache
     * @param silentCacheClient SilentCacheClient
     * @param commonRequest CommonSilentFlowRequest
     * @param silentRequest SilentRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenFromCache(commonRequest, cacheLookupPolicy) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenFromCache, commonRequest.correlationId);
        switch(cacheLookupPolicy){
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).Default:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessToken:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
                const silentCacheClient = this.createSilentCacheClient(commonRequest.correlationId);
                return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(silentCacheClient.acquireToken.bind(silentCacheClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentCacheClientAcquireToken, this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).tokenRefreshRequired);
        }
    }
    /**
     * Attempt to acquire an access token via a refresh token
     * @param commonRequest CommonSilentFlowRequest
     * @param cacheLookupPolicy CacheLookupPolicy
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenByRefreshToken(commonRequest, cacheLookupPolicy) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenByRefreshToken, commonRequest.correlationId);
        switch(cacheLookupPolicy){
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).Default:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).RefreshToken:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).RefreshTokenAndNetwork:
                const silentRefreshClient = this.createSilentRefreshClient(commonRequest.correlationId);
                return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(silentRefreshClient.acquireToken.bind(silentRefreshClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentRefreshClientAcquireToken, this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).tokenRefreshRequired);
        }
    }
    /**
     * Attempt to acquire an access token via an iframe
     * @param request CommonSilentFlowRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenBySilentIframe(request) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, request.correlationId);
        const silentIframeClient = this.createSilentIframeClient(request.correlationId);
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(silentIframeClient.acquireToken.bind(silentIframeClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentIframeClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(request);
    }
    // #endregion
    // #region Logout
    /**
     * Deprecated logout function. Use logoutRedirect or logoutPopup instead
     * @param logoutRequest
     * @deprecated
     */ async logout(logoutRequest) {
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        this.logger.warning("logout API is deprecated and will be removed in msal-browser v3.0.0. Use logoutRedirect instead.", correlationId);
        return this.logoutRedirect({
            correlationId: correlationId,
            ...logoutRequest
        });
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logoutRedirect(logoutRequest) {
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        (0, $3003b661a087a867$export$62c8f4fdca4df60f)(this.initialized, this.config);
        this.browserStorage.setInteractionInProgress(true, (0, $5ff55562d73e0e2b$export$dc1d3aa5f3837765).SIGNOUT);
        const redirectClient = this.createRedirectClient(correlationId);
        return redirectClient.logout(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        try {
            const correlationId = this.getRequestCorrelationId(logoutRequest);
            (0, $3003b661a087a867$export$4dd091cbdc98b52e)(this.initialized);
            this.browserStorage.setInteractionInProgress(true, (0, $5ff55562d73e0e2b$export$dc1d3aa5f3837765).SIGNOUT);
            const popupClient = this.createPopupClient(correlationId);
            return popupClient.logout(logoutRequest).finally(()=>{
                this.browserStorage.setInteractionInProgress(false);
            });
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Creates a cache interaction client to clear broswer cache.
     * @param logoutRequest
     */ async clearCache(logoutRequest) {
        if (!this.isBrowserEnvironment) {
            this.logger.info("in non-browser environment, returning early.");
            return;
        }
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        const cacheClient = this.createSilentCacheClient(correlationId);
        return cacheClient.logout(logoutRequest);
    }
    // #endregion
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return (0, $807e525bbe19e865$export$a4fc43c2a99143cd)(this.logger, this.browserStorage, this.isBrowserEnvironment, accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return (0, $807e525bbe19e865$export$4f9234baf34abd0)(accountFilter, this.logger, this.browserStorage);
    }
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param username
     * @returns The account object stored in MSAL
     */ getAccountByUsername(username) {
        return (0, $807e525bbe19e865$export$d915baf55d86927d)(username, this.logger, this.browserStorage);
    }
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     */ getAccountByHomeId(homeAccountId) {
        return (0, $807e525bbe19e865$export$d6fa7d1e8099998e)(homeAccountId, this.logger, this.browserStorage);
    }
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     */ getAccountByLocalId(localAccountId) {
        return (0, $807e525bbe19e865$export$7ac8aa09fdf78340)(localAccountId, this.logger, this.browserStorage);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        (0, $807e525bbe19e865$export$c55c3d25cf1bcd99)(account, this.browserStorage);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return (0, $807e525bbe19e865$export$13dd2e33a23839ad)(this.browserStorage);
    }
    // #endregion
    /**
     * Hydrates the cache with the tokens from an AuthenticationResult
     * @param result
     * @param request
     * @returns
     */ async hydrateCache(result, request) {
        this.logger.verbose("hydrateCache called");
        // Account gets saved to browser storage regardless of native or not
        const accountEntity = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).createFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        await this.browserStorage.setAccount(accountEntity, result.correlationId);
        if (result.fromNativeBroker) {
            this.logger.verbose("Response was from native broker, storing in-memory");
            // Tokens from native broker are stored in-memory
            return this.nativeInternalStorage.hydrateCache(result, request);
        } else return this.browserStorage.hydrateCache(result, request);
    }
    // #region Helpers
    /**
     * Acquire a token from native device (e.g. WAM)
     * @param request
     */ async acquireTokenNative(request, apiId, accountId, cacheLookupPolicy) {
        this.logger.trace("acquireTokenNative called");
        if (!this.platformAuthProvider) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$7b7357e3538624aa));
        const nativeClient = new (0, $e6f06a03b9c6516d$export$3f89612b3fd8831f)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, apiId, this.performanceClient, this.platformAuthProvider, accountId || this.getNativeAccountId(request), this.nativeInternalStorage, request.correlationId);
        return nativeClient.acquireToken(request, cacheLookupPolicy);
    }
    /**
     * Returns boolean indicating if this request can use the platform broker
     * @param request
     */ canUsePlatformBroker(request, accountId) {
        this.logger.trace("canUsePlatformBroker called");
        if (!this.platformAuthProvider) {
            this.logger.trace("canUsePlatformBroker: platform broker unavilable, returning false");
            return false;
        }
        if (!(0, $1ef3eb788d38d5ed$export$4815cc9f88d4f6a5)(this.config, this.logger, this.platformAuthProvider, request.authenticationScheme)) {
            this.logger.trace("canUsePlatformBroker: isBrokerAvailable returned false, returning false");
            return false;
        }
        if (request.prompt) switch(request.prompt){
            case (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE:
            case (0, $7c375ae106b964be$export$49a06cbda5acaa5).CONSENT:
            case (0, $7c375ae106b964be$export$49a06cbda5acaa5).LOGIN:
                this.logger.trace("canUsePlatformBroker: prompt is compatible with platform broker flow");
                break;
            default:
                this.logger.trace(`canUsePlatformBroker: prompt = ${request.prompt} is not compatible with platform broker flow, returning false`);
                return false;
        }
        if (!accountId && !this.getNativeAccountId(request)) {
            this.logger.trace("canUsePlatformBroker: nativeAccountId is not available, returning false");
            return false;
        }
        return true;
    }
    /**
     * Get the native accountId from the account
     * @param request
     * @returns
     */ getNativeAccountId(request) {
        const account = request.account || this.getAccount({
            loginHint: request.loginHint,
            sid: request.sid
        }) || this.getActiveAccount();
        return account && account.nativeAccountId || "";
    }
    /**
     * Returns new instance of the Popup Interaction Client
     * @param correlationId
     */ createPopupClient(correlationId) {
        return new (0, $674f66832275a4d9$export$43b0fce132d066f4)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.platformAuthProvider, correlationId);
    }
    /**
     * Returns new instance of the Redirect Interaction Client
     * @param correlationId
     */ createRedirectClient(correlationId) {
        return new (0, $9c96cbdf0340174c$export$a368977effbc1ed6)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.platformAuthProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent Iframe Interaction Client
     * @param correlationId
     */ createSilentIframeClient(correlationId) {
        return new (0, $73772bb7ece2a11b$export$e81c7938bccef977)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).ssoSilent, this.performanceClient, this.nativeInternalStorage, this.platformAuthProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent Cache Interaction Client
     */ createSilentCacheClient(correlationId) {
        return new (0, $5d2b86ff94a0079d$export$59d4f873ee62d01e)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.platformAuthProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent Refresh Interaction Client
     */ createSilentRefreshClient(correlationId) {
        return new (0, $9a90898a8c83eb8c$export$b4a36596822a5d2)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.platformAuthProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent AuthCode Interaction Client
     */ createSilentAuthCodeClient(correlationId) {
        return new (0, $74f7d1cf2fd01491$export$d7f5ef311b3e9fca)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenByCode, this.performanceClient, this.platformAuthProvider, correlationId);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        (0, $3003b661a087a867$export$c7939bfe92ae2787)();
        return this.performanceClient.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.performanceClient.removePerformanceCallback(callbackId);
    }
    /**
     * Adds event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     * @deprecated These events will be raised by default and this method will be removed in a future major version.
     */ enableAccountStorageEvents() {
        if (this.config.cache.cacheLocation !== (0, $5ff55562d73e0e2b$export$573384e47a12d835).LocalStorage) {
            this.logger.info("Account storage events are only available when cacheLocation is set to localStorage");
            return;
        }
        this.eventHandler.subscribeCrossTab();
    }
    /**
     * Removes event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     * @deprecated These events will be raised by default and this method will be removed in a future major version.
     */ disableAccountStorageEvents() {
        if (this.config.cache.cacheLocation !== (0, $5ff55562d73e0e2b$export$573384e47a12d835).LocalStorage) {
            this.logger.info("Account storage events are only available when cacheLocation is set to localStorage");
            return;
        }
        this.eventHandler.unsubscribeCrossTab();
    }
    /**
     * Gets the token cache for the application.
     */ getTokenCache() {
        return this.tokenCache;
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        // Validate the SKU passed in is one we expect
        this.browserStorage.setWrapperMetadata(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.navigationClient = navigationClient;
    }
    /**
     * Returns the configuration object
     */ getConfiguration() {
        return this.config;
    }
    /**
     * Returns the performance client
     */ getPerformanceClient() {
        return this.performanceClient;
    }
    /**
     * Returns the browser env indicator
     */ isBrowserEnv() {
        return this.isBrowserEnvironment;
    }
    /**
     * Generates a correlation id for a request if none is provided.
     *
     * @protected
     * @param {?Partial<BaseAuthRequest>} [request]
     * @returns {string}
     */ getRequestCorrelationId(request) {
        if (request?.correlationId) return request.correlationId;
        if (this.isBrowserEnvironment) return (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
        /*
         * Included for fallback for non-browser environments,
         * and to ensure this method always returns a string.
         */ return (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
    }
    // #endregion
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async loginRedirect(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("loginRedirect called", correlationId);
        return this.acquireTokenRedirect({
            correlationId: correlationId,
            ...request || (0, $5ff55562d73e0e2b$export$7e12949cd6884193)
        });
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("loginPopup called", correlationId);
        return this.acquireTokenPopup({
            correlationId: correlationId,
            ...request || (0, $5ff55562d73e0e2b$export$7e12949cd6884193)
        });
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse} object
     */ async acquireTokenSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atsMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenSilent, correlationId);
        atsMeasurement.add({
            cacheLookupPolicy: request.cacheLookupPolicy,
            scenarioId: request.scenarioId
        });
        $1d9f6519fe722240$var$preflightCheck(this.initialized, atsMeasurement);
        this.logger.verbose("acquireTokenSilent called", correlationId);
        const account = request.account || this.getActiveAccount();
        if (!account) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$87933d7d4116cb12));
        atsMeasurement.add({
            accountType: $1d9f6519fe722240$var$getAccountType(account)
        });
        return this.acquireTokenSilentDeduped(request, account, correlationId).then((result)=>{
            atsMeasurement.end({
                success: true,
                fromCache: result.fromCache,
                isNativeBroker: result.fromNativeBroker,
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            return {
                ...result,
                state: request.state,
                correlationId: correlationId
            };
        }).catch((error)=>{
            if (error instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) // Ensures PWB scenarios can correctly match request to response
            error.setCorrelationId(correlationId);
            atsMeasurement.end({
                success: false
            }, error);
            throw error;
        });
    }
    /**
     * Checks if identical request is already in flight and returns reference to the existing promise or fires off a new one if this is the first
     * @param request
     * @param account
     * @param correlationId
     * @returns
     */ async acquireTokenSilentDeduped(request, account, correlationId) {
        const thumbprint = (0, $762faca86a0f7942$export$2daa8cfcf54c2b48)(this.config.auth.clientId, {
            ...request,
            authority: request.authority || this.config.auth.authority,
            correlationId: correlationId
        }, account.homeAccountId);
        const silentRequestKey = JSON.stringify(thumbprint);
        const inProgressRequest = this.activeSilentTokenRequests.get(silentRequestKey);
        if (typeof inProgressRequest === "undefined") {
            this.logger.verbose("acquireTokenSilent called for the first time, storing active request", correlationId);
            this.performanceClient.addFields({
                deduped: false
            }, correlationId);
            const activeRequest = (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenSilentAsync.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenSilentAsync, this.logger, this.performanceClient, correlationId)({
                ...request,
                correlationId: correlationId
            }, account);
            this.activeSilentTokenRequests.set(silentRequestKey, activeRequest);
            return activeRequest.finally(()=>{
                this.activeSilentTokenRequests.delete(silentRequestKey);
            });
        } else {
            this.logger.verbose("acquireTokenSilent has been called previously, returning the result from the first call", correlationId);
            this.performanceClient.addFields({
                deduped: true
            }, correlationId);
            return inProgressRequest;
        }
    }
    /**
     * Silently acquire an access token for a given set of scopes. Will use cached token if available, otherwise will attempt to acquire a new token from the network via refresh token.
     * @param {@link (SilentRequest:type)}
     * @param {@link (AccountInfo:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse}
     */ async acquireTokenSilentAsync(request, account) {
        const trackPageVisibility = ()=>this.trackPageVisibility(request.correlationId);
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenSilentAsync, request.correlationId);
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, request);
        if (request.correlationId) this.performanceClient.incrementFields({
            visibilityChangeCount: 0
        }, request.correlationId);
        document.addEventListener("visibilitychange", trackPageVisibility);
        const silentRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $550ae9dc1dae1add$export$4c8aa78c426811d4), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeSilentRequest, this.logger, this.performanceClient, request.correlationId)(request, account, this.config, this.performanceClient, this.logger);
        const cacheLookupPolicy = request.cacheLookupPolicy || (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).Default;
        const result = this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy).catch(async (refreshTokenError)=>{
            const shouldTryToResolveSilently = $1d9f6519fe722240$var$checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy);
            if (shouldTryToResolveSilently) {
                if (!this.activeIframeRequest) {
                    let _resolve;
                    // Always set the active request tracker immediately after checking it to prevent races
                    this.activeIframeRequest = [
                        new Promise((resolve)=>{
                            _resolve = resolve;
                        }),
                        silentRequest.correlationId
                    ];
                    this.logger.verbose("Refresh token expired/invalid or CacheLookupPolicy is set to Skip, attempting acquire token by iframe.", silentRequest.correlationId);
                    return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenBySilentIframe.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest).then((iframeResult)=>{
                        _resolve(true);
                        return iframeResult;
                    }).catch((e)=>{
                        _resolve(false);
                        throw e;
                    }).finally(()=>{
                        this.activeIframeRequest = undefined;
                    });
                } else if (cacheLookupPolicy !== (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).Skip) {
                    const [activePromise, activeCorrelationId] = this.activeIframeRequest;
                    this.logger.verbose(`Iframe request is already in progress, awaiting resolution for request with correlationId: ${activeCorrelationId}`, silentRequest.correlationId);
                    const awaitConcurrentIframeMeasure = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AwaitConcurrentIframe, silentRequest.correlationId);
                    awaitConcurrentIframeMeasure.add({
                        awaitIframeCorrelationId: activeCorrelationId
                    });
                    const activePromiseResult = await activePromise;
                    awaitConcurrentIframeMeasure.end({
                        success: activePromiseResult
                    });
                    if (activePromiseResult) {
                        this.logger.verbose(`Parallel iframe request with correlationId: ${activeCorrelationId} succeeded. Retrying cache and/or RT redemption`, silentRequest.correlationId);
                        // Retry cache lookup and/or RT exchange after iframe completes
                        return this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy);
                    } else {
                        this.logger.info(`Iframe request with correlationId: ${activeCorrelationId} failed. Interaction is required.`);
                        // If previous iframe request failed, it's unlikely to succeed this time. Throw original error.
                        throw refreshTokenError;
                    }
                } else {
                    // Cache policy set to skip and another iframe request is already in progress
                    this.logger.warning("Another iframe request is currently in progress and CacheLookupPolicy is set to Skip. This may result in degraded performance and/or reliability for both calls. Please consider changing the CacheLookupPolicy to take advantage of request queuing and token cache.", silentRequest.correlationId);
                    return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenBySilentIframe.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
                }
            } else // Error cannot be silently resolved or iframe renewal is not allowed, interaction required
            throw refreshTokenError;
        });
        return result.then((response)=>{
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, response);
            if (request.correlationId) this.performanceClient.addFields({
                fromCache: response.fromCache,
                isNativeBroker: response.fromNativeBroker
            }, request.correlationId);
            return response;
        }).catch((tokenRenewalError)=>{
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, null, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            document.removeEventListener("visibilitychange", trackPageVisibility);
        });
    }
    /**
     * AcquireTokenSilent without the iframe fallback. This is used to enable the correct fallbacks in cases where there's a potential for multiple silent requests to be made in parallel and prevent those requests from making concurrent iframe requests.
     * @param silentRequest
     * @param cacheLookupPolicy
     * @returns
     */ async acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy) {
        // if the cache policy is set to access_token only, we should not be hitting the native layer yet
        if ((0, $1ef3eb788d38d5ed$export$4815cc9f88d4f6a5)(this.config, this.logger, this.platformAuthProvider, silentRequest.authenticationScheme) && silentRequest.account.nativeAccountId) {
            this.logger.verbose("acquireTokenSilent - attempting to acquire token from native platform");
            return this.acquireTokenNative(silentRequest, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenSilent_silentFlow, silentRequest.account.nativeAccountId, cacheLookupPolicy).catch(async (e)=>{
                // If native token acquisition fails for availability reasons fallback to web flow
                if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab) && (0, $a5e5dee51df551c2$export$f21e42e365baeb50)(e)) {
                    this.logger.verbose("acquireTokenSilent - native platform unavailable, falling back to web flow");
                    this.platformAuthProvider = undefined; // Prevent future requests from continuing to attempt
                    // Cache will not contain tokens, given that previous WAM requests succeeded. Skip cache and RT renewal and go straight to iframe renewal
                    throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).tokenRefreshRequired);
                }
                throw e;
            });
        } else {
            this.logger.verbose("acquireTokenSilent - attempting to acquire token from web flow");
            // add logs to identify embedded cache retrieval
            if (cacheLookupPolicy === (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessToken) this.logger.verbose("acquireTokenSilent - cache lookup policy set to AccessToken, attempting to acquire token from local cache");
            return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenFromCache.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenFromCache, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy).catch((cacheError)=>{
                if (cacheLookupPolicy === (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessToken) throw cacheError;
                this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_NETWORK_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, silentRequest);
                return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenByRefreshToken.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenByRefreshToken, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy);
            });
        }
    }
    /**
     * Pre-generates PKCE codes and stores it in local variable
     * @param correlationId
     */ async preGeneratePkceCodes(correlationId) {
        this.logger.verbose("Generating new PKCE codes");
        this.pkceCode = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $cab7ad26b4a73b7b$export$91d5e5a023803853), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        return Promise.resolve();
    }
    /**
     * Provides pre-generated PKCE codes, if any
     * @param correlationId
     */ getPreGeneratedPkceCodes(correlationId) {
        this.logger.verbose("Attempting to pick up pre-generated PKCE codes");
        const res = this.pkceCode ? {
            ...this.pkceCode
        } : undefined;
        this.pkceCode = undefined;
        this.logger.verbose(`${res ? "Found" : "Did not find"} pre-generated PKCE codes`);
        this.performanceClient.addFields({
            usePreGeneratedPkce: !!res
        }, correlationId);
        return res;
    }
    logMultipleInstances(performanceEvent) {
        const clientId = this.config.auth.clientId;
        if (!window) return;
        // @ts-ignore
        window.msal = window.msal || {};
        // @ts-ignore
        window.msal.clientIds = window.msal.clientIds || [];
        // @ts-ignore
        const clientIds = window.msal.clientIds;
        if (clientIds.length > 0) this.logger.verbose("There is already an instance of MSAL.js in the window.");
        // @ts-ignore
        window.msal.clientIds.push(clientId);
        (0, $ae095a3d7bff7e6f$export$fe0570c25bf19cec)(clientId, performanceEvent, this.logger);
    }
}
/**
 * Determines whether an error thrown by the refresh token endpoint can be resolved without interaction
 * @param refreshTokenError
 * @param silentRequest
 * @param cacheLookupPolicy
 * @returns
 */ function $1d9f6519fe722240$var$checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy) {
    const noInteractionRequired = !(refreshTokenError instanceof (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba) && // For refresh token errors, bad_token does not always require interaction (silently resolvable)
    refreshTokenError.subError !== (0, $84767569d86b0bc0$exports).badToken);
    // Errors that result when the refresh token needs to be replaced
    const refreshTokenRefreshRequired = refreshTokenError.errorCode === (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).INVALID_GRANT_ERROR || refreshTokenError.errorCode === (0, $6be88bbe69356b76$exports).tokenRefreshRequired;
    // Errors that may be resolved before falling back to interaction (through iframe renewal)
    const isSilentlyResolvable = noInteractionRequired && refreshTokenRefreshRequired || refreshTokenError.errorCode === (0, $84767569d86b0bc0$exports).noTokensFound || refreshTokenError.errorCode === (0, $84767569d86b0bc0$exports).refreshTokenExpired;
    // Only these policies allow for an iframe renewal attempt
    const tryIframeRenewal = (0, $5ff55562d73e0e2b$export$736180706fb122ee).includes(cacheLookupPolicy);
    return isSilentlyResolvable && tryIframeRenewal;
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 
/*! @azure/msal-browser v4.13.1 2025-06-10 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $61425a9d4424b5fd$export$caa3bc10e51dd7ee(error) {
    return error.status !== undefined;
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $03968fc19372b2df$export$cee94b20506f02aa {
    constructor(clientId, clientCapabilities, crypto, logger){
        this.clientId = clientId;
        this.clientCapabilities = clientCapabilities;
        this.crypto = crypto;
        this.logger = logger;
    }
    toNaaTokenRequest(request) {
        let extraParams;
        if (request.extraQueryParameters === undefined) extraParams = new Map();
        else extraParams = new Map(Object.entries(request.extraQueryParameters));
        const correlationId = request.correlationId || this.crypto.createNewGuid();
        const claims = (0, $7d3a00eb36d325b3$exports).addClientCapabilitiesToClaims(request.claims, this.clientCapabilities);
        const scopes = request.scopes || (0, $7c375ae106b964be$export$893b1b5b686d84ef);
        const tokenRequest = {
            platformBrokerId: request.account?.homeAccountId,
            clientId: this.clientId,
            authority: request.authority,
            scope: scopes.join(" "),
            correlationId: correlationId,
            claims: !(0, $442eacaa0418a38d$export$ecc754f99843e759).isEmptyObj(claims) ? claims : undefined,
            state: request.state,
            authenticationScheme: request.authenticationScheme || (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER,
            extraParameters: extraParams
        };
        return tokenRequest;
    }
    fromNaaTokenResponse(request, response, reqTimestamp) {
        if (!response.token.id_token || !response.token.access_token) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).nullOrEmptyToken);
        // Request timestamp and AuthResult expires_in are in seconds, converting to Date for AuthenticationResult
        const expiresOn = (0, $0a4a8f22735f9ff5$exports).toDateFromSeconds(reqTimestamp + (response.token.expires_in || 0));
        const idTokenClaims = (0, $b29e27fb146a7ddd$exports).extractTokenClaims(response.token.id_token, this.crypto.base64Decode);
        const account = this.fromNaaAccountInfo(response.account, response.token.id_token, idTokenClaims);
        const scopes = response.token.scope || request.scope;
        const authenticationResult = {
            authority: response.token.authority || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account: account,
            idToken: response.token.id_token,
            idTokenClaims: idTokenClaims,
            accessToken: response.token.access_token,
            fromCache: false,
            expiresOn: expiresOn,
            tokenType: request.authenticationScheme || (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER,
            correlationId: request.correlationId,
            extExpiresOn: expiresOn,
            state: request.state
        };
        return authenticationResult;
    }
    /*
     *  export type AccountInfo = {
     *     homeAccountId: string;
     *     environment: string;
     *     tenantId: string;
     *     username: string;
     *     localAccountId: string;
     *     name?: string;
     *     idToken?: string;
     *     idTokenClaims?: TokenClaims & {
     *         [key: string]:
     *             | string
     *             | number
     *             | string[]
     *             | object
     *             | undefined
     *             | unknown;
     *     };
     *     nativeAccountId?: string;
     *     authorityType?: string;
     * };
     */ fromNaaAccountInfo(fromAccount, idToken, idTokenClaims) {
        const effectiveIdTokenClaims = idTokenClaims || fromAccount.idTokenClaims;
        const localAccountId = fromAccount.localAccountId || effectiveIdTokenClaims?.oid || effectiveIdTokenClaims?.sub || "";
        const tenantId = fromAccount.tenantId || effectiveIdTokenClaims?.tid || "";
        const homeAccountId = fromAccount.homeAccountId || `${localAccountId}.${tenantId}`;
        const username = fromAccount.username || effectiveIdTokenClaims?.preferred_username || "";
        const name = fromAccount.name || effectiveIdTokenClaims?.name;
        const tenantProfiles = new Map();
        const tenantProfile = (0, $54830df9a5d9a12c$export$924857724cb21ba4)(homeAccountId, localAccountId, tenantId, effectiveIdTokenClaims);
        tenantProfiles.set(tenantId, tenantProfile);
        const account = {
            homeAccountId: homeAccountId,
            environment: fromAccount.environment,
            tenantId: tenantId,
            username: username,
            localAccountId: localAccountId,
            name: name,
            idToken: idToken,
            idTokenClaims: effectiveIdTokenClaims,
            tenantProfiles: tenantProfiles
        };
        return account;
    }
    /**
     *
     * @param error BridgeError
     * @returns AuthError, ClientAuthError, ClientConfigurationError, ServerError, InteractionRequiredError
     */ fromBridgeError(error) {
        if ((0, $61425a9d4424b5fd$export$caa3bc10e51dd7ee)(error)) switch(error.status){
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).UserCancel:
                return new (0, $eaea74bac26129fa$export$a839ff85a7957561)((0, $6be88bbe69356b76$exports).userCanceled);
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).NoNetwork:
                return new (0, $eaea74bac26129fa$export$a839ff85a7957561)((0, $6be88bbe69356b76$exports).noNetworkConnectivity);
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).AccountUnavailable:
                return new (0, $eaea74bac26129fa$export$a839ff85a7957561)((0, $6be88bbe69356b76$exports).noAccountFound);
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).Disabled:
                return new (0, $eaea74bac26129fa$export$a839ff85a7957561)((0, $6be88bbe69356b76$exports).nestedAppAuthBridgeDisabled);
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).NestedAppAuthUnavailable:
                return new (0, $eaea74bac26129fa$export$a839ff85a7957561)(error.code || (0, $6be88bbe69356b76$exports).nestedAppAuthBridgeDisabled, error.description);
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).TransientError:
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).PersistentError:
                return new (0, $016e46db2c2afa86$export$ea52035eac03daf0)(error.code, error.description);
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).UserInteractionRequired:
                return new (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)(error.code, error.description);
            default:
                return new (0, $0ff8310393c4d2db$export$145273558d58e0ac)(error.code, error.description);
        }
        else return new (0, $0ff8310393c4d2db$export$145273558d58e0ac)("unknown_error", "An unknown error occurred");
    }
    /**
     * Returns an AuthenticationResult from the given cache items
     *
     * @param account
     * @param idToken
     * @param accessToken
     * @param reqTimestamp
     * @returns
     */ toAuthenticationResultFromCache(account, idToken, accessToken, request, correlationId) {
        if (!idToken || !accessToken) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).nullOrEmptyToken);
        const idTokenClaims = (0, $b29e27fb146a7ddd$exports).extractTokenClaims(idToken.secret, this.crypto.base64Decode);
        const scopes = accessToken.target || request.scopes.join(" ");
        const authenticationResult = {
            authority: accessToken.environment || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account: account,
            idToken: idToken.secret,
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken.secret,
            fromCache: true,
            expiresOn: (0, $0a4a8f22735f9ff5$exports).toDateFromSeconds(accessToken.expiresOn),
            extExpiresOn: (0, $0a4a8f22735f9ff5$exports).toDateFromSeconds(accessToken.extendedExpiresOn),
            tokenType: request.authenticationScheme || (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER,
            correlationId: correlationId,
            state: request.state
        };
        return authenticationResult;
    }
}


/*! @azure/msal-browser v4.13.1 2025-06-10 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * NestedAppAuthErrorMessage class containing string constants used by error codes and messages.
 */ const $f43fb4a2edb734fd$export$81a70490e660273a = {
    unsupportedMethod: {
        code: "unsupported_method",
        desc: "This method is not supported in nested app environment."
    }
};
class $f43fb4a2edb734fd$export$7c79ceb488783308 extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        Object.setPrototypeOf(this, $f43fb4a2edb734fd$export$7c79ceb488783308.prototype);
        this.name = "NestedAppAuthError";
    }
    static createUnsupportedError() {
        return new $f43fb4a2edb734fd$export$7c79ceb488783308($f43fb4a2edb734fd$export$81a70490e660273a.unsupportedMethod.code, $f43fb4a2edb734fd$export$81a70490e660273a.unsupportedMethod.desc);
    }
}







'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $8ac21447ebc7e19d$export$2319deb182e38ab3 {
    constructor(operatingContext){
        this.operatingContext = operatingContext;
        const proxy = this.operatingContext.getBridgeProxy();
        if (proxy !== undefined) this.bridgeProxy = proxy;
        else throw new Error("unexpected: bridgeProxy is undefined");
        // Set the configuration.
        this.config = operatingContext.getConfig();
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        // Initialize the crypto class.
        this.browserCrypto = operatingContext.isBrowserEnvironment() ? new (0, $e72c2cdc5fe24d6f$export$c274a7f0ebd24b14)(this.logger, this.performanceClient, true) : (0, $dd88ab1a0b4d3851$export$865f57d401606752);
        this.eventHandler = new (0, $9f61ab73b66f619a$export$ce0ba2422a1c7815)(this.logger);
        // Initialize the browser storage class.
        this.browserStorage = this.operatingContext.isBrowserEnvironment() ? new (0, $d3981d5134d5331a$export$44d7291b5c8cc149)(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler, (0, $77bb430f4568f6e8$export$2b9ebf6f25078cc0)(this.config.auth)) : (0, $d3981d5134d5331a$export$8e2d54002f8f6e5d)(this.config.auth.clientId, this.logger, this.performanceClient, this.eventHandler);
        this.nestedAppAuthAdapter = new (0, $03968fc19372b2df$export$cee94b20506f02aa)(this.config.auth.clientId, this.config.auth.clientCapabilities, this.browserCrypto, this.logger);
        // Set the active account if available
        const accountContext = this.bridgeProxy.getAccountContext();
        this.currentAccountContext = accountContext ? accountContext : null;
    }
    /**
     * Factory function to create a new instance of NestedAppAuthController
     * @param operatingContext
     * @returns Promise<IController>
     */ static async createController(operatingContext) {
        const controller = new $8ac21447ebc7e19d$export$2319deb182e38ab3(operatingContext);
        return Promise.resolve(controller);
    }
    /**
     * Specific implementation of initialize function for NestedAppAuthController
     * @returns
     */ async initialize(request, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isBroker) {
        const initCorrelationId = request?.correlationId || (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
        await this.browserStorage.initialize(initCorrelationId);
        return Promise.resolve();
    }
    /**
     * Validate the incoming request and add correlationId if not present
     * @param request
     * @returns
     */ ensureValidRequest(request) {
        if (request?.correlationId) return request;
        return {
            ...request,
            correlationId: this.browserCrypto.createNewGuid()
        };
    }
    /**
     * Internal implementation of acquireTokenInteractive flow
     * @param request
     * @returns
     */ async acquireTokenInteractive(request) {
        const validRequest = this.ensureValidRequest(request);
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, validRequest);
        const atPopupMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenPopup, validRequest.correlationId);
        atPopupMeasurement?.add({
            nestedAppAuthRequest: true
        });
        try {
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            const reqTimestamp = (0, $0a4a8f22735f9ff5$exports).nowSeconds();
            const response = await this.bridgeProxy.getTokenInteractive(naaRequest);
            const result = {
                ...this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp)
            };
            // cache the tokens in the response
            await this.hydrateCache(result, request);
            // cache the account context in memory after successful token fetch
            this.currentAccountContext = {
                homeAccountId: result.account.homeAccountId,
                environment: result.account.environment,
                tenantId: result.account.tenantId
            };
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, result);
            atPopupMeasurement.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            atPopupMeasurement.end({
                success: true,
                requestId: result.requestId
            });
            return result;
        } catch (e) {
            const error = e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac) ? e : this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e);
            throw error;
        }
    }
    /**
     * Internal implementation of acquireTokenSilent flow
     * @param request
     * @returns
     */ async acquireTokenSilentInternal(request) {
        const validRequest = this.ensureValidRequest(request);
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, validRequest);
        // Look for tokens in the cache first
        const result = await this.acquireTokenFromCache(validRequest);
        if (result) {
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, result);
            return result;
        }
        // proceed with acquiring tokens via the host
        const ssoSilentMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SsoSilent, validRequest.correlationId);
        ssoSilentMeasurement?.increment({
            visibilityChangeCount: 0
        });
        ssoSilentMeasurement?.add({
            nestedAppAuthRequest: true
        });
        try {
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            const reqTimestamp = (0, $0a4a8f22735f9ff5$exports).nowSeconds();
            const response = await this.bridgeProxy.getTokenSilent(naaRequest);
            const result = this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp);
            // cache the tokens in the response
            await this.hydrateCache(result, request);
            // cache the account context in memory after successful token fetch
            this.currentAccountContext = {
                homeAccountId: result.account.homeAccountId,
                environment: result.account.environment,
                tenantId: result.account.tenantId
            };
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, result);
            ssoSilentMeasurement?.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            ssoSilentMeasurement?.end({
                success: true,
                requestId: result.requestId
            });
            return result;
        } catch (e) {
            const error = e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac) ? e : this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, null, e);
            ssoSilentMeasurement?.end({
                success: false
            }, e);
            throw error;
        }
    }
    /**
     * acquires tokens from cache
     * @param request
     * @returns
     */ async acquireTokenFromCache(request) {
        const atsMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenSilent, request.correlationId);
        atsMeasurement?.add({
            nestedAppAuthRequest: true
        });
        // if the request has claims, we cannot look up in the cache
        if (request.claims) {
            this.logger.verbose("Claims are present in the request, skipping cache lookup");
            return null;
        }
        // if the request has forceRefresh, we cannot look up in the cache
        if (request.forceRefresh) {
            this.logger.verbose("forceRefresh is set to true, skipping cache lookup");
            return null;
        }
        // respect cache lookup policy
        let result = null;
        if (!request.cacheLookupPolicy) request.cacheLookupPolicy = (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).Default;
        switch(request.cacheLookupPolicy){
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).Default:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessToken:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
                result = await this.acquireTokenFromCacheInternal(request);
                break;
            default:
                return null;
        }
        if (result) {
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, result);
            atsMeasurement?.add({
                accessTokenSize: result?.accessToken.length,
                idTokenSize: result?.idToken.length
            });
            atsMeasurement?.end({
                success: true
            });
            return result;
        }
        this.logger.warning("Cached tokens are not found for the account, proceeding with silent token request.");
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, null);
        atsMeasurement?.end({
            success: false
        });
        return null;
    }
    /**
     *
     * @param request
     * @returns
     */ async acquireTokenFromCacheInternal(request) {
        // always prioritize the account context from the bridge
        const accountContext = this.bridgeProxy.getAccountContext() || this.currentAccountContext;
        let currentAccount = null;
        if (accountContext) currentAccount = (0, $807e525bbe19e865$export$4f9234baf34abd0)(accountContext, this.logger, this.browserStorage);
        // fall back to brokering if no cached account is found
        if (!currentAccount) {
            this.logger.verbose("No active account found, falling back to the host");
            return Promise.resolve(null);
        }
        this.logger.verbose("active account found, attempting to acquire token silently");
        const authRequest = {
            ...request,
            correlationId: request.correlationId || this.browserCrypto.createNewGuid(),
            authority: request.authority || currentAccount.environment,
            scopes: request.scopes?.length ? request.scopes : [
                ...(0, $7c375ae106b964be$export$893b1b5b686d84ef)
            ]
        };
        // fetch access token and check for expiry
        const tokenKeys = this.browserStorage.getTokenKeys();
        const cachedAccessToken = this.browserStorage.getAccessToken(currentAccount, authRequest, tokenKeys, currentAccount.tenantId, this.performanceClient, authRequest.correlationId);
        // If there is no access token, log it and return null
        if (!cachedAccessToken) {
            this.logger.verbose("No cached access token found");
            return Promise.resolve(null);
        } else if ((0, $0a4a8f22735f9ff5$exports).wasClockTurnedBack(cachedAccessToken.cachedAt) || (0, $0a4a8f22735f9ff5$exports).isTokenExpired(cachedAccessToken.expiresOn, this.config.system.tokenRenewalOffsetSeconds)) {
            this.logger.verbose("Cached access token has expired");
            return Promise.resolve(null);
        }
        const cachedIdToken = this.browserStorage.getIdToken(currentAccount, tokenKeys, currentAccount.tenantId, this.performanceClient, authRequest.correlationId);
        if (!cachedIdToken) {
            this.logger.verbose("No cached id token found");
            return Promise.resolve(null);
        }
        return this.nestedAppAuthAdapter.toAuthenticationResultFromCache(currentAccount, cachedIdToken, cachedAccessToken, authRequest, authRequest.correlationId);
    }
    /**
     * acquireTokenPopup flow implementation
     * @param request
     * @returns
     */ async acquireTokenPopup(request) {
        return this.acquireTokenInteractive(request);
    }
    /**
     * acquireTokenRedirect flow is not supported in nested app auth
     * @param request
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    acquireTokenRedirect(request) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * acquireTokenSilent flow implementation
     * @param silentRequest
     * @returns
     */ async acquireTokenSilent(silentRequest) {
        return this.acquireTokenSilentInternal(silentRequest);
    }
    /**
     * Hybrid flow is not currently supported in nested app auth
     * @param request
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    acquireTokenByCode(request // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * acquireTokenNative flow is not currently supported in nested app auth
     * @param request
     * @param apiId
     * @param accountId
     */ acquireTokenNative(request, apiId, accountId // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * acquireTokenByRefreshToken flow is not currently supported in nested app auth
     * @param commonRequest
     * @param silentRequest
     */ acquireTokenByRefreshToken(commonRequest, silentRequest // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addPerformanceCallback(callback) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removePerformanceCallback(callbackId) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    enableAccountStorageEvents() {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    disableAccountStorageEvents() {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return (0, $807e525bbe19e865$export$a4fc43c2a99143cd)(this.logger, this.browserStorage, this.isBrowserEnv(), accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return (0, $807e525bbe19e865$export$4f9234baf34abd0)(accountFilter, this.logger, this.browserStorage);
    }
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param username
     * @returns The account object stored in MSAL
     */ getAccountByUsername(username) {
        return (0, $807e525bbe19e865$export$d915baf55d86927d)(username, this.logger, this.browserStorage);
    }
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     */ getAccountByHomeId(homeAccountId) {
        return (0, $807e525bbe19e865$export$d6fa7d1e8099998e)(homeAccountId, this.logger, this.browserStorage);
    }
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     */ getAccountByLocalId(localAccountId) {
        return (0, $807e525bbe19e865$export$7ac8aa09fdf78340)(localAccountId, this.logger, this.browserStorage);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        /*
         * StandardController uses this to allow the developer to set the active account
         * in the nested app auth scenario the active account is controlled by the app hosting the nested app
         */ return (0, $807e525bbe19e865$export$c55c3d25cf1bcd99)(account, this.browserStorage);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return (0, $807e525bbe19e865$export$13dd2e33a23839ad)(this.browserStorage);
    }
    // #endregion
    handleRedirectPromise(hash // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return Promise.resolve(null);
    }
    loginPopup(request // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return this.acquireTokenInteractive(request || (0, $5ff55562d73e0e2b$export$7e12949cd6884193));
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loginRedirect(request) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    logout(logoutRequest) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    logoutRedirect(logoutRequest // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    logoutPopup(logoutRequest // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    ssoSilent(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    request) {
        return this.acquireTokenSilentInternal(request);
    }
    getTokenCache() {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    initializeWrapperLibrary(sku, version) {
        /*
         * Standard controller uses this to set the sku and version of the wrapper library in the storage
         * we do nothing here
         */ return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setNavigationClient(navigationClient) {
        this.logger.warning("setNavigationClient is not supported in nested app auth");
    }
    getConfiguration() {
        return this.config;
    }
    isBrowserEnv() {
        return this.operatingContext.isBrowserEnvironment();
    }
    getBrowserCrypto() {
        return this.browserCrypto;
    }
    getPerformanceClient() {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    getRedirectResponse() {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async clearCache(logoutRequest) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    async hydrateCache(result, request) {
        this.logger.verbose("hydrateCache called");
        const accountEntity = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).createFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        await this.browserStorage.setAccount(accountEntity, result.correlationId);
        return this.browserStorage.hydrateCache(result, request);
    }
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ async function $54e1c8c64fb5e616$export$414d5e42be8c56db(config, request) {
    const standard = new (0, $36cb4f619f94d121$export$f39c23bbfed89e6e)(config);
    await standard.initialize();
    return (0, $1d9f6519fe722240$export$e9d1ef1cb8705404).createController(standard, request);
}
async function $54e1c8c64fb5e616$export$6a1d744b364856f2(config) {
    const standard = new (0, $36cb4f619f94d121$export$f39c23bbfed89e6e)(config);
    const nestedApp = new (0, $769cd552162fdff8$export$a2170d4e3f010950)(config);
    const operatingContexts = [
        standard.initialize(),
        nestedApp.initialize()
    ];
    await Promise.all(operatingContexts);
    if (nestedApp.isAvailable() && config.auth.supportsNestedAppAuth) return (0, $8ac21447ebc7e19d$export$2319deb182e38ab3).createController(nestedApp);
    else if (standard.isAvailable()) return (0, $1d9f6519fe722240$export$e9d1ef1cb8705404).createController(standard);
    else // Since neither of the actual operating contexts are available keep the UnknownOperatingContextController
    return null;
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The PublicClientApplication class is the object exposed by the library to perform authentication and authorization functions in Single Page Applications
 * to obtain JWT tokens as described in the OAuth 2.0 Authorization Code Flow with PKCE specification.
 */ class $5579c29889b267e7$export$89f4855ef88b7920 {
    /**
     * Creates StandardController and passes it to the PublicClientApplication
     *
     * @param configuration {Configuration}
     */ static async createPublicClientApplication(configuration) {
        const controller = await (0, $54e1c8c64fb5e616$export$414d5e42be8c56db)(configuration);
        const pca = new $5579c29889b267e7$export$89f4855ef88b7920(configuration, controller);
        return pca;
    }
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     * @param IController Optional parameter to explictly set the controller. (Will be removed when we remove public constructor)
     */ constructor(configuration, controller){
        this.isBroker = false;
        this.controller = controller || new (0, $1d9f6519fe722240$export$e9d1ef1cb8705404)(new (0, $36cb4f619f94d121$export$f39c23bbfed89e6e)(configuration));
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest}
     */ async initialize(request) {
        return this.controller.initialize(request, this.isBroker);
    }
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopup(request) {
        return this.controller.acquireTokenPopup(request);
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ acquireTokenRedirect(request) {
        return this.controller.acquireTokenRedirect(request);
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthenticationResult} object
     */ acquireTokenSilent(silentRequest) {
        return this.controller.acquireTokenSilent(silentRequest);
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenByCode(request) {
        return this.controller.acquireTokenByCode(request);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.controller.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        return this.controller.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        return this.controller.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.controller.removePerformanceCallback(callbackId);
    }
    /**
     * Adds event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ enableAccountStorageEvents() {
        this.controller.enableAccountStorageEvents();
    }
    /**
     * Removes event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ disableAccountStorageEvents() {
        this.controller.disableAccountStorageEvents();
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return this.controller.getAccount(accountFilter);
    }
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     * @deprecated - Use getAccount instead
     */ getAccountByHomeId(homeAccountId) {
        return this.controller.getAccountByHomeId(homeAccountId);
    }
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     * @deprecated - Use getAccount instead
     */ getAccountByLocalId(localId) {
        return this.controller.getAccountByLocalId(localId);
    }
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param userName
     * @returns The account object stored in MSAL
     * @deprecated - Use getAccount instead
     */ getAccountByUsername(userName) {
        return this.controller.getAccountByUsername(userName);
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return this.controller.getAllAccounts(accountFilter);
    }
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ handleRedirectPromise(hash) {
        return this.controller.handleRedirectPromise(hash);
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        return this.controller.loginPopup(request);
    }
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ loginRedirect(request) {
        return this.controller.loginRedirect(request);
    }
    /**
     * Deprecated logout function. Use logoutRedirect or logoutPopup instead
     * @param logoutRequest
     * @deprecated
     */ logout(logoutRequest) {
        return this.controller.logout(logoutRequest);
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ logoutRedirect(logoutRequest) {
        return this.controller.logoutRedirect(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        return this.controller.logoutPopup(logoutRequest);
    }
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ ssoSilent(request) {
        return this.controller.ssoSilent(request);
    }
    /**
     * Gets the token cache for the application.
     */ getTokenCache() {
        return this.controller.getTokenCache();
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.controller.getLogger();
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.controller.setLogger(logger);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        this.controller.setActiveAccount(account);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return this.controller.getActiveAccount();
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        return this.controller.initializeWrapperLibrary(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.controller.setNavigationClient(navigationClient);
    }
    /**
     * Returns the configuration object
     * @internal
     */ getConfiguration() {
        return this.controller.getConfiguration();
    }
    /**
     * Hydrates cache with the tokens and account in the AuthenticationResult object
     * @param result
     * @param request - The request object that was used to obtain the AuthenticationResult
     * @returns
     */ async hydrateCache(result, request) {
        return this.controller.hydrateCache(result, request);
    }
    /**
     * Clears tokens and account from the browser cache.
     * @param logoutRequest
     */ clearCache(logoutRequest) {
        return this.controller.clearCache(logoutRequest);
    }
}
/**
 * creates NestedAppAuthController and passes it to the PublicClientApplication,
 * falls back to StandardController if NestedAppAuthController is not available
 *
 * @param configuration
 * @returns IPublicClientApplication
 *
 */ async function $5579c29889b267e7$export$210078d2745a65ac(configuration) {
    const nestedAppAuth = new (0, $769cd552162fdff8$export$a2170d4e3f010950)(configuration);
    await nestedAppAuth.initialize();
    if (nestedAppAuth.isAvailable()) {
        const controller = new (0, $8ac21447ebc7e19d$export$2319deb182e38ab3)(nestedAppAuth);
        const nestablePCA = new $5579c29889b267e7$export$89f4855ef88b7920(configuration, controller);
        await nestablePCA.initialize();
        return nestablePCA;
    }
    return $5579c29889b267e7$export$f28b97cfb2f3098(configuration);
}
/**
 * creates PublicClientApplication using StandardController
 *
 * @param configuration
 * @returns IPublicClientApplication
 *
 */ async function $5579c29889b267e7$export$f28b97cfb2f3098(configuration) {
    const pca = new $5579c29889b267e7$export$89f4855ef88b7920(configuration);
    await pca.initialize();
    return pca;
}


const $e73bf42412feb220$var$STORAGE_ACCOUNT = "bpadevmember";
const $e73bf42412feb220$var$MSAL_CLIENT_ID = "c4367c1c-33c3-4010-a91d-cd74f73b16bd";
const $e73bf42412feb220$var$msalConfig = {
    auth: {
        clientId: $e73bf42412feb220$var$MSAL_CLIENT_ID,
        authority: "https://login.microsoftonline.com/e81c845a-b877-44c3-bc58-ef6e9173838f",
        redirectUri: window.location.origin
    },
    cache: {
        cacheLocation: "sessionStorage"
    }
};
const $e73bf42412feb220$var$msalInstance = new (0, $5579c29889b267e7$export$89f4855ef88b7920)($e73bf42412feb220$var$msalConfig);
const $e73bf42412feb220$var$loginRequest = {
    scopes: [
        "https://storage.azure.com/user_impersonation"
    ]
};
let $e73bf42412feb220$var$accessToken = null;
/**
 * Downloads the specified blob from the given container.
 */ async function $e73bf42412feb220$var$downloadBlob(containerName, blobName) {
    const out = document.getElementById("output");
    const blobUrl = `https://${$e73bf42412feb220$var$STORAGE_ACCOUNT}.blob.core.windows.net/${containerName}/${blobName}`;
    out.textContent = `\u{23F3} Downloading ${blobName}\u{2026}`;
    try {
        const resp = await fetch(blobUrl, {
            headers: {
                Authorization: `Bearer ${$e73bf42412feb220$var$accessToken}`,
                "x-ms-version": "2020-10-02"
            }
        });
        if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
        const blob = await resp.blob();
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = blobName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        out.textContent = `\u{2705} Download of ${blobName} started`;
    } catch (e) {
        console.error("Download failed:", e);
        out.textContent = `\u{274C} Download error: ${e.message}`;
    }
}
/**
 * Main flow: initialize MSAL, handle redirect, acquire token, download blob.
 */ async function $e73bf42412feb220$var$run() {
    const out = document.getElementById("output");
    // 1) Initialize the MSAL instance
    out.textContent = "Initializing MSAL\u2026";
    await $e73bf42412feb220$var$msalInstance.initialize();
    // 2) Process a redirect response if present
    out.textContent = "Handling redirect\u2026";
    const redirectResp = await $e73bf42412feb220$var$msalInstance.handleRedirectPromise();
    if (redirectResp) {
        $e73bf42412feb220$var$msalInstance.setActiveAccount(redirectResp.account);
        // Restore the original URL (remove code & state)
        const original = decodeURIComponent(redirectResp.state || "");
        const cleanUrl = window.location.origin + original;
        window.history.replaceState({}, document.title, cleanUrl);
        out.textContent = "Logged in via redirect.";
    }
    // 3) If not signed in yet, redirect to Azure AD and pass original path as "state"
    const account = $e73bf42412feb220$var$msalInstance.getActiveAccount();
    if (!account) {
        const originalPath = window.location.pathname + window.location.search;
        out.textContent = "Redirecting to sign-in\u2026";
        return $e73bf42412feb220$var$msalInstance.loginRedirect({
            ...$e73bf42412feb220$var$loginRequest,
            state: encodeURIComponent(originalPath)
        });
    }
    // 4) Parse container & blob names from the (restored) URL
    const params = new URLSearchParams(window.location.search);
    const containerName = params.get("container");
    const blobName = params.get("blob");
    if (!containerName || !blobName) {
        out.textContent = "\u274C Missing ?container=\u2026&blob=\u2026 in URL";
        return;
    }
    // 5) Acquire an access token silently (fallback to redirect if needed)
    out.textContent = "Acquiring token silently\u2026";
    try {
        const silentResp = await $e73bf42412feb220$var$msalInstance.acquireTokenSilent({
            ...$e73bf42412feb220$var$loginRequest,
            account: account
        });
        $e73bf42412feb220$var$accessToken = silentResp.accessToken;
    } catch  {
        out.textContent = "Redirecting for token\u2026";
        return $e73bf42412feb220$var$msalInstance.acquireTokenRedirect($e73bf42412feb220$var$loginRequest);
    }
    // 6) Download the blob now that we have a token
    out.textContent = `\u{2705} Token acquired; downloading ${blobName}\u{2026}`;
    await $e73bf42412feb220$var$downloadBlob(containerName, blobName);
}
// Kick off the workflow
$e73bf42412feb220$var$run();


//# sourceMappingURL=azure-blob-downloader.28281354.js.map
